export const PROD_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "productTypeId", "brandName", "productName", "description" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Product Name ID"
        }, {
            "name" : "productTypeId",
            "title" : "Product Type ID"
        }, {
            "name" : "brandName",
            "title" : "Brand Name"
        }, {
            "name" : "productName",
            "title" : "Product Name"
        }, {
            "name" : "description",
            "title" : "Description"
        } ],
        "formName" : "ListProductCategoryMembers",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productCategoryId",
            "action" : "",
            "id" : "ListProductCategoryMembers_productCategoryId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Product Name ID",
            "type" : "HYPERLINK",
            "target" : "EditProduct",
            "name" : "productId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProductCategoryMembers_productId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "event" :  "edit",
            "formData":{
                "formName":"EditProductRest",
                "formLocation":"component://kwikstore/widget/ProductForms.xml",
                "link":"/admin/products/product/${productId}"
            },
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "productTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_productTypeId",
            "type" : "DISPLAY_ENTITY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "brandName",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_brandName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "productName",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_productName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_description",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productTypeId", "internalName", "brandName", "productName", "description" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "productTypeId",
            "title" : "Product Type ID"
        }, {
            "name" : "internalName",
            "title" : "Internal Name"
        }, {
            "name" : "brandName",
            "title" : "Brand Name"
        }, {
            "name" : "productName",
            "title" : "Product Name"
        }, {
            "name" : "description",
            "title" : "Description"
        } ],
        "formName" : "ListProducts",
        "altTarget" : [ ],
        "formLocation" : "component://product/widget/catalog/ProductForms.xml",
        "titleDescriptionField":"categoryName",
        "idFieldName":"productCategoryId",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "type" : "HYPERLINK",
            "isSortField" : "Y",
            "width" : "",
            "name" : "productId",
            "parameterList" : [ {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProducts_productId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "productTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListProducts_productTypeId",
            "type" : "DISPLAY_ENTITY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "internalName",
            "description" : "",
            "style" : "",
            "id" : "ListProducts_internalName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "brandName",
            "description" : "",
            "style" : "",
            "id" : "ListProducts_brandName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "productName",
            "description" : "",
            "style" : "",
            "id" : "ListProducts_productName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListProducts_description",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Classification",
            "fields" : [ "productId", "productTypeId", "primaryProductCategoryId" ]
        }, {
            "fieldSetName" : "Naming",
            "fields" : [ "internalName", "productName", "brandName", "comments" ]
        }, {
            "fieldSetName" : "Virtual Product",
            "fields" : [ "isVirtual","isVariant", "virtualVariantMethodEnum" ]
        }, {
            "fieldSetName" : "Dates",
            "fields" : [ "introductionDate","releaseDate", "salesDiscontinuationDate", "supportDiscontinuationDate", "salesDiscWhenNotAvail" ]
        }, {
            "fieldSetName" : "Inventory",
            "fields" : [ "requirementMethodEnumId", "inventoryItemTypeId", "inventoryItemTypeId", "requireInventory", "inventoryMessage", "lotIdFilledIn" ]
        }, {
            "fieldSetName" : "Rating",
            "fields" : [ "ratingTypeEnum","productRating"  ]
        }, {
            "fieldSetName" : "Amount",
            "fields" : [ "requireAmount","amountUomTypeId" ]
        }, {
            "fieldSetName" : "Measures",
            "fields" : [ "productHeight","heightUomId", "shippingHeight", "productWidth", "widthUomId", "shippingWidth", "productDepth", "depthUomId", "shippingDepth", "productDiameter", "diameterUomId", "productWeight", "weightUomId", "shippingWeight", "quantityIncluded", "quantityUomId" ]
        }, {
            "fieldSetName" : "Shipping",
            "fields" : [ "piecesIncluded","inShippingBox", "defaultShipmentBoxTypeId", "chargeShipping" ]
        }, {
            "fieldSetName" : "Cart",
            "fields" : [ "orderDecimalQuantity" ]
        }, {
            "fieldSetName" : "Miscellaneous",
            "fields" : [ "returnable","includeInPromotions", "taxable", "autoCreateKeywords", "isCreate", "contentInfoText", "submitButton", "submitButton", "lastUpdatedByText", "createdByText" ]
        } ],
        "formName" : "EditProductRest",
        "altTarget" : [ {
            "useWhen" : "product==null",
            "targetExdr" : {
            "chars" : "createProduct",
            "hint" : 20,
            "empty" : false,
            "original" : "createProduct"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "titleDescriptionField":"internalName",
        "idFieldName":"productId",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "isCreate",
            "action" : "",
            "id" : "EditProduct_isCreate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "true"
        }, {
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Product ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_productId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "FINISHED_GOOD",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "(Fixed) Asset Usage",
            "key" : "ASSET_USAGE"
            }, {
            "description" : "Asset Rental",
            "key" : "ASSET_USAGE_OUT_IN"
            }, {
            "description" : "Configurable Good",
            "key" : "AGGREGATED"
            }, {
            "description" : "Configurable Good Configuration",
            "key" : "AGGREGATED_CONF"
            }, {
            "description" : "Configurable Service Configuration",
            "key" : "AGGREGATEDSERV_CONF"
            }, {
            "description" : "Configurable Service using inventory",
            "key" : "AGGREGATED_SERVICE"
            }, {
            "description" : "Digital Good",
            "key" : "DIGITAL_GOOD"
            }, {
            "description" : "Finished Good",
            "key" : "FINISHED_GOOD"
            }, {
            "description" : "Finished/Digital Good",
            "key" : "FINDIG_GOOD"
            }, {
            "description" : "Good",
            "key" : "GOOD"
            }, {
            "description" : "Marketing Package",
            "key" : "MARKETING_PKG"
            }, {
            "description" : "Marketing Package: Auto Manufactured",
            "key" : "MARKETING_PKG_AUTO"
            }, {
            "description" : "Marketing Package: Pick Assembly",
            "key" : "MARKETING_PKG_PICK"
            }, {
            "description" : "Product From Scrum",
            "key" : "SCRUM_ITEM"
            }, {
            "description" : "Raw Material",
            "key" : "RAW_MATERIAL"
            }, {
            "description" : "Service",
            "key" : "SERVICE"
            }, {
            "description" : "Service a product using inventory",
            "key" : "SERVICE_PRODUCT"
            }, {
            "description" : "Subassembly",
            "key" : "SUBASSEMBLY"
            }, {
            "description" : "Work In Process",
            "key" : "WIP"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_productTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "30",
            "ajaxUrl" : "",
            "maxlength" : "255",
            "tabindex" : "",
            "className" : "required",
            "title" : "Internal Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "internalName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_internalName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "30",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Brand Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "brandName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_brandName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "30",
            "ajaxUrl" : "",
            "maxlength" : "255",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_productName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "CommonComments",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "comments",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_comments",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Is VIRTUAL Product ?",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonN",
            "key" : "N"
            }, {
            "description" : "CommonY",
            "key" : "Y"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_isVirtual",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "isVirtual",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Is VARIANT Product ?",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonN",
            "key" : "N"
            }, {
            "description" : "CommonY",
            "key" : "Y"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_isVariant",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "isVariant",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Virtual Variant Method",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Feature tree Generation",
            "key" : "VV_FEATURETREE"
            }, {
            "description" : "Variant Tree generation",
            "key" : "VV_VARIANTTREE"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_virtualVariantMethodEnum",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "virtualVariantMethodEnum",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Primary Category",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ ],
            "disabled" : "false",
            "id" : "EditProduct_primaryProductCategoryId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "primaryProductCategoryId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "CommonIntroductionDate",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-10%2018:25:42.39",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductRest",
            "timeDropdownParamName" : "introductionDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProduct_introductionDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "CommonFormatDateTime",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "CommonViewCalendar",
            "timeHourName" : "",
            "name" : "introductionDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "CommonReleaseDate",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-10%2018:25:42.391",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductRest",
            "timeDropdownParamName" : "releaseDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProduct_releaseDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "CommonFormatDateTime",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "CommonViewCalendar",
            "timeHourName" : "",
            "name" : "releaseDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Sales Discontinuation Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-10%2018:25:42.391",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductRest",
            "timeDropdownParamName" : "salesDiscontinuationDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProduct_salesDiscontinuationDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "CommonFormatDateTime",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "CommonViewCalendar",
            "timeHourName" : "",
            "name" : "salesDiscontinuationDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Support Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-10%2018:25:42.391",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductRest",
            "timeDropdownParamName" : "supportDiscontinuationDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProduct_supportDiscontinuationDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "CommonFormatDateTime",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "CommonViewCalendar",
            "timeHourName" : "",
            "name" : "supportDiscontinuationDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Disc. When Inv. Not Avail?",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonY",
            "key" : "Y"
            }, {
            "description" : "CommonN",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_salesDiscWhenNotAvail",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "salesDiscWhenNotAvail",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Requirement Method Enum ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "No Requirement Created",
            "key" : "PRODRQM_NONE"
            }, {
            "description" : "Automatic For Every Sales Order",
            "key" : "PRODRQM_AUTO"
            }, {
            "description" : "When QOH Reaches Minimum Stock for Product-Facility",
            "key" : "PRODRQM_STOCK"
            }, {
            "description" : "When ATP Reaches Minimum Stock for Product-Facility",
            "key" : "PRODRQM_STOCK_ATP"
            }, {
            "description" : "Requirement for order when ATP Reaches Minimum Stock for Product-Facility",
            "key" : "PRODRQM_ATP"
            }, {
            "description" : "Drop-ship only",
            "key" : "PRODRQM_DS"
            }, {
            "description" : "Auto drop-ship on low quantity",
            "key" : "PRODRQM_DSATP"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_requirementMethodEnumId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "requirementMethodEnumId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "InventoryItem Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Non-Serialized",
            "key" : "NON_SERIAL_INV_ITEM"
            }, {
            "description" : "Serialized",
            "key" : "SERIALIZED_INV_ITEM"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_inventoryItemTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "inventoryItemTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Require Inventory",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonY",
            "key" : "Y"
            }, {
            "description" : "CommonN",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_requireInventory",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "requireInventory",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "255",
            "tabindex" : "",
            "className" : "",
            "title" : "Inventory Message",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "inventoryMessage",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_inventoryMessage",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Lot ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Allowed",
            "key" : "Allowed"
            }, {
            "description" : "Mandatory",
            "key" : "Mandatory"
            }, {
            "description" : "Forbidden",
            "key" : "Forbidden"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_lotIdFilledIn",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "lotIdFilledIn",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Rating Type Enum",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Min Rating",
            "key" : "PRDR_MIN"
            }, {
            "description" : "Max Rating",
            "key" : "PRDR_MAX"
            }, {
            "description" : "Rating Override",
            "key" : "PRDR_FLAT"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_ratingTypeEnum",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "ratingTypeEnum",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Rating",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productRating",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_productRating",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Require Amount",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonY",
            "key" : "Y"
            }, {
            "description" : "CommonN",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_requireAmount",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "requireAmount",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Amount Uom Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Area",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Currency",
            "key" : "CURRENCY_MEASURE"
            }, {
            "description" : "Data Size",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Data Speed",
            "key" : "DATASPD_MEASURE"
            }, {
            "description" : "Dry Volume",
            "key" : "VOLUME_DRY_MEASURE"
            }, {
            "description" : "Energy",
            "key" : "ENERGY_MEASURE"
            }, {
            "description" : "Length",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Liquid Volume",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Other",
            "key" : "OTHER_MEASURE"
            }, {
            "description" : "Temperature",
            "key" : "TEMP_MEASURE"
            }, {
            "description" : "Time/Frequency",
            "key" : "TIME_FREQ_MEASURE"
            }, {
            "description" : "Weight",
            "key" : "WEIGHT_MEASURE"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_amountUomTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "amountUomTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Height",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productHeight",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_productHeight",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Height Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Angstrom [A]",
            "key" : "LEN_A"
            }, {
            "description" : "Cable [cb]",
            "key" : "LEN_cb"
            }, {
            "description" : "Centimeter [cm]",
            "key" : "LEN_cm"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s) [chG]",
            "key" : "LEN_chG"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s) [chR]",
            "key" : "LEN_chR"
            }, {
            "description" : "Decimeter [dm]",
            "key" : "LEN_dm"
            }, {
            "description" : "Dekameter [dam]",
            "key" : "LEN_dam"
            }, {
            "description" : "Fathom [fm]",
            "key" : "LEN_fm"
            }, {
            "description" : "Foot [ft]",
            "key" : "LEN_ft"
            }, {
            "description" : "Furlong [fur]",
            "key" : "LEN_fur"
            }, {
            "description" : "Hand (horse\\'s height) [hand]",
            "key" : "LEN_hand"
            }, {
            "description" : "Inch [in]",
            "key" : "LEN_in"
            }, {
            "description" : "Kilometer [km]",
            "key" : "LEN_km"
            }, {
            "description" : "League [league]",
            "key" : "LEN_league"
            }, {
            "description" : "Link (Gunter\\'s) [lnG]",
            "key" : "LEN_lnG"
            }, {
            "description" : "Link (Ramden\\'s) [lnR]",
            "key" : "LEN_lnR"
            }, {
            "description" : "Meter [m]",
            "key" : "LEN_m"
            }, {
            "description" : "Micrometer (Micron) [u]",
            "key" : "LEN_u"
            }, {
            "description" : "Mil (Milli-inch) [mil]",
            "key" : "LEN_mil"
            }, {
            "description" : "Mile (nautical/sea) [nmi]",
            "key" : "LEN_nmi"
            }, {
            "description" : "Mile (statute/land) [mi]",
            "key" : "LEN_mi"
            }, {
            "description" : "Millimeter [mm]",
            "key" : "LEN_mm"
            }, {
            "description" : "Pica (type size) [pica]",
            "key" : "LEN_pica"
            }, {
            "description" : "Point (type size) [point]",
            "key" : "LEN_point"
            }, {
            "description" : "Rod [rd]",
            "key" : "LEN_rd"
            }, {
            "description" : "Yard [yd]",
            "key" : "LEN_yd"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_heightUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "heightUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Shipping Height",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shippingHeight",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_shippingHeight",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Width",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productWidth",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_productWidth",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Width Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Angstrom [A]",
            "key" : "LEN_A"
            }, {
            "description" : "Cable [cb]",
            "key" : "LEN_cb"
            }, {
            "description" : "Centimeter [cm]",
            "key" : "LEN_cm"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s) [chG]",
            "key" : "LEN_chG"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s) [chR]",
            "key" : "LEN_chR"
            }, {
            "description" : "Decimeter [dm]",
            "key" : "LEN_dm"
            }, {
            "description" : "Dekameter [dam]",
            "key" : "LEN_dam"
            }, {
            "description" : "Fathom [fm]",
            "key" : "LEN_fm"
            }, {
            "description" : "Foot [ft]",
            "key" : "LEN_ft"
            }, {
            "description" : "Furlong [fur]",
            "key" : "LEN_fur"
            }, {
            "description" : "Hand (horse\\'s height) [hand]",
            "key" : "LEN_hand"
            }, {
            "description" : "Inch [in]",
            "key" : "LEN_in"
            }, {
            "description" : "Kilometer [km]",
            "key" : "LEN_km"
            }, {
            "description" : "League [league]",
            "key" : "LEN_league"
            }, {
            "description" : "Link (Gunter\\'s) [lnG]",
            "key" : "LEN_lnG"
            }, {
            "description" : "Link (Ramden\\'s) [lnR]",
            "key" : "LEN_lnR"
            }, {
            "description" : "Meter [m]",
            "key" : "LEN_m"
            }, {
            "description" : "Micrometer (Micron) [u]",
            "key" : "LEN_u"
            }, {
            "description" : "Mil (Milli-inch) [mil]",
            "key" : "LEN_mil"
            }, {
            "description" : "Mile (nautical/sea) [nmi]",
            "key" : "LEN_nmi"
            }, {
            "description" : "Mile (statute/land) [mi]",
            "key" : "LEN_mi"
            }, {
            "description" : "Millimeter [mm]",
            "key" : "LEN_mm"
            }, {
            "description" : "Pica (type size) [pica]",
            "key" : "LEN_pica"
            }, {
            "description" : "Point (type size) [point]",
            "key" : "LEN_point"
            }, {
            "description" : "Rod [rd]",
            "key" : "LEN_rd"
            }, {
            "description" : "Yard [yd]",
            "key" : "LEN_yd"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_widthUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "widthUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Shipping Width",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shippingWidth",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_shippingWidth",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Depth",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productDepth",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_productDepth",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Depth Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Angstrom [A]",
            "key" : "LEN_A"
            }, {
            "description" : "Cable [cb]",
            "key" : "LEN_cb"
            }, {
            "description" : "Centimeter [cm]",
            "key" : "LEN_cm"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s) [chG]",
            "key" : "LEN_chG"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s) [chR]",
            "key" : "LEN_chR"
            }, {
            "description" : "Decimeter [dm]",
            "key" : "LEN_dm"
            }, {
            "description" : "Dekameter [dam]",
            "key" : "LEN_dam"
            }, {
            "description" : "Fathom [fm]",
            "key" : "LEN_fm"
            }, {
            "description" : "Foot [ft]",
            "key" : "LEN_ft"
            }, {
            "description" : "Furlong [fur]",
            "key" : "LEN_fur"
            }, {
            "description" : "Hand (horse\\'s height) [hand]",
            "key" : "LEN_hand"
            }, {
            "description" : "Inch [in]",
            "key" : "LEN_in"
            }, {
            "description" : "Kilometer [km]",
            "key" : "LEN_km"
            }, {
            "description" : "League [league]",
            "key" : "LEN_league"
            }, {
            "description" : "Link (Gunter\\'s) [lnG]",
            "key" : "LEN_lnG"
            }, {
            "description" : "Link (Ramden\\'s) [lnR]",
            "key" : "LEN_lnR"
            }, {
            "description" : "Meter [m]",
            "key" : "LEN_m"
            }, {
            "description" : "Micrometer (Micron) [u]",
            "key" : "LEN_u"
            }, {
            "description" : "Mil (Milli-inch) [mil]",
            "key" : "LEN_mil"
            }, {
            "description" : "Mile (nautical/sea) [nmi]",
            "key" : "LEN_nmi"
            }, {
            "description" : "Mile (statute/land) [mi]",
            "key" : "LEN_mi"
            }, {
            "description" : "Millimeter [mm]",
            "key" : "LEN_mm"
            }, {
            "description" : "Pica (type size) [pica]",
            "key" : "LEN_pica"
            }, {
            "description" : "Point (type size) [point]",
            "key" : "LEN_point"
            }, {
            "description" : "Rod [rd]",
            "key" : "LEN_rd"
            }, {
            "description" : "Yard [yd]",
            "key" : "LEN_yd"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_depthUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "depthUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Shipping Depth",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shippingDepth",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_shippingDepth",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Diameter",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productDiameter",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_productDiameter",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Diameter Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Angstrom [A]",
            "key" : "LEN_A"
            }, {
            "description" : "Cable [cb]",
            "key" : "LEN_cb"
            }, {
            "description" : "Centimeter [cm]",
            "key" : "LEN_cm"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s) [chG]",
            "key" : "LEN_chG"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s) [chR]",
            "key" : "LEN_chR"
            }, {
            "description" : "Decimeter [dm]",
            "key" : "LEN_dm"
            }, {
            "description" : "Dekameter [dam]",
            "key" : "LEN_dam"
            }, {
            "description" : "Fathom [fm]",
            "key" : "LEN_fm"
            }, {
            "description" : "Foot [ft]",
            "key" : "LEN_ft"
            }, {
            "description" : "Furlong [fur]",
            "key" : "LEN_fur"
            }, {
            "description" : "Hand (horse\\'s height) [hand]",
            "key" : "LEN_hand"
            }, {
            "description" : "Inch [in]",
            "key" : "LEN_in"
            }, {
            "description" : "Kilometer [km]",
            "key" : "LEN_km"
            }, {
            "description" : "League [league]",
            "key" : "LEN_league"
            }, {
            "description" : "Link (Gunter\\'s) [lnG]",
            "key" : "LEN_lnG"
            }, {
            "description" : "Link (Ramden\\'s) [lnR]",
            "key" : "LEN_lnR"
            }, {
            "description" : "Meter [m]",
            "key" : "LEN_m"
            }, {
            "description" : "Micrometer (Micron) [u]",
            "key" : "LEN_u"
            }, {
            "description" : "Mil (Milli-inch) [mil]",
            "key" : "LEN_mil"
            }, {
            "description" : "Mile (nautical/sea) [nmi]",
            "key" : "LEN_nmi"
            }, {
            "description" : "Mile (statute/land) [mi]",
            "key" : "LEN_mi"
            }, {
            "description" : "Millimeter [mm]",
            "key" : "LEN_mm"
            }, {
            "description" : "Pica (type size) [pica]",
            "key" : "LEN_pica"
            }, {
            "description" : "Point (type size) [point]",
            "key" : "LEN_point"
            }, {
            "description" : "Rod [rd]",
            "key" : "LEN_rd"
            }, {
            "description" : "Yard [yd]",
            "key" : "LEN_yd"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_diameterUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "diameterUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Weight",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productWeight",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_productWeight",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Weight Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Dram (avdp) [dr avdp]",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Grain [gr]",
            "key" : "WT_gr"
            }, {
            "description" : "Gram [g]",
            "key" : "WT_g"
            }, {
            "description" : "Kilogram [kg]",
            "key" : "WT_kg"
            }, {
            "description" : "Milligram [mg]",
            "key" : "WT_mg"
            }, {
            "description" : "Ounce (avdp) [oz]",
            "key" : "WT_oz"
            }, {
            "description" : "Ounce (troy) [oz tr]",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Pennyweight [dwt]",
            "key" : "WT_dwt"
            }, {
            "description" : "Pound (avdp) [lbs]",
            "key" : "WT_lb"
            }, {
            "description" : "Stone [st]",
            "key" : "WT_st"
            }, {
            "description" : "Ton (long or British) [lt]",
            "key" : "WT_lt"
            }, {
            "description" : "Ton (metric) [mt]",
            "key" : "WT_mt"
            }, {
            "description" : "Ton (short) [sh t]",
            "key" : "WT_sh_t"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_weightUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "weightUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Shipping Weight",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shippingWeight",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_shippingWeight",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity Included",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "quantityIncluded",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_quantityIncluded",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Quantity UomId",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "Acre - A",
            "key" : "AREA_A"
            }, {
            "description" : "Amphere - Electric current - A",
            "key" : "OTH_A"
            }, {
            "description" : "Angstrom - A",
            "key" : "LEN_A"
            }, {
            "description" : "Are - a",
            "key" : "AREA_a"
            }, {
            "description" : "Barrel (US) - bbl",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "Bit of Data - b",
            "key" : "DATA_b"
            }, {
            "description" : "Bit-per-second of Data - bps",
            "key" : "DATASPD_bps"
            }, {
            "description" : "Box - bx",
            "key" : "OTH_box"
            }, {
            "description" : "British Thermal Unit - Btu",
            "key" : "EN_Btu"
            }, {
            "description" : "Byte of Data - B",
            "key" : "DATA_B"
            }, {
            "description" : "Cable - cb",
            "key" : "LEN_cb"
            }, {
            "description" : "Calorie (@15.5c) - cal15",
            "key" : "EN_cal15"
            }, {
            "description" : "Candela - Luminosity (intensity of light) - cd",
            "key" : "OTH_cd"
            }, {
            "description" : "Centimeter - cm",
            "key" : "LEN_cm"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s) - chG",
            "key" : "LEN_chG"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s) - chR",
            "key" : "LEN_chR"
            }, {
            "description" : "Cubic centimeter - cm3",
            "key" : "VDRY_cm3"
            }, {
            "description" : "Cubic foot - ft3",
            "key" : "VDRY_ft3"
            }, {
            "description" : "Cubic inch - in3",
            "key" : "VDRY_in3"
            }, {
            "description" : "Cubic meter - m3",
            "key" : "VDRY_m3"
            }, {
            "description" : "Cubic meter (liquid) - m3",
            "key" : "VLIQ_M3"
            }, {
            "description" : "Cubic millimeter - mm3",
            "key" : "VDRY_mm3"
            }, {
            "description" : "Cubic yard - yd3",
            "key" : "VDRY_yd3"
            }, {
            "description" : "Cup - cup",
            "key" : "VLIQ_cup"
            }, {
            "description" : "Decimeter - dm",
            "key" : "LEN_dm"
            }, {
            "description" : "Degrees Celsius - C",
            "key" : "TEMP_C"
            }, {
            "description" : "Degrees Fahrenheit - F",
            "key" : "TEMP_F"
            }, {
            "description" : "Dekameter - dam",
            "key" : "LEN_dam"
            }, {
            "description" : "Dram (US) - dr",
            "key" : "VLIQ_dr"
            }, {
            "description" : "Dram (avdp) - dr avdp",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Each - ea",
            "key" : "OTH_ea"
            }, {
            "description" : "Fathom - fm",
            "key" : "LEN_fm"
            }, {
            "description" : "Foot - ft",
            "key" : "LEN_ft"
            }, {
            "description" : "Furlong - fur",
            "key" : "LEN_fur"
            }, {
            "description" : "Gallon (UK) - gal",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "Gallon (US) - gal",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "Gigabit of Data - Gb",
            "key" : "DATA_Gb"
            }, {
            "description" : "Gigabit-per-second of Data - Gbps",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "Gigabyte of Data - GB",
            "key" : "DATA_GB"
            }, {
            "description" : "Gill (1/4 UK pint) - gi",
            "key" : "VLIQ_gi"
            }, {
            "description" : "Grain - gr",
            "key" : "WT_gr"
            }, {
            "description" : "Gram - g",
            "key" : "WT_g"
            }, {
            "description" : "Hand (horse\\'s height) - hand",
            "key" : "LEN_hand"
            }, {
            "description" : "Hectare - ha",
            "key" : "AREA_ha"
            }, {
            "description" : "Hectoliter - hL",
            "key" : "VLIQ_HL"
            }, {
            "description" : "Horsepower (mechanical) - HP",
            "key" : "EN_HP"
            }, {
            "description" : "Inch - in",
            "key" : "LEN_in"
            }, {
            "description" : "Joule (absolute) - J",
            "key" : "EN_J"
            }, {
            "description" : "Kelvin - K",
            "key" : "TEMP_K"
            }, {
            "description" : "Kilobit of Data - Kb",
            "key" : "DATA_Kb"
            }, {
            "description" : "Kilobit-per-second of Data - Kbps",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "Kilobyte of Data - KB",
            "key" : "DATA_KB"
            }, {
            "description" : "Kilogram - kg",
            "key" : "WT_kg"
            }, {
            "description" : "Kilometer - km",
            "key" : "LEN_km"
            }, {
            "description" : "Kilowatt - Kw",
            "key" : "EN_Kw"
            }, {
            "description" : "League - league",
            "key" : "LEN_league"
            }, {
            "description" : "Link (Gunter\\'s) - lnG",
            "key" : "LEN_lnG"
            }, {
            "description" : "Link (Ramden\\'s) - lnR",
            "key" : "LEN_lnR"
            }, {
            "description" : "Liter - L",
            "key" : "VLIQ_L"
            }, {
            "description" : "Megabit of Data - Mb",
            "key" : "DATA_Mb"
            }, {
            "description" : "Megabit-per-second of Data - Mbps",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "Megabyte of Data - MB",
            "key" : "DATA_MB"
            }, {
            "description" : "Meter - m",
            "key" : "LEN_m"
            }, {
            "description" : "Micrometer (Micron) - u",
            "key" : "LEN_u"
            }, {
            "description" : "Mil (Milli-inch) - mil",
            "key" : "LEN_mil"
            }, {
            "description" : "Mile (nautical/sea) - nmi",
            "key" : "LEN_nmi"
            }, {
            "description" : "Mile (statute/land) - mi",
            "key" : "LEN_mi"
            }, {
            "description" : "Milligram - mg",
            "key" : "WT_mg"
            }, {
            "description" : "Milliliter - ml",
            "key" : "VLIQ_ml"
            }, {
            "description" : "Millimeter - mm",
            "key" : "LEN_mm"
            }, {
            "description" : "Mole - Substance (molecule) - mol",
            "key" : "OTH_mol"
            }, {
            "description" : "Ounce (avdp) - oz",
            "key" : "WT_oz"
            }, {
            "description" : "Ounce (troy) - oz tr",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Ounce, fluid (UK) - fl. oz (UK)",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "Ounce, fluid (US) - fl. oz (US)",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "Package - pk",
            "key" : "OTH_pk"
            }, {
            "description" : "Pennyweight - dwt",
            "key" : "WT_dwt"
            }, {
            "description" : "Per Person - pp",
            "key" : "OTH_pp"
            }, {
            "description" : "Petabit of Data - Pb",
            "key" : "DATA_Pb"
            }, {
            "description" : "Petabyte of Data - PB",
            "key" : "DATA_PB"
            }, {
            "description" : "Pica (type size) - pica",
            "key" : "LEN_pica"
            }, {
            "description" : "Pint (UK) - pt (UK)",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "Pint (US) - pt (US)",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "Point (type size) - point",
            "key" : "LEN_point"
            }, {
            "description" : "Pound (avdp) - lbs",
            "key" : "WT_lb"
            }, {
            "description" : "Quart - qt",
            "key" : "VLIQ_qt"
            }, {
            "description" : "Rod - rd",
            "key" : "LEN_rd"
            }, {
            "description" : "Square Centimeter - cm2",
            "key" : "AREA_cm2"
            }, {
            "description" : "Square Foot - ft2",
            "key" : "AREA_ft2"
            }, {
            "description" : "Square Inch - in2",
            "key" : "AREA_in2"
            }, {
            "description" : "Square Kilometer - km2",
            "key" : "AREA_km2"
            }, {
            "description" : "Square Meter - m2",
            "key" : "AREA_m2"
            }, {
            "description" : "Square Mile - mi2",
            "key" : "AREA_mi2"
            }, {
            "description" : "Square Millimeter - mm2",
            "key" : "AREA_mm2"
            }, {
            "description" : "Square Rod - rd2",
            "key" : "AREA_rd2"
            }, {
            "description" : "Square Yard - yd2",
            "key" : "AREA_yd2"
            }, {
            "description" : "Stere (cubic meter) - ST",
            "key" : "VDRY_ST"
            }, {
            "description" : "Stone - st",
            "key" : "WT_st"
            }, {
            "description" : "Tablespoon - Tbs",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "Teaspoon - tsp",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "Terabit of Data - Tb",
            "key" : "DATA_Tb"
            }, {
            "description" : "Terabit-per-second of Data - Tbps",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "Terabyte of Data - TB",
            "key" : "DATA_TB"
            }, {
            "description" : "Time in Centuries - century",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days - day",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades - decade",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours - hr",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia - millenium",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds - ms",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes - min",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months - mon",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores - score",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds - s",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks - wk",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years - yr",
            "key" : "TF_yr"
            }, {
            "description" : "Ton (long or British) - lt",
            "key" : "WT_lt"
            }, {
            "description" : "Ton (metric) - mt",
            "key" : "WT_mt"
            }, {
            "description" : "Ton (short) - sh t",
            "key" : "WT_sh_t"
            }, {
            "description" : "Watt - w",
            "key" : "EN_w"
            }, {
            "description" : "Yard - yd",
            "key" : "LEN_yd"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_quantityUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "quantityUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "10",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Pieces Included",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "piecesIncluded",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProduct_piecesIncluded",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "In Shipping Box ?",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonN",
            "key" : "N"
            }, {
            "description" : "CommonY",
            "key" : "Y"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_inShippingBox",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "inShippingBox",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Default Shipment Box Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "FedEx 10KG Box",
            "key" : "FX10KGBOX"
            }, {
            "description" : "FedEx 25KG Box",
            "key" : "FX25KGBOX"
            }, {
            "description" : "FedEx Box (Large)",
            "key" : "FXBOX_LRG"
            }, {
            "description" : "FedEx Box (Medium)",
            "key" : "FXBOX_MED"
            }, {
            "description" : "FedEx Box (Small)",
            "key" : "FXBOX_SM"
            }, {
            "description" : "FedEx Envelope",
            "key" : "FXENV"
            }, {
            "description" : "FedEx Envelope (Legal)",
            "key" : "FXENV_LGL"
            }, {
            "description" : "FedEx Pak (Large)",
            "key" : "FXPAK_LRG"
            }, {
            "description" : "FedEx Pak (Small)",
            "key" : "FXPAK_SM"
            }, {
            "description" : "FedEx Tube",
            "key" : "FXTUBE"
            }, {
            "description" : "Your Packaging",
            "key" : "YOURPACKNG"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_defaultShipmentBoxTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "defaultShipmentBoxTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Charge Shipping",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonY",
            "key" : "Y"
            }, {
            "description" : "CommonN",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_chargeShipping",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "chargeShipping",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Allow order decimal quantity",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonY",
            "key" : "Y"
            }, {
            "description" : "CommonN",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_orderDecimalQuantity",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "orderDecimalQuantity",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Returnable",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonY",
            "key" : "Y"
            }, {
            "description" : "CommonN",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_returnable",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "returnable",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Include In Promotions",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonY",
            "key" : "Y"
            }, {
            "description" : "CommonN",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_includeInPromotions",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "includeInPromotions",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Taxable",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonY",
            "key" : "Y"
            }, {
            "description" : "CommonN",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_taxable",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "taxable",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "AutoCreateKeywords",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductRest",
            "options" : [ {
            "description" : "CommonY",
            "key" : "Y"
            }, {
            "description" : "CommonN",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditProduct_autoCreateKeywords",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "autoCreateKeywords",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contentInfoText",
            "description" : "NOTE: For content options, use the Content tab.",
            "style" : "",
            "id" : "EditProduct_contentInfoText",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditProductRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditProduct_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create Product",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProduct"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productPriceTypeId", "productPricePurposeId", "currencyUomId", "productStoreGroupId", "fromDate", "thruDate", "price", "termUomId", "customPriceCalcService", "taxPercentage", "taxAuthPartyId", "taxAuthGeoId", "taxInPrice", "lastUpdatedByText", "submitButton", "viewHistoryLink", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "productPriceTypeId",
            "title" : "Type"
        }, {
            "name" : "productPricePurposeId",
            "title" : "Purpose"
        }, {
            "name" : "currencyUomId",
            "title" : "Currency"
        }, {
            "name" : "productStoreGroupId",
            "title" : "Store Group"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "price",
            "title" : "Price"
        }, {
            "name" : "termUomId",
            "title" : "termUomId"
        }, {
            "name" : "customPriceCalcService",
            "title" : "Custom Price Calc Service"
        }, {
            "name" : "taxPercentage",
            "title" : "Tax %"
        }, {
            "name" : "taxAuthPartyId",
            "title" : "Tax Authority"
        }, {
            "name" : "taxAuthGeoId",
            "title" : "Tax Geo ID"
        }, {
            "name" : "taxInPrice",
            "title" : "Tax In Price"
        }, {
            "name" : "lastUpdatedByText",
            "title" : "Last Modified By:"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "viewHistoryLink",
            "title" : " "
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductPriceRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductPrice_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productPriceTypeId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductPrice_productPriceTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productPricePurposeId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductPrice_productPricePurposeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currencyUomId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductPrice_currencyUomId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productStoreGroupId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductPrice_productStoreGroupId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductPrice_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-16%2008:40:20.395",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "UpdateProductPriceRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "UpdateProductPrice_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Price",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "price",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductPrice_price",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "termUomId",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "UpdateProductPriceRest",
            "options" : [ {
            "description" : "Area: Acre (A)",
            "key" : "AREA_A"
            }, {
            "description" : "Area: Are (a)",
            "key" : "AREA_a"
            }, {
            "description" : "Area: Square Centimeter (cm2)",
            "key" : "AREA_cm2"
            }, {
            "description" : "Area: Square Foot (ft2)",
            "key" : "AREA_ft2"
            }, {
            "description" : "Area: Hectare (ha)",
            "key" : "AREA_ha"
            }, {
            "description" : "Area: Square Inch (in2)",
            "key" : "AREA_in2"
            }, {
            "description" : "Area: Square Kilometer (km2)",
            "key" : "AREA_km2"
            }, {
            "description" : "Area: Square Meter (m2)",
            "key" : "AREA_m2"
            }, {
            "description" : "Area: Square Mile (mi2)",
            "key" : "AREA_mi2"
            }, {
            "description" : "Area: Square Millimeter (mm2)",
            "key" : "AREA_mm2"
            }, {
            "description" : "Area: Square Rod (rd2)",
            "key" : "AREA_rd2"
            }, {
            "description" : "Area: Square Yard (yd2)",
            "key" : "AREA_yd2"
            }, {
            "description" : "Data Size: Byte of Data (B)",
            "key" : "DATA_B"
            }, {
            "description" : "Data Size: Gigabyte of Data (GB)",
            "key" : "DATA_GB"
            }, {
            "description" : "Data Size: Gigabit of Data (Gb)",
            "key" : "DATA_Gb"
            }, {
            "description" : "Data Size: Kilobyte of Data (KB)",
            "key" : "DATA_KB"
            }, {
            "description" : "Data Size: Kilobit of Data (Kb)",
            "key" : "DATA_Kb"
            }, {
            "description" : "Data Size: Megabyte of Data (MB)",
            "key" : "DATA_MB"
            }, {
            "description" : "Data Size: Megabit of Data (Mb)",
            "key" : "DATA_Mb"
            }, {
            "description" : "Data Size: Petabyte of Data (PB)",
            "key" : "DATA_PB"
            }, {
            "description" : "Data Size: Petabit of Data (Pb)",
            "key" : "DATA_Pb"
            }, {
            "description" : "Data Size: Terabyte of Data (TB)",
            "key" : "DATA_TB"
            }, {
            "description" : "Data Size: Terabit of Data (Tb)",
            "key" : "DATA_Tb"
            }, {
            "description" : "Data Size: Bit of Data (b)",
            "key" : "DATA_b"
            }, {
            "description" : "Data Speed: Gigabit-per-second of Data (Gbps)",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "Data Speed: Kilobit-per-second of Data (Kbps)",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "Data Speed: Megabit-per-second of Data (Mbps)",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "Data Speed: Terabit-per-second of Data (Tbps)",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "Data Speed: Bit-per-second of Data (bps)",
            "key" : "DATASPD_bps"
            }, {
            "description" : "Dry Volume: Stere (cubic meter) (ST)",
            "key" : "VDRY_ST"
            }, {
            "description" : "Dry Volume: Cubic centimeter (cm3)",
            "key" : "VDRY_cm3"
            }, {
            "description" : "Dry Volume: Cubic foot (ft3)",
            "key" : "VDRY_ft3"
            }, {
            "description" : "Dry Volume: Cubic inch (in3)",
            "key" : "VDRY_in3"
            }, {
            "description" : "Dry Volume: Cubic meter (m3)",
            "key" : "VDRY_m3"
            }, {
            "description" : "Dry Volume: Cubic millimeter (mm3)",
            "key" : "VDRY_mm3"
            }, {
            "description" : "Dry Volume: Cubic yard (yd3)",
            "key" : "VDRY_yd3"
            }, {
            "description" : "Energy: British Thermal Unit (Btu)",
            "key" : "EN_Btu"
            }, {
            "description" : "Energy: Horsepower (mechanical) (HP)",
            "key" : "EN_HP"
            }, {
            "description" : "Energy: Joule (absolute) (J)",
            "key" : "EN_J"
            }, {
            "description" : "Energy: Kilowatt (Kw)",
            "key" : "EN_Kw"
            }, {
            "description" : "Energy: Calorie (@15.5c) (cal15)",
            "key" : "EN_cal15"
            }, {
            "description" : "Energy: Watt (w)",
            "key" : "EN_w"
            }, {
            "description" : "Length: Angstrom (A)",
            "key" : "LEN_A"
            }, {
            "description" : "Length: Cable (cb)",
            "key" : "LEN_cb"
            }, {
            "description" : "Length: Chain (Gunter\\'s/surveyor\\'s) (chG)",
            "key" : "LEN_chG"
            }, {
            "description" : "Length: Chain (Ramden\\'s/engineer\\'s) (chR)",
            "key" : "LEN_chR"
            }, {
            "description" : "Length: Centimeter (cm)",
            "key" : "LEN_cm"
            }, {
            "description" : "Length: Dekameter (dam)",
            "key" : "LEN_dam"
            }, {
            "description" : "Length: Decimeter (dm)",
            "key" : "LEN_dm"
            }, {
            "description" : "Length: Fathom (fm)",
            "key" : "LEN_fm"
            }, {
            "description" : "Length: Foot (ft)",
            "key" : "LEN_ft"
            }, {
            "description" : "Length: Furlong (fur)",
            "key" : "LEN_fur"
            }, {
            "description" : "Length: Hand (horse\\'s height) (hand)",
            "key" : "LEN_hand"
            }, {
            "description" : "Length: Inch (in)",
            "key" : "LEN_in"
            }, {
            "description" : "Length: Kilometer (km)",
            "key" : "LEN_km"
            }, {
            "description" : "Length: League (league)",
            "key" : "LEN_league"
            }, {
            "description" : "Length: Link (Gunter\\'s) (lnG)",
            "key" : "LEN_lnG"
            }, {
            "description" : "Length: Link (Ramden\\'s) (lnR)",
            "key" : "LEN_lnR"
            }, {
            "description" : "Length: Meter (m)",
            "key" : "LEN_m"
            }, {
            "description" : "Length: Mile (statute/land) (mi)",
            "key" : "LEN_mi"
            }, {
            "description" : "Length: Mil (Milli-inch) (mil)",
            "key" : "LEN_mil"
            }, {
            "description" : "Length: Millimeter (mm)",
            "key" : "LEN_mm"
            }, {
            "description" : "Length: Mile (nautical/sea) (nmi)",
            "key" : "LEN_nmi"
            }, {
            "description" : "Length: Pica (type size) (pica)",
            "key" : "LEN_pica"
            }, {
            "description" : "Length: Point (type size) (point)",
            "key" : "LEN_point"
            }, {
            "description" : "Length: Rod (rd)",
            "key" : "LEN_rd"
            }, {
            "description" : "Length: Micrometer (Micron) (u)",
            "key" : "LEN_u"
            }, {
            "description" : "Length: Yard (yd)",
            "key" : "LEN_yd"
            }, {
            "description" : "Liquid Volume: Hectoliter (hL)",
            "key" : "VLIQ_HL"
            }, {
            "description" : "Liquid Volume: Liter (L)",
            "key" : "VLIQ_L"
            }, {
            "description" : "Liquid Volume: Cubic meter (liquid) (m3)",
            "key" : "VLIQ_M3"
            }, {
            "description" : "Liquid Volume: Tablespoon (Tbs)",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "Liquid Volume: Barrel (US) (bbl)",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "Liquid Volume: Cup (cup)",
            "key" : "VLIQ_cup"
            }, {
            "description" : "Liquid Volume: Dram (US) (dr)",
            "key" : "VLIQ_dr"
            }, {
            "description" : "Liquid Volume: Gallon (UK) (gal)",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "Liquid Volume: Gallon (US) (gal)",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "Liquid Volume: Gill (1/4 UK pint) (gi)",
            "key" : "VLIQ_gi"
            }, {
            "description" : "Liquid Volume: Milliliter (ml)",
            "key" : "VLIQ_ml"
            }, {
            "description" : "Liquid Volume: Ounce, fluid (UK) (fl. oz (UK))",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "Liquid Volume: Ounce, fluid (US) (fl. oz (US))",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "Liquid Volume: Pint (UK) (pt (UK))",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "Liquid Volume: Pint (US) (pt (US))",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "Liquid Volume: Quart (qt)",
            "key" : "VLIQ_qt"
            }, {
            "description" : "Liquid Volume: Teaspoon (tsp)",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "Other: Amphere - Electric current (A)",
            "key" : "OTH_A"
            }, {
            "description" : "Other: Box (bx)",
            "key" : "OTH_box"
            }, {
            "description" : "Other: Candela - Luminosity (intensity of light) (cd)",
            "key" : "OTH_cd"
            }, {
            "description" : "Other: Each (ea)",
            "key" : "OTH_ea"
            }, {
            "description" : "Other: Mole - Substance (molecule) (mol)",
            "key" : "OTH_mol"
            }, {
            "description" : "Other: Package (pk)",
            "key" : "OTH_pk"
            }, {
            "description" : "Other: Per Person (pp)",
            "key" : "OTH_pp"
            }, {
            "description" : "Temperature: Degrees Celsius (C)",
            "key" : "TEMP_C"
            }, {
            "description" : "Temperature: Degrees Fahrenheit (F)",
            "key" : "TEMP_F"
            }, {
            "description" : "Temperature: Kelvin (K)",
            "key" : "TEMP_K"
            }, {
            "description" : "Time/Frequency: Time in Centuries (century)",
            "key" : "TF_century"
            }, {
            "description" : "Time/Frequency: Time in Days (day)",
            "key" : "TF_day"
            }, {
            "description" : "Time/Frequency: Time in Decades (decade)",
            "key" : "TF_decade"
            }, {
            "description" : "Time/Frequency: Time in Hours (hr)",
            "key" : "TF_hr"
            }, {
            "description" : "Time/Frequency: Time in Millenia (millenium)",
            "key" : "TF_millenium"
            }, {
            "description" : "Time/Frequency: Time in Minutes (min)",
            "key" : "TF_min"
            }, {
            "description" : "Time/Frequency: Time in Months (mon)",
            "key" : "TF_mon"
            }, {
            "description" : "Time/Frequency: Time in Milli-Seconds (ms)",
            "key" : "TF_ms"
            }, {
            "description" : "Time/Frequency: Time in Seconds (s)",
            "key" : "TF_s"
            }, {
            "description" : "Time/Frequency: Time in Scores (score)",
            "key" : "TF_score"
            }, {
            "description" : "Time/Frequency: Time in Weeks (wk)",
            "key" : "TF_wk"
            }, {
            "description" : "Time/Frequency: Time in Years (yr)",
            "key" : "TF_yr"
            }, {
            "description" : "Weight: Dram (avdp) (dr avdp)",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Weight: Pennyweight (dwt)",
            "key" : "WT_dwt"
            }, {
            "description" : "Weight: Gram (g)",
            "key" : "WT_g"
            }, {
            "description" : "Weight: Grain (gr)",
            "key" : "WT_gr"
            }, {
            "description" : "Weight: Kilogram (kg)",
            "key" : "WT_kg"
            }, {
            "description" : "Weight: Pound (avdp) (lbs)",
            "key" : "WT_lb"
            }, {
            "description" : "Weight: Ton (long or British) (lt)",
            "key" : "WT_lt"
            }, {
            "description" : "Weight: Milligram (mg)",
            "key" : "WT_mg"
            }, {
            "description" : "Weight: Ton (metric) (mt)",
            "key" : "WT_mt"
            }, {
            "description" : "Weight: Ounce (avdp) (oz)",
            "key" : "WT_oz"
            }, {
            "description" : "Weight: Ounce (troy) (oz tr)",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Weight: Ton (short) (sh t)",
            "key" : "WT_sh_t"
            }, {
            "description" : "Weight: Stone (st)",
            "key" : "WT_st"
            } ],
            "disabled" : "false",
            "id" : "UpdateProductPrice_termUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "termUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Custom Price Calc Service",
            "type" : "HIDDEN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "UpdateProductPriceRest",
            "options" : [ ],
            "disabled" : "false",
            "id" : "UpdateProductPrice_customPriceCalcService",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "customPriceCalcService",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Tax Percentage",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "taxPercentage",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductPrice_taxPercentage",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "HIDDEN",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "UpdateProductPriceRest",
            "id" : "UpdateProductPrice_taxAuthPartyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "taxAuthPartyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "taxAuthPartyId",
            "style" : "",
            "id" : "UpdateProductPrice_taxAuthPartyId",
            "title" : "Tax Authority Party",
            "type" : "HIDDEN"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "HIDDEN",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "UpdateProductPriceRest",
            "id" : "UpdateProductPrice_taxAuthGeoId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupGeo",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "taxAuthGeoId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "taxAuthGeoId",
            "style" : "",
            "id" : "UpdateProductPrice_taxAuthGeoId",
            "title" : "Tax Auth Geo ID",
            "type" : "HIDDEN"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Tax In Price",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "UpdateProductPriceRest",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "UpdateProductPrice_taxInPrice",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "first-in-list",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "taxInPrice",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "lastUpdatedByText",
            "description" : "[] On ",
            "style" : "",
            "id" : "UpdateProductPrice_lastUpdatedByText",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductPriceRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "UpdateProductPrice_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "viewHistoryLink",
            "alternate" : "",
            "description" : "History",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productPriceTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "UpdateProductPrice_viewHistoryLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productPriceTypeId"
            }, {
            "name" : "productPricePurposeId"
            }, {
            "name" : "currencyUomId"
            }, {
            "name" : "productStoreGroupId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "UpdateProductPrice_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : "updateProductPrice"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productPriceTypeId", "productPricePurposeId", "currencyUomId", "productStoreGroupId", "fromDate", "thruDate", "price", "termUomId", "customPriceCalcService", "taxPercentage", "taxAuthPartyId", "taxAuthGeoId", "taxInPrice", "submitButton" ]
        } ],
        "formName" : "AddProductPriceRest",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"createProductPrice"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductPrice_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Price Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "DEFAULT_PRICE",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductPriceRest",
            "options" : [ {
            "description" : "Average Cost",
            "key" : "AVERAGE_COST"
            }, {
            "description" : "Box Price",
            "key" : "BOX_PRICE"
            }, {
            "description" : "Competitive Price",
            "key" : "COMPETITIVE_PRICE"
            }, {
            "description" : "Default Price",
            "key" : "DEFAULT_PRICE"
            }, {
            "description" : "List Price",
            "key" : "LIST_PRICE"
            }, {
            "description" : "Maximum Price",
            "key" : "MAXIMUM_PRICE"
            }, {
            "description" : "Minimum Price",
            "key" : "MINIMUM_PRICE"
            }, {
            "description" : "Minimum order Price",
            "key" : "MINIMUM_ORDER_PRICE"
            }, {
            "description" : "Promotional Price",
            "key" : "PROMO_PRICE"
            }, {
            "description" : "Shipping Allowance Price",
            "key" : "SHIPPING_ALLOWANCE"
            }, {
            "description" : "Special Promo Price",
            "key" : "SPECIAL_PROMO_PRICE"
            }, {
            "description" : "Wholesale Price",
            "key" : "WHOLESALE_PRICE"
            } ],
            "disabled" : "false",
            "id" : "AddProductPrice_productPriceTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productPriceTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Purpose",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "PURCHASE",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductPriceRest",
            "options" : [ {
            "description" : "Component Price",
            "key" : "COMPONENT_PRICE"
            }, {
            "description" : "Deposit price",
            "key" : "DEPOSIT"
            }, {
            "description" : "Purchase/Initial",
            "key" : "PURCHASE"
            }, {
            "description" : "Recurring Charge",
            "key" : "RECURRING_CHARGE"
            }, {
            "description" : "Usage Charge",
            "key" : "USAGE_CHARGE"
            }, {
            "description" : "eBay Auction",
            "key" : "EBAY"
            } ],
            "disabled" : "false",
            "id" : "AddProductPrice_productPricePurposeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productPricePurposeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Currency Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductPriceRest",
            "options" : [ {
            "description" : "Afghani - AFN",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek - ALL",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar - DZD",
            "key" : "DZD"
            }, {
            "description" : "American Dollar - USD",
            "key" : "USD"
            }, {
            "description" : "Angolan Kwanza - AOA",
            "key" : "AOA"
            }, {
            "description" : "Argentina Peso - ARS",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram - AMD",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder - AWG",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar - AUD",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat - AZN",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar - BSD",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar - BHD",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka - BDT",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar - BBD",
            "key" : "BBD"
            }, {
            "description" : "Belize Dollar - BZD",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble - BYN",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc - XOF",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar - BMD",
            "key" : "BMD"
            }, {
            "description" : "Bolivian Boliviano - BOB",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula - BWP",
            "key" : "BWP"
            }, {
            "description" : "Brazilian Real - BRL",
            "key" : "BRL"
            }, {
            "description" : "British Pound - GBP",
            "key" : "GBP"
            }, {
            "description" : "Brunei Dollar - BND",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev - BGN",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc - BIF",
            "key" : "BIF"
            }, {
            "description" : "Cambodian Riel - KHR",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar - CAD",
            "key" : "CAD"
            }, {
            "description" : "Cape Verde Escudo - CVE",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar - KYD",
            "key" : "KYD"
            }, {
            "description" : "Chilean Peso - CLP",
            "key" : "CLP"
            }, {
            "description" : "China - CNY",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso - COP",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc - KMF",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks - BAM",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon - CRC",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna - HRK",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso - CUP",
            "key" : "CUP"
            }, {
            "description" : "Czech Krona - CZK",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone - DKK",
            "key" : "DKK"
            }, {
            "description" : "Djibouti Franc - DJF",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso - DOP",
            "key" : "DOP"
            }, {
            "description" : "East Carribean Dollar - XCD",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound - EGP",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon - SVC",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr - ETB",
            "key" : "ETB"
            }, {
            "description" : "Euro - EUR",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound - FKP",
            "key" : "FKP"
            }, {
            "description" : "Fiji Dollar - FJD",
            "key" : "FJD"
            }, {
            "description" : "Gabon C.f.A Franc - XAF",
            "key" : "XAF"
            }, {
            "description" : "Gambian Dalasi - GMD",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi - GHS",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound - GIP",
            "key" : "GIP"
            }, {
            "description" : "Guatemalan Quedzal - GTQ",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc - GNF",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar - GYD",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde - HTG",
            "key" : "HTG"
            }, {
            "description" : "Honduran Lempira - HNL",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar - HKD",
            "key" : "HKD"
            }, {
            "description" : "Hungarian forint - HUF",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona - ISK",
            "key" : "ISK"
            }, {
            "description" : "Indian Rupee - INR",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah - IDR",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial - IRR",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar - IQD",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar - JMD",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen - JPY",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar - JOD",
            "key" : "JOD"
            }, {
            "description" : "Kazakhstani Tenge - KZT",
            "key" : "KZT"
            }, {
            "description" : "Kenyan Shilling - KES",
            "key" : "KES"
            }, {
            "description" : "Kirghizstan Som - KGS",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar - KWD",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip - LAK",
            "key" : "LAK"
            }, {
            "description" : "Lari - GEL",
            "key" : "GEL"
            }, {
            "description" : "Lebanese Pound - LBP",
            "key" : "LBP"
            }, {
            "description" : "Leone - SLL",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti - LSL",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar - LRD",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar - LYD",
            "key" : "LYD"
            }, {
            "description" : "Macao Pataca - MOP",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary - MGA",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha - MWK",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit - MYR",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa - MVR",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya - MRU",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee - MUR",
            "key" : "MUR"
            }, {
            "description" : "Mexican Peso - MXN",
            "key" : "MXN"
            }, {
            "description" : "Moldavian Lei - MDL",
            "key" : "MDL"
            }, {
            "description" : "Mongolian Tugrik - MNT",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham - MAD",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical - MZN",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee - NPR",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel - ILS",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar - TWD",
            "key" : "TWD"
            }, {
            "description" : "New Zaire - ZRN",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar - NZD",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba - NIO",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira - NGN",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won - KPW",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone - NOK",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial - OMR",
            "key" : "OMR"
            }, {
            "description" : "Pakistan Rupee - PKR",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa - PAB",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina - PGK",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani - PYG",
            "key" : "PYG"
            }, {
            "description" : "Peruvian Sol - PEN",
            "key" : "PEN"
            }, {
            "description" : "Philippino Peso - PHP",
            "key" : "PHP"
            }, {
            "description" : "Polish Zloty - PLN",
            "key" : "PLN"
            }, {
            "description" : "Qatar Riyal - QAR",
            "key" : "QAR"
            }, {
            "description" : "Romanian Leu - RON",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble - RUB",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc - RWF",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala - WST",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra - STN",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal - SAR",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee - SCR",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar - SGD",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar - SBD",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling - SOS",
            "key" : "SOS"
            }, {
            "description" : "South African Rand - ZAR",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won - KRW",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound - SSP",
            "key" : "SSP"
            }, {
            "description" : "Sri Lankan Rupee - LKR",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound - SHP",
            "key" : "SHP"
            }, {
            "description" : "Sudanese Pound - SDG",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar - SRD",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni - SZL",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona - SEK",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc - CHF",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound - SYP",
            "key" : "SYP"
            }, {
            "description" : "Tadzhikistani Somoni - TJS",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling - TZS",
            "key" : "TZS"
            }, {
            "description" : "Thailand Baht - THB",
            "key" : "THB"
            }, {
            "description" : "Tongan Pa\\'anga - TOP",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar - TTD",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar - TND",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira - TRY",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat - TMT",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling - UGX",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia - UAH",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham - AED",
            "key" : "AED"
            }, {
            "description" : "Uruguay - UYU",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI) - UYI",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu - VUV",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano - VES",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong - VND",
            "key" : "VND"
            }, {
            "description" : "West Indian Guilder - ANG",
            "key" : "ANG"
            }, {
            "description" : "Yemeni Ryal - YER",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha - ZMW",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar - ZWL",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "AddProductPrice_currencyUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "currencyUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Store Group ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "_NA_",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductPriceRest",
            "options" : [ {
            "description" : "Not Applicable",
            "key" : "_NA_"
            } ],
            "disabled" : "false",
            "id" : "AddProductPrice_productStoreGroupId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productStoreGroupId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "required",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductPriceRest",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductPrice_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-16%2008:42:50.504",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductPriceRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductPrice_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "required",
            "title" : "Price",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "price",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductPrice_price",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "termUomId",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductPriceRest",
            "options" : [ {
            "description" : "Area: Acre (A)",
            "key" : "AREA_A"
            }, {
            "description" : "Area: Are (a)",
            "key" : "AREA_a"
            }, {
            "description" : "Area: Hectare (ha)",
            "key" : "AREA_ha"
            }, {
            "description" : "Area: Square Centimeter (cm2)",
            "key" : "AREA_cm2"
            }, {
            "description" : "Area: Square Foot (ft2)",
            "key" : "AREA_ft2"
            }, {
            "description" : "Area: Square Inch (in2)",
            "key" : "AREA_in2"
            }, {
            "description" : "Area: Square Kilometer (km2)",
            "key" : "AREA_km2"
            }, {
            "description" : "Area: Square Meter (m2)",
            "key" : "AREA_m2"
            }, {
            "description" : "Area: Square Mile (mi2)",
            "key" : "AREA_mi2"
            }, {
            "description" : "Area: Square Millimeter (mm2)",
            "key" : "AREA_mm2"
            }, {
            "description" : "Area: Square Rod (rd2)",
            "key" : "AREA_rd2"
            }, {
            "description" : "Area: Square Yard (yd2)",
            "key" : "AREA_yd2"
            }, {
            "description" : "Data Size: Bit of Data (b)",
            "key" : "DATA_b"
            }, {
            "description" : "Data Size: Byte of Data (B)",
            "key" : "DATA_B"
            }, {
            "description" : "Data Size: Gigabit of Data (Gb)",
            "key" : "DATA_Gb"
            }, {
            "description" : "Data Size: Gigabyte of Data (GB)",
            "key" : "DATA_GB"
            }, {
            "description" : "Data Size: Kilobit of Data (Kb)",
            "key" : "DATA_Kb"
            }, {
            "description" : "Data Size: Kilobyte of Data (KB)",
            "key" : "DATA_KB"
            }, {
            "description" : "Data Size: Megabit of Data (Mb)",
            "key" : "DATA_Mb"
            }, {
            "description" : "Data Size: Megabyte of Data (MB)",
            "key" : "DATA_MB"
            }, {
            "description" : "Data Size: Petabit of Data (Pb)",
            "key" : "DATA_Pb"
            }, {
            "description" : "Data Size: Petabyte of Data (PB)",
            "key" : "DATA_PB"
            }, {
            "description" : "Data Size: Terabit of Data (Tb)",
            "key" : "DATA_Tb"
            }, {
            "description" : "Data Size: Terabyte of Data (TB)",
            "key" : "DATA_TB"
            }, {
            "description" : "Data Speed: Bit-per-second of Data (bps)",
            "key" : "DATASPD_bps"
            }, {
            "description" : "Data Speed: Gigabit-per-second of Data (Gbps)",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "Data Speed: Kilobit-per-second of Data (Kbps)",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "Data Speed: Megabit-per-second of Data (Mbps)",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "Data Speed: Terabit-per-second of Data (Tbps)",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "Dry Volume: Cubic centimeter (cm3)",
            "key" : "VDRY_cm3"
            }, {
            "description" : "Dry Volume: Cubic foot (ft3)",
            "key" : "VDRY_ft3"
            }, {
            "description" : "Dry Volume: Cubic inch (in3)",
            "key" : "VDRY_in3"
            }, {
            "description" : "Dry Volume: Cubic meter (m3)",
            "key" : "VDRY_m3"
            }, {
            "description" : "Dry Volume: Cubic millimeter (mm3)",
            "key" : "VDRY_mm3"
            }, {
            "description" : "Dry Volume: Cubic yard (yd3)",
            "key" : "VDRY_yd3"
            }, {
            "description" : "Dry Volume: Stere (cubic meter) (ST)",
            "key" : "VDRY_ST"
            }, {
            "description" : "Energy: British Thermal Unit (Btu)",
            "key" : "EN_Btu"
            }, {
            "description" : "Energy: Calorie (@15.5c) (cal15)",
            "key" : "EN_cal15"
            }, {
            "description" : "Energy: Horsepower (mechanical) (HP)",
            "key" : "EN_HP"
            }, {
            "description" : "Energy: Joule (absolute) (J)",
            "key" : "EN_J"
            }, {
            "description" : "Energy: Kilowatt (Kw)",
            "key" : "EN_Kw"
            }, {
            "description" : "Energy: Watt (w)",
            "key" : "EN_w"
            }, {
            "description" : "Length: Angstrom (A)",
            "key" : "LEN_A"
            }, {
            "description" : "Length: Cable (cb)",
            "key" : "LEN_cb"
            }, {
            "description" : "Length: Centimeter (cm)",
            "key" : "LEN_cm"
            }, {
            "description" : "Length: Chain (Gunter\\'s/surveyor\\'s) (chG)",
            "key" : "LEN_chG"
            }, {
            "description" : "Length: Chain (Ramden\\'s/engineer\\'s) (chR)",
            "key" : "LEN_chR"
            }, {
            "description" : "Length: Decimeter (dm)",
            "key" : "LEN_dm"
            }, {
            "description" : "Length: Dekameter (dam)",
            "key" : "LEN_dam"
            }, {
            "description" : "Length: Fathom (fm)",
            "key" : "LEN_fm"
            }, {
            "description" : "Length: Foot (ft)",
            "key" : "LEN_ft"
            }, {
            "description" : "Length: Furlong (fur)",
            "key" : "LEN_fur"
            }, {
            "description" : "Length: Hand (horse\\'s height) (hand)",
            "key" : "LEN_hand"
            }, {
            "description" : "Length: Inch (in)",
            "key" : "LEN_in"
            }, {
            "description" : "Length: Kilometer (km)",
            "key" : "LEN_km"
            }, {
            "description" : "Length: League (league)",
            "key" : "LEN_league"
            }, {
            "description" : "Length: Link (Gunter\\'s) (lnG)",
            "key" : "LEN_lnG"
            }, {
            "description" : "Length: Link (Ramden\\'s) (lnR)",
            "key" : "LEN_lnR"
            }, {
            "description" : "Length: Meter (m)",
            "key" : "LEN_m"
            }, {
            "description" : "Length: Micrometer (Micron) (u)",
            "key" : "LEN_u"
            }, {
            "description" : "Length: Mil (Milli-inch) (mil)",
            "key" : "LEN_mil"
            }, {
            "description" : "Length: Mile (nautical/sea) (nmi)",
            "key" : "LEN_nmi"
            }, {
            "description" : "Length: Mile (statute/land) (mi)",
            "key" : "LEN_mi"
            }, {
            "description" : "Length: Millimeter (mm)",
            "key" : "LEN_mm"
            }, {
            "description" : "Length: Pica (type size) (pica)",
            "key" : "LEN_pica"
            }, {
            "description" : "Length: Point (type size) (point)",
            "key" : "LEN_point"
            }, {
            "description" : "Length: Rod (rd)",
            "key" : "LEN_rd"
            }, {
            "description" : "Length: Yard (yd)",
            "key" : "LEN_yd"
            }, {
            "description" : "Liquid Volume: Barrel (US) (bbl)",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "Liquid Volume: Cubic meter (liquid) (m3)",
            "key" : "VLIQ_M3"
            }, {
            "description" : "Liquid Volume: Cup (cup)",
            "key" : "VLIQ_cup"
            }, {
            "description" : "Liquid Volume: Dram (US) (dr)",
            "key" : "VLIQ_dr"
            }, {
            "description" : "Liquid Volume: Gallon (UK) (gal)",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "Liquid Volume: Gallon (US) (gal)",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "Liquid Volume: Gill (1/4 UK pint) (gi)",
            "key" : "VLIQ_gi"
            }, {
            "description" : "Liquid Volume: Hectoliter (hL)",
            "key" : "VLIQ_HL"
            }, {
            "description" : "Liquid Volume: Liter (L)",
            "key" : "VLIQ_L"
            }, {
            "description" : "Liquid Volume: Milliliter (ml)",
            "key" : "VLIQ_ml"
            }, {
            "description" : "Liquid Volume: Ounce, fluid (UK) (fl. oz (UK))",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "Liquid Volume: Ounce, fluid (US) (fl. oz (US))",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "Liquid Volume: Pint (UK) (pt (UK))",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "Liquid Volume: Pint (US) (pt (US))",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "Liquid Volume: Quart (qt)",
            "key" : "VLIQ_qt"
            }, {
            "description" : "Liquid Volume: Tablespoon (Tbs)",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "Liquid Volume: Teaspoon (tsp)",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "Other: Amphere - Electric current (A)",
            "key" : "OTH_A"
            }, {
            "description" : "Other: Box (bx)",
            "key" : "OTH_box"
            }, {
            "description" : "Other: Candela - Luminosity (intensity of light) (cd)",
            "key" : "OTH_cd"
            }, {
            "description" : "Other: Each (ea)",
            "key" : "OTH_ea"
            }, {
            "description" : "Other: Mole - Substance (molecule) (mol)",
            "key" : "OTH_mol"
            }, {
            "description" : "Other: Package (pk)",
            "key" : "OTH_pk"
            }, {
            "description" : "Other: Per Person (pp)",
            "key" : "OTH_pp"
            }, {
            "description" : "Temperature: Degrees Celsius (C)",
            "key" : "TEMP_C"
            }, {
            "description" : "Temperature: Degrees Fahrenheit (F)",
            "key" : "TEMP_F"
            }, {
            "description" : "Temperature: Kelvin (K)",
            "key" : "TEMP_K"
            }, {
            "description" : "Time/Frequency: Time in Centuries (century)",
            "key" : "TF_century"
            }, {
            "description" : "Time/Frequency: Time in Days (day)",
            "key" : "TF_day"
            }, {
            "description" : "Time/Frequency: Time in Decades (decade)",
            "key" : "TF_decade"
            }, {
            "description" : "Time/Frequency: Time in Hours (hr)",
            "key" : "TF_hr"
            }, {
            "description" : "Time/Frequency: Time in Millenia (millenium)",
            "key" : "TF_millenium"
            }, {
            "description" : "Time/Frequency: Time in Milli-Seconds (ms)",
            "key" : "TF_ms"
            }, {
            "description" : "Time/Frequency: Time in Minutes (min)",
            "key" : "TF_min"
            }, {
            "description" : "Time/Frequency: Time in Months (mon)",
            "key" : "TF_mon"
            }, {
            "description" : "Time/Frequency: Time in Scores (score)",
            "key" : "TF_score"
            }, {
            "description" : "Time/Frequency: Time in Seconds (s)",
            "key" : "TF_s"
            }, {
            "description" : "Time/Frequency: Time in Weeks (wk)",
            "key" : "TF_wk"
            }, {
            "description" : "Time/Frequency: Time in Years (yr)",
            "key" : "TF_yr"
            }, {
            "description" : "Weight: Dram (avdp) (dr avdp)",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Weight: Grain (gr)",
            "key" : "WT_gr"
            }, {
            "description" : "Weight: Gram (g)",
            "key" : "WT_g"
            }, {
            "description" : "Weight: Kilogram (kg)",
            "key" : "WT_kg"
            }, {
            "description" : "Weight: Milligram (mg)",
            "key" : "WT_mg"
            }, {
            "description" : "Weight: Ounce (avdp) (oz)",
            "key" : "WT_oz"
            }, {
            "description" : "Weight: Ounce (troy) (oz tr)",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Weight: Pennyweight (dwt)",
            "key" : "WT_dwt"
            }, {
            "description" : "Weight: Pound (avdp) (lbs)",
            "key" : "WT_lb"
            }, {
            "description" : "Weight: Stone (st)",
            "key" : "WT_st"
            }, {
            "description" : "Weight: Ton (long or British) (lt)",
            "key" : "WT_lt"
            }, {
            "description" : "Weight: Ton (metric) (mt)",
            "key" : "WT_mt"
            }, {
            "description" : "Weight: Ton (short) (sh t)",
            "key" : "WT_sh_t"
            } ],
            "disabled" : "false",
            "id" : "AddProductPrice_termUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "termUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Custom Price Calc Service",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductPriceRest",
            "options" : [ ],
            "disabled" : "false",
            "id" : "AddProductPrice_customPriceCalcService",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "customPriceCalcService",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Tax Percentage",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "taxPercentage",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductPrice_taxPercentage",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductPriceRest",
            "id" : "AddProductPrice_taxAuthPartyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "taxAuthPartyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "taxAuthPartyId",
            "style" : "",
            "id" : "AddProductPrice_taxAuthPartyId",
            "title" : "Tax Authority Party",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductPriceRest",
            "id" : "AddProductPrice_taxAuthGeoId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupGeo",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "taxAuthGeoId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "taxAuthGeoId",
            "style" : "",
            "id" : "AddProductPrice_taxAuthGeoId",
            "title" : "Tax Auth Geo ID",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Tax In Price",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductPriceRest",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "AddProductPrice_taxInPrice",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "first-in-list",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "taxInPrice",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductPriceRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductPrice_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductPrice"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productContentTypeId", "fromDate", "thruDate", "purchaseFromDate", "purchaseThruDate", "useCountLimit", "useTime", "useTimeUomId", "useRoleTypeId", "sequenceNum", "editContent", "removeContent", "submitButton" ]
        } ],
        "columns" : [ {
            "name" : "editProductContentInfo",
            "title" : "Content"
        }, {
            "name" : "productContentTypeId",
            "title" : "Type"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "purchaseFromDate",
            "title" : "Purchase From Date"
        }, {
            "name" : "purchaseThruDate",
            "title" : "Purchase Through Date"
        }, {
            "name" : "useCountLimit",
            "title" : "Use Count Limit"
        }, {
            "name" : "useTime",
            "title" : "Use Time"
        }, {
            "name" : "useTimeUomId",
            "title" : "Use Time Uom ID"
        }, {
            "name" : "useRoleTypeId",
            "title" : "Use Role Type ID"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "editContent",
            "title" : "Edit Content"
        }, {
            "name" : "removeContent",
            "title" : " "
        }, {
            "name" : "submitButton",
            "title" : "Update"
        } ],
        "formName" : "ListProductContentInfosRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Content",
            "type" : "HYPERLINK",
            "name" : "editProductContentInfo",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "contentId"
            }, {
            "name" : "productContentTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "style" : "",
            "id" : "ListProductContentInfosRest_editProductContentInfo",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
              "formName":"EditProductContent",
              "formLocation":"component://kwikstore/widget/ProductForms.xml",
            },
            "event" : "edit"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productContentTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListProductContentInfosRest_productContentTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductContentInfosRest_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-22%2007:35:29.393",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListProductContentInfosRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListProductContentInfosRest_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Purchase From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-22%2007:35:29.393",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListProductContentInfosRest",
            "timeDropdownParamName" : "purchaseFromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListProductContentInfosRest_purchaseFromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "purchaseFromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Purchase Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-22%2007:35:29.394",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListProductContentInfosRest",
            "timeDropdownParamName" : "purchaseThruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListProductContentInfosRest_purchaseThruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "purchaseThruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Use Count Limit",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "useCountLimit",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductContentInfosRest_useCountLimit",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Use Time",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "useTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductContentInfosRest_useTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Use Time Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductContentInfosRest",
            "options" : [ {
            "description" : "Time in Milli-Seconds",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Seconds",
            "key" : "TF_s"
            }, {
            "description" : "Time in Minutes",
            "key" : "TF_min"
            }, {
            "description" : "Time in Hours",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Days",
            "key" : "TF_day"
            }, {
            "description" : "Time in Weeks",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Months",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Years",
            "key" : "TF_yr"
            }, {
            "description" : "Time in Decades",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Scores",
            "key" : "TF_score"
            }, {
            "description" : "Time in Centuries",
            "key" : "TF_century"
            }, {
            "description" : "Time in Millenia",
            "key" : "TF_millenium"
            } ],
            "disabled" : "false",
            "id" : "ListProductContentInfosRest_useTimeUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "useTimeUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Use Role Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductContentInfosRest",
            "options" : [ {
            "description" : "Bill-To Customer",
            "key" : "BILL_TO_CUSTOMER"
            }, {
            "description" : "Bulk Customer",
            "key" : "BULK_CUSTOMER"
            }, {
            "description" : "End-User Customer",
            "key" : "END_USER_CUSTOMER"
            }, {
            "description" : "Placing Customer",
            "key" : "PLACING_CUSTOMER"
            }, {
            "description" : "Ship-To Customer",
            "key" : "SHIP_TO_CUSTOMER"
            } ],
            "disabled" : "false",
            "id" : "ListProductContentInfosRest_useRoleTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "useRoleTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductContentInfosRest_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Edit Content",
            "type" : "HYPERLINK",
            "name" : "editContent",
            "width" : "",
            "parameterList" : [ {
            "name" : "contentId"
            } ],
            "style" : "",
            "id" : "ListProductContentInfosRest_editContent",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "EditContent",
            "formData":{
              "formName":"EditContent",
              "formLocation":"component://kwikstore/widget/ProductForms.xml",
            },
            "event":"edit"
        }, {
            "image" : "",
            "width" : "",
            "name" : "removeContent",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "contentId"
            }, {
            "name" : "productContentTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "ListProductContentInfosRest_removeContent",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "removeContentFromProduct"
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListProductContentInfosRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ListProductContentInfosRest_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateContentToProduct"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productContentTypeId", "submitButton" ]
        } ],
        "formName" : "PrepareAddProductContentAssocRest",
        "altTarget" : [ ],
        "targets": {
            "createTarget":"prepareAddContentToProduct"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "PrepareAddProductContentAssoc_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Content Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "PrepareAddProductContentAssocRest",
            "options" : [ {
            "description" : "Add To Cart Image",
            "key" : "ADDTOCART_IMAGE"
            }, {
            "description" : "Add To Cart Label",
            "key" : "ADDTOCART_LABEL"
            }, {
            "description" : "Alternative URL",
            "key" : "ALTERNATIVE_URL"
            }, {
            "description" : "Defaut Image",
            "key" : "DEFAULT_IMAGE"
            }, {
            "description" : "Delivery Info",
            "key" : "DELIVERY_INFO"
            }, {
            "description" : "Description",
            "key" : "DESCRIPTION"
            }, {
            "description" : "Description - Long",
            "key" : "LONG_DESCRIPTION"
            }, {
            "description" : "Detail Page for eBay Auctions",
            "key" : "EBAY_DESCRIPTION"
            }, {
            "description" : "Digital Download",
            "key" : "DIGITAL_DOWNLOAD"
            }, {
            "description" : "Directions",
            "key" : "DIRECTIONS"
            }, {
            "description" : "Elevator Pitch",
            "key" : "SHORT_SALES_PITCH"
            }, {
            "description" : "Fulfillment Email",
            "key" : "FULFILLMENT_EMAIL"
            }, {
            "description" : "Fulfillment External (Async)",
            "key" : "FULFILLMENT_EXTASYNC"
            }, {
            "description" : "Fulfillment External (Sync)",
            "key" : "FULFILLMENT_EXTSYNC"
            }, {
            "description" : "Image",
            "key" : "IMAGE"
            }, {
            "description" : "Image - Additional View 1",
            "key" : "ADDITIONAL_IMAGE_1"
            }, {
            "description" : "Image - Additional View 1 Detail",
            "key" : "XTRA_IMG_1_DETAIL"
            }, {
            "description" : "Image - Additional View 1 Large",
            "key" : "XTRA_IMG_1_LARGE"
            }, {
            "description" : "Image - Additional View 1 Medium",
            "key" : "XTRA_IMG_1_MEDIUM"
            }, {
            "description" : "Image - Additional View 1 Small",
            "key" : "XTRA_IMG_1_SMALL"
            }, {
            "description" : "Image - Additional View 2",
            "key" : "ADDITIONAL_IMAGE_2"
            }, {
            "description" : "Image - Additional View 2 Detail",
            "key" : "XTRA_IMG_2_DETAIL"
            }, {
            "description" : "Image - Additional View 2 Large",
            "key" : "XTRA_IMG_2_LARGE"
            }, {
            "description" : "Image - Additional View 2 Medium",
            "key" : "XTRA_IMG_2_MEDIUM"
            }, {
            "description" : "Image - Additional View 2 Small",
            "key" : "XTRA_IMG_2_SMALL"
            }, {
            "description" : "Image - Additional View 3",
            "key" : "ADDITIONAL_IMAGE_3"
            }, {
            "description" : "Image - Additional View 3 Detail",
            "key" : "XTRA_IMG_3_DETAIL"
            }, {
            "description" : "Image - Additional View 3 Large",
            "key" : "XTRA_IMG_3_LARGE"
            }, {
            "description" : "Image - Additional View 3 Medium",
            "key" : "XTRA_IMG_3_MEDIUM"
            }, {
            "description" : "Image - Additional View 3 Small",
            "key" : "XTRA_IMG_3_SMALL"
            }, {
            "description" : "Image - Additional View 4",
            "key" : "ADDITIONAL_IMAGE_4"
            }, {
            "description" : "Image - Additional View 4 Detail",
            "key" : "XTRA_IMG_4_DETAIL"
            }, {
            "description" : "Image - Additional View 4 Large",
            "key" : "XTRA_IMG_4_LARGE"
            }, {
            "description" : "Image - Additional View 4 Medium",
            "key" : "XTRA_IMG_4_MEDIUM"
            }, {
            "description" : "Image - Additional View 4 Small",
            "key" : "XTRA_IMG_4_SMALL"
            }, {
            "description" : "Image - Additional View Detail",
            "key" : "XTRA_IMG_L_DETAIL"
            }, {
            "description" : "Image - Additional View Large",
            "key" : "XTRA_IMG_L_LARGE"
            }, {
            "description" : "Image - Additional View Medium",
            "key" : "XTRA_IMG_L_MEDIUM"
            }, {
            "description" : "Image - Additional View Small",
            "key" : "XTRA_IMG_L_SMALL"
            }, {
            "description" : "Image - Detail",
            "key" : "DETAIL_IMAGE_URL"
            }, {
            "description" : "Image - Large",
            "key" : "LARGE_IMAGE_URL"
            }, {
            "description" : "Image - Medium",
            "key" : "MEDIUM_IMAGE_URL"
            }, {
            "description" : "Image - Original",
            "key" : "ORIGINAL_IMAGE_URL"
            }, {
            "description" : "Image - Small",
            "key" : "SMALL_IMAGE_URL"
            }, {
            "description" : "Image Alt Text - Detail",
            "key" : "DETAIL_IMAGE_ALT"
            }, {
            "description" : "Image Alt Text - Large",
            "key" : "LARGE_IMAGE_ALT"
            }, {
            "description" : "Image Alt Text - Medium",
            "key" : "MEDIUM_IMAGE_ALT"
            }, {
            "description" : "Image Alt Text - Small",
            "key" : "SMALL_IMAGE_ALT"
            }, {
            "description" : "Ingredients",
            "key" : "INGREDIENTS"
            }, {
            "description" : "Installation",
            "key" : "INSTALLATION"
            }, {
            "description" : "Meta Description",
            "key" : "META_DESCRIPTION"
            }, {
            "description" : "Meta Keywords",
            "key" : "META_KEYWORD"
            }, {
            "description" : "Online Access",
            "key" : "ONLINE_ACCESS"
            }, {
            "description" : "Page Title",
            "key" : "PAGE_TITLE"
            }, {
            "description" : "Price Detail Text",
            "key" : "PRICE_DETAIL_TEXT"
            }, {
            "description" : "Product Name",
            "key" : "PRODUCT_NAME"
            }, {
            "description" : "Special Instructions",
            "key" : "SPECIALINSTRUCTIONS"
            }, {
            "description" : "Specification",
            "key" : "SPECIFICATION"
            }, {
            "description" : "Terms and Conditions",
            "key" : "TERMS_AND_CONDS"
            }, {
            "description" : "Unique Ingredients",
            "key" : "UNIQUE_INGREDIENTS"
            }, {
            "description" : "Warnings",
            "key" : "WARNINGS"
            }, {
            "description" : "Warranty",
            "key" : "WARRANTY"
            } ],
            "disabled" : "false",
            "id" : "PrepareAddProductContentAssoc_productContentTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productContentTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "PrepareAddProductContentAssocRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "PrepareAddProductContentAssoc_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Prepare Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "prepareAddContentToProduct"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "contentId", "productContentTypeId", "fromDate", "thruDate", "purchaseFromDate", "purchaseThruDate", "useCountLimit", "useTime", "useTimeUomId", "useRoleTypeId", "sequenceNum", "submitButton" ]
        } ],
        "formName" : "AddProductContentAssocRest",
        "targets":{
            "createTarget":"addContentToProduct"
        },
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductContentAssoc_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductContentAssocRest",
            "id" : "AddProductContentAssoc_contentId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupContent",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "contentId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "contentId",
            "style" : "",
            "id" : "AddProductContentAssoc_contentId",
            "title" : "Content ID",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Content Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductContentAssocRest",
            "options" : [ {
            "description" : "Add To Cart Image",
            "key" : "ADDTOCART_IMAGE"
            }, {
            "description" : "Add To Cart Label",
            "key" : "ADDTOCART_LABEL"
            }, {
            "description" : "Alternative URL",
            "key" : "ALTERNATIVE_URL"
            }, {
            "description" : "Defaut Image",
            "key" : "DEFAULT_IMAGE"
            }, {
            "description" : "Delivery Info",
            "key" : "DELIVERY_INFO"
            }, {
            "description" : "Description",
            "key" : "DESCRIPTION"
            }, {
            "description" : "Description - Long",
            "key" : "LONG_DESCRIPTION"
            }, {
            "description" : "Detail Page for eBay Auctions",
            "key" : "EBAY_DESCRIPTION"
            }, {
            "description" : "Digital Download",
            "key" : "DIGITAL_DOWNLOAD"
            }, {
            "description" : "Directions",
            "key" : "DIRECTIONS"
            }, {
            "description" : "Elevator Pitch",
            "key" : "SHORT_SALES_PITCH"
            }, {
            "description" : "Fulfillment Email",
            "key" : "FULFILLMENT_EMAIL"
            }, {
            "description" : "Fulfillment External (Async)",
            "key" : "FULFILLMENT_EXTASYNC"
            }, {
            "description" : "Fulfillment External (Sync)",
            "key" : "FULFILLMENT_EXTSYNC"
            }, {
            "description" : "Image",
            "key" : "IMAGE"
            }, {
            "description" : "Image - Additional View 1",
            "key" : "ADDITIONAL_IMAGE_1"
            }, {
            "description" : "Image - Additional View 1 Detail",
            "key" : "XTRA_IMG_1_DETAIL"
            }, {
            "description" : "Image - Additional View 1 Large",
            "key" : "XTRA_IMG_1_LARGE"
            }, {
            "description" : "Image - Additional View 1 Medium",
            "key" : "XTRA_IMG_1_MEDIUM"
            }, {
            "description" : "Image - Additional View 1 Small",
            "key" : "XTRA_IMG_1_SMALL"
            }, {
            "description" : "Image - Additional View 2",
            "key" : "ADDITIONAL_IMAGE_2"
            }, {
            "description" : "Image - Additional View 2 Detail",
            "key" : "XTRA_IMG_2_DETAIL"
            }, {
            "description" : "Image - Additional View 2 Large",
            "key" : "XTRA_IMG_2_LARGE"
            }, {
            "description" : "Image - Additional View 2 Medium",
            "key" : "XTRA_IMG_2_MEDIUM"
            }, {
            "description" : "Image - Additional View 2 Small",
            "key" : "XTRA_IMG_2_SMALL"
            }, {
            "description" : "Image - Additional View 3",
            "key" : "ADDITIONAL_IMAGE_3"
            }, {
            "description" : "Image - Additional View 3 Detail",
            "key" : "XTRA_IMG_3_DETAIL"
            }, {
            "description" : "Image - Additional View 3 Large",
            "key" : "XTRA_IMG_3_LARGE"
            }, {
            "description" : "Image - Additional View 3 Medium",
            "key" : "XTRA_IMG_3_MEDIUM"
            }, {
            "description" : "Image - Additional View 3 Small",
            "key" : "XTRA_IMG_3_SMALL"
            }, {
            "description" : "Image - Additional View 4",
            "key" : "ADDITIONAL_IMAGE_4"
            }, {
            "description" : "Image - Additional View 4 Detail",
            "key" : "XTRA_IMG_4_DETAIL"
            }, {
            "description" : "Image - Additional View 4 Large",
            "key" : "XTRA_IMG_4_LARGE"
            }, {
            "description" : "Image - Additional View 4 Medium",
            "key" : "XTRA_IMG_4_MEDIUM"
            }, {
            "description" : "Image - Additional View 4 Small",
            "key" : "XTRA_IMG_4_SMALL"
            }, {
            "description" : "Image - Additional View Detail",
            "key" : "XTRA_IMG_L_DETAIL"
            }, {
            "description" : "Image - Additional View Large",
            "key" : "XTRA_IMG_L_LARGE"
            }, {
            "description" : "Image - Additional View Medium",
            "key" : "XTRA_IMG_L_MEDIUM"
            }, {
            "description" : "Image - Additional View Small",
            "key" : "XTRA_IMG_L_SMALL"
            }, {
            "description" : "Image - Detail",
            "key" : "DETAIL_IMAGE_URL"
            }, {
            "description" : "Image - Large",
            "key" : "LARGE_IMAGE_URL"
            }, {
            "description" : "Image - Medium",
            "key" : "MEDIUM_IMAGE_URL"
            }, {
            "description" : "Image - Original",
            "key" : "ORIGINAL_IMAGE_URL"
            }, {
            "description" : "Image - Small",
            "key" : "SMALL_IMAGE_URL"
            }, {
            "description" : "Image Alt Text - Detail",
            "key" : "DETAIL_IMAGE_ALT"
            }, {
            "description" : "Image Alt Text - Large",
            "key" : "LARGE_IMAGE_ALT"
            }, {
            "description" : "Image Alt Text - Medium",
            "key" : "MEDIUM_IMAGE_ALT"
            }, {
            "description" : "Image Alt Text - Small",
            "key" : "SMALL_IMAGE_ALT"
            }, {
            "description" : "Ingredients",
            "key" : "INGREDIENTS"
            }, {
            "description" : "Installation",
            "key" : "INSTALLATION"
            }, {
            "description" : "Meta Description",
            "key" : "META_DESCRIPTION"
            }, {
            "description" : "Meta Keywords",
            "key" : "META_KEYWORD"
            }, {
            "description" : "Online Access",
            "key" : "ONLINE_ACCESS"
            }, {
            "description" : "Page Title",
            "key" : "PAGE_TITLE"
            }, {
            "description" : "Price Detail Text",
            "key" : "PRICE_DETAIL_TEXT"
            }, {
            "description" : "Product Name",
            "key" : "PRODUCT_NAME"
            }, {
            "description" : "Special Instructions",
            "key" : "SPECIALINSTRUCTIONS"
            }, {
            "description" : "Specification",
            "key" : "SPECIFICATION"
            }, {
            "description" : "Terms and Conditions",
            "key" : "TERMS_AND_CONDS"
            }, {
            "description" : "Unique Ingredients",
            "key" : "UNIQUE_INGREDIENTS"
            }, {
            "description" : "Warnings",
            "key" : "WARNINGS"
            }, {
            "description" : "Warranty",
            "key" : "WARRANTY"
            } ],
            "disabled" : "false",
            "id" : "AddProductContentAssoc_productContentTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productContentTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "required",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductContentAssocRest",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductContentAssoc_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-16%2011:37:21.618",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductContentAssocRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductContentAssoc_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Purchase From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-16%2011:37:21.618",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductContentAssocRest",
            "timeDropdownParamName" : "purchaseFromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductContentAssoc_purchaseFromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "purchaseFromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Purchase Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-16%2011:37:21.618",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductContentAssocRest",
            "timeDropdownParamName" : "purchaseThruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductContentAssoc_purchaseThruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "purchaseThruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Use Count Limit",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "useCountLimit",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductContentAssoc_useCountLimit",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Use Time",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "useTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductContentAssoc_useTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Use Time Uom",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductContentAssocRest",
            "options" : [ {
            "description" : "Time in Centuries",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years",
            "key" : "TF_yr"
            } ],
            "disabled" : "false",
            "id" : "AddProductContentAssoc_useTimeUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "useTimeUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Use Role",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductContentAssocRest",
            "options" : [ {
            "description" : "Account",
            "key" : "ACCOUNT"
            }, {
            "description" : "Account Lead",
            "key" : "ACCOUNT_LEAD"
            }, {
            "description" : "Accountant",
            "key" : "ACCOUNTANT"
            }, {
            "description" : "Addressee",
            "key" : "ADDRESSEE"
            }, {
            "description" : "Administrator",
            "key" : "ADMIN"
            }, {
            "description" : "Affiliate",
            "key" : "AFFILIATE"
            }, {
            "description" : "Agent",
            "key" : "AGENT"
            }, {
            "description" : "Approver",
            "key" : "APPROVER"
            }, {
            "description" : "Association",
            "key" : "ASSOCIATION"
            }, {
            "description" : "Automated Agent",
            "key" : "AUTOMATED_AGENT_ROLE"
            }, {
            "description" : "Bill-From-Vendor",
            "key" : "BILL_FROM_VENDOR"
            }, {
            "description" : "Bill-To Customer",
            "key" : "BILL_TO_CUSTOMER"
            }, {
            "description" : "Blind Copy",
            "key" : "BCC"
            }, {
            "description" : "Budget Application",
            "key" : "BUDGET_APPL"
            }, {
            "description" : "Budget Approver",
            "key" : "BUDGET_APPRV"
            }, {
            "description" : "Budget Manager",
            "key" : "BUDGET_MGR"
            }, {
            "description" : "Budget Reviewer",
            "key" : "BUDGET_RVR"
            }, {
            "description" : "Budget Roles Group (not to be assigned to parties)",
            "key" : "BUDGET"
            }, {
            "description" : "Bulk Customer",
            "key" : "BULK_CUSTOMER"
            }, {
            "description" : "Buyer",
            "key" : "BUYER"
            }, {
            "description" : "Calendar",
            "key" : "CALENDAR_ROLE"
            }, {
            "description" : "Calendar Attendee",
            "key" : "CAL_ATTENDEE"
            }, {
            "description" : "Calendar Delegate",
            "key" : "CAL_DELEGATE"
            }, {
            "description" : "Calendar Host",
            "key" : "CAL_HOST"
            }, {
            "description" : "Calendar Member",
            "key" : "ICAL_MEMBER"
            }, {
            "description" : "Calendar Organizer",
            "key" : "CAL_ORGANIZER"
            }, {
            "description" : "Calendar Owner",
            "key" : "CAL_OWNER"
            }, {
            "description" : "Carbon Copy",
            "key" : "CC"
            }, {
            "description" : "Carrier",
            "key" : "CARRIER"
            }, {
            "description" : "Cashier",
            "key" : "CASHIER"
            }, {
            "description" : "Client",
            "key" : "CLIENT"
            }, {
            "description" : "Client Analyst",
            "key" : "CLIENT_ANALYST"
            }, {
            "description" : "Client Billing",
            "key" : "CLIENT_BILLING"
            }, {
            "description" : "Client Manager",
            "key" : "CLIENT_MANAGER"
            }, {
            "description" : "Communication Participant",
            "key" : "COMMEVENT_ROLE"
            }, {
            "description" : "Competitor",
            "key" : "COMPETITOR"
            }, {
            "description" : "Consumer",
            "key" : "CONSUMER"
            }, {
            "description" : "Contact",
            "key" : "CONTACT"
            }, {
            "description" : "Content Administrator",
            "key" : "CONTENT_ADMIN"
            }, {
            "description" : "Content Author",
            "key" : "CONTENT_AUTHOR"
            }, {
            "description" : "Content Editor",
            "key" : "CONTENT_EDITOR"
            }, {
            "description" : "Content Guest",
            "key" : "CONTENT_GUEST"
            }, {
            "description" : "Content Member",
            "key" : "CONTENT"
            }, {
            "description" : "Content Publisher",
            "key" : "CONTENT_PUBLISHER"
            }, {
            "description" : "Content User",
            "key" : "CONTENT_USER"
            }, {
            "description" : "Contractor",
            "key" : "CONTRACTOR"
            }, {
            "description" : "Customer",
            "key" : "CUSTOMER"
            }, {
            "description" : "Department",
            "key" : "DEPARTMENT"
            }, {
            "description" : "Distribution Channel",
            "key" : "DISTRIBUTION_CHANNEL"
            }, {
            "description" : "Distributor",
            "key" : "DISTRIBUTOR"
            }, {
            "description" : "Division",
            "key" : "DIVISION"
            }, {
            "description" : "Email Administrator",
            "key" : "EMAIL_ADMIN"
            }, {
            "description" : "Employee",
            "key" : "EMPLOYEE"
            }, {
            "description" : "Employer",
            "key" : "EMPLOYER"
            }, {
            "description" : "End-User Customer",
            "key" : "END_USER_CUSTOMER"
            }, {
            "description" : "Family Member",
            "key" : "FAMILY_MEMBER"
            }, {
            "description" : "Fixed Asset Maint Assignee",
            "key" : "FAM_ASSIGNEE"
            }, {
            "description" : "Government Agency",
            "key" : "GOV_AGENCY"
            }, {
            "description" : "Hosting Server",
            "key" : "HOSTING_SERVER"
            }, {
            "description" : "Household",
            "key" : "HOUSEHOLD"
            }, {
            "description" : "ISP",
            "key" : "ISP"
            }, {
            "description" : "Image Approver",
            "key" : "IMAGEAPPROVER"
            }, {
            "description" : "Internal Organization",
            "key" : "INTERNAL_ORGANIZATIO"
            }, {
            "description" : "Lead",
            "key" : "LEAD"
            }, {
            "description" : "Limited Administrator",
            "key" : "LTD_ADMIN"
            }, {
            "description" : "Logged In",
            "key" : "LOGGEDIN"
            }, {
            "description" : "Main Role",
            "key" : "MAIN_ROLE"
            }, {
            "description" : "Maintenance Manager or Supervisor",
            "key" : "FAM_MANAGER"
            }, {
            "description" : "Maintenance Supplier or Service",
            "key" : "FAM_SUPPLIER"
            }, {
            "description" : "Maintenance Worker",
            "key" : "FAM_WORKER"
            }, {
            "description" : "Manager",
            "key" : "MANAGER"
            }, {
            "description" : "Manufacturer",
            "key" : "MANUFACTURER"
            }, {
            "description" : "Not Applicable",
            "key" : "_NA_"
            }, {
            "description" : "Order Clerk",
            "key" : "ORDER_CLERK"
            }, {
            "description" : "Organization",
            "key" : "ORGANIZATION_ROLE"
            }, {
            "description" : "Organization Unit",
            "key" : "ORGANIZATION_UNIT"
            }, {
            "description" : "Originator",
            "key" : "ORIGINATOR"
            }, {
            "description" : "Other Internal",
            "key" : "OTHER_INTERNAL_ORGAN"
            }, {
            "description" : "Other Organization Unit",
            "key" : "OTHER_ORGANIZATION_U"
            }, {
            "description" : "Owner",
            "key" : "OWNER"
            }, {
            "description" : "Packer",
            "key" : "PACKER"
            }, {
            "description" : "Parent Organization",
            "key" : "PARENT_ORGANIZATION"
            }, {
            "description" : "Partner",
            "key" : "PARTNER"
            }, {
            "description" : "Person",
            "key" : "PERSON_ROLE"
            }, {
            "description" : "Picker",
            "key" : "PICKER"
            }, {
            "description" : "Placing Customer",
            "key" : "PLACING_CUSTOMER"
            }, {
            "description" : "Product Owner",
            "key" : "PRODUCT_OWNER"
            }, {
            "description" : "Product Owner Company",
            "key" : "PRODUCT_OWNER_COMP"
            }, {
            "description" : "Project Team",
            "key" : "PROJECT_TEAM"
            }, {
            "description" : "Prospect",
            "key" : "PROSPECT"
            }, {
            "description" : "Provider Accounting",
            "key" : "PROVIDER_ACCOUNTING"
            }, {
            "description" : "Provider Analyst",
            "key" : "PROVIDER_ANALYST"
            }, {
            "description" : "Provider Functional",
            "key" : "PROVIDER_FUNCTIONAL"
            }, {
            "description" : "Provider Manager",
            "key" : "PROVIDER_MANAGER"
            }, {
            "description" : "Provider Tester",
            "key" : "PROVIDER_TESTER"
            }, {
            "description" : "Provider Validator",
            "key" : "PROVIDER_VALIDATOR"
            }, {
            "description" : "Receiver",
            "key" : "RECEIVER"
            }, {
            "description" : "Referrer",
            "key" : "REFERRER"
            }, {
            "description" : "Regulatory Agency",
            "key" : "REGULATORY_AGENCY"
            }, {
            "description" : "Request Manager",
            "key" : "REQ_MANAGER"
            }, {
            "description" : "Request Respondent",
            "key" : "REQ_RESPOND"
            }, {
            "description" : "Request Role",
            "key" : "REQUEST_ROLE"
            }, {
            "description" : "Request Taker",
            "key" : "REQ_TAKER"
            }, {
            "description" : "Requesting Party",
            "key" : "REQ_REQUESTER"
            }, {
            "description" : "Reviewer",
            "key" : "REVIEWER"
            }, {
            "description" : "SCRUM Master",
            "key" : "SCRUM_MASTER"
            }, {
            "description" : "SCRUM Team",
            "key" : "SCRUM_TEAM"
            }, {
            "description" : "Sales Force Autm.",
            "key" : "SFA_ROLE"
            }, {
            "description" : "Sales Representative",
            "key" : "SALES_REP"
            }, {
            "description" : "Scrum Member",
            "key" : "SCRUM_MEMBER"
            }, {
            "description" : "Shareholder",
            "key" : "SHAREHOLDER"
            }, {
            "description" : "Ship-From Vendor",
            "key" : "SHIP_FROM_VENDOR"
            }, {
            "description" : "Ship-To Customer",
            "key" : "SHIP_TO_CUSTOMER"
            }, {
            "description" : "Shipment Clerk",
            "key" : "SHIPMENT_CLERK"
            }, {
            "description" : "Sponsor",
            "key" : "SPONSOR"
            }, {
            "description" : "Spouse",
            "key" : "SPOUSE"
            }, {
            "description" : "Stakeholder",
            "key" : "STAKEHOLDER"
            }, {
            "description" : "Stocker",
            "key" : "STOCKER"
            }, {
            "description" : "Subscriber",
            "key" : "SUBSCRIBER"
            }, {
            "description" : "Subsidiary",
            "key" : "SUBSIDIARY"
            }, {
            "description" : "Supplier",
            "key" : "SUPPLIER"
            }, {
            "description" : "Supplier Agent",
            "key" : "SUPPLIER_AGENT"
            }, {
            "description" : "Tax Authority",
            "key" : "TAX_AUTHORITY"
            }, {
            "description" : "Union",
            "key" : "UNION"
            }, {
            "description" : "Vendor",
            "key" : "VENDOR"
            }, {
            "description" : "Visitor",
            "key" : "VISITOR"
            }, {
            "description" : "Web Master",
            "key" : "WEB_MASTER"
            }, {
            "description" : "Worker",
            "key" : "WORKER"
            }, {
            "description" : "Workflow",
            "key" : "WORKFLOW_ROLE"
            }, {
            "description" : "Workflow Owner",
            "key" : "WF_OWNER"
            } ],
            "disabled" : "false",
            "id" : "AddProductContentAssoc_useRoleTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "useRoleTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductContentAssoc_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductContentAssocRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductContentAssoc_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "addContentToProduct"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productName", "description", "longDescription", "detailScreen", "smallImageUrl", "mediumImageUrl", "largeImageUrl", "detailImageUrl", "originalImageUrl", "submitButton" ]
        } ],
        "formName" : "EditProductContent",
        "altTarget" : [ ],
        "targets":{
            "updateTarget":"updateProductContent"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "EditProductContent_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductContent_productName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "buttons" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "language" : "en",
            "title" : "Product Description",
            "type" : "TEXTAREA",
            "rows" : "3",
            "readonly" : "",
            "visualEditorEnable" : "",
            "alert" : "false",
            "name" : "description",
            "style" : "",
            "disabled" : "false",
            "id" : "EditProductContent_description",
            "value" : "",
            "cols" : "60"
        }, {
            "fieldHelpText" : "",
            "buttons" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "language" : "en",
            "title" : "Long Description",
            "type" : "TEXTAREA",
            "rows" : "3",
            "readonly" : "",
            "visualEditorEnable" : "",
            "alert" : "false",
            "name" : "longDescription",
            "style" : "",
            "disabled" : "false",
            "id" : "EditProductContent_longDescription",
            "value" : "",
            "cols" : "60"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Detail Screen",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "detailScreen",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductContent_detailScreen",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Small Image",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "smallImageUrl",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductContent_smallImageUrl",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Medium Image",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "mediumImageUrl",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductContent_mediumImageUrl",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Large Image",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "largeImageUrl",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductContent_largeImageUrl",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Detail Image",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "detailImageUrl",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductContent_detailImageUrl",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Original Image",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "originalImageUrl",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductContent_originalImageUrl",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditProductContent",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditProductContent_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductContent"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "originalImage", "additionalImageOne", "additionalImageTwo", "additionalImageThree", "additionalImageFour", "submitButton" ]
        } ],
        "formName" : "AddAdditionalImages",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"addAdditionalImagesForProduct"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddAdditionalImages_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "originalImage",
            "action" : "",
            "id" : "AddAdditionalImages_originalImage",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image One",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageOne",
            "style" : "",
            "id" : "AddAdditionalImages_additionalImageOne",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image Two",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageTwo",
            "style" : "",
            "id" : "AddAdditionalImages_additionalImageTwo",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image Three",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageThree",
            "style" : "",
            "id" : "AddAdditionalImages_additionalImageThree",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image Four",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageFour",
            "style" : "",
            "id" : "AddAdditionalImages_additionalImageFour",
            "value" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddAdditionalImages",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddAdditionalImages_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Upload",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "addAdditionalImagesForProduct"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "fname", "upload_file_type", "submitButton" ]
        } ],
        "formName" : "ProductUploadImage",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"UploadProductImage"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ProductUploadImage_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Fname",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "fname",
            "style" : "",
            "id" : "ProductUploadImage_fname",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "upload_file_type",
            "style" : "",
            "id" : "ProductUploadImage_upload_file_type",
            "title" : "Upload_file_type",
            "type" : "RADIO"
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ProductUploadImage",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ProductUploadImage_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Upload",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "UploadProductImage"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "geoId", "productGeoEnumId", "description", "deleteLink", "submitButton" ]
        } ],
        "columns" : [ {
            "name" : "geoId",
            "title" : "Geo ID"
        }, {
            "name" : "productGeoEnumId",
            "title" : "Product Geo Enum ID"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "deleteLink",
            "title" : " "
        }, {
            "name" : "submitButton",
            "title" : "Update"
        } ],
        "formName" : "ListProductGeosRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductGeos_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "geoId",
            "description" : "",
            "style" : "",
            "id" : "ListProductGeos_geoId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Geo Enum ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductGeosRest",
            "options" : [ {
            "description" : "Purchase Include Geo",
            "key" : "PG_PURCH_INCLUDE"
            }, {
            "description" : "Purchase Exclude Geo",
            "key" : "PG_PURCH_EXCLUDE"
            }, {
            "description" : "Shipment Include Geo",
            "key" : "PG_SHIP_INCLUDE"
            }, {
            "description" : "Shipment Exclude Geo",
            "key" : "PG_SHIP_EXCLUDE"
            } ],
            "disabled" : "false",
            "id" : "ListProductGeos_productGeoEnumId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productGeoEnumId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductGeos_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "geoId"
            } ],
            "id" : "ListProductGeos_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListProductGeosRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "ListProductGeos_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductGeo"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "geoId", "productGeoEnumId", "description", "submitButton" ]
        } ],
        "formName" : "AddProductGeoRest",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"createProductGeo"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductGeo_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Geo ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductGeoRest",
            "options" : [ {
            "description" : "Afghanistan",
            "key" : "AFG"
            }, {
            "description" : "Albania",
            "key" : "ALB"
            }, {
            "description" : "Algeria",
            "key" : "DZA"
            }, {
            "description" : "American Samoa",
            "key" : "ASM"
            }, {
            "description" : "Andorra",
            "key" : "AND"
            }, {
            "description" : "Angola",
            "key" : "AGO"
            }, {
            "description" : "Anguilla",
            "key" : "AIA"
            }, {
            "description" : "Antarctica",
            "key" : "ATA"
            }, {
            "description" : "Antigua And Barbuda",
            "key" : "ATG"
            }, {
            "description" : "Argentina",
            "key" : "ARG"
            }, {
            "description" : "Armenia",
            "key" : "ARM"
            }, {
            "description" : "Aruba",
            "key" : "ABW"
            }, {
            "description" : "Australia",
            "key" : "AUS"
            }, {
            "description" : "Austria",
            "key" : "AUT"
            }, {
            "description" : "Azerbaijan",
            "key" : "AZE"
            }, {
            "description" : "Bahamas",
            "key" : "BHS"
            }, {
            "description" : "Bahrain",
            "key" : "BHR"
            }, {
            "description" : "Bangladesh",
            "key" : "BGD"
            }, {
            "description" : "Barbados",
            "key" : "BRB"
            }, {
            "description" : "Belarus",
            "key" : "BLR"
            }, {
            "description" : "Belgium",
            "key" : "BEL"
            }, {
            "description" : "Belize",
            "key" : "BLZ"
            }, {
            "description" : "Benin",
            "key" : "BEN"
            }, {
            "description" : "Bermuda",
            "key" : "BMU"
            }, {
            "description" : "Bhutan",
            "key" : "BTN"
            }, {
            "description" : "Bolivia",
            "key" : "BOL"
            }, {
            "description" : "Bonaire, Sint Eustatius and Saba",
            "key" : "BES"
            }, {
            "description" : "Bosnia And Herzegowina",
            "key" : "BIH"
            }, {
            "description" : "Botswana ",
            "key" : "BWA"
            }, {
            "description" : "Bouvet Island",
            "key" : "BVT"
            }, {
            "description" : "Brazil",
            "key" : "BRA"
            }, {
            "description" : "British Indian Ocean Territory",
            "key" : "IOT"
            }, {
            "description" : "Brunei Darussalam",
            "key" : "BRN"
            }, {
            "description" : "Bulgaria",
            "key" : "BGR"
            }, {
            "description" : "Burkina Faso",
            "key" : "BFA"
            }, {
            "description" : "Burundi",
            "key" : "BDI"
            }, {
            "description" : "Cambodia",
            "key" : "KHM"
            }, {
            "description" : "Cameroon",
            "key" : "CMR"
            }, {
            "description" : "Canada",
            "key" : "CAN"
            }, {
            "description" : "Cape Verde",
            "key" : "CPV"
            }, {
            "description" : "Cayman Islands",
            "key" : "CYM"
            }, {
            "description" : "Central African Republic",
            "key" : "CAF"
            }, {
            "description" : "Chad",
            "key" : "TCD"
            }, {
            "description" : "Chile",
            "key" : "CHL"
            }, {
            "description" : "China",
            "key" : "CHN"
            }, {
            "description" : "Christmas Island",
            "key" : "CXR"
            }, {
            "description" : "Cocos (keeling) Islands",
            "key" : "CCK"
            }, {
            "description" : "Colombia",
            "key" : "COL"
            }, {
            "description" : "Comoros",
            "key" : "COM"
            }, {
            "description" : "Congo",
            "key" : "COG"
            }, {
            "description" : "Congo, The Democratic Republic Of The",
            "key" : "COD"
            }, {
            "description" : "Cook Islands",
            "key" : "COK"
            }, {
            "description" : "Costa Rica",
            "key" : "CRI"
            }, {
            "description" : "Cote D\\'ivoire",
            "key" : "CIV"
            }, {
            "description" : "Croatia (local Name: Hrvatska)",
            "key" : "HRV"
            }, {
            "description" : "Cuba",
            "key" : "CUB"
            }, {
            "description" : "Curaçao",
            "key" : "CUW"
            }, {
            "description" : "Cyprus",
            "key" : "CYP"
            }, {
            "description" : "Czech Republic",
            "key" : "CZE"
            }, {
            "description" : "Denmark",
            "key" : "DNK"
            }, {
            "description" : "Djibouti",
            "key" : "DJI"
            }, {
            "description" : "Dominica",
            "key" : "DMA"
            }, {
            "description" : "Dominican Republic",
            "key" : "DOM"
            }, {
            "description" : "East Timor",
            "key" : "TLS"
            }, {
            "description" : "Ecuador",
            "key" : "ECU"
            }, {
            "description" : "Egypt",
            "key" : "EGY"
            }, {
            "description" : "El Salvador",
            "key" : "SLV"
            }, {
            "description" : "England",
            "key" : "ENGL"
            }, {
            "description" : "Equatorial Guinea",
            "key" : "GNQ"
            }, {
            "description" : "Eritrea",
            "key" : "ERI"
            }, {
            "description" : "Estonia",
            "key" : "EST"
            }, {
            "description" : "Ethiopia",
            "key" : "ETH"
            }, {
            "description" : "Falkland Islands (malvinas)",
            "key" : "FLK"
            }, {
            "description" : "Faroe Islands",
            "key" : "FRO"
            }, {
            "description" : "Fiji",
            "key" : "FJI"
            }, {
            "description" : "Finland",
            "key" : "FIN"
            }, {
            "description" : "France",
            "key" : "FRA"
            }, {
            "description" : "France, Metropolitan",
            "key" : "FXX"
            }, {
            "description" : "French Guiana",
            "key" : "GUF"
            }, {
            "description" : "French Polynesia",
            "key" : "PYF"
            }, {
            "description" : "French Southern Territories",
            "key" : "ATF"
            }, {
            "description" : "Gabon",
            "key" : "GAB"
            }, {
            "description" : "Gambia",
            "key" : "GMB"
            }, {
            "description" : "Georgia",
            "key" : "GEO"
            }, {
            "description" : "Germany",
            "key" : "DEU"
            }, {
            "description" : "Ghana",
            "key" : "GHA"
            }, {
            "description" : "Gibraltar",
            "key" : "GIB"
            }, {
            "description" : "Greece",
            "key" : "GRC"
            }, {
            "description" : "Greenland",
            "key" : "GRL"
            }, {
            "description" : "Grenada",
            "key" : "GRD"
            }, {
            "description" : "Guadeloupe",
            "key" : "GLP"
            }, {
            "description" : "Guam",
            "key" : "GUM"
            }, {
            "description" : "Guatemala",
            "key" : "GTM"
            }, {
            "description" : "Guernsey",
            "key" : "GGY"
            }, {
            "description" : "Guinea",
            "key" : "GIN"
            }, {
            "description" : "Guinea-bissau",
            "key" : "GNB"
            }, {
            "description" : "Guyana",
            "key" : "GUY"
            }, {
            "description" : "Haiti",
            "key" : "HTI"
            }, {
            "description" : "Heard And Mc Donald Islands",
            "key" : "HMD"
            }, {
            "description" : "Holy See (vatican City State)",
            "key" : "VAT"
            }, {
            "description" : "Honduras",
            "key" : "HND"
            }, {
            "description" : "Hong Kong",
            "key" : "HKG"
            }, {
            "description" : "Hungary",
            "key" : "HUN"
            }, {
            "description" : "Iceland",
            "key" : "ISL"
            }, {
            "description" : "India",
            "key" : "IND"
            }, {
            "description" : "Indonesia",
            "key" : "IDN"
            }, {
            "description" : "Iran (islamic Republic Of)",
            "key" : "IRN"
            }, {
            "description" : "Iraq",
            "key" : "IRQ"
            }, {
            "description" : "Ireland",
            "key" : "IRL"
            }, {
            "description" : "Isle of Man",
            "key" : "IMN"
            }, {
            "description" : "Israel",
            "key" : "ISR"
            }, {
            "description" : "Italy",
            "key" : "ITA"
            }, {
            "description" : "Jamaica",
            "key" : "JAM"
            }, {
            "description" : "Japan",
            "key" : "JPN"
            }, {
            "description" : "Jersey",
            "key" : "JEY"
            }, {
            "description" : "Jordan",
            "key" : "JOR"
            }, {
            "description" : "Kazakhstan",
            "key" : "KAZ"
            }, {
            "description" : "Kenya",
            "key" : "KEN"
            }, {
            "description" : "Kiribati",
            "key" : "KIR"
            }, {
            "description" : "Korea, Democratic People\\'s Republic Of",
            "key" : "PRK"
            }, {
            "description" : "Korea, Republic Of",
            "key" : "KOR"
            }, {
            "description" : "Kuwait",
            "key" : "KWT"
            }, {
            "description" : "Kyrgyzstan",
            "key" : "KGZ"
            }, {
            "description" : "Lao People\\'s Democratic Republic",
            "key" : "LAO"
            }, {
            "description" : "Latvia",
            "key" : "LVA"
            }, {
            "description" : "Lebanon",
            "key" : "LBN"
            }, {
            "description" : "Lesotho",
            "key" : "LSO"
            }, {
            "description" : "Liberia",
            "key" : "LBR"
            }, {
            "description" : "Libyan Arab Jamahiriya",
            "key" : "LBY"
            }, {
            "description" : "Liechtenstein",
            "key" : "LIE"
            }, {
            "description" : "Lithuania",
            "key" : "LTU"
            }, {
            "description" : "Luxembourg",
            "key" : "LUX"
            }, {
            "description" : "Macau",
            "key" : "MAC"
            }, {
            "description" : "Macedonia, The Former Yugoslav Republic Of",
            "key" : "MKD"
            }, {
            "description" : "Madagascar",
            "key" : "MDG"
            }, {
            "description" : "Malawi",
            "key" : "MWI"
            }, {
            "description" : "Malaysia",
            "key" : "MYS"
            }, {
            "description" : "Maldives",
            "key" : "MDV"
            }, {
            "description" : "Mali",
            "key" : "MLI"
            }, {
            "description" : "Malta",
            "key" : "MLT"
            }, {
            "description" : "Marshall Islands",
            "key" : "MHL"
            }, {
            "description" : "Martinique",
            "key" : "MTQ"
            }, {
            "description" : "Mauritania",
            "key" : "MRT"
            }, {
            "description" : "Mauritius",
            "key" : "MUS"
            }, {
            "description" : "Mayotte",
            "key" : "MYT"
            }, {
            "description" : "Mexico",
            "key" : "MEX"
            }, {
            "description" : "Micronesia, Federated States Of",
            "key" : "FSM"
            }, {
            "description" : "Moldova, Republic Of",
            "key" : "MDA"
            }, {
            "description" : "Monaco",
            "key" : "MCO"
            }, {
            "description" : "Mongolia",
            "key" : "MNG"
            }, {
            "description" : "Montenegro",
            "key" : "MNE"
            }, {
            "description" : "Montserrat",
            "key" : "MSR"
            }, {
            "description" : "Morocco",
            "key" : "MAR"
            }, {
            "description" : "Mozambique",
            "key" : "MOZ"
            }, {
            "description" : "Myanmar",
            "key" : "MMR"
            }, {
            "description" : "NIRL",
            "key" : "NIRL"
            }, {
            "description" : "Namibia",
            "key" : "NAM"
            }, {
            "description" : "Nauru",
            "key" : "NRU"
            }, {
            "description" : "Nepal",
            "key" : "NPL"
            }, {
            "description" : "Netherlands",
            "key" : "NLD"
            }, {
            "description" : "Netherlands Antilles",
            "key" : "ANT"
            }, {
            "description" : "New Caledonia",
            "key" : "NCL"
            }, {
            "description" : "New Zealand",
            "key" : "NZL"
            }, {
            "description" : "Nicaragua",
            "key" : "NIC"
            }, {
            "description" : "Niger",
            "key" : "NER"
            }, {
            "description" : "Nigeria",
            "key" : "NGA"
            }, {
            "description" : "Niue",
            "key" : "NIU"
            }, {
            "description" : "Norfolk Island",
            "key" : "NFK"
            }, {
            "description" : "Northern Mariana Islands",
            "key" : "MNP"
            }, {
            "description" : "Norway",
            "key" : "NOR"
            }, {
            "description" : "Oman",
            "key" : "OMN"
            }, {
            "description" : "Pakistan",
            "key" : "PAK"
            }, {
            "description" : "Palau",
            "key" : "PLW"
            }, {
            "description" : "Palestinian Territory, Occupied",
            "key" : "PSE"
            }, {
            "description" : "Panama",
            "key" : "PAN"
            }, {
            "description" : "Papua New Guinea",
            "key" : "PNG"
            }, {
            "description" : "Paraguay",
            "key" : "PRY"
            }, {
            "description" : "Peru",
            "key" : "PER"
            }, {
            "description" : "Philippines",
            "key" : "PHL"
            }, {
            "description" : "Pitcairn",
            "key" : "PCN"
            }, {
            "description" : "Poland",
            "key" : "POL"
            }, {
            "description" : "Portugal",
            "key" : "PRT"
            }, {
            "description" : "Puerto Rico",
            "key" : "PRI"
            }, {
            "description" : "Qatar",
            "key" : "QAT"
            }, {
            "description" : "Reunion",
            "key" : "REU"
            }, {
            "description" : "Romania",
            "key" : "ROU"
            }, {
            "description" : "Russian Federation",
            "key" : "RUS"
            }, {
            "description" : "Rwanda",
            "key" : "RWA"
            }, {
            "description" : "Saint Barthélemy",
            "key" : "BLM"
            }, {
            "description" : "Saint Kitts And Nevis",
            "key" : "KNA"
            }, {
            "description" : "Saint Lucia",
            "key" : "LCA"
            }, {
            "description" : "Saint Martin (French part)",
            "key" : "MAF"
            }, {
            "description" : "Saint Vincent And The Grenadines",
            "key" : "VCT"
            }, {
            "description" : "Samoa",
            "key" : "WSM"
            }, {
            "description" : "San Marino",
            "key" : "SMR"
            }, {
            "description" : "Sao Tome And Principe",
            "key" : "STP"
            }, {
            "description" : "Saudi Arabia",
            "key" : "SAU"
            }, {
            "description" : "Scotland",
            "key" : "SCOT"
            }, {
            "description" : "Senegal",
            "key" : "SEN"
            }, {
            "description" : "Serbia",
            "key" : "SRB"
            }, {
            "description" : "Seychelles",
            "key" : "SYC"
            }, {
            "description" : "Sierra Leone",
            "key" : "SLE"
            }, {
            "description" : "Singapore",
            "key" : "SGP"
            }, {
            "description" : "Sint Maarten (Dutch part)",
            "key" : "SXM"
            }, {
            "description" : "Slovakia (slovak Republic)",
            "key" : "SVK"
            }, {
            "description" : "Slovenia",
            "key" : "SVN"
            }, {
            "description" : "Solomon Islands",
            "key" : "SLB"
            }, {
            "description" : "Somalia",
            "key" : "SOM"
            }, {
            "description" : "South Africa",
            "key" : "ZAF"
            }, {
            "description" : "South Georgia And The South Sandwich Islands",
            "key" : "SGS"
            }, {
            "description" : "South Sudan",
            "key" : "SSD"
            }, {
            "description" : "Spain",
            "key" : "ESP"
            }, {
            "description" : "Sri Lanka",
            "key" : "LKA"
            }, {
            "description" : "St. Helena",
            "key" : "SHN"
            }, {
            "description" : "St. Pierre And Miquelon",
            "key" : "SPM"
            }, {
            "description" : "Sudan",
            "key" : "SDN"
            }, {
            "description" : "Suriname",
            "key" : "SUR"
            }, {
            "description" : "Svalbard And Jan Mayen Islands",
            "key" : "SJM"
            }, {
            "description" : "Swaziland",
            "key" : "SWZ"
            }, {
            "description" : "Sweden",
            "key" : "SWE"
            }, {
            "description" : "Switzerland",
            "key" : "CHE"
            }, {
            "description" : "Syrian Arab Republic",
            "key" : "SYR"
            }, {
            "description" : "Taiwan",
            "key" : "TWN"
            }, {
            "description" : "Tajikistan",
            "key" : "TJK"
            }, {
            "description" : "Tanzania, United Republic Of",
            "key" : "TZA"
            }, {
            "description" : "Thailand",
            "key" : "THA"
            }, {
            "description" : "Togo",
            "key" : "TGO"
            }, {
            "description" : "Tokelau",
            "key" : "TKL"
            }, {
            "description" : "Tonga",
            "key" : "TON"
            }, {
            "description" : "Trinidad And Tobago",
            "key" : "TTO"
            }, {
            "description" : "Tunisia",
            "key" : "TUN"
            }, {
            "description" : "Turkey",
            "key" : "TUR"
            }, {
            "description" : "Turkmenistan",
            "key" : "TKM"
            }, {
            "description" : "Turks And Caicos Islands",
            "key" : "TCA"
            }, {
            "description" : "Tuvalu",
            "key" : "TUV"
            }, {
            "description" : "Uganda",
            "key" : "UGA"
            }, {
            "description" : "Ukraine",
            "key" : "UKR"
            }, {
            "description" : "United Arab Emirates",
            "key" : "ARE"
            }, {
            "description" : "United Kingdom",
            "key" : "GBR"
            }, {
            "description" : "United States",
            "key" : "USA"
            }, {
            "description" : "United States Minor Outlying Islands",
            "key" : "UMI"
            }, {
            "description" : "Uruguay",
            "key" : "URY"
            }, {
            "description" : "Uzbekistan",
            "key" : "UZB"
            }, {
            "description" : "Vanuatu",
            "key" : "VUT"
            }, {
            "description" : "Venezuela",
            "key" : "VEN"
            }, {
            "description" : "Viet Nam",
            "key" : "VNM"
            }, {
            "description" : "Virgin Islands (british)",
            "key" : "VGB"
            }, {
            "description" : "Virgin Islands (u.s.)",
            "key" : "VIR"
            }, {
            "description" : "WALS",
            "key" : "WALS"
            }, {
            "description" : "Wallis And Futuna Islands",
            "key" : "WLF"
            }, {
            "description" : "Western Sahara",
            "key" : "ESH"
            }, {
            "description" : "Yemen",
            "key" : "YEM"
            }, {
            "description" : "Yugoslavia",
            "key" : "YUG"
            }, {
            "description" : "Zambia",
            "key" : "ZMB"
            }, {
            "description" : "Zimbabwe",
            "key" : "ZWE"
            }, {
            "description" : "Åland islands",
            "key" : "ALA"
            }, {
            "description" : "Aberdeenshire",
            "key" : "GB-ABDN"
            }, {
            "description" : "Ain",
            "key" : "FR-01"
            }, {
            "description" : "Aisne",
            "key" : "FR-02"
            }, {
            "description" : "Allier",
            "key" : "FR-03"
            }, {
            "description" : "Alpes de Hautes-Provence",
            "key" : "FR-04"
            }, {
            "description" : "Alpes-Maritimes",
            "key" : "FR-06"
            }, {
            "description" : "Anglesey/Sir Fon",
            "key" : "GB-AGSY"
            }, {
            "description" : "Angus/Forfarshire",
            "key" : "GB-ANGS"
            }, {
            "description" : "Antrim",
            "key" : "NIRL-ATRM"
            }, {
            "description" : "Ardennes",
            "key" : "FR-08"
            }, {
            "description" : "Ardèche",
            "key" : "FR-07"
            }, {
            "description" : "Argyllshire",
            "key" : "GB-ARGL"
            }, {
            "description" : "Ariège",
            "key" : "FR-09"
            }, {
            "description" : "Armagh",
            "key" : "NIRL-ARMG"
            }, {
            "description" : "Aube",
            "key" : "FR-10"
            }, {
            "description" : "Aude",
            "key" : "FR-11"
            }, {
            "description" : "Aveyron",
            "key" : "FR-12"
            }, {
            "description" : "Ayrshire",
            "key" : "GB-AYRS"
            }, {
            "description" : "Banffshire",
            "key" : "GB-BANF"
            }, {
            "description" : "Bas-Rhin",
            "key" : "FR-67"
            }, {
            "description" : "Bedfordshire",
            "key" : "GB-BDFD"
            }, {
            "description" : "Berkshire",
            "key" : "GB-BRKS"
            }, {
            "description" : "Berwickshire",
            "key" : "GB-BWKS"
            }, {
            "description" : "Bouches-du-Rhône",
            "key" : "FR-13"
            }, {
            "description" : "Brecknockshire/Sir Frycheiniog",
            "key" : "GB-BREK"
            }, {
            "description" : "Buckinghamshire",
            "key" : "GB-BUCKS"
            }, {
            "description" : "Buteshire",
            "key" : "GB-BUTE"
            }, {
            "description" : "Caernarfonshire/Sir Gaernarfon",
            "key" : "GB-CNFN"
            }, {
            "description" : "Caithness",
            "key" : "GB-CTHN"
            }, {
            "description" : "Calvados",
            "key" : "FR-14"
            }, {
            "description" : "Cambridgeshire",
            "key" : "GB-CAMBS"
            }, {
            "description" : "Cantal",
            "key" : "FR-15"
            }, {
            "description" : "Cardiganshire/Ceredigion",
            "key" : "GB-CDGN"
            }, {
            "description" : "Carlow",
            "key" : "IE-CRLW"
            }, {
            "description" : "Carmarthenshire/Sir Gaerfyrddin",
            "key" : "GB-CMRN"
            }, {
            "description" : "Cavan",
            "key" : "IE-CAVN"
            }, {
            "description" : "Charente",
            "key" : "FR-16"
            }, {
            "description" : "Charente-Maritime",
            "key" : "FR-17"
            }, {
            "description" : "Cher",
            "key" : "FR-18"
            }, {
            "description" : "Cheshire",
            "key" : "GB-CHES"
            }, {
            "description" : "Clackmannanshire",
            "key" : "GB-CLAK"
            }, {
            "description" : "Clare",
            "key" : "IE-CLARE"
            }, {
            "description" : "Cork",
            "key" : "IE-CORK"
            }, {
            "description" : "Cornwall",
            "key" : "GB-CNWL"
            }, {
            "description" : "Corrèze",
            "key" : "FR-19"
            }, {
            "description" : "Corse",
            "key" : "FR-20"
            }, {
            "description" : "Corse-du-Sud",
            "key" : "FR-2A"
            }, {
            "description" : "Creuse",
            "key" : "FR-23"
            }, {
            "description" : "Cromartyshire",
            "key" : "GB-CMTY"
            }, {
            "description" : "Cumberland",
            "key" : "GB-CUMB"
            }, {
            "description" : "Côte-d\\'Or",
            "key" : "FR-21"
            }, {
            "description" : "Côtes d\\'Armor",
            "key" : "FR-22"
            }, {
            "description" : "Denbighshire/Sir Ddinbych",
            "key" : "GB-DENB"
            }, {
            "description" : "Derbyshire",
            "key" : "GB-DRBYS"
            }, {
            "description" : "Deux-Sèvres",
            "key" : "FR-79"
            }, {
            "description" : "Devon",
            "key" : "GB-DEVON"
            }, {
            "description" : "Donegal",
            "key" : "IE-DNGL"
            }, {
            "description" : "Dordogne",
            "key" : "FR-24"
            }, {
            "description" : "Dorset",
            "key" : "GB-DRST"
            }, {
            "description" : "Doubs",
            "key" : "FR-25"
            }, {
            "description" : "Down",
            "key" : "NIRL-DOWN"
            }, {
            "description" : "Drôme",
            "key" : "FR-26"
            }, {
            "description" : "Dublin",
            "key" : "IE-DBLN"
            }, {
            "description" : "Dumfriesshire",
            "key" : "GB-DMFS"
            }, {
            "description" : "Dunbartonshire/Dumbartonshire",
            "key" : "GB-DMBR"
            }, {
            "description" : "Durham",
            "key" : "GB-DRHM"
            }, {
            "description" : "East Lothian/Haddingtonshire",
            "key" : "GB-ELOTH"
            }, {
            "description" : "Essex",
            "key" : "GB-ESSX"
            }, {
            "description" : "Essonne",
            "key" : "FR-91"
            }, {
            "description" : "Eure",
            "key" : "FR-27"
            }, {
            "description" : "Eure-et-Loir",
            "key" : "FR-28"
            }, {
            "description" : "Fermanagh",
            "key" : "NIRL-FMNH"
            }, {
            "description" : "Fife",
            "key" : "GB-FIFE"
            }, {
            "description" : "Finistère",
            "key" : "FR-29"
            }, {
            "description" : "Flintshire/Sir Fflint",
            "key" : "GB-FTSH"
            }, {
            "description" : "Galway",
            "key" : "IE-GALW"
            }, {
            "description" : "Gard",
            "key" : "FR-30"
            }, {
            "description" : "Gers",
            "key" : "FR-32"
            }, {
            "description" : "Gironde",
            "key" : "FR-33"
            }, {
            "description" : "Glamorgan/Morgannwg",
            "key" : "GB-GLAM"
            }, {
            "description" : "Gloucestershire",
            "key" : "GB-GLOU"
            }, {
            "description" : "Guadeloupe",
            "key" : "FR-GP"
            }, {
            "description" : "Guyane",
            "key" : "FR-GF"
            }, {
            "description" : "Hampshire",
            "key" : "GB-HAMPS"
            }, {
            "description" : "Haut-Rhin",
            "key" : "FR-68"
            }, {
            "description" : "Haute-Corse",
            "key" : "FR-2B"
            }, {
            "description" : "Haute-Garonne",
            "key" : "FR-31"
            }, {
            "description" : "Haute-Loire",
            "key" : "FR-43"
            }, {
            "description" : "Haute-Marne",
            "key" : "FR-52"
            }, {
            "description" : "Haute-Savoie",
            "key" : "FR-74"
            }, {
            "description" : "Haute-Saône",
            "key" : "FR-70"
            }, {
            "description" : "Haute-Vienne",
            "key" : "FR-87"
            }, {
            "description" : "Hautes-Alpes",
            "key" : "FR-05"
            }, {
            "description" : "Hautes-Pyrénées",
            "key" : "FR-65"
            }, {
            "description" : "Hauts-de-Seine",
            "key" : "FR-92"
            }, {
            "description" : "Herefordshire",
            "key" : "GB-HRFDS"
            }, {
            "description" : "Hertfordshire",
            "key" : "GB-HERTS"
            }, {
            "description" : "Huntingdonshire",
            "key" : "GB-HUNTS"
            }, {
            "description" : "Hérault",
            "key" : "FR-34"
            }, {
            "description" : "Ille-et-Vilaine",
            "key" : "FR-35"
            }, {
            "description" : "Indre",
            "key" : "FR-36"
            }, {
            "description" : "Indre-et-Loire",
            "key" : "FR-37"
            }, {
            "description" : "Inverness-shire",
            "key" : "GB-INVER"
            }, {
            "description" : "Isère",
            "key" : "FR-38"
            }, {
            "description" : "Jura",
            "key" : "FR-39"
            }, {
            "description" : "Kent",
            "key" : "GB-KENT"
            }, {
            "description" : "Kerry",
            "key" : "IE-KERRY"
            }, {
            "description" : "Kildare",
            "key" : "IE-KLDR"
            }, {
            "description" : "Kilkenny",
            "key" : "IE-KLKNY"
            }, {
            "description" : "Kincardineshire",
            "key" : "GB-KNDN"
            }, {
            "description" : "Kinross-shire",
            "key" : "GB-KRSS"
            }, {
            "description" : "Kirkcudbrightshire",
            "key" : "GB-KRCUD"
            }, {
            "description" : "La Réunion",
            "key" : "FR-RE"
            }, {
            "description" : "Lanarkshire",
            "key" : "GB-LRKS"
            }, {
            "description" : "Lancashire",
            "key" : "GB-LANCS"
            }, {
            "description" : "Landes",
            "key" : "FR-40"
            }, {
            "description" : "Laois",
            "key" : "IE-LAOIS"
            }, {
            "description" : "Leicestershire",
            "key" : "GB-LIECS"
            }, {
            "description" : "Leitrim",
            "key" : "IE-LTRM"
            }, {
            "description" : "Limerick",
            "key" : "IE-LMRK"
            }, {
            "description" : "Lincolnshire",
            "key" : "GB-LINCS"
            }, {
            "description" : "Loir-et-Cher",
            "key" : "FR-41"
            }, {
            "description" : "Loire",
            "key" : "FR-42"
            }, {
            "description" : "Loire-Atlantique",
            "key" : "FR-44"
            }, {
            "description" : "Loiret",
            "key" : "FR-45"
            }, {
            "description" : "Londonderry",
            "key" : "NIRL-LDRY"
            }, {
            "description" : "Longford",
            "key" : "IE-LGFD"
            }, {
            "description" : "Lot",
            "key" : "FR-46"
            }, {
            "description" : "Lot-et-Garonne",
            "key" : "FR-47"
            }, {
            "description" : "Louth",
            "key" : "IE-LOUTH"
            }, {
            "description" : "Lozère",
            "key" : "FR-48"
            }, {
            "description" : "Maine-et-Loire",
            "key" : "FR-49"
            }, {
            "description" : "Manche",
            "key" : "FR-50"
            }, {
            "description" : "Marne",
            "key" : "FR-51"
            }, {
            "description" : "Martinique",
            "key" : "FR-MQ"
            }, {
            "description" : "Mayenne",
            "key" : "FR-53"
            }, {
            "description" : "Mayo",
            "key" : "IE-MAYO"
            }, {
            "description" : "Mayotte",
            "key" : "FR-YT"
            }, {
            "description" : "Meath",
            "key" : "IE-MEATH"
            }, {
            "description" : "Merioneth/Meirionnydd",
            "key" : "GB-MIENT"
            }, {
            "description" : "Meurthe-et-Moselle",
            "key" : "FR-54"
            }, {
            "description" : "Meuse",
            "key" : "FR-55"
            }, {
            "description" : "Middlesex",
            "key" : "GB-MSEX"
            }, {
            "description" : "Midlothian/Edinburghshire",
            "key" : "GB-MLOTH"
            }, {
            "description" : "Monaco",
            "key" : "FR-98"
            }, {
            "description" : "Monaghan",
            "key" : "IE-MNGHN"
            }, {
            "description" : "Monmouthshire/Sir Fynwy",
            "key" : "GB-MMTH"
            }, {
            "description" : "Montgomeryshire/Sir Drefaldwyn",
            "key" : "GB-MNTGS"
            }, {
            "description" : "Morayshire",
            "key" : "GB-MORAY"
            }, {
            "description" : "Morbihan",
            "key" : "FR-56"
            }, {
            "description" : "Moselle",
            "key" : "FR-57"
            }, {
            "description" : "Nairnshire",
            "key" : "GB-NAIRN"
            }, {
            "description" : "Nièvre",
            "key" : "FR-58"
            }, {
            "description" : "Nord",
            "key" : "FR-59"
            }, {
            "description" : "Norfolk",
            "key" : "GB-NFLK"
            }, {
            "description" : "Northamptonshire",
            "key" : "GB-NHANTS"
            }, {
            "description" : "Northumberland",
            "key" : "GB-NHUMB"
            }, {
            "description" : "Nottinghamshire",
            "key" : "GB-NOTTS"
            }, {
            "description" : "Nouvelle-Calédonie",
            "key" : "FR-NC"
            }, {
            "description" : "Offaly",
            "key" : "IE-OFLY"
            }, {
            "description" : "Oise",
            "key" : "FR-60"
            }, {
            "description" : "Orkney",
            "key" : "GB-ORK"
            }, {
            "description" : "Orne",
            "key" : "FR-61"
            }, {
            "description" : "Oxfordshire",
            "key" : "GB-OXFD"
            }, {
            "description" : "Paris",
            "key" : "FR-75"
            }, {
            "description" : "Pas-de-Calais",
            "key" : "FR-62"
            }, {
            "description" : "Peeblesshire",
            "key" : "GB-PEEBS"
            }, {
            "description" : "Pembrokeshire/Sir Benfro",
            "key" : "GB-PMBRK"
            }, {
            "description" : "Perthshire",
            "key" : "GB-PERTH"
            }, {
            "description" : "Polynésie française",
            "key" : "FR-PF"
            }, {
            "description" : "Puy-de-Dôme",
            "key" : "FR-63"
            }, {
            "description" : "Pyrénées-Atlantiques",
            "key" : "FR-64"
            }, {
            "description" : "Pyrénées-Orientales",
            "key" : "FR-66"
            }, {
            "description" : "Radnorshire/Sir Faesyfed",
            "key" : "GB-RNRS"
            }, {
            "description" : "Renfrewshire",
            "key" : "GB-RNFR"
            }, {
            "description" : "Rhône",
            "key" : "FR-69"
            }, {
            "description" : "Roscommon",
            "key" : "IE-RSCMN"
            }, {
            "description" : "Ross-shire",
            "key" : "GB-ROSS"
            }, {
            "description" : "Roxburghshire",
            "key" : "GB-ROXB"
            }, {
            "description" : "Rutland",
            "key" : "GB-RUTL"
            }, {
            "description" : "Saint-Barthélemy",
            "key" : "FR-BL"
            }, {
            "description" : "Saint-Martin",
            "key" : "FR-MT"
            }, {
            "description" : "Sanpete",
            "key" : "UT-SANPETE"
            }, {
            "description" : "Sarthe",
            "key" : "FR-72"
            }, {
            "description" : "Savoie",
            "key" : "FR-73"
            }, {
            "description" : "Saône-et-Loire",
            "key" : "FR-71"
            }, {
            "description" : "Seine-Maritime",
            "key" : "FR-76"
            }, {
            "description" : "Seine-Saint-Denis",
            "key" : "FR-93"
            }, {
            "description" : "Seine-et-Marne",
            "key" : "FR-77"
            }, {
            "description" : "Selkirkshire",
            "key" : "GB-SELKS"
            }, {
            "description" : "Shetland",
            "key" : "GB-SHET"
            }, {
            "description" : "Shropshire",
            "key" : "GB-SHROPS"
            }, {
            "description" : "Sligo",
            "key" : "IE-SLIGO"
            }, {
            "description" : "Somerset",
            "key" : "GB-SOMST"
            }, {
            "description" : "Somme",
            "key" : "FR-80"
            }, {
            "description" : "St Pierre et Miquelon",
            "key" : "FR-PM"
            }, {
            "description" : "Staffordshire",
            "key" : "GB-STAFFS"
            }, {
            "description" : "Stirlingshire",
            "key" : "GB-STLNG"
            }, {
            "description" : "Suffolk",
            "key" : "GB-SFFK"
            }, {
            "description" : "Surrey",
            "key" : "GB-SURR"
            }, {
            "description" : "Sussex",
            "key" : "GB-SUSX"
            }, {
            "description" : "Sutherland",
            "key" : "GB-SUTH"
            }, {
            "description" : "Tarn",
            "key" : "FR-81"
            }, {
            "description" : "Tarn-et-Garonne",
            "key" : "FR-82"
            }, {
            "description" : "Terres australes françaises",
            "key" : "FR-TF"
            }, {
            "description" : "Territoire-de-Belfort",
            "key" : "FR-90"
            }, {
            "description" : "Tipperary",
            "key" : "IE-TPRY"
            }, {
            "description" : "Tyrone",
            "key" : "NIRL-TYR"
            }, {
            "description" : "Utah County",
            "key" : "UT-UTAH"
            }, {
            "description" : "Val-d\\'Oise",
            "key" : "FR-95"
            }, {
            "description" : "Val-de-Marne",
            "key" : "FR-94"
            }, {
            "description" : "Var",
            "key" : "FR-83"
            }, {
            "description" : "Vaucluse",
            "key" : "FR-84"
            }, {
            "description" : "Vendée",
            "key" : "FR-85"
            }, {
            "description" : "Vienne",
            "key" : "FR-86"
            }, {
            "description" : "Vosges",
            "key" : "FR-88"
            }, {
            "description" : "Wallis et Futuna",
            "key" : "FR-WF"
            }, {
            "description" : "Warwickshire",
            "key" : "GB-WWKS"
            }, {
            "description" : "Waterford",
            "key" : "IE-WTFD"
            }, {
            "description" : "West Lothian/Linlithgowshire",
            "key" : "GB-WLOTH"
            }, {
            "description" : "West Meath",
            "key" : "IE-WMETH"
            }, {
            "description" : "Westmorland",
            "key" : "GB-WMLD"
            }, {
            "description" : "Wexford",
            "key" : "IE-WXFD"
            }, {
            "description" : "Wicklow",
            "key" : "IE-WKLW"
            }, {
            "description" : "Wigtownshire",
            "key" : "GB-WGNSH"
            }, {
            "description" : "Wiltshire",
            "key" : "GB-WILTS"
            }, {
            "description" : "Worcestershire",
            "key" : "GB-WORCS"
            }, {
            "description" : "Yonne",
            "key" : "FR-89"
            }, {
            "description" : "Yorkshire",
            "key" : "GB-YORKS"
            }, {
            "description" : "Yvelines",
            "key" : "FR-78"
            }, {
            "description" : "Agen",
            "key" : "FR-AGE47"
            }, {
            "description" : "Ajaccio",
            "key" : "FR-AJA2A"
            }, {
            "description" : "Albi",
            "key" : "FR-ALB81"
            }, {
            "description" : "Alençon",
            "key" : "FR-ALE61"
            }, {
            "description" : "Amiens",
            "key" : "FR-AMI80"
            }, {
            "description" : "Angers",
            "key" : "FR-ANG49"
            }, {
            "description" : "Angoulême",
            "key" : "FR-ANG16"
            }, {
            "description" : "Annecy",
            "key" : "FR-ACY74"
            }, {
            "description" : "Arras",
            "key" : "FR-ARR62"
            }, {
            "description" : "Auch",
            "key" : "FR-AUC32"
            }, {
            "description" : "Aurillac",
            "key" : "FR-AUR15"
            }, {
            "description" : "Auxerre",
            "key" : "FR-AXR89"
            }, {
            "description" : "Avignon",
            "key" : "FR-AVG84"
            }, {
            "description" : "Bar-le-Duc",
            "key" : "FR-BLD55"
            }, {
            "description" : "Bastia",
            "key" : "FR-BAS2B"
            }, {
            "description" : "Beauvais",
            "key" : "FR-BVA60"
            }, {
            "description" : "Belfort",
            "key" : "FR-BLF90"
            }, {
            "description" : "Besançon",
            "key" : "FR-BES25"
            }, {
            "description" : "Blois",
            "key" : "FR-BLO41"
            }, {
            "description" : "Bobigny",
            "key" : "FR-BBY93"
            }, {
            "description" : "Bordeaux",
            "key" : "FR-BOR33"
            }, {
            "description" : "Bourg-en-Bresse",
            "key" : "FR-BEB01"
            }, {
            "description" : "Bourges",
            "key" : "FR-BOU18"
            }, {
            "description" : "Caen",
            "key" : "FR-CAE14"
            }, {
            "description" : "Cahors",
            "key" : "FR-CAH46"
            }, {
            "description" : "Carcassonne",
            "key" : "FR-CAR11"
            }, {
            "description" : "Chambéry",
            "key" : "FR-CBY73"
            }, {
            "description" : "Charleville-Mézières",
            "key" : "FR-CHM08"
            }, {
            "description" : "Chartres",
            "key" : "FR-CHA28"
            }, {
            "description" : "Chaumont",
            "key" : "FR-CHM52"
            }, {
            "description" : "Châlons-en-Champagne",
            "key" : "FR-CEC51"
            }, {
            "description" : "Châteauroux",
            "key" : "FR-CHT36"
            }, {
            "description" : "Clermont-Ferrand",
            "key" : "FR-CLF63"
            }, {
            "description" : "Colmar",
            "key" : "FR-CLM68"
            }, {
            "description" : "Créteil",
            "key" : "FR-CTL94"
            }, {
            "description" : "Digne",
            "key" : "FR-DIG04"
            }, {
            "description" : "Dijon",
            "key" : "FR-DIJ21"
            }, {
            "description" : "Foix",
            "key" : "FR-FOI09"
            }, {
            "description" : "Gap",
            "key" : "FR-GAP05"
            }, {
            "description" : "Grenoble",
            "key" : "FR-GRE38"
            }, {
            "description" : "Guéret",
            "key" : "FR-GUE23"
            }, {
            "description" : "La Roche-sur-Yon",
            "key" : "FR-RSY85"
            }, {
            "description" : "La Rochelle",
            "key" : "FR-LRO17"
            }, {
            "description" : "Laon",
            "key" : "FR-LAO02"
            }, {
            "description" : "Laval",
            "key" : "FR-LVL53"
            }, {
            "description" : "Le Mans",
            "key" : "FR-LMA72"
            }, {
            "description" : "Le Puy-en-Velay",
            "key" : "FR-PEV43"
            }, {
            "description" : "Lille",
            "key" : "FR-LIL59"
            }, {
            "description" : "Limoges",
            "key" : "FR-LMG87"
            }, {
            "description" : "Lons-le-Saunier",
            "key" : "FR-LON39"
            }, {
            "description" : "Lyon",
            "key" : "FR-LYO69"
            }, {
            "description" : "Marseille",
            "key" : "FR-MAR13"
            }, {
            "description" : "Melun",
            "key" : "FR-MLN77"
            }, {
            "description" : "Mende",
            "key" : "FR-MEN48"
            }, {
            "description" : "Metz",
            "key" : "FR-MET57"
            }, {
            "description" : "Mont-de-Marsan",
            "key" : "FR-MDM40"
            }, {
            "description" : "Montauban",
            "key" : "FR-MTB82"
            }, {
            "description" : "Montpellier",
            "key" : "FR-MON34"
            }, {
            "description" : "Moulins",
            "key" : "FR-MOU03"
            }, {
            "description" : "Mâcon",
            "key" : "FR-MCN71"
            }, {
            "description" : "Nancy",
            "key" : "FR-NCY54"
            }, {
            "description" : "Nanterre",
            "key" : "FR-NTR92"
            }, {
            "description" : "Nantes",
            "key" : "FR-NAN44"
            }, {
            "description" : "Nevers",
            "key" : "FR-NEV58"
            }, {
            "description" : "Nice",
            "key" : "FR-NIC06"
            }, {
            "description" : "Niort",
            "key" : "FR-NIO79"
            }, {
            "description" : "Nîmes",
            "key" : "FR-NIM30"
            }, {
            "description" : "Orléans",
            "key" : "FR-ORL45"
            }, {
            "description" : "Paris",
            "key" : "FR-PAR75"
            }, {
            "description" : "Pau",
            "key" : "FR-PAU64"
            }, {
            "description" : "Perpignan",
            "key" : "FR-PPG66"
            }, {
            "description" : "Poitiers",
            "key" : "FR-POI86"
            }, {
            "description" : "Pontoise",
            "key" : "FR-PTO95"
            }, {
            "description" : "Privas",
            "key" : "FR-PRI07"
            }, {
            "description" : "Périgueux",
            "key" : "FR-PER24"
            }, {
            "description" : "Quimper",
            "key" : "FR-QUI29"
            }, {
            "description" : "Rennes",
            "key" : "FR-REN35"
            }, {
            "description" : "Rodez",
            "key" : "FR-ROD12"
            }, {
            "description" : "Rouen",
            "key" : "FR-ROU76"
            }, {
            "description" : "Saint-Brieuc",
            "key" : "FR-SBR22"
            }, {
            "description" : "Saint-Lô",
            "key" : "FR-SLO50"
            }, {
            "description" : "Saint-Étienne",
            "key" : "FR-SET42"
            }, {
            "description" : "Strasbourg",
            "key" : "FR-SBG67"
            }, {
            "description" : "Tarbes",
            "key" : "FR-TBS65"
            }, {
            "description" : "Toulon",
            "key" : "FR-TLN83"
            }, {
            "description" : "Toulouse",
            "key" : "FR-TLS31"
            }, {
            "description" : "Tours",
            "key" : "FR-TOU37"
            }, {
            "description" : "Troyes",
            "key" : "FR-TRO10"
            }, {
            "description" : "Tulle",
            "key" : "FR-TUL19"
            }, {
            "description" : "Valence",
            "key" : "FR-VAL26"
            }, {
            "description" : "Vannes",
            "key" : "FR-VAN56"
            }, {
            "description" : "Versailles",
            "key" : "FR-VSS78"
            }, {
            "description" : "Vesoul",
            "key" : "FR-VSL70"
            }, {
            "description" : "Épinal",
            "key" : "FR-EPI88"
            }, {
            "description" : "Évreux",
            "key" : "FR-EVR27"
            }, {
            "description" : "Évry",
            "key" : "FR-EVR91"
            }, {
            "description" : "Alaska/Hawaii",
            "key" : "AKHI"
            }, {
            "description" : "Alaska/Hawaii/Territories",
            "key" : "AHUST"
            }, {
            "description" : "European Union",
            "key" : "EU"
            }, {
            "description" : "Mexico/Canada",
            "key" : "MEXCAN"
            }, {
            "description" : "US 50 (no APO/FPO)",
            "key" : "US50"
            }, {
            "description" : "US All (w/ APO/FPO)",
            "key" : "USALL"
            }, {
            "description" : "US Armed Forces",
            "key" : "USAF"
            }, {
            "description" : "US Continental",
            "key" : "USCN"
            }, {
            "description" : "US Territories",
            "key" : "USTR"
            }, {
            "description" : "US/Canada",
            "key" : "USCAN"
            }, {
            "description" : "US/Mexico/Canada",
            "key" : "USMEXCAN"
            }, {
            "description" : "上海",
            "key" : "CN-SH"
            }, {
            "description" : "北京",
            "key" : "CN-BJ"
            }, {
            "description" : "天津",
            "key" : "CN-TJ"
            }, {
            "description" : "重庆",
            "key" : "CN-CQ"
            }, {
            "description" : "84057",
            "key" : "USA-84057"
            }, {
            "description" : "Agrigento",
            "key" : "IT-AG"
            }, {
            "description" : "Albacete",
            "key" : "ES-AB"
            }, {
            "description" : "Alberta",
            "key" : "AB"
            }, {
            "description" : "Alessandria",
            "key" : "IT-AL"
            }, {
            "description" : "Alicante",
            "key" : "ES-A"
            }, {
            "description" : "Almería",
            "key" : "ES-AL"
            }, {
            "description" : "Amnat Charoen",
            "key" : "TH-37"
            }, {
            "description" : "Ancona",
            "key" : "IT-AN"
            }, {
            "description" : "Ang Thong",
            "key" : "TH-15"
            }, {
            "description" : "Aosta",
            "key" : "IT-AO"
            }, {
            "description" : "Arezzo",
            "key" : "IT-AR"
            }, {
            "description" : "Ascoli Piceno",
            "key" : "IT-AP"
            }, {
            "description" : "Asti",
            "key" : "IT-AT"
            }, {
            "description" : "Asturias",
            "key" : "ES-O"
            }, {
            "description" : "Avellino",
            "key" : "IT-AV"
            }, {
            "description" : "Badajoz",
            "key" : "ES-BA"
            }, {
            "description" : "Bangkok",
            "key" : "TH-10"
            }, {
            "description" : "Barcelona",
            "key" : "ES-B"
            }, {
            "description" : "Bari",
            "key" : "IT-BA"
            }, {
            "description" : "Barletta-Andria-Trani",
            "key" : "IT-BT"
            }, {
            "description" : "Belluno",
            "key" : "IT-BL"
            }, {
            "description" : "Benevento",
            "key" : "IT-BN"
            }, {
            "description" : "Bergamo",
            "key" : "IT-BG"
            }, {
            "description" : "Biella",
            "key" : "IT-BI"
            }, {
            "description" : "Blagoevgrad",
            "key" : "BG-01"
            }, {
            "description" : "Bologna",
            "key" : "IT-BO"
            }, {
            "description" : "Bolzano",
            "key" : "IT-BZ"
            }, {
            "description" : "Brescia",
            "key" : "IT-BS"
            }, {
            "description" : "Brindisi",
            "key" : "IT-BR"
            }, {
            "description" : "British Columbia",
            "key" : "BC"
            }, {
            "description" : "Bueng Kan",
            "key" : "TH-38"
            }, {
            "description" : "Burgas",
            "key" : "BG-02"
            }, {
            "description" : "Burgos",
            "key" : "ES-BU"
            }, {
            "description" : "Buriram",
            "key" : "TH-31"
            }, {
            "description" : "Cagliari",
            "key" : "IT-CA"
            }, {
            "description" : "Caltanissetta",
            "key" : "IT-CL"
            }, {
            "description" : "Campobasso",
            "key" : "IT-CB"
            }, {
            "description" : "Cantabria",
            "key" : "ES-S"
            }, {
            "description" : "Carbonia-Iglesias",
            "key" : "IT-CI"
            }, {
            "description" : "Caserta",
            "key" : "IT-CE"
            }, {
            "description" : "Castellón",
            "key" : "ES-CS"
            }, {
            "description" : "Catania",
            "key" : "IT-CT"
            }, {
            "description" : "Catanzaro",
            "key" : "IT-CZ"
            }, {
            "description" : "Ceuta",
            "key" : "ES-CE"
            }, {
            "description" : "Chachoengsao",
            "key" : "TH-24"
            }, {
            "description" : "Chainat",
            "key" : "TH-18"
            }, {
            "description" : "Chaiyaphum",
            "key" : "TH-36"
            }, {
            "description" : "Chanthaburi",
            "key" : "TH-22"
            }, {
            "description" : "Chiang Mai",
            "key" : "TH-50"
            }, {
            "description" : "Chiang Rai",
            "key" : "TH-57"
            }, {
            "description" : "Chieti",
            "key" : "IT-CH"
            }, {
            "description" : "Chonburi",
            "key" : "TH-20"
            }, {
            "description" : "Chumphon",
            "key" : "TH-86"
            }, {
            "description" : "Ciudad Real",
            "key" : "ES-CR"
            }, {
            "description" : "Como",
            "key" : "IT-CO"
            }, {
            "description" : "Cosenza",
            "key" : "IT-CS"
            }, {
            "description" : "Cremona",
            "key" : "IT-CR"
            }, {
            "description" : "Crotone",
            "key" : "IT-KR"
            }, {
            "description" : "Cuenca",
            "key" : "ES-CU"
            }, {
            "description" : "Cuneo",
            "key" : "IT-CN"
            }, {
            "description" : "Cáceres",
            "key" : "ES-CC"
            }, {
            "description" : "Cádiz",
            "key" : "ES-CA"
            }, {
            "description" : "Córdoba",
            "key" : "ES-CO"
            }, {
            "description" : "Dobrich",
            "key" : "BG-08"
            }, {
            "description" : "Drenthe",
            "key" : "NL-DR"
            }, {
            "description" : "Enna",
            "key" : "IT-EN"
            }, {
            "description" : "Fermo",
            "key" : "IT-FM"
            }, {
            "description" : "Ferrara",
            "key" : "IT-FE"
            }, {
            "description" : "Firenze",
            "key" : "IT-FI"
            }, {
            "description" : "Flevoland",
            "key" : "NL-FL"
            }, {
            "description" : "Foggia",
            "key" : "IT-FG"
            }, {
            "description" : "Forli\\'-Cesena",
            "key" : "IT-FC"
            }, {
            "description" : "Friesland",
            "key" : "NL-FR"
            }, {
            "description" : "Frosinone",
            "key" : "IT-FR"
            }, {
            "description" : "Gabrovo",
            "key" : "BG-07"
            }, {
            "description" : "Gelderland",
            "key" : "NL-GL"
            }, {
            "description" : "Genova",
            "key" : "IT-GE"
            }, {
            "description" : "Gerona",
            "key" : "ES-GI"
            }, {
            "description" : "Gorizia",
            "key" : "IT-GO"
            }, {
            "description" : "Granada",
            "key" : "ES-GR"
            }, {
            "description" : "Groningen",
            "key" : "NL-GR"
            }, {
            "description" : "Grosseto",
            "key" : "IT-GR"
            }, {
            "description" : "Guadalajara",
            "key" : "ES-GU"
            }, {
            "description" : "Guipúzcoa",
            "key" : "ES-SS"
            }, {
            "description" : "HaDarom",
            "key" : "IL-D"
            }, {
            "description" : "HaMerkaz",
            "key" : "IL-M"
            }, {
            "description" : "HaZafon",
            "key" : "IL-Z"
            }, {
            "description" : "Haifa",
            "key" : "IL-HA"
            }, {
            "description" : "Haskovo",
            "key" : "BG-26"
            }, {
            "description" : "Huelva",
            "key" : "ES-H"
            }, {
            "description" : "Huesca",
            "key" : "ES-HU"
            }, {
            "description" : "Imperia",
            "key" : "IT-IM"
            }, {
            "description" : "Isernia",
            "key" : "IT-IS"
            }, {
            "description" : "Islas Baleares",
            "key" : "ES-PM"
            }, {
            "description" : "Jaén",
            "key" : "ES-J"
            }, {
            "description" : "Jerusalem",
            "key" : "IL-JM"
            }, {
            "description" : "Kalasin",
            "key" : "TH-46"
            }, {
            "description" : "Kamphaeng Phet",
            "key" : "TH-62"
            }, {
            "description" : "Kanchanaburi",
            "key" : "TH-71"
            }, {
            "description" : "Kardzhali",
            "key" : "BG-09"
            }, {
            "description" : "Khon Kaen",
            "key" : "TH-40"
            }, {
            "description" : "Krabi",
            "key" : "TH-81"
            }, {
            "description" : "Kyustendil",
            "key" : "BG-10"
            }, {
            "description" : "L\\'Aquila",
            "key" : "IT-AQ"
            }, {
            "description" : "La Coruña",
            "key" : "ES-C"
            }, {
            "description" : "La Spezia",
            "key" : "IT-SP"
            }, {
            "description" : "Lampang",
            "key" : "TH-52"
            }, {
            "description" : "Lamphun",
            "key" : "TH-51"
            }, {
            "description" : "Las Palmas",
            "key" : "ES-GC"
            }, {
            "description" : "Latina",
            "key" : "IT-LT"
            }, {
            "description" : "Lecce",
            "key" : "IT-LE"
            }, {
            "description" : "Lecco",
            "key" : "IT-LC"
            }, {
            "description" : "León",
            "key" : "ES-LE"
            }, {
            "description" : "Limburg",
            "key" : "NL-LB"
            }, {
            "description" : "Livorno",
            "key" : "IT-LI"
            }, {
            "description" : "Lodi",
            "key" : "IT-LO"
            }, {
            "description" : "Loei",
            "key" : "TH-42"
            }, {
            "description" : "Logroño",
            "key" : "ES-LO"
            }, {
            "description" : "Lopburi",
            "key" : "TH-16"
            }, {
            "description" : "Lovech",
            "key" : "BG-11"
            }, {
            "description" : "Lucca",
            "key" : "IT-LU"
            }, {
            "description" : "Lugo",
            "key" : "ES-LU"
            }, {
            "description" : "Lérida",
            "key" : "ES-L"
            }, {
            "description" : "Macerata",
            "key" : "IT-MC"
            }, {
            "description" : "Madrid",
            "key" : "ES-M"
            }, {
            "description" : "Mae Hong Son",
            "key" : "TH-58"
            }, {
            "description" : "Maha Sarakham",
            "key" : "TH-44"
            }, {
            "description" : "Manitoba",
            "key" : "MB"
            }, {
            "description" : "Mantova",
            "key" : "IT-MN"
            }, {
            "description" : "Massa-Carrara",
            "key" : "IT-MS"
            }, {
            "description" : "Matera",
            "key" : "IT-MT"
            }, {
            "description" : "Medio Campidano",
            "key" : "IT-VS"
            }, {
            "description" : "Melilla",
            "key" : "ES-ML"
            }, {
            "description" : "Messina",
            "key" : "IT-ME"
            }, {
            "description" : "Milano",
            "key" : "IT-MI"
            }, {
            "description" : "Modena",
            "key" : "IT-MO"
            }, {
            "description" : "Montana",
            "key" : "BG-12"
            }, {
            "description" : "Monza e Brianza",
            "key" : "IT-MB"
            }, {
            "description" : "Mukdahan",
            "key" : "TH-49"
            }, {
            "description" : "Murcia",
            "key" : "ES-MU"
            }, {
            "description" : "Málaga",
            "key" : "ES-MA"
            }, {
            "description" : "Nakhon Nayok",
            "key" : "TH-26"
            }, {
            "description" : "Nakhon Pathom",
            "key" : "TH-73"
            }, {
            "description" : "Nakhon Phanom",
            "key" : "TH-48"
            }, {
            "description" : "Nakhon Ratchasima",
            "key" : "TH-30"
            }, {
            "description" : "Nakhon Sawan",
            "key" : "TH-60"
            }, {
            "description" : "Nakhon Si Thammarat",
            "key" : "TH-80"
            }, {
            "description" : "Nan",
            "key" : "TH-55"
            }, {
            "description" : "Napoli",
            "key" : "IT-NA"
            }, {
            "description" : "Narathiwat",
            "key" : "TH-96"
            }, {
            "description" : "Navarra",
            "key" : "ES-NA"
            }, {
            "description" : "New Brunswick",
            "key" : "NB"
            }, {
            "description" : "Newfoundland/Labrador",
            "key" : "NL"
            }, {
            "description" : "Nong Bua Lamphu",
            "key" : "TH-39"
            }, {
            "description" : "Nong Khai",
            "key" : "TH-43"
            }, {
            "description" : "Nonthaburi",
            "key" : "TH-12"
            }, {
            "description" : "Noord-Brabant",
            "key" : "NL-NB"
            }, {
            "description" : "Noord-Holland",
            "key" : "NL-NH"
            }, {
            "description" : "Northwest Territories",
            "key" : "NT"
            }, {
            "description" : "Nova Scotia",
            "key" : "NS"
            }, {
            "description" : "Novara",
            "key" : "IT-NO"
            }, {
            "description" : "Nunavut",
            "key" : "NU"
            }, {
            "description" : "Nuoro",
            "key" : "IT-NU"
            }, {
            "description" : "Ogliastra",
            "key" : "IT-OG"
            }, {
            "description" : "Olbia-Tempio",
            "key" : "IT-OT"
            }, {
            "description" : "Ontario",
            "key" : "ON"
            }, {
            "description" : "Orense",
            "key" : "ES-OR"
            }, {
            "description" : "Oristano",
            "key" : "IT-OR"
            }, {
            "description" : "Overijssel",
            "key" : "NL-OV"
            }, {
            "description" : "Padova",
            "key" : "IT-PD"
            }, {
            "description" : "Palencia",
            "key" : "ES-P"
            }, {
            "description" : "Palermo",
            "key" : "IT-PA"
            }, {
            "description" : "Parma",
            "key" : "IT-PR"
            }, {
            "description" : "Pathum Thani",
            "key" : "TH-13"
            }, {
            "description" : "Pattani",
            "key" : "TH-94"
            }, {
            "description" : "Pavia",
            "key" : "IT-PV"
            }, {
            "description" : "Pazardzhik",
            "key" : "BG-13"
            }, {
            "description" : "Pernik",
            "key" : "BG-14"
            }, {
            "description" : "Perugia",
            "key" : "IT-PG"
            }, {
            "description" : "Pesaro e Urbino",
            "key" : "IT-PU"
            }, {
            "description" : "Pescara",
            "key" : "IT-PE"
            }, {
            "description" : "Phang Nga",
            "key" : "TH-82"
            }, {
            "description" : "Phatthalung",
            "key" : "TH-93"
            }, {
            "description" : "Phayao",
            "key" : "TH-56"
            }, {
            "description" : "Phetchabun",
            "key" : "TH-67"
            }, {
            "description" : "Phetchaburi",
            "key" : "TH-76"
            }, {
            "description" : "Phichit",
            "key" : "TH-66"
            }, {
            "description" : "Phitsanulok",
            "key" : "TH-65"
            }, {
            "description" : "Phra Nakhon Si Ayutthaya",
            "key" : "TH-14"
            }, {
            "description" : "Phrae",
            "key" : "TH-54"
            }, {
            "description" : "Phuket",
            "key" : "TH-83"
            }, {
            "description" : "Piacenza",
            "key" : "IT-PC"
            }, {
            "description" : "Pisa",
            "key" : "IT-PI"
            }, {
            "description" : "Pistoia",
            "key" : "IT-PT"
            }, {
            "description" : "Pleven",
            "key" : "BG-15"
            }, {
            "description" : "Plovdiv",
            "key" : "BG-16"
            }, {
            "description" : "Pontevedra",
            "key" : "ES-PO"
            }, {
            "description" : "Pordenone",
            "key" : "IT-PN"
            }, {
            "description" : "Potenza",
            "key" : "IT-PZ"
            }, {
            "description" : "Prachinburi",
            "key" : "TH-25"
            }, {
            "description" : "Prachuap Khiri Khan",
            "key" : "TH-77"
            }, {
            "description" : "Prato",
            "key" : "IT-PO"
            }, {
            "description" : "Prince Edward Island",
            "key" : "PE"
            }, {
            "description" : "Quebec",
            "key" : "QC"
            }, {
            "description" : "Ragusa",
            "key" : "IT-RG"
            }, {
            "description" : "Ranong",
            "key" : "TH-85"
            }, {
            "description" : "Ratchaburi",
            "key" : "TH-70"
            }, {
            "description" : "Ravenna",
            "key" : "IT-RA"
            }, {
            "description" : "Rayong",
            "key" : "TH-21"
            }, {
            "description" : "Razgrad",
            "key" : "BG-17"
            }, {
            "description" : "Reggio Calabria",
            "key" : "IT-RC"
            }, {
            "description" : "Reggio Emilia",
            "key" : "IT-RE"
            }, {
            "description" : "Rieti",
            "key" : "IT-RI"
            }, {
            "description" : "Rimini",
            "key" : "IT-RN"
            }, {
            "description" : "Roi Et",
            "key" : "TH-45"
            }, {
            "description" : "Roma",
            "key" : "IT-RM"
            }, {
            "description" : "Rovigo",
            "key" : "IT-RO"
            }, {
            "description" : "Ruse",
            "key" : "BG-18"
            }, {
            "description" : "Sa Kaeo",
            "key" : "TH-27"
            }, {
            "description" : "Sakon Nakhon",
            "key" : "TH-47"
            }, {
            "description" : "Salamanca",
            "key" : "ES-SA"
            }, {
            "description" : "Salerno",
            "key" : "IT-SA"
            }, {
            "description" : "Samut Prakan",
            "key" : "TH-11"
            }, {
            "description" : "Samut Sakhon",
            "key" : "TH-74"
            }, {
            "description" : "Samut Songkhram",
            "key" : "TH-75"
            }, {
            "description" : "Santa Cruz de Tenerife",
            "key" : "ES-TF"
            }, {
            "description" : "Saraburi",
            "key" : "TH-19"
            }, {
            "description" : "Saskatchewan",
            "key" : "SK"
            }, {
            "description" : "Sassari",
            "key" : "IT-SS"
            }, {
            "description" : "Satun",
            "key" : "TH-91"
            }, {
            "description" : "Savona",
            "key" : "IT-SV"
            }, {
            "description" : "Segovia",
            "key" : "ES-SG"
            }, {
            "description" : "Sevilla",
            "key" : "ES-SE"
            }, {
            "description" : "Shumen",
            "key" : "BG-27"
            }, {
            "description" : "Siena",
            "key" : "IT-SI"
            }, {
            "description" : "Silistra",
            "key" : "BG-19"
            }, {
            "description" : "Sing Buri",
            "key" : "TH-17"
            }, {
            "description" : "Siracusa",
            "key" : "IT-SR"
            }, {
            "description" : "Sisaket",
            "key" : "TH-33"
            }, {
            "description" : "Sliven",
            "key" : "BG-20"
            }, {
            "description" : "Smolyan",
            "key" : "BG-21"
            }, {
            "description" : "Sofia",
            "key" : "BG-22"
            }, {
            "description" : "Sofia Province",
            "key" : "BG-23"
            }, {
            "description" : "Sondrio",
            "key" : "IT-SO"
            }, {
            "description" : "Songkhla",
            "key" : "TH-90"
            }, {
            "description" : "Soria",
            "key" : "ES-SO"
            }, {
            "description" : "Stara Zagora",
            "key" : "BG-24"
            }, {
            "description" : "Sukhothai",
            "key" : "TH-64"
            }, {
            "description" : "Suphan Buri",
            "key" : "TH-72"
            }, {
            "description" : "Surat Thani",
            "key" : "TH-84"
            }, {
            "description" : "Surin",
            "key" : "TH-32"
            }, {
            "description" : "Tak",
            "key" : "TH-63"
            }, {
            "description" : "Taranto",
            "key" : "IT-TA"
            }, {
            "description" : "Targovishte",
            "key" : "BG-25"
            }, {
            "description" : "Tarragona",
            "key" : "ES-T"
            }, {
            "description" : "Tel Aviv",
            "key" : "IL-TA"
            }, {
            "description" : "Teramo",
            "key" : "IT-TE"
            }, {
            "description" : "Terni",
            "key" : "IT-TR"
            }, {
            "description" : "Teruel",
            "key" : "ES-TE"
            }, {
            "description" : "Toledo",
            "key" : "ES-TO"
            }, {
            "description" : "Torino",
            "key" : "IT-TO"
            }, {
            "description" : "Trang",
            "key" : "TH-92"
            }, {
            "description" : "Trapani",
            "key" : "IT-TP"
            }, {
            "description" : "Trat",
            "key" : "TH-23"
            }, {
            "description" : "Trento",
            "key" : "IT-TN"
            }, {
            "description" : "Treviso",
            "key" : "IT-TV"
            }, {
            "description" : "Trieste",
            "key" : "IT-TS"
            }, {
            "description" : "Ubon Ratchathani",
            "key" : "TH-34"
            }, {
            "description" : "Udine",
            "key" : "IT-UD"
            }, {
            "description" : "Udon Thani",
            "key" : "TH-41"
            }, {
            "description" : "Uthai Thani",
            "key" : "TH-61"
            }, {
            "description" : "Utrecht",
            "key" : "NL-UT"
            }, {
            "description" : "Uttaradit",
            "key" : "TH-53"
            }, {
            "description" : "Valencia",
            "key" : "ES-V"
            }, {
            "description" : "Valladolid",
            "key" : "ES-VA"
            }, {
            "description" : "Varese",
            "key" : "IT-VA"
            }, {
            "description" : "Varna",
            "key" : "BG-03"
            }, {
            "description" : "Veliko Tarnovo",
            "key" : "BG-04"
            }, {
            "description" : "Venezia",
            "key" : "IT-VE"
            }, {
            "description" : "Verbano-Cusio-Ossola",
            "key" : "IT-VB"
            }, {
            "description" : "Vercelli",
            "key" : "IT-VC"
            }, {
            "description" : "Verona",
            "key" : "IT-VR"
            }, {
            "description" : "Vibo Valentia",
            "key" : "IT-VV"
            }, {
            "description" : "Vicenza",
            "key" : "IT-VI"
            }, {
            "description" : "Vidin",
            "key" : "BG-05"
            }, {
            "description" : "Viterbo",
            "key" : "IT-VT"
            }, {
            "description" : "Vizcaya",
            "key" : "ES-BI"
            }, {
            "description" : "Vratsa",
            "key" : "BG-06"
            }, {
            "description" : "Yala",
            "key" : "TH-95"
            }, {
            "description" : "Yambol",
            "key" : "BG-28"
            }, {
            "description" : "Yasothon",
            "key" : "TH-35"
            }, {
            "description" : "Yukon Territory",
            "key" : "YT"
            }, {
            "description" : "Zamora",
            "key" : "ES-ZA"
            }, {
            "description" : "Zaragoza",
            "key" : "ES-Z"
            }, {
            "description" : "Zeeland",
            "key" : "NL-ZE"
            }, {
            "description" : "Zeeland",
            "key" : "NL-ZL"
            }, {
            "description" : "Zuid-Holland",
            "key" : "NL-ZH"
            }, {
            "description" : "Álava",
            "key" : "ES-VI"
            }, {
            "description" : "Ávila",
            "key" : "ES-AV"
            }, {
            "description" : "三重県",
            "key" : "JP-24"
            }, {
            "description" : "云南",
            "key" : "CN-YN"
            }, {
            "description" : "京都府",
            "key" : "JP-26"
            }, {
            "description" : "佐賀県",
            "key" : "JP-41"
            }, {
            "description" : "兵庫県",
            "key" : "JP-28"
            }, {
            "description" : "北海道",
            "key" : "JP-01"
            }, {
            "description" : "千葉県",
            "key" : "JP-12"
            }, {
            "description" : "台湾",
            "key" : "CN-TW"
            }, {
            "description" : "吉林",
            "key" : "CN-JL"
            }, {
            "description" : "和歌山県",
            "key" : "JP-30"
            }, {
            "description" : "四川",
            "key" : "CN-SC"
            }, {
            "description" : "埼玉県",
            "key" : "JP-11"
            }, {
            "description" : "大分県",
            "key" : "JP-44"
            }, {
            "description" : "大阪府",
            "key" : "JP-27"
            }, {
            "description" : "奈良県",
            "key" : "JP-29"
            }, {
            "description" : "安徽",
            "key" : "CN-AH"
            }, {
            "description" : "宮城県",
            "key" : "JP-04"
            }, {
            "description" : "宮崎県",
            "key" : "JP-45"
            }, {
            "description" : "富山県",
            "key" : "JP-16"
            }, {
            "description" : "山东",
            "key" : "CN-SD"
            }, {
            "description" : "山口県",
            "key" : "JP-35"
            }, {
            "description" : "山形県",
            "key" : "JP-06"
            }, {
            "description" : "山梨県",
            "key" : "JP-19"
            }, {
            "description" : "山西",
            "key" : "CN-SX"
            }, {
            "description" : "岐阜県",
            "key" : "JP-21"
            }, {
            "description" : "岡山県",
            "key" : "JP-33"
            }, {
            "description" : "岩手県",
            "key" : "JP-03"
            }, {
            "description" : "島根県",
            "key" : "JP-32"
            }, {
            "description" : "广东",
            "key" : "CN-GD"
            }, {
            "description" : "広島県",
            "key" : "JP-34"
            }, {
            "description" : "徳島県",
            "key" : "JP-36"
            }, {
            "description" : "愛媛県",
            "key" : "JP-38"
            }, {
            "description" : "愛知県",
            "key" : "JP-23"
            }, {
            "description" : "新潟県",
            "key" : "JP-15"
            }, {
            "description" : "東京都",
            "key" : "JP-13"
            }, {
            "description" : "栃木県",
            "key" : "JP-09"
            }, {
            "description" : "江苏",
            "key" : "CN-JS"
            }, {
            "description" : "江西",
            "key" : "CN-JX"
            }, {
            "description" : "沖縄県",
            "key" : "JP-47"
            }, {
            "description" : "河北",
            "key" : "CN-HE"
            }, {
            "description" : "河南",
            "key" : "CN-HA"
            }, {
            "description" : "浙江",
            "key" : "CN-ZJ"
            }, {
            "description" : "海南",
            "key" : "CN-HI"
            }, {
            "description" : "湖北",
            "key" : "CN-HB"
            }, {
            "description" : "湖南",
            "key" : "CN-HN"
            }, {
            "description" : "滋賀県",
            "key" : "JP-25"
            }, {
            "description" : "熊本県",
            "key" : "JP-43"
            }, {
            "description" : "甘肃",
            "key" : "CN-GS"
            }, {
            "description" : "石川県",
            "key" : "JP-17"
            }, {
            "description" : "神奈川県",
            "key" : "JP-14"
            }, {
            "description" : "福井県",
            "key" : "JP-18"
            }, {
            "description" : "福岡県",
            "key" : "JP-40"
            }, {
            "description" : "福島県",
            "key" : "JP-07"
            }, {
            "description" : "福建",
            "key" : "CN-FJ"
            }, {
            "description" : "秋田県",
            "key" : "JP-05"
            }, {
            "description" : "群馬県",
            "key" : "JP-10"
            }, {
            "description" : "茨城県",
            "key" : "JP-08"
            }, {
            "description" : "贵州",
            "key" : "CN-GZ"
            }, {
            "description" : "辽宁",
            "key" : "CN-LN"
            }, {
            "description" : "長崎県",
            "key" : "JP-42"
            }, {
            "description" : "長野県",
            "key" : "JP-20"
            }, {
            "description" : "陕西",
            "key" : "CN-SN"
            }, {
            "description" : "青森県",
            "key" : "JP-02"
            }, {
            "description" : "青海",
            "key" : "CN-QH"
            }, {
            "description" : "静岡県",
            "key" : "JP-22"
            }, {
            "description" : "香川県",
            "key" : "JP-37"
            }, {
            "description" : "高知県",
            "key" : "JP-39"
            }, {
            "description" : "鳥取県",
            "key" : "JP-31"
            }, {
            "description" : "鹿児島県",
            "key" : "JP-46"
            }, {
            "description" : "黑龙江",
            "key" : "CN-HL"
            }, {
            "description" : "Andalucía",
            "key" : "ES-AN"
            }, {
            "description" : "Aragón",
            "key" : "ES-AR"
            }, {
            "description" : "Auckland",
            "key" : "NZ-AUK"
            }, {
            "description" : "Auvergne-Rhône-Alpes",
            "key" : "FR-ARA"
            }, {
            "description" : "Bay of Plenty",
            "key" : "NZ-BOP"
            }, {
            "description" : "Bourgogne-Franche-Comté",
            "key" : "FR-BFC"
            }, {
            "description" : "Bretagne",
            "key" : "FR-BRE"
            }, {
            "description" : "Canarias",
            "key" : "ES-CN"
            }, {
            "description" : "Cantabria",
            "key" : "ES-CAN"
            }, {
            "description" : "Canterbury",
            "key" : "NZ-CAN"
            }, {
            "description" : "Castilla y León",
            "key" : "ES-CL"
            }, {
            "description" : "Castilla-La Mancha",
            "key" : "ES-CM"
            }, {
            "description" : "Cataluña",
            "key" : "ES-CT"
            }, {
            "description" : "Centre-Val de Loire",
            "key" : "FR-CVL"
            }, {
            "description" : "Comunidad Valenciana",
            "key" : "ES-VC"
            }, {
            "description" : "Corse",
            "key" : "FR-COR"
            }, {
            "description" : "Extremadura",
            "key" : "ES-EX"
            }, {
            "description" : "Galicia",
            "key" : "ES-GA"
            }, {
            "description" : "Gisborne",
            "key" : "NZ-GIS"
            }, {
            "description" : "Grand-Est",
            "key" : "FR-GES"
            }, {
            "description" : "Guadeloupe",
            "key" : "FR-GUA"
            }, {
            "description" : "Hauts-de-France",
            "key" : "FR-HDF"
            }, {
            "description" : "Hawkes Bay",
            "key" : "NZ-HKB"
            }, {
            "description" : "Ile-de-France",
            "key" : "FR-IDF"
            }, {
            "description" : "Islas Baleares",
            "key" : "ES-IB"
            }, {
            "description" : "La Rioja",
            "key" : "ES-LR"
            }, {
            "description" : "La Réunion",
            "key" : "FR-LRE"
            }, {
            "description" : "Madrid",
            "key" : "ES-MAD"
            }, {
            "description" : "Manawatu-Whanganui",
            "key" : "NZ-MWT"
            }, {
            "description" : "Marlborough",
            "key" : "NZ-MBH"
            }, {
            "description" : "Mayotte",
            "key" : "FR-MAY"
            }, {
            "description" : "Navarra",
            "key" : "ES-NAV"
            }, {
            "description" : "Nelson",
            "key" : "NZ-NSN"
            }, {
            "description" : "Normandie",
            "key" : "FR-NOR"
            }, {
            "description" : "Northland",
            "key" : "NZ-NTL"
            }, {
            "description" : "Nouvelle-Aquitaine",
            "key" : "FR-NAQ"
            }, {
            "description" : "Occitanie",
            "key" : "FR-OCC"
            }, {
            "description" : "Otago",
            "key" : "NZ-OTA"
            }, {
            "description" : "Oviedo",
            "key" : "ES-AS"
            }, {
            "description" : "Pays de la Loire",
            "key" : "FR-PDL"
            }, {
            "description" : "País Vasco",
            "key" : "ES-PV"
            }, {
            "description" : "Provence-Alpes-Côte d\\'Azur",
            "key" : "FR-PAC"
            }, {
            "description" : "Región de Murcia",
            "key" : "ES-MUR"
            }, {
            "description" : "Southland",
            "key" : "NZ-STL"
            }, {
            "description" : "Taranaki",
            "key" : "NZ-TKI"
            }, {
            "description" : "Tasman",
            "key" : "NZ-TAS"
            }, {
            "description" : "Waikato",
            "key" : "NZ-WKO"
            }, {
            "description" : "Wellington",
            "key" : "NZ-WGN"
            }, {
            "description" : "West Coast",
            "key" : "NZ-WTC"
            }, {
            "description" : "内蒙古",
            "key" : "CN-NM"
            }, {
            "description" : "宁夏",
            "key" : "CN-NX"
            }, {
            "description" : "广西",
            "key" : "CN-GX"
            }, {
            "description" : "新疆",
            "key" : "CN-XJ"
            }, {
            "description" : "澳门",
            "key" : "CN-MO"
            }, {
            "description" : "西藏",
            "key" : "CN-XZ"
            }, {
            "description" : "香港",
            "key" : "CN-HK"
            }, {
            "description" : "Aargau",
            "key" : "CH-AG"
            }, {
            "description" : "Acre",
            "key" : "BR-AC"
            }, {
            "description" : "Aguascalientes",
            "key" : "MX-AG"
            }, {
            "description" : "Alabama",
            "key" : "AL"
            }, {
            "description" : "Alagoas",
            "key" : "BR-AL"
            }, {
            "description" : "Alaska",
            "key" : "AK"
            }, {
            "description" : "Amapá",
            "key" : "BR-AP"
            }, {
            "description" : "Amazonas",
            "key" : "BR-AM"
            }, {
            "description" : "Amazonas",
            "key" : "CO-AMA"
            }, {
            "description" : "American Samoa",
            "key" : "AS"
            }, {
            "description" : "Andhra Pradesh",
            "key" : "IN-AP"
            }, {
            "description" : "Antioquia",
            "key" : "CO-ANT"
            }, {
            "description" : "Appenzell Ausserrhoden",
            "key" : "CH-AR"
            }, {
            "description" : "Appenzell Innerrhoden",
            "key" : "CH-AI"
            }, {
            "description" : "Arauca",
            "key" : "CO-ARA"
            }, {
            "description" : "Arizona",
            "key" : "AZ"
            }, {
            "description" : "Arkansas",
            "key" : "AR"
            }, {
            "description" : "Armed Forces Americas",
            "key" : "AA"
            }, {
            "description" : "Armed Forces Europe",
            "key" : "AE"
            }, {
            "description" : "Armed Forces Pacific",
            "key" : "AP"
            }, {
            "description" : "Arunāchal Pradesh",
            "key" : "IN-AR"
            }, {
            "description" : "Assam",
            "key" : "IN-AS"
            }, {
            "description" : "Atlántico",
            "key" : "CO-ATL"
            }, {
            "description" : "Baden-Württemberg",
            "key" : "DE-BW"
            }, {
            "description" : "Bahia",
            "key" : "BR-BA"
            }, {
            "description" : "Baja California",
            "key" : "MX-BC"
            }, {
            "description" : "Baja California Sur",
            "key" : "MX-BS"
            }, {
            "description" : "Basel-Landschaft",
            "key" : "CH-BL"
            }, {
            "description" : "Basel-Stadt",
            "key" : "CH-BS"
            }, {
            "description" : "Bayern",
            "key" : "DE-BY"
            }, {
            "description" : "Berlin",
            "key" : "DE-BE"
            }, {
            "description" : "Bern",
            "key" : "CH-BE"
            }, {
            "description" : "Bihār",
            "key" : "IN-BR"
            }, {
            "description" : "Bogotá D.C.",
            "key" : "CO-DC"
            }, {
            "description" : "Bolívar",
            "key" : "CO-BOL"
            }, {
            "description" : "Boyacá",
            "key" : "CO-BOY"
            }, {
            "description" : "Brandenburg",
            "key" : "DE-BB"
            }, {
            "description" : "Bremen",
            "key" : "DE-HB"
            }, {
            "description" : "Caldas",
            "key" : "CO-CAL"
            }, {
            "description" : "California",
            "key" : "CA"
            }, {
            "description" : "Campeche",
            "key" : "MX-CM"
            }, {
            "description" : "Caquetá",
            "key" : "CO-CAQ"
            }, {
            "description" : "Casanare",
            "key" : "CO-CAS"
            }, {
            "description" : "Cauca",
            "key" : "CO-CAU"
            }, {
            "description" : "Ceará",
            "key" : "BR-CE"
            }, {
            "description" : "Cesar",
            "key" : "CO-CES"
            }, {
            "description" : "Chhattīsgarh",
            "key" : "IN-CT"
            }, {
            "description" : "Chiapas",
            "key" : "MX-CS"
            }, {
            "description" : "Chihuahua",
            "key" : "MX-CH"
            }, {
            "description" : "Chocó",
            "key" : "CO-CHO"
            }, {
            "description" : "Ciudad de México",
            "key" : "MX-CX"
            }, {
            "description" : "Coahuila de Zaragoza",
            "key" : "MX-CO"
            }, {
            "description" : "Colima",
            "key" : "MX-CL"
            }, {
            "description" : "Colorado",
            "key" : "CO"
            }, {
            "description" : "Connecticut",
            "key" : "CT"
            }, {
            "description" : "Cundinamarca",
            "key" : "CO-CUN"
            }, {
            "description" : "Córdoba",
            "key" : "CO-COR"
            }, {
            "description" : "Delaware",
            "key" : "DE"
            }, {
            "description" : "District of Columbia",
            "key" : "DC"
            }, {
            "description" : "Distrito Federal",
            "key" : "BR-DF"
            }, {
            "description" : "Durango",
            "key" : "MX-DG"
            }, {
            "description" : "Espírito Santo",
            "key" : "BR-ES"
            }, {
            "description" : "Federated States of Micronesia",
            "key" : "FM"
            }, {
            "description" : "Florida",
            "key" : "FL"
            }, {
            "description" : "Fribourg",
            "key" : "CH-FR"
            }, {
            "description" : "Genève",
            "key" : "CH-GE"
            }, {
            "description" : "Georgia",
            "key" : "GA"
            }, {
            "description" : "Glarus",
            "key" : "CH-GL"
            }, {
            "description" : "Goa",
            "key" : "IN-GA"
            }, {
            "description" : "Goiás",
            "key" : "BR-GO"
            }, {
            "description" : "Graubünden",
            "key" : "CH-GR"
            }, {
            "description" : "Guainía",
            "key" : "CO-GUA"
            }, {
            "description" : "Guam",
            "key" : "GU"
            }, {
            "description" : "Guanajuato",
            "key" : "MX-GT"
            }, {
            "description" : "Guaviare",
            "key" : "CO-GUV"
            }, {
            "description" : "Guerrero",
            "key" : "MX-GR"
            }, {
            "description" : "Gujarāt",
            "key" : "IN-GJ"
            }, {
            "description" : "Hamburg",
            "key" : "DE-HH"
            }, {
            "description" : "Haryāna",
            "key" : "IN-HR"
            }, {
            "description" : "Hawaii",
            "key" : "HI"
            }, {
            "description" : "Hessen",
            "key" : "DE-HE"
            }, {
            "description" : "Hidalgo",
            "key" : "MX-HG"
            }, {
            "description" : "Himāchal Pradesh",
            "key" : "IN-HP"
            }, {
            "description" : "Huila",
            "key" : "CO-HUI"
            }, {
            "description" : "Idaho",
            "key" : "ID"
            }, {
            "description" : "Illinois",
            "key" : "IL"
            }, {
            "description" : "Indiana",
            "key" : "IN"
            }, {
            "description" : "Iowa",
            "key" : "IA"
            }, {
            "description" : "Jalisco",
            "key" : "MX-JC"
            }, {
            "description" : "Jhārkhand",
            "key" : "IN-JH"
            }, {
            "description" : "Johor",
            "key" : "MY-01"
            }, {
            "description" : "Jura",
            "key" : "CH-JU"
            }, {
            "description" : "Kansas",
            "key" : "KS"
            }, {
            "description" : "Karnātaka",
            "key" : "IN-KA"
            }, {
            "description" : "Kedah",
            "key" : "MY-02"
            }, {
            "description" : "Kelantan",
            "key" : "MY-03"
            }, {
            "description" : "Kentucky",
            "key" : "KY"
            }, {
            "description" : "Kerala",
            "key" : "IN-KL"
            }, {
            "description" : "La Guajira",
            "key" : "CO-LAG"
            }, {
            "description" : "Louisiana",
            "key" : "LA"
            }, {
            "description" : "Luzern",
            "key" : "CH-LU"
            }, {
            "description" : "Madhya Pradesh",
            "key" : "IN-MP"
            }, {
            "description" : "Magdalena",
            "key" : "CO-MAG"
            }, {
            "description" : "Mahārāshtra",
            "key" : "IN-MH"
            }, {
            "description" : "Maine",
            "key" : "ME"
            }, {
            "description" : "Malacca",
            "key" : "MY-04"
            }, {
            "description" : "Manipur",
            "key" : "IN-MN"
            }, {
            "description" : "Maranhão",
            "key" : "BR-MA"
            }, {
            "description" : "Marshall Islands",
            "key" : "MH"
            }, {
            "description" : "Maryland",
            "key" : "MD"
            }, {
            "description" : "Massachusetts",
            "key" : "MA"
            }, {
            "description" : "Mato Grosso",
            "key" : "BR-MT"
            }, {
            "description" : "Mato Grosso do Sul",
            "key" : "BR-MS"
            }, {
            "description" : "Mecklenburg-Vorpommern",
            "key" : "DE-MV"
            }, {
            "description" : "Meghālaya",
            "key" : "IN-ML"
            }, {
            "description" : "Meta",
            "key" : "CO-MET"
            }, {
            "description" : "Michigan",
            "key" : "MI"
            }, {
            "description" : "Michoacán de Ocampo",
            "key" : "MX-MI"
            }, {
            "description" : "Minas Gerais",
            "key" : "BR-MG"
            }, {
            "description" : "Minnesota",
            "key" : "MN"
            }, {
            "description" : "Mississippi",
            "key" : "MS"
            }, {
            "description" : "Missouri",
            "key" : "MO"
            }, {
            "description" : "Mizoram",
            "key" : "IN-MZ"
            }, {
            "description" : "Montana",
            "key" : "MT"
            }, {
            "description" : "Morelos",
            "key" : "MX-MO"
            }, {
            "description" : "México",
            "key" : "MX-EM"
            }, {
            "description" : "Nariño",
            "key" : "CO-NAR"
            }, {
            "description" : "Nayarit",
            "key" : "MX-NA"
            }, {
            "description" : "Nebraska",
            "key" : "NE"
            }, {
            "description" : "Negeri Sembilan",
            "key" : "MY-05"
            }, {
            "description" : "Neuchâtel",
            "key" : "CH-NE"
            }, {
            "description" : "Nevada",
            "key" : "NV"
            }, {
            "description" : "New Hampshire",
            "key" : "NH"
            }, {
            "description" : "New Jersey",
            "key" : "NJ"
            }, {
            "description" : "New Mexico",
            "key" : "NM"
            }, {
            "description" : "New South Wales",
            "key" : "AU-NSW"
            }, {
            "description" : "New York",
            "key" : "NY"
            }, {
            "description" : "Nidwalden",
            "key" : "CH-NW"
            }, {
            "description" : "Niedersachsen",
            "key" : "DE-NI"
            }, {
            "description" : "Nordrhein-Westfalen",
            "key" : "DE-NW"
            }, {
            "description" : "Norte de Santander",
            "key" : "CO-NSA"
            }, {
            "description" : "North Carolina",
            "key" : "NC"
            }, {
            "description" : "North Dakota",
            "key" : "ND"
            }, {
            "description" : "Northern Mariana Islands",
            "key" : "MP"
            }, {
            "description" : "Nuevo León",
            "key" : "MX-NL"
            }, {
            "description" : "Nāgāland",
            "key" : "IN-NL"
            }, {
            "description" : "Oaxaca",
            "key" : "MX-OA"
            }, {
            "description" : "Obwalden",
            "key" : "CH-OW"
            }, {
            "description" : "Odisha",
            "key" : "IN-OR"
            }, {
            "description" : "Ohio",
            "key" : "OH"
            }, {
            "description" : "Oklahoma",
            "key" : "OK"
            }, {
            "description" : "Oregon",
            "key" : "OR"
            }, {
            "description" : "Pahang",
            "key" : "MY-06"
            }, {
            "description" : "Palau",
            "key" : "PW"
            }, {
            "description" : "Paraná",
            "key" : "BR-PR"
            }, {
            "description" : "Paraíba",
            "key" : "BR-PB"
            }, {
            "description" : "Pará",
            "key" : "BR-PA"
            }, {
            "description" : "Penang",
            "key" : "MY-07"
            }, {
            "description" : "Pennsylvania",
            "key" : "PA"
            }, {
            "description" : "Perak",
            "key" : "MY-08"
            }, {
            "description" : "Perlis",
            "key" : "MY-09"
            }, {
            "description" : "Pernambuco",
            "key" : "BR-PE"
            }, {
            "description" : "Piauí",
            "key" : "BR-PI"
            }, {
            "description" : "Puebla",
            "key" : "MX-PU"
            }, {
            "description" : "Puerto Rico",
            "key" : "PR"
            }, {
            "description" : "Punjab",
            "key" : "IN-PB"
            }, {
            "description" : "Putumayo",
            "key" : "CO-PUT"
            }, {
            "description" : "Queensland",
            "key" : "AU-QLD"
            }, {
            "description" : "Querétaro",
            "key" : "MX-QT"
            }, {
            "description" : "Quindío",
            "key" : "CO-QUI"
            }, {
            "description" : "Quintana Roo",
            "key" : "MX-QR"
            }, {
            "description" : "Rheinland-Pfalz",
            "key" : "DE-RP"
            }, {
            "description" : "Rhode Island",
            "key" : "RI"
            }, {
            "description" : "Rio Grande do Norte",
            "key" : "BR-RN"
            }, {
            "description" : "Rio Grande do Sul",
            "key" : "BR-RS"
            }, {
            "description" : "Rio de Janeiro",
            "key" : "BR-RJ"
            }, {
            "description" : "Risaralda",
            "key" : "CO-RIS"
            }, {
            "description" : "Rondônia",
            "key" : "BR-RO"
            }, {
            "description" : "Roraima",
            "key" : "BR-RR"
            }, {
            "description" : "Rājasthān",
            "key" : "IN-RJ"
            }, {
            "description" : "Saarland",
            "key" : "DE-SL"
            }, {
            "description" : "Sabah",
            "key" : "MY-12"
            }, {
            "description" : "Sachsen",
            "key" : "DE-SN"
            }, {
            "description" : "Sachsen-Anhalt",
            "key" : "DE-ST"
            }, {
            "description" : "San Andrés y Providencia",
            "key" : "CO-SAP"
            }, {
            "description" : "San Luis Potosí",
            "key" : "MX-SL"
            }, {
            "description" : "Santa Catarina",
            "key" : "BR-SC"
            }, {
            "description" : "Santander",
            "key" : "CO-SAN"
            }, {
            "description" : "Sarawak",
            "key" : "MY-13"
            }, {
            "description" : "Schaffhausen",
            "key" : "CH-SH"
            }, {
            "description" : "Schleswig-Holstein",
            "key" : "DE-SH"
            }, {
            "description" : "Schwyz",
            "key" : "CH-SZ"
            }, {
            "description" : "Selangor",
            "key" : "MY-10"
            }, {
            "description" : "Sergipe",
            "key" : "BR-SE"
            }, {
            "description" : "Sikkim",
            "key" : "IN-SK"
            }, {
            "description" : "Sinaloa",
            "key" : "MX-SI"
            }, {
            "description" : "Solothurn",
            "key" : "CH-SO"
            }, {
            "description" : "Sonora",
            "key" : "MX-SO"
            }, {
            "description" : "South Australia",
            "key" : "AU-SA"
            }, {
            "description" : "South Carolina",
            "key" : "SC"
            }, {
            "description" : "South Dakota",
            "key" : "SD"
            }, {
            "description" : "St. Gallen",
            "key" : "CH-SG"
            }, {
            "description" : "Sucre",
            "key" : "CO-SUC"
            }, {
            "description" : "São Paulo",
            "key" : "BR-SP"
            }, {
            "description" : "Tabasco",
            "key" : "MX-TB"
            }, {
            "description" : "Tamaulipas",
            "key" : "MX-TM"
            }, {
            "description" : "Tamil Nādu",
            "key" : "IN-TN"
            }, {
            "description" : "Tasmania",
            "key" : "AU-TAS"
            }, {
            "description" : "Telangāna",
            "key" : "IN-TG"
            }, {
            "description" : "Tennessee",
            "key" : "TN"
            }, {
            "description" : "Terengganu",
            "key" : "MY-11"
            }, {
            "description" : "Texas",
            "key" : "TX"
            }, {
            "description" : "Thurgau",
            "key" : "CH-TG"
            }, {
            "description" : "Thüringen",
            "key" : "DE-TH"
            }, {
            "description" : "Ticino",
            "key" : "CH-TI"
            }, {
            "description" : "Tlaxcala",
            "key" : "MX-TL"
            }, {
            "description" : "Tocantins",
            "key" : "BR-TO"
            }, {
            "description" : "Tolima",
            "key" : "CO-TOL"
            }, {
            "description" : "Tripura",
            "key" : "IN-TR"
            }, {
            "description" : "U.S. Minor Outlying Islands",
            "key" : "UM"
            }, {
            "description" : "Uri",
            "key" : "CH-UR"
            }, {
            "description" : "Utah",
            "key" : "UT"
            }, {
            "description" : "Uttar Pradesh",
            "key" : "IN-UP"
            }, {
            "description" : "Uttarākhand",
            "key" : "IN-UT"
            }, {
            "description" : "Valais",
            "key" : "CH-VS"
            }, {
            "description" : "Valle del Cauca",
            "key" : "CO-VAC"
            }, {
            "description" : "Vaud",
            "key" : "CH-VD"
            }, {
            "description" : "Vaupés",
            "key" : "CO-VAU"
            }, {
            "description" : "Veracruz de Ignacio de la Llave",
            "key" : "MX-VE"
            }, {
            "description" : "Vermont",
            "key" : "VT"
            }, {
            "description" : "Vichada",
            "key" : "CO-VID"
            }, {
            "description" : "Victoria",
            "key" : "AU-VIC"
            }, {
            "description" : "Virgin Islands",
            "key" : "VI"
            }, {
            "description" : "Virginia",
            "key" : "VA"
            }, {
            "description" : "Washington",
            "key" : "WA"
            }, {
            "description" : "West Bengal",
            "key" : "IN-WB"
            }, {
            "description" : "West Virginia",
            "key" : "WV"
            }, {
            "description" : "Western Australia",
            "key" : "AU-WA"
            }, {
            "description" : "Wisconsin",
            "key" : "WI"
            }, {
            "description" : "Wyoming",
            "key" : "WY"
            }, {
            "description" : "Yucatán",
            "key" : "MX-YU"
            }, {
            "description" : "Zacatecas",
            "key" : "MX-ZA"
            }, {
            "description" : "Zug",
            "key" : "CH-ZG"
            }, {
            "description" : "Zürich",
            "key" : "CH-ZH"
            }, {
            "description" : "dolnośląskie",
            "key" : "PL-DŚ"
            }, {
            "description" : "kujawsko-pomorskie",
            "key" : "PL-KP"
            }, {
            "description" : "lubelskie",
            "key" : "PL-LB"
            }, {
            "description" : "lubuskie",
            "key" : "PL-LS"
            }, {
            "description" : "mazowieckie",
            "key" : "PL-MZ"
            }, {
            "description" : "małopolskie",
            "key" : "PL-MP"
            }, {
            "description" : "opolskie",
            "key" : "PL-OP"
            }, {
            "description" : "podkarpackie",
            "key" : "PL-PK"
            }, {
            "description" : "podlaskie",
            "key" : "PL-PL"
            }, {
            "description" : "pomorskie",
            "key" : "PL-PM"
            }, {
            "description" : "warmińsko-mazurskie",
            "key" : "PL-WM"
            }, {
            "description" : "wielkopolskie",
            "key" : "PL-WP"
            }, {
            "description" : "zachodniopomorskie",
            "key" : "PL-ZP"
            }, {
            "description" : "łódzkie",
            "key" : "PL-ŁD"
            }, {
            "description" : "śląskie",
            "key" : "PL-ŚL"
            }, {
            "description" : "świętokrzyskie",
            "key" : "PL-ŚK"
            }, {
            "description" : "Andaman and Nicobar Islands",
            "key" : "IN-AN"
            }, {
            "description" : "Australian Capital Territory",
            "key" : "AU-ACT"
            }, {
            "description" : "Chandigarh",
            "key" : "IN-CH"
            }, {
            "description" : "Chatham Islands",
            "key" : "NZ-CIT"
            }, {
            "description" : "Delhi",
            "key" : "IN-DL"
            }, {
            "description" : "Dādra and Nagar Haveli and Damān and Diu",
            "key" : "IN-DH"
            }, {
            "description" : "Federal Territory of Kuala Lumpur",
            "key" : "MY-14"
            }, {
            "description" : "Federal Territory of Labuan",
            "key" : "MY-15"
            }, {
            "description" : "Federal Territory of Putrajaya",
            "key" : "MY-16"
            }, {
            "description" : "Jammu and Kashmīr",
            "key" : "IN-JK"
            }, {
            "description" : "Ladākh",
            "key" : "IN-LA"
            }, {
            "description" : "Lakshadweep",
            "key" : "IN-LD"
            }, {
            "description" : "Northern Territory",
            "key" : "AU-NT"
            }, {
            "description" : "Puducherry",
            "key" : "IN-PY"
            }, {
            "description" : "Not Applicable",
            "key" : "_NA_"
            } ],
            "disabled" : "false",
            "id" : "AddProductGeo_geoId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "geoId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Geo Enum ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductGeoRest",
            "options" : [ {
            "description" : "Purchase Include Geo",
            "key" : "PG_PURCH_INCLUDE"
            }, {
            "description" : "Purchase Exclude Geo",
            "key" : "PG_PURCH_EXCLUDE"
            }, {
            "description" : "Shipment Include Geo",
            "key" : "PG_SHIP_INCLUDE"
            }, {
            "description" : "Shipment Exclude Geo",
            "key" : "PG_SHIP_EXCLUDE"
            } ],
            "disabled" : "false",
            "id" : "AddProductGeo_productGeoEnumId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productGeoEnumId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductGeo_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductGeoRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddProductGeo_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductGeo"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "idValue", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "goodIdentificationTypeId",
            "title" : "ID Type"
        }, {
            "name" : "idValue",
            "title" : "Id Value"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductGoodIdentificationsRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductGoodIdentifications_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "goodIdentificationTypeId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductGoodIdentifications_goodIdentificationTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Id Value",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "idValue",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductGoodIdentifications_idValue",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductGoodIdentificationsRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "UpdateProductGoodIdentifications_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "goodIdentificationTypeId"
            } ],
            "id" : "UpdateProductGoodIdentifications_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : "updateGoodIdentification"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "idValue", "submitButton" ]
        } ],
        "formName" : "AddProductGoodIdentificationRest",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"createGoodIdentification"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductGoodIdentification_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "ID Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "ISBN",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductGoodIdentificationRest",
            "options" : [ {
            "description" : "EAN",
            "key" : "EAN"
            }, {
            "description" : "Harmonized System Codes (HS Code)",
            "key" : "HS_CODE"
            }, {
            "description" : "ISBN",
            "key" : "ISBN"
            }, {
            "description" : "Library of Congress",
            "key" : "LOC"
            }, {
            "description" : "Manufacturer (Model) Number",
            "key" : "MANUFACTURER_ID_NO"
            }, {
            "description" : "Model Year",
            "key" : "MODEL_YEAR"
            }, {
            "description" : "Other",
            "key" : "OTHER_ID"
            }, {
            "description" : "SKU",
            "key" : "SKU"
            }, {
            "description" : "UPCA",
            "key" : "UPCA"
            }, {
            "description" : "UPCE",
            "key" : "UPCE"
            }, {
            "description" : "replacement value for partyId in the invoice export function in accounting",
            "key" : "INVOICE_EXPORT"
            } ],
            "disabled" : "false",
            "id" : "AddProductGoodIdentification_goodIdentificationTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "goodIdentificationTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "required",
            "title" : "Id Value",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "idValue",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductGoodIdentification_idValue",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductGoodIdentificationRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddProductGoodIdentification_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createGoodIdentification"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "fromDate", "thruDate", "comments", "sequenceNum", "quantity", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "productCategoryId",
            "title" : "Category [ID]"
        }, {
            "name" : "fromDate",
            "title" : "From Date  Time"
        }, {
            "name" : "thruDate",
            "title" : "Through Date  Time"
        }, {
            "name" : "comments",
            "title" : "Comments"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductCategoryMemberRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductCategoryMember_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "intra-app",
            "confirmation" : "FokofMan",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            },
            "uniqueItemName" : "Modal_c7f21122_4155_4ecf_8083_0d2f64f22a3f",
            "target" : "EditCategory",
            "targetWindow" : "",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productCategoryId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductCategoryMember_productCategoryId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
            
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductCategoryMember_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date  Time",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-17%2004:38:23.819",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "UpdateProductCategoryMemberRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "UpdateProductCategoryMember_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldHelpText" : "",
            "buttons" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "language" : "en",
            "title" : "Comments",
            "type" : "HIDDEN",
            "rows" : "3",
            "readonly" : "",
            "visualEditorEnable" : "",
            "alert" : "false",
            "name" : "comments",
            "style" : "",
            "disabled" : "false",
            "id" : "UpdateProductCategoryMember_comments",
            "value" : "",
            "cols" : "60"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductCategoryMember_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "quantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductCategoryMember_quantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductCategoryMemberRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "UpdateProductCategoryMember_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productCategoryId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "UpdateProductCategoryMember_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : "updateProductToCategory"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "fromDate", "thruDate", "comments", "sequenceNum", "quantity", "submitButton" ]
        } ],
        "formName" : "AddProductCategoryMemberRest",
        "targets":{
            "createTarget":"addProductToCategory"
        },
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductCategoryMember_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductCategoryMemberRest",
            "id" : "AddProductCategoryMember_productCategoryId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProductCategory",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productCategoryId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productCategoryId",
            "style" : "",
            "id" : "AddProductCategoryMember_productCategoryId",
            "title" : "Product Category ID",
            "type" : "LOOKUP"
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "required",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductCategoryMemberRest",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductCategoryMember_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-17%2004:41:10.121",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductCategoryMemberRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductCategoryMember_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldHelpText" : "",
            "buttons" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "language" : "en",
            "title" : "Comments",
            "type" : "TEXTAREA",
            "rows" : "3",
            "readonly" : "",
            "visualEditorEnable" : "",
            "alert" : "false",
            "name" : "comments",
            "style" : "",
            "disabled" : "false",
            "id" : "AddProductCategoryMember_comments",
            "value" : "",
            "cols" : "60"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductCategoryMember_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "quantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductCategoryMember_quantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductCategoryMemberRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductCategoryMember_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "addProductToCategory"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "keyword", "keywordTypeId", "relevancyWeight", "statusId", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "keyword",
            "title" : "Keyword"
        }, {
            "name" : "keywordTypeId",
            "title" : "Keyword Type"
        }, {
            "name" : "relevancyWeight",
            "title" : "Relevancy Weight"
        }, {
            "name" : "statusId",
            "title" : "Status ID"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductKeywordRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductKeyword_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "keyword",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductKeyword_keyword",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "keywordTypeId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductKeyword_keywordTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "relevancyWeight",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductKeyword_relevancyWeight",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "UpdateProductKeywordRest",
            "options" : [ {
            "description" : "Approved",
            "key" : "KW_APPROVED"
            }, {
            "description" : "Pending",
            "key" : "KW_PENDING"
            }, {
            "description" : "Disapproved",
            "key" : "KW_DISAPPROVED"
            } ],
            "disabled" : "false",
            "id" : "UpdateProductKeyword_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductKeywordRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "UpdateProductKeyword_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "keyword"
            }, {
            "name" : "keywordTypeId"
            } ],
            "id" : "UpdateProductKeyword_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : "updateProductKeyword"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "keyword", "keywordTypeId", "relevancyWeight", "statusId", "submitButton" ]
        } ],
        "formName" : "AddProductKeywordRest",
        "targets":{
            "createTarget":"createProductKeyword"
        },
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductKeyword_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "40",
            "tabindex" : "",
            "className" : "required",
            "title" : "Keyword",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "keyword",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductKeyword_keyword",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Keyword Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductKeywordRest",
            "options" : [ {
            "description" : "Keyword",
            "key" : "KWT_KEYWORD"
            }, {
            "description" : "Tag",
            "key" : "KWT_TAG"
            } ],
            "disabled" : "false",
            "id" : "AddProductKeyword_keywordTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "keywordTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "1",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Relevancy Weight",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "relevancyWeight",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductKeyword_relevancyWeight",
            "placeholder" : "",
            "event" : "",
            "value" : "1",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductKeywordRest",
            "options" : [ {
            "description" : "Approved",
            "key" : "KW_APPROVED"
            }, {
            "description" : "Pending",
            "key" : "KW_PENDING"
            }, {
            "description" : "Disapproved",
            "key" : "KW_DISAPPROVED"
            } ],
            "disabled" : "false",
            "id" : "AddProductKeyword_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductKeywordRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddProductKeyword_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductKeyword"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productIdTo", "productAssocTypeId", "fromDate", "thruDate", "sequenceNum", "reason", "instruction", "quantity", "editLink", "deleteButton" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "productIdTo",
            "title" : "Product ID"
        }, {
            "name" : "productAssocTypeId",
            "title" : "Association Type"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "reason",
            "title" : "Reason"
        }, {
            "name" : "instruction",
            "title" : "Instruction"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "editLink",
            "title" : "Edit Link"
        }, {
            "name" : "deleteButton",
            "title" : "Delete"
        } ],
        "formName" : "ListProductAssocsRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_f32de382_df2e_4cc6_9f5d_39ca3ad7163b",
            "target" : "EditProductAssoc",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_productId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "productId" : "",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_5f0b6de1_d16d_4b8c_a199_dd053817dda5",
            "target" : "EditProductAssoc",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditProductAssoc",
                    "formLocation":"component://kwikstore/widget/ProductForms.xml"
                }
            }
            },
            "event":"edit",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productIdTo",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_productIdTo",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productAssocTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_productAssocTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sequenceNum",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_sequenceNum",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "reason",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_reason",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "instruction",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_instruction",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_quantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Edit",
            "title" : "Edit Link",
            "type" : "HYPERLINK",
            "name" : "editLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productIdTo"
            }, {
            "name" : "productAssocTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "style" : "",
            "id" : "ListProductAssocs_editLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Delete",
            "title" : "Delete",
            "type" : "HYPERLINK",
            "name" : "deleteButton",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productIdTo"
            }, {
            "name" : "productAssocTypeId"
            }, {
            "name" : "fromDate"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "parameters.productId",
                "bracketedOriginal" : "${parameters.productId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "parameters.productId"
            },
            "name" : "lastProductId"
            } ],
            "style" : "",
            "id" : "ListProductAssocs_deleteButton",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "productIdTo", "productIdTo", "productAssocTypeId", "productAssocTypeId", "fromDate", "fromDate", "thruDate", "sequenceNum", "reason", "instruction", "quantity", "scrapFactor", "routingWorkEffortId", "estimateCalcMethod", "recurrenceInfoId", "createButton", "updateButton" ]
        } ],
        "formName" : "EditProductAssocRest",
        "targets":{
            "createTarget":"createProductAssoc"
        },
        "altTarget" : [ {
            "useWhen" : "productAssoc!=null",
            "targetExdr" : {
            "chars" : "updateProductAssoc",
            "hint" : 20,
            "empty" : false,
            "original" : "updateProductAssoc"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "scrapFactor",
            "action" : "",
            "id" : "EditProductAssoc_scrapFactor",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "routingWorkEffortId",
            "action" : "",
            "id" : "EditProductAssoc_routingWorkEffortId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "estimateCalcMethod",
            "action" : "",
            "id" : "EditProductAssoc_estimateCalcMethod",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "recurrenceInfoId",
            "action" : "",
            "id" : "EditProductAssoc_recurrenceInfoId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditProductAssocRest",
            "id" : "EditProductAssoc_productId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProduct",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productId",
            "style" : "",
            "id" : "EditProductAssoc_productId",
            "title" : "Product ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditProductAssocRest",
            "id" : "EditProductAssoc_productIdTo",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProduct",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productIdTo",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productIdTo",
            "style" : "",
            "id" : "EditProductAssoc_productIdTo",
            "title" : "Product ID To",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Association Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductAssocRest",
            "options" : [ {
            "description" : "Accessory",
            "key" : "PRODUCT_ACCESSORY"
            }, {
            "description" : "Actual Product Component",
            "key" : "PRODUCT_COMPONENT"
            }, {
            "description" : "Also Bought",
            "key" : "ALSO_BOUGHT"
            }, {
            "description" : "Alternative Packaging",
            "key" : "ALTERNATIVE_PACKAGE"
            }, {
            "description" : "Auto Reorder (needs recurrenceInfoId)",
            "key" : "PRODUCT_AUTORO"
            }, {
            "description" : "Complementary or Cross-Sell",
            "key" : "PRODUCT_COMPLEMENT"
            }, {
            "description" : "Configurable product instance",
            "key" : "PRODUCT_CONF"
            }, {
            "description" : "Engineering Bill of Materials",
            "key" : "ENGINEER_COMPONENT"
            }, {
            "description" : "Equivalent or Substitute",
            "key" : "PRODUCT_SUBSTITUTE"
            }, {
            "description" : "Incompatable",
            "key" : "PRODUCT_INCOMPATABLE"
            }, {
            "description" : "Manufacturing Bill of Materials",
            "key" : "MANUF_COMPONENT"
            }, {
            "description" : "New Version, Replacement",
            "key" : "PRODUCT_OBSOLESCENCE"
            }, {
            "description" : "Product Manufactured As",
            "key" : "PRODUCT_MANUFACTURED"
            }, {
            "description" : "Product Variant",
            "key" : "PRODUCT_VARIANT"
            }, {
            "description" : "Refurbished Equivalent",
            "key" : "PRODUCT_REFURB"
            }, {
            "description" : "Repair Service",
            "key" : "PRODUCT_REPAIR_SRV"
            }, {
            "description" : "Revision",
            "key" : "PRODUCT_REVISION"
            }, {
            "description" : "Unique Item",
            "key" : "UNIQUE_ITEM"
            }, {
            "description" : "Upgrade or Up-Sell",
            "key" : "PRODUCT_UPGRADE"
            } ],
            "disabled" : "false",
            "id" : "EditProductAssoc_productAssocTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productAssocTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductAssocRest",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProductAssoc_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-17%2006:10:02.016",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductAssocRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProductAssoc_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductAssoc_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Reason",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "reason",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductAssoc_reason",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Instruction",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "instruction",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductAssoc_instruction",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "quantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductAssoc_quantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditProductAssocRest",
            "tabindex" : "",
            "name" : "createButton",
            "className" : "",
            "id" : "EditProductAssoc_createButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductAssoc"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "workEffortGoodStdTypeId", "fromDate", "thruDate", "statusId", "estimatedQuantity", "estimatedCost", "workEffortName" ]
        } ],
        "columns" : [ {
            "name" : "workEffortId",
            "title" : "Edit"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "estimatedQuantity",
            "title" : "Estimated Quantity"
        }, {
            "name" : "estimatedCost",
            "title" : "Estimated cost"
        }, {
            "name" : "workEffortName",
            "title" : "Work Effort Name"
        } ],
        "formName" : "ListProductRoutingsRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductRoutings_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "workEffortGoodStdTypeId",
            "action" : "",
            "id" : "ListProductRoutings_workEffortGoodStdTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "ROU_PROD_TEMPLATE"
        }, {
            "conditionGroup" : "",
            "name" : "statusId",
            "action" : "",
            "id" : "ListProductRoutings_statusId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Edit",
            "type" : "HYPERLINK",
            "name" : "workEffortId",
            "width" : "",
            "parameterList" : [ {
            "name" : "workEffortId"
            } ],
            "style" : "",
            "id" : "ListProductRoutings_workEffortId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimatedQuantity",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_estimatedQuantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimatedCost",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_estimatedCost",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "workEffortName",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_workEffortName",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productIdTo", "productAssocTypeId", "fromDate", "thruDate", "sequenceNum", "reason", "quantity", "scrapFactor", "instruction", "routingWorkEffortId", "estimateCalcMethod", "recurrenceInfoId", "productName" ]
        } ],
        "columns" : [ {
            "name" : "productIdTo",
            "title" : "Edit"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "scrapFactor",
            "title" : "Scrap Factor"
        }, {
            "name" : "estimateCalcMethod",
            "title" : "Estimate Calc Method"
        }, {
            "name" : "recurrenceInfoId",
            "title" : "Recurrence Info ID"
        }, {
            "name" : "productName",
            "title" : "Product Name"
        } ],
        "formName" : "ListProductComponentsRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductComponents_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productAssocTypeId",
            "action" : "",
            "id" : "ListProductComponents_productAssocTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "MANUF_COMPONENT"
        }, {
            "conditionGroup" : "",
            "name" : "reason",
            "action" : "",
            "id" : "ListProductComponents_reason",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "instruction",
            "action" : "",
            "id" : "ListProductComponents_instruction",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "routingWorkEffortId",
            "action" : "",
            "id" : "ListProductComponents_routingWorkEffortId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Edit",
            "type" : "HYPERLINK",
            "name" : "productIdTo",
            "width" : "",
            "parameterList" : [ {
            "fromField" : {
                "isEmpty" : false,
                "original" : "productIdTo",
                "bracketedOriginal" : "${productIdTo}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "productIdTo"
            },
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProductComponents_productIdTo",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sequenceNum",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_sequenceNum",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_quantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "scrapFactor",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_scrapFactor",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimateCalcMethod",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_estimateCalcMethod",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "recurrenceInfoId",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_recurrenceInfoId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productName",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_productName",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productIdTo", "productAssocTypeId", "fromDate", "thruDate", "sequenceNum", "reason", "quantity", "scrapFactor", "instruction", "routingWorkEffortId", "estimateCalcMethod", "recurrenceInfoId", "productName" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Edit"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "estimateCalcMethod",
            "title" : "Estimate Calc Method"
        }, {
            "name" : "recurrenceInfoId",
            "title" : "Recurrence Info ID"
        }, {
            "name" : "productName",
            "title" : "Product Name"
        } ],
        "formName" : "ListProductParentsRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productIdTo",
            "action" : "",
            "id" : "ListProductParents_productIdTo",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productAssocTypeId",
            "action" : "",
            "id" : "ListProductParents_productAssocTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "MANUF_COMPONENT"
        }, {
            "conditionGroup" : "",
            "name" : "sequenceNum",
            "action" : "",
            "id" : "ListProductParents_sequenceNum",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "reason",
            "action" : "",
            "id" : "ListProductParents_reason",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "scrapFactor",
            "action" : "",
            "id" : "ListProductParents_scrapFactor",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "instruction",
            "action" : "",
            "id" : "ListProductParents_instruction",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "routingWorkEffortId",
            "action" : "",
            "id" : "ListProductParents_routingWorkEffortId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Edit",
            "type" : "HYPERLINK",
            "name" : "productId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProductParents_productId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_quantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimateCalcMethod",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_estimateCalcMethod",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "recurrenceInfoId",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_recurrenceInfoId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productName",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_productName",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "attrName", "attrValue", "attrType", "attrDescription", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "attrName",
            "title" : "Attr Name"
        }, {
            "name" : "attrValue",
            "title" : "Attr Value"
        }, {
            "name" : "attrType",
            "title" : "Attr Type"
        }, {
            "name" : "attrDescription",
            "title" : "Attr Description"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductAttributeRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductAttribute_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "attrName",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductAttribute_attrName",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Value",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrValue",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductAttribute_attrValue",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Type",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrType",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductAttribute_attrType",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrDescription",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductAttribute_attrDescription",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductAttributeRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "UpdateProductAttribute_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "attrName"
            } ],
            "id" : "UpdateProductAttribute_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : "updateProductAttribute"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "attrName", "attrValue", "attrType", "attrDescription", "submitButton" ]
        } ],
        "formName" : "AddProductAttributeRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductAttribute_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "required",
            "title" : "Attr Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductAttribute_attrName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Value",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrValue",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductAttribute_attrValue",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Type",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrType",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductAttribute_attrType",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrDescription",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductAttribute_attrDescription",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductAttributeRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddProductAttribute_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductAttribute"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureId", "uomId", "productFeatureTypeId", "productFeatureCategoryId", "fromDate", "thruDate", "sequenceNum", "productFeatureApplTypeId", "_rowSubmit" ]
        } ],
        "columns" : [ {
            "name" : "productFeatureId",
            "title" : "Product Name ID"
        }, {
            "name" : "uomId",
            "title" : "Uom ID"
        }, {
            "name" : "productFeatureTypeId",
            "title" : "Type"
        }, {
            "name" : "productFeatureCategoryId",
            "title" : "Category"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence"
        }, {
            "name" : "productFeatureApplTypeId",
            "title" : "Type"
        }, {
            "name" : "_rowSubmit",
            "title" : "Select"
        } ],
        "formName" : "UpdateFeatureToProductApplication",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "multi",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateFeatureToProductApplication_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "[]",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_8d47951e_c1d5_40f5_a416_bc0f0fd4924e",
            "target" : "EditProductFeature",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productFeatureId",
            "description" : "",
            "style" : "",
            "id" : "UpdateFeatureToProductApplication_productFeatureId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "uomId",
            "description" : "",
            "style" : "",
            "id" : "UpdateFeatureToProductApplication_uomId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productFeatureTypeId",
            "description" : "",
            "style" : "",
            "id" : "UpdateFeatureToProductApplication_productFeatureTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "[]",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_221773bf_e883_4d0f_9606_627703c657c2",
            "target" : "EditProductFeatureCategory",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productFeatureCategoryId",
            "description" : "",
            "style" : "",
            "id" : "UpdateFeatureToProductApplication_productFeatureCategoryId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "UpdateFeatureToProductApplication_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-02-18%2013:07:16.033",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "UpdateFeatureToProductApplication",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "UpdateFeatureToProductApplication_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateFeatureToProductApplication_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "UpdateFeatureToProductApplication",
            "options" : [ {
            "description" : "Distinguishing",
            "key" : "DISTINGUISHING_FEAT"
            }, {
            "description" : "Optional",
            "key" : "OPTIONAL_FEATURE"
            }, {
            "description" : "Required",
            "key" : "REQUIRED_FEATURE"
            }, {
            "description" : "Selectable",
            "key" : "SELECTABLE_FEATURE"
            }, {
            "description" : "Standard",
            "key" : "STANDARD_FEATURE"
            } ],
            "disabled" : "false",
            "id" : "UpdateFeatureToProductApplication_productFeatureApplTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureApplTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "showSelectAll" : "Y",
            "name" : "_rowSubmit",
            "style" : "",
            "id" : "UpdateFeatureToProductApplication__rowSubmit",
            "title" : "Select",
            "type" : "CHECK"
        } ],
        "target" : "UpdateFeatureToProductApplication"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "workEffortGoodStdTypeId", "fromDate", "thruDate", "statusId", "estimatedQuantity", "estimatedCost", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "workEffortId",
            "title" : "Work Effort ID"
        }, {
            "name" : "workEffortGoodStdTypeId",
            "title" : "Work Effort Good Std Type ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "estimatedQuantity",
            "title" : "Estimated Quantity"
        }, {
            "name" : "estimatedCost",
            "title" : "Estimated cost"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "ListProductWorkEffortsRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductWorkEfforts_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "inter-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_fcfda52a_31a8_4c23_a5ac_8f4b301fe560",
            "target" : "/workeffort/control/EditWorkEffort",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditWorkEffort",
                    "formLocation" : "component://kwikstore/widget/ProductForms.xml",
                }
            }
            },
            "event":"edit",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "workEffortId",
            "description" : "",
            "style" : "",
            "id" : "ListProductWorkEfforts_workEffortId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "workEffortGoodStdTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListProductWorkEfforts_workEffortGoodStdTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductWorkEfforts_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-01%2008:03:43.952",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListProductWorkEffortsRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListProductWorkEfforts_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductWorkEffortsRest",
            "options" : [ {
            "description" : "Cancelled",
            "key" : "WEGS_CANCELLED"
            }, {
            "description" : "Completed",
            "key" : "WEGS_COMPLETED"
            }, {
            "description" : "Created",
            "key" : "WEGS_CREATED"
            } ],
            "disabled" : "false",
            "id" : "ListProductWorkEfforts_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Estimated Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "estimatedQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductWorkEfforts_estimatedQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Estimated cost",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "estimatedCost",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductWorkEfforts_estimatedCost",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListProductWorkEffortsRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ListProductWorkEfforts_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "[Delete]",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "workEffortId"
            }, {
            "name" : "workEffortGoodStdTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "ListProductWorkEfforts_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "removeWorkEffortGoodStandard"
        } ],
        "target" : "updateWorkEffortGoodStandard"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "workEffortGoodStdTypeId", "fromDate", "thruDate", "statusId", "estimatedQuantity", "estimatedCost", "submitButton" ]
        } ],
        "formName" : "AddProductWorkEffortRest",
        "altTarget" : [ ],
        "targets":{
            createTarget:"createWorkEffortGoodStandard"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductWorkEffort_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductWorkEffortRest",
            "id" : "AddProductWorkEffort_workEffortId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupWorkEffort",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "workEffortId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "workEffortId",
            "style" : "",
            "id" : "AddProductWorkEffort_workEffortId",
            "title" : "Work Effort ID",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Work Effort Good Std Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductWorkEffortRest",
            "options" : [ {
            "description" : "Product and Routing Association",
            "key" : "ROU_PROD_TEMPLATE"
            }, {
            "description" : "Product and Workeffort Association in scrum",
            "key" : "SCRUM_PRO_WORKEFF"
            }, {
            "description" : "Product to Represent General Sales of the WorkEffort",
            "key" : "GENERAL_SALES"
            }, {
            "description" : "Production Run Task and Deliverable Product Association",
            "key" : "PRUNT_PROD_DELIV"
            }, {
            "description" : "Production Run Task and Needed Product Association",
            "key" : "PRUNT_PROD_NEEDED"
            }, {
            "description" : "Production Run and Product to Deliver Association",
            "key" : "PRUN_PROD_DELIV"
            } ],
            "disabled" : "false",
            "id" : "AddProductWorkEffort_workEffortGoodStdTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "workEffortGoodStdTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "required",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductWorkEffortRest",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductWorkEffort_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-01%2008:23:47.36",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductWorkEffortRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductWorkEffort_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductWorkEffortRest",
            "options" : [ {
            "description" : "Cancelled",
            "key" : "WEGS_CANCELLED"
            }, {
            "description" : "Completed",
            "key" : "WEGS_COMPLETED"
            }, {
            "description" : "Created",
            "key" : "WEGS_CREATED"
            } ],
            "disabled" : "false",
            "id" : "AddProductWorkEffort_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Estimated Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "estimatedQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductWorkEffort_estimatedQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Estimated cost",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "estimatedCost",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductWorkEffort_estimatedCost",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductWorkEffortRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductWorkEffort_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createWorkEffortGoodStandard"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "roleTypeId", "fromDate", "thruDate", "sequenceNum", "comments", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "partyId",
            "title" : "Party"
        }, {
            "name" : "roleTypeId",
            "title" : "Role"
        }, {
            "name" : "fromDate",
            "title" : "From Date  Time"
        }, {
            "name" : "thruDate",
            "title" : "Through Date  Time"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "comments",
            "title" : "Comments"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductRoleRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductRole_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "inter-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_1f633e3b_f824_4d36_88bb_4c763a8ad7aa",
            "target" : "/partymgr/control/viewprofile",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"viewprofile",
                    "formLocation":"component://kwikstore/widget/ProductForms.xml"
                }
            }
            },
            "event":"view",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductRole_partyId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "roleTypeId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductRole_roleTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductRole_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date  Time",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-01%2010:33:43.561",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "UpdateProductRoleRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "UpdateProductRole_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "5",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductRole_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "30",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Comments",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "comments",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductRole_comments",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductRoleRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "UpdateProductRole_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "partyId"
            }, {
            "name" : "roleTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "UpdateProductRole_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "removePartyFromProduct"
        } ],
        "target" : "updatePartyToProduct"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "roleTypeId", "fromDate", "thruDate", "sequenceNum", "comments", "submitButton" ]
        } ],
        "formName" : "AddProductRoleRest",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"addPartyToProduct"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductRole_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductRoleRest",
            "id" : "AddProductRole_partyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "partyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "partyId",
            "style" : "",
            "id" : "AddProductRole_partyId",
            "title" : "Party ID",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Role Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductRoleRest",
            "options" : [ {
            "description" : "Account",
            "key" : "ACCOUNT"
            }, {
            "description" : "Account Lead",
            "key" : "ACCOUNT_LEAD"
            }, {
            "description" : "Accountant",
            "key" : "ACCOUNTANT"
            }, {
            "description" : "Addressee",
            "key" : "ADDRESSEE"
            }, {
            "description" : "Administrator",
            "key" : "ADMIN"
            }, {
            "description" : "Affiliate",
            "key" : "AFFILIATE"
            }, {
            "description" : "Agent",
            "key" : "AGENT"
            }, {
            "description" : "Approver",
            "key" : "APPROVER"
            }, {
            "description" : "Association",
            "key" : "ASSOCIATION"
            }, {
            "description" : "Automated Agent",
            "key" : "AUTOMATED_AGENT_ROLE"
            }, {
            "description" : "Bill-From-Vendor",
            "key" : "BILL_FROM_VENDOR"
            }, {
            "description" : "Bill-To Customer",
            "key" : "BILL_TO_CUSTOMER"
            }, {
            "description" : "Blind Copy",
            "key" : "BCC"
            }, {
            "description" : "Budget Application",
            "key" : "BUDGET_APPL"
            }, {
            "description" : "Budget Approver",
            "key" : "BUDGET_APPRV"
            }, {
            "description" : "Budget Manager",
            "key" : "BUDGET_MGR"
            }, {
            "description" : "Budget Reviewer",
            "key" : "BUDGET_RVR"
            }, {
            "description" : "Budget Roles Group (not to be assigned to parties)",
            "key" : "BUDGET"
            }, {
            "description" : "Bulk Customer",
            "key" : "BULK_CUSTOMER"
            }, {
            "description" : "Buyer",
            "key" : "BUYER"
            }, {
            "description" : "Calendar",
            "key" : "CALENDAR_ROLE"
            }, {
            "description" : "Calendar Attendee",
            "key" : "CAL_ATTENDEE"
            }, {
            "description" : "Calendar Delegate",
            "key" : "CAL_DELEGATE"
            }, {
            "description" : "Calendar Host",
            "key" : "CAL_HOST"
            }, {
            "description" : "Calendar Member",
            "key" : "ICAL_MEMBER"
            }, {
            "description" : "Calendar Organizer",
            "key" : "CAL_ORGANIZER"
            }, {
            "description" : "Calendar Owner",
            "key" : "CAL_OWNER"
            }, {
            "description" : "Carbon Copy",
            "key" : "CC"
            }, {
            "description" : "Carrier",
            "key" : "CARRIER"
            }, {
            "description" : "Cashier",
            "key" : "CASHIER"
            }, {
            "description" : "Client",
            "key" : "CLIENT"
            }, {
            "description" : "Client Analyst",
            "key" : "CLIENT_ANALYST"
            }, {
            "description" : "Client Billing",
            "key" : "CLIENT_BILLING"
            }, {
            "description" : "Client Manager",
            "key" : "CLIENT_MANAGER"
            }, {
            "description" : "Communication Participant",
            "key" : "COMMEVENT_ROLE"
            }, {
            "description" : "Competitor",
            "key" : "COMPETITOR"
            }, {
            "description" : "Consumer",
            "key" : "CONSUMER"
            }, {
            "description" : "Contact",
            "key" : "CONTACT"
            }, {
            "description" : "Content Administrator",
            "key" : "CONTENT_ADMIN"
            }, {
            "description" : "Content Author",
            "key" : "CONTENT_AUTHOR"
            }, {
            "description" : "Content Editor",
            "key" : "CONTENT_EDITOR"
            }, {
            "description" : "Content Guest",
            "key" : "CONTENT_GUEST"
            }, {
            "description" : "Content Member",
            "key" : "CONTENT"
            }, {
            "description" : "Content Publisher",
            "key" : "CONTENT_PUBLISHER"
            }, {
            "description" : "Content User",
            "key" : "CONTENT_USER"
            }, {
            "description" : "Contractor",
            "key" : "CONTRACTOR"
            }, {
            "description" : "Customer",
            "key" : "CUSTOMER"
            }, {
            "description" : "Department",
            "key" : "DEPARTMENT"
            }, {
            "description" : "Distribution Channel",
            "key" : "DISTRIBUTION_CHANNEL"
            }, {
            "description" : "Distributor",
            "key" : "DISTRIBUTOR"
            }, {
            "description" : "Division",
            "key" : "DIVISION"
            }, {
            "description" : "Email Administrator",
            "key" : "EMAIL_ADMIN"
            }, {
            "description" : "Employee",
            "key" : "EMPLOYEE"
            }, {
            "description" : "Employer",
            "key" : "EMPLOYER"
            }, {
            "description" : "End-User Customer",
            "key" : "END_USER_CUSTOMER"
            }, {
            "description" : "Family Member",
            "key" : "FAMILY_MEMBER"
            }, {
            "description" : "Fixed Asset Maint Assignee",
            "key" : "FAM_ASSIGNEE"
            }, {
            "description" : "Government Agency",
            "key" : "GOV_AGENCY"
            }, {
            "description" : "Hosting Server",
            "key" : "HOSTING_SERVER"
            }, {
            "description" : "Household",
            "key" : "HOUSEHOLD"
            }, {
            "description" : "ISP",
            "key" : "ISP"
            }, {
            "description" : "Image Approver",
            "key" : "IMAGEAPPROVER"
            }, {
            "description" : "Internal Organization",
            "key" : "INTERNAL_ORGANIZATIO"
            }, {
            "description" : "Lead",
            "key" : "LEAD"
            }, {
            "description" : "Limited Administrator",
            "key" : "LTD_ADMIN"
            }, {
            "description" : "Logged In",
            "key" : "LOGGEDIN"
            }, {
            "description" : "Main Role",
            "key" : "MAIN_ROLE"
            }, {
            "description" : "Maintenance Manager or Supervisor",
            "key" : "FAM_MANAGER"
            }, {
            "description" : "Maintenance Supplier or Service",
            "key" : "FAM_SUPPLIER"
            }, {
            "description" : "Maintenance Worker",
            "key" : "FAM_WORKER"
            }, {
            "description" : "Manager",
            "key" : "MANAGER"
            }, {
            "description" : "Manufacturer",
            "key" : "MANUFACTURER"
            }, {
            "description" : "Not Applicable",
            "key" : "_NA_"
            }, {
            "description" : "Order Clerk",
            "key" : "ORDER_CLERK"
            }, {
            "description" : "Organization",
            "key" : "ORGANIZATION_ROLE"
            }, {
            "description" : "Organization Unit",
            "key" : "ORGANIZATION_UNIT"
            }, {
            "description" : "Originator",
            "key" : "ORIGINATOR"
            }, {
            "description" : "Other Internal",
            "key" : "OTHER_INTERNAL_ORGAN"
            }, {
            "description" : "Other Organization Unit",
            "key" : "OTHER_ORGANIZATION_U"
            }, {
            "description" : "Owner",
            "key" : "OWNER"
            }, {
            "description" : "Packer",
            "key" : "PACKER"
            }, {
            "description" : "Parent Organization",
            "key" : "PARENT_ORGANIZATION"
            }, {
            "description" : "Partner",
            "key" : "PARTNER"
            }, {
            "description" : "Person",
            "key" : "PERSON_ROLE"
            }, {
            "description" : "Picker",
            "key" : "PICKER"
            }, {
            "description" : "Placing Customer",
            "key" : "PLACING_CUSTOMER"
            }, {
            "description" : "Product Owner",
            "key" : "PRODUCT_OWNER"
            }, {
            "description" : "Product Owner Company",
            "key" : "PRODUCT_OWNER_COMP"
            }, {
            "description" : "Project Team",
            "key" : "PROJECT_TEAM"
            }, {
            "description" : "Prospect",
            "key" : "PROSPECT"
            }, {
            "description" : "Provider Accounting",
            "key" : "PROVIDER_ACCOUNTING"
            }, {
            "description" : "Provider Analyst",
            "key" : "PROVIDER_ANALYST"
            }, {
            "description" : "Provider Functional",
            "key" : "PROVIDER_FUNCTIONAL"
            }, {
            "description" : "Provider Manager",
            "key" : "PROVIDER_MANAGER"
            }, {
            "description" : "Provider Tester",
            "key" : "PROVIDER_TESTER"
            }, {
            "description" : "Provider Validator",
            "key" : "PROVIDER_VALIDATOR"
            }, {
            "description" : "Receiver",
            "key" : "RECEIVER"
            }, {
            "description" : "Referrer",
            "key" : "REFERRER"
            }, {
            "description" : "Regulatory Agency",
            "key" : "REGULATORY_AGENCY"
            }, {
            "description" : "Request Manager",
            "key" : "REQ_MANAGER"
            }, {
            "description" : "Request Respondent",
            "key" : "REQ_RESPOND"
            }, {
            "description" : "Request Role",
            "key" : "REQUEST_ROLE"
            }, {
            "description" : "Request Taker",
            "key" : "REQ_TAKER"
            }, {
            "description" : "Requesting Party",
            "key" : "REQ_REQUESTER"
            }, {
            "description" : "Reviewer",
            "key" : "REVIEWER"
            }, {
            "description" : "SCRUM Master",
            "key" : "SCRUM_MASTER"
            }, {
            "description" : "SCRUM Team",
            "key" : "SCRUM_TEAM"
            }, {
            "description" : "Sales Force Autm.",
            "key" : "SFA_ROLE"
            }, {
            "description" : "Sales Representative",
            "key" : "SALES_REP"
            }, {
            "description" : "Scrum Member",
            "key" : "SCRUM_MEMBER"
            }, {
            "description" : "Shareholder",
            "key" : "SHAREHOLDER"
            }, {
            "description" : "Ship-From Vendor",
            "key" : "SHIP_FROM_VENDOR"
            }, {
            "description" : "Ship-To Customer",
            "key" : "SHIP_TO_CUSTOMER"
            }, {
            "description" : "Shipment Clerk",
            "key" : "SHIPMENT_CLERK"
            }, {
            "description" : "Sponsor",
            "key" : "SPONSOR"
            }, {
            "description" : "Spouse",
            "key" : "SPOUSE"
            }, {
            "description" : "Stakeholder",
            "key" : "STAKEHOLDER"
            }, {
            "description" : "Stocker",
            "key" : "STOCKER"
            }, {
            "description" : "Subscriber",
            "key" : "SUBSCRIBER"
            }, {
            "description" : "Subsidiary",
            "key" : "SUBSIDIARY"
            }, {
            "description" : "Supplier",
            "key" : "SUPPLIER"
            }, {
            "description" : "Supplier Agent",
            "key" : "SUPPLIER_AGENT"
            }, {
            "description" : "Tax Authority",
            "key" : "TAX_AUTHORITY"
            }, {
            "description" : "Union",
            "key" : "UNION"
            }, {
            "description" : "Vendor",
            "key" : "VENDOR"
            }, {
            "description" : "Visitor",
            "key" : "VISITOR"
            }, {
            "description" : "Web Master",
            "key" : "WEB_MASTER"
            }, {
            "description" : "Worker",
            "key" : "WORKER"
            }, {
            "description" : "Workflow",
            "key" : "WORKFLOW_ROLE"
            }, {
            "description" : "Workflow Owner",
            "key" : "WF_OWNER"
            } ],
            "disabled" : "false",
            "id" : "AddProductRole_roleTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "roleTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "required",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductRoleRest",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductRole_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-01%2010:50:04.637",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductRoleRest",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductRole_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductRole_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Comments",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "comments",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductRole_comments",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductRoleRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductRole_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "addPartyToProduct"
    },
    {
      "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "subject", "communicationEventTypeId", "contactMechTypeId", "statusId", "lastUpdatedStampCE", "contactMechIdTo", "content" ]
      } ],
      "columns" : [ {
        "name" : "communicationEventId",
        "title" : "Communication Event ID"
      }, {
        "name" : "subject",
        "title" : "Subject"
      }, {
        "name" : "communicationEventTypeId",
        "title" : "Comm.Type ID"
      }, {
        "name" : "contactMechTypeId",
        "title" : "Contact Mech Type ID"
      }, {
        "name" : "statusId",
        "title" : "Status"
      }, {
        "name" : "lastUpdatedStampCE",
        "title" : "Email Sent On"
      }, {
        "name" : "contactMechIdTo",
        "title" : "To Email Address"
      }, {
        "name" : "content",
        "title" : "Content"
      } ],
      "formName" : "ListCommEventsRest",
      "altTarget" : [ ],
      "formLocation" : "component://kwikstore/widget/ProductForms.xml",
      "type" : "list",
      "fields" : [ {
        "image" : "",
        "fieldHelpText" : "",
        "alternate" : "",
        "description" : "",
        "title" : "Communication Event ID",
        "type" : "HYPERLINK",
        "target" : "/partymgr/control/EditCommunicationEvent?communicationEventId=",
        "name" : "communicationEventId",
        "width" : "",
        "parameterList" : [ ],
        "style" : "",
        "id" : "ListCommEvents_communicationEventId",
        "imageTitle" : "",
        "parameterMap" : { },
        "height" : "",
        "formData":{
            "formName":"EditCommunicationEvent",
            "formLocation":"component://kwikstore/widget/ProductForms.xml"
        },
        "event":"edit"
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "subject",
        "description" : "",
        "style" : "",
        "id" : "ListCommEvents_subject",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "communicationEventTypeId",
        "description" : "",
        "style" : "",
        "id" : "ListCommEvents_communicationEventTypeId",
        "title" : "",
        "type" : "DISPLAY_ENTITY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "contactMechTypeId",
        "description" : "",
        "style" : "",
        "id" : "ListCommEvents_contactMechTypeId",
        "title" : "",
        "type" : "DISPLAY_ENTITY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "statusId",
        "description" : "",
        "style" : "",
        "id" : "ListCommEvents_statusId",
        "title" : "",
        "type" : "DISPLAY_ENTITY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "lastUpdatedStampCE",
        "description" : "",
        "style" : "",
        "id" : "ListCommEvents_lastUpdatedStampCE",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "contactMechIdTo",
        "description" : "",
        "style" : "",
        "id" : "ListCommEvents_contactMechIdTo",
        "title" : "",
        "type" : "DISPLAY_ENTITY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "content",
        "description" : "",
        "style" : "",
        "id" : "ListCommEvents_content",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      } ],
    },
    {
      "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "communicationEventId", "my", "parentCommEventId", "communicationEventTypeId", "statusId", "partyIdFrom", "partyIdTo", "contactMechTypeId", "contactMechIdFrom", "contactMechIdTo", "roleTypeIdFrom", "roleTypeIdTo", "contactListId", "datetimeStarted", "datetimeEnded", "subject", "reasonEnumId", "contentMimeTypeId", "content", "note", "messageId", "submitButton", "productId" ]
      } ],
      "formName" : "EditCommEventRest",
      "targets":{
        "createTargeut":"createCommunicationEvent",
        "updateTarget":"updateCommunicationEvent"
      },
      "altTarget" : [ {
        "useWhen" : "communicationEvent==null",
        "targetExdr" : {
          "chars" : "createCommunicationEvent",
          "hint" : 20,
          "empty" : false,
          "original" : "createCommunicationEvent"
        }
      } ],
      "formLocation" : "component://kwikstore/widget/ProductForms.xml",
      "type" : "single",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "action",
        "action" : "",
        "id" : "EditCommEvent_action",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "my",
        "action" : "",
        "id" : "EditCommEvent_my",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "messageId",
        "action" : "",
        "id" : "EditCommEvent_messageId",
        "type" : "DISPLAY",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "productId",
        "action" : "",
        "id" : "EditCommEvent_productId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "" ],
          "className" : "",
          "type" : "LOOKUP",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditCommEventRest",
          "id" : "EditCommEvent_parentCommEventId",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupCommEvent",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "parentCommEventId",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "parentCommEventId",
        "style" : "",
        "id" : "EditCommEvent_parentCommEventId",
        "title" : "Parent Comm Event ID",
        "type" : "LOOKUP"
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Comm.Type ID",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditCommEventRest",
        "options" : [ {
          "description" : "Auto Email",
          "key" : "AUTO_EMAIL_COMM"
        }, {
          "description" : "Comment/Note",
          "key" : "COMMENT_NOTE"
        }, {
          "description" : "Email",
          "key" : "EMAIL_COMMUNICATION"
        }, {
          "description" : "Face-To-Face",
          "key" : "FACE_TO_FACE_COMMUNI"
        }, {
          "description" : "Fax",
          "key" : "FAX_COMMUNICATION"
        }, {
          "description" : "File transfer",
          "key" : "FILE_TRANSFER_COMM"
        }, {
          "description" : "Letter",
          "key" : "LETTER_CORRESPONDENC"
        }, {
          "description" : "Phone",
          "key" : "PHONE_COMMUNICATION"
        }, {
          "description" : "Web Site",
          "key" : "WEB_SITE_COMMUNICATI"
        } ],
        "disabled" : "false",
        "id" : "EditCommEvent_communicationEventTypeId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "communicationEventTypeId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Status",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditCommEventRest",
        "options" : [ {
          "description" : "Pending",
          "key" : "COM_PENDING"
        }, {
          "description" : "Entered",
          "key" : "COM_ENTERED"
        }, {
          "description" : "In-Progress",
          "key" : "COM_IN_PROGRESS"
        }, {
          "description" : "Unknown Party",
          "key" : "COM_UNKNOWN_PARTY"
        }, {
          "description" : "Complete",
          "key" : "COM_COMPLETE"
        }, {
          "description" : "Resolved",
          "key" : "COM_RESOLVED"
        }, {
          "description" : "Referred",
          "key" : "COM_REFERRED"
        }, {
          "description" : "Bounced",
          "key" : "COM_BOUNCED"
        }, {
          "description" : "Cancelled",
          "key" : "COM_CANCELLED"
        } ],
        "disabled" : "false",
        "id" : "EditCommEvent_statusId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "statusId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "" ],
          "className" : "",
          "type" : "LOOKUP",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditCommEventRest",
          "id" : "EditCommEvent_partyIdFrom",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupPartyName",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "partyIdFrom",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "partyIdFrom",
        "style" : "",
        "id" : "EditCommEvent_partyIdFrom",
        "title" : "Party From",
        "type" : "LOOKUP"
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "" ],
          "className" : "",
          "type" : "LOOKUP",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditCommEventRest",
          "id" : "EditCommEvent_partyIdTo",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupPartyName",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "partyIdTo",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "partyIdTo",
        "style" : "",
        "id" : "EditCommEvent_partyIdTo",
        "title" : "Party To",
        "type" : "LOOKUP"
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Contact Mech Type ID",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditCommEventRest",
        "options" : [ {
          "description" : "Electronic Address",
          "key" : "ELECTRONIC_ADDRESS"
        }, {
          "description" : "Postal Address",
          "key" : "POSTAL_ADDRESS"
        }, {
          "description" : "Phone Number",
          "key" : "TELECOM_NUMBER"
        }, {
          "description" : "Email Address",
          "key" : "EMAIL_ADDRESS"
        }, {
          "description" : "Internet IP Address",
          "key" : "IP_ADDRESS"
        }, {
          "description" : "Internet Domain Name",
          "key" : "DOMAIN_NAME"
        }, {
          "description" : "Web URL/Address",
          "key" : "WEB_ADDRESS"
        }, {
          "description" : "Internal Party Note",
          "key" : "INTERNAL_PARTYID"
        }, {
          "description" : "File server",
          "key" : "FTP_ADDRESS"
        }, {
          "description" : "LDAP Address",
          "key" : "LDAP_ADDRESS"
        } ],
        "disabled" : "false",
        "id" : "EditCommEvent_contactMechTypeId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "contactMechTypeId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "partyIdFrom" ],
          "className" : "",
          "type" : "LOOKUP",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditCommEventRest",
          "id" : "EditCommEvent_contactMechIdFrom",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupPreferredContactMech",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "contactMechIdFrom",
          "descriptionFieldName" : "partyIdFrom",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "contactMechIdFrom",
        "style" : "",
        "id" : "EditCommEvent_contactMechIdFrom",
        "title" : "From Contact Mech",
        "type" : "LOOKUP"
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "partyIdTo" ],
          "className" : "",
          "type" : "LOOKUP",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditCommEventRest",
          "id" : "EditCommEvent_contactMechIdTo",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupPreferredContactMech",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "contactMechIdTo",
          "descriptionFieldName" : "partyIdTo",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "contactMechIdTo",
        "style" : "",
        "id" : "EditCommEvent_contactMechIdTo",
        "title" : "To Contact Mech",
        "type" : "LOOKUP"
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Role Type Id From",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "_NA_",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditCommEventRest",
        "options" : [ {
          "description" : "Account",
          "key" : "ACCOUNT"
        }, {
          "description" : "Account Lead",
          "key" : "ACCOUNT_LEAD"
        }, {
          "description" : "Accountant",
          "key" : "ACCOUNTANT"
        }, {
          "description" : "Addressee",
          "key" : "ADDRESSEE"
        }, {
          "description" : "Administrator",
          "key" : "ADMIN"
        }, {
          "description" : "Affiliate",
          "key" : "AFFILIATE"
        }, {
          "description" : "Agent",
          "key" : "AGENT"
        }, {
          "description" : "Approver",
          "key" : "APPROVER"
        }, {
          "description" : "Association",
          "key" : "ASSOCIATION"
        }, {
          "description" : "Automated Agent",
          "key" : "AUTOMATED_AGENT_ROLE"
        }, {
          "description" : "Bill-From-Vendor",
          "key" : "BILL_FROM_VENDOR"
        }, {
          "description" : "Bill-To Customer",
          "key" : "BILL_TO_CUSTOMER"
        }, {
          "description" : "Blind Copy",
          "key" : "BCC"
        }, {
          "description" : "Budget Application",
          "key" : "BUDGET_APPL"
        }, {
          "description" : "Budget Approver",
          "key" : "BUDGET_APPRV"
        }, {
          "description" : "Budget Manager",
          "key" : "BUDGET_MGR"
        }, {
          "description" : "Budget Reviewer",
          "key" : "BUDGET_RVR"
        }, {
          "description" : "Budget Roles Group (not to be assigned to parties)",
          "key" : "BUDGET"
        }, {
          "description" : "Bulk Customer",
          "key" : "BULK_CUSTOMER"
        }, {
          "description" : "Buyer",
          "key" : "BUYER"
        }, {
          "description" : "Calendar",
          "key" : "CALENDAR_ROLE"
        }, {
          "description" : "Calendar Attendee",
          "key" : "CAL_ATTENDEE"
        }, {
          "description" : "Calendar Delegate",
          "key" : "CAL_DELEGATE"
        }, {
          "description" : "Calendar Host",
          "key" : "CAL_HOST"
        }, {
          "description" : "Calendar Member",
          "key" : "ICAL_MEMBER"
        }, {
          "description" : "Calendar Organizer",
          "key" : "CAL_ORGANIZER"
        }, {
          "description" : "Calendar Owner",
          "key" : "CAL_OWNER"
        }, {
          "description" : "Carbon Copy",
          "key" : "CC"
        }, {
          "description" : "Carrier",
          "key" : "CARRIER"
        }, {
          "description" : "Cashier",
          "key" : "CASHIER"
        }, {
          "description" : "Client",
          "key" : "CLIENT"
        }, {
          "description" : "Client Analyst",
          "key" : "CLIENT_ANALYST"
        }, {
          "description" : "Client Billing",
          "key" : "CLIENT_BILLING"
        }, {
          "description" : "Client Manager",
          "key" : "CLIENT_MANAGER"
        }, {
          "description" : "Communication Participant",
          "key" : "COMMEVENT_ROLE"
        }, {
          "description" : "Competitor",
          "key" : "COMPETITOR"
        }, {
          "description" : "Consumer",
          "key" : "CONSUMER"
        }, {
          "description" : "Contact",
          "key" : "CONTACT"
        }, {
          "description" : "Content Administrator",
          "key" : "CONTENT_ADMIN"
        }, {
          "description" : "Content Author",
          "key" : "CONTENT_AUTHOR"
        }, {
          "description" : "Content Editor",
          "key" : "CONTENT_EDITOR"
        }, {
          "description" : "Content Guest",
          "key" : "CONTENT_GUEST"
        }, {
          "description" : "Content Member",
          "key" : "CONTENT"
        }, {
          "description" : "Content Publisher",
          "key" : "CONTENT_PUBLISHER"
        }, {
          "description" : "Content User",
          "key" : "CONTENT_USER"
        }, {
          "description" : "Contractor",
          "key" : "CONTRACTOR"
        }, {
          "description" : "Customer",
          "key" : "CUSTOMER"
        }, {
          "description" : "Department",
          "key" : "DEPARTMENT"
        }, {
          "description" : "Distribution Channel",
          "key" : "DISTRIBUTION_CHANNEL"
        }, {
          "description" : "Distributor",
          "key" : "DISTRIBUTOR"
        }, {
          "description" : "Division",
          "key" : "DIVISION"
        }, {
          "description" : "Email Administrator",
          "key" : "EMAIL_ADMIN"
        }, {
          "description" : "Employee",
          "key" : "EMPLOYEE"
        }, {
          "description" : "Employer",
          "key" : "EMPLOYER"
        }, {
          "description" : "End-User Customer",
          "key" : "END_USER_CUSTOMER"
        }, {
          "description" : "Family Member",
          "key" : "FAMILY_MEMBER"
        }, {
          "description" : "Fixed Asset Maint Assignee",
          "key" : "FAM_ASSIGNEE"
        }, {
          "description" : "Government Agency",
          "key" : "GOV_AGENCY"
        }, {
          "description" : "Hosting Server",
          "key" : "HOSTING_SERVER"
        }, {
          "description" : "Household",
          "key" : "HOUSEHOLD"
        }, {
          "description" : "ISP",
          "key" : "ISP"
        }, {
          "description" : "Image Approver",
          "key" : "IMAGEAPPROVER"
        }, {
          "description" : "Internal Organization",
          "key" : "INTERNAL_ORGANIZATIO"
        }, {
          "description" : "Lead",
          "key" : "LEAD"
        }, {
          "description" : "Limited Administrator",
          "key" : "LTD_ADMIN"
        }, {
          "description" : "Logged In",
          "key" : "LOGGEDIN"
        }, {
          "description" : "Main Role",
          "key" : "MAIN_ROLE"
        }, {
          "description" : "Maintenance Manager or Supervisor",
          "key" : "FAM_MANAGER"
        }, {
          "description" : "Maintenance Supplier or Service",
          "key" : "FAM_SUPPLIER"
        }, {
          "description" : "Maintenance Worker",
          "key" : "FAM_WORKER"
        }, {
          "description" : "Manager",
          "key" : "MANAGER"
        }, {
          "description" : "Manufacturer",
          "key" : "MANUFACTURER"
        }, {
          "description" : "Not Applicable",
          "key" : "_NA_"
        }, {
          "description" : "Order Clerk",
          "key" : "ORDER_CLERK"
        }, {
          "description" : "Organization",
          "key" : "ORGANIZATION_ROLE"
        }, {
          "description" : "Organization Unit",
          "key" : "ORGANIZATION_UNIT"
        }, {
          "description" : "Originator",
          "key" : "ORIGINATOR"
        }, {
          "description" : "Other Internal",
          "key" : "OTHER_INTERNAL_ORGAN"
        }, {
          "description" : "Other Organization Unit",
          "key" : "OTHER_ORGANIZATION_U"
        }, {
          "description" : "Owner",
          "key" : "OWNER"
        }, {
          "description" : "Packer",
          "key" : "PACKER"
        }, {
          "description" : "Parent Organization",
          "key" : "PARENT_ORGANIZATION"
        }, {
          "description" : "Partner",
          "key" : "PARTNER"
        }, {
          "description" : "Person",
          "key" : "PERSON_ROLE"
        }, {
          "description" : "Picker",
          "key" : "PICKER"
        }, {
          "description" : "Placing Customer",
          "key" : "PLACING_CUSTOMER"
        }, {
          "description" : "Product Owner",
          "key" : "PRODUCT_OWNER"
        }, {
          "description" : "Product Owner Company",
          "key" : "PRODUCT_OWNER_COMP"
        }, {
          "description" : "Project Team",
          "key" : "PROJECT_TEAM"
        }, {
          "description" : "Prospect",
          "key" : "PROSPECT"
        }, {
          "description" : "Provider Accounting",
          "key" : "PROVIDER_ACCOUNTING"
        }, {
          "description" : "Provider Analyst",
          "key" : "PROVIDER_ANALYST"
        }, {
          "description" : "Provider Functional",
          "key" : "PROVIDER_FUNCTIONAL"
        }, {
          "description" : "Provider Manager",
          "key" : "PROVIDER_MANAGER"
        }, {
          "description" : "Provider Tester",
          "key" : "PROVIDER_TESTER"
        }, {
          "description" : "Provider Validator",
          "key" : "PROVIDER_VALIDATOR"
        }, {
          "description" : "Receiver",
          "key" : "RECEIVER"
        }, {
          "description" : "Referrer",
          "key" : "REFERRER"
        }, {
          "description" : "Regulatory Agency",
          "key" : "REGULATORY_AGENCY"
        }, {
          "description" : "Request Manager",
          "key" : "REQ_MANAGER"
        }, {
          "description" : "Request Respondent",
          "key" : "REQ_RESPOND"
        }, {
          "description" : "Request Role",
          "key" : "REQUEST_ROLE"
        }, {
          "description" : "Request Taker",
          "key" : "REQ_TAKER"
        }, {
          "description" : "Requesting Party",
          "key" : "REQ_REQUESTER"
        }, {
          "description" : "Reviewer",
          "key" : "REVIEWER"
        }, {
          "description" : "SCRUM Master",
          "key" : "SCRUM_MASTER"
        }, {
          "description" : "SCRUM Team",
          "key" : "SCRUM_TEAM"
        }, {
          "description" : "Sales Force Autm.",
          "key" : "SFA_ROLE"
        }, {
          "description" : "Sales Representative",
          "key" : "SALES_REP"
        }, {
          "description" : "Scrum Member",
          "key" : "SCRUM_MEMBER"
        }, {
          "description" : "Shareholder",
          "key" : "SHAREHOLDER"
        }, {
          "description" : "Ship-From Vendor",
          "key" : "SHIP_FROM_VENDOR"
        }, {
          "description" : "Ship-To Customer",
          "key" : "SHIP_TO_CUSTOMER"
        }, {
          "description" : "Shipment Clerk",
          "key" : "SHIPMENT_CLERK"
        }, {
          "description" : "Sponsor",
          "key" : "SPONSOR"
        }, {
          "description" : "Spouse",
          "key" : "SPOUSE"
        }, {
          "description" : "Stakeholder",
          "key" : "STAKEHOLDER"
        }, {
          "description" : "Stocker",
          "key" : "STOCKER"
        }, {
          "description" : "Subscriber",
          "key" : "SUBSCRIBER"
        }, {
          "description" : "Subsidiary",
          "key" : "SUBSIDIARY"
        }, {
          "description" : "Supplier",
          "key" : "SUPPLIER"
        }, {
          "description" : "Supplier Agent",
          "key" : "SUPPLIER_AGENT"
        }, {
          "description" : "Tax Authority",
          "key" : "TAX_AUTHORITY"
        }, {
          "description" : "Union",
          "key" : "UNION"
        }, {
          "description" : "Vendor",
          "key" : "VENDOR"
        }, {
          "description" : "Visitor",
          "key" : "VISITOR"
        }, {
          "description" : "Web Master",
          "key" : "WEB_MASTER"
        }, {
          "description" : "Worker",
          "key" : "WORKER"
        }, {
          "description" : "Workflow",
          "key" : "WORKFLOW_ROLE"
        }, {
          "description" : "Workflow Owner",
          "key" : "WF_OWNER"
        } ],
        "disabled" : "false",
        "id" : "EditCommEvent_roleTypeIdFrom",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "roleTypeIdFrom",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Role Type Id To",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "_NA_",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditCommEventRest",
        "options" : [ {
          "description" : "Account",
          "key" : "ACCOUNT"
        }, {
          "description" : "Account Lead",
          "key" : "ACCOUNT_LEAD"
        }, {
          "description" : "Accountant",
          "key" : "ACCOUNTANT"
        }, {
          "description" : "Addressee",
          "key" : "ADDRESSEE"
        }, {
          "description" : "Administrator",
          "key" : "ADMIN"
        }, {
          "description" : "Affiliate",
          "key" : "AFFILIATE"
        }, {
          "description" : "Agent",
          "key" : "AGENT"
        }, {
          "description" : "Approver",
          "key" : "APPROVER"
        }, {
          "description" : "Association",
          "key" : "ASSOCIATION"
        }, {
          "description" : "Automated Agent",
          "key" : "AUTOMATED_AGENT_ROLE"
        }, {
          "description" : "Bill-From-Vendor",
          "key" : "BILL_FROM_VENDOR"
        }, {
          "description" : "Bill-To Customer",
          "key" : "BILL_TO_CUSTOMER"
        }, {
          "description" : "Blind Copy",
          "key" : "BCC"
        }, {
          "description" : "Budget Application",
          "key" : "BUDGET_APPL"
        }, {
          "description" : "Budget Approver",
          "key" : "BUDGET_APPRV"
        }, {
          "description" : "Budget Manager",
          "key" : "BUDGET_MGR"
        }, {
          "description" : "Budget Reviewer",
          "key" : "BUDGET_RVR"
        }, {
          "description" : "Budget Roles Group (not to be assigned to parties)",
          "key" : "BUDGET"
        }, {
          "description" : "Bulk Customer",
          "key" : "BULK_CUSTOMER"
        }, {
          "description" : "Buyer",
          "key" : "BUYER"
        }, {
          "description" : "Calendar",
          "key" : "CALENDAR_ROLE"
        }, {
          "description" : "Calendar Attendee",
          "key" : "CAL_ATTENDEE"
        }, {
          "description" : "Calendar Delegate",
          "key" : "CAL_DELEGATE"
        }, {
          "description" : "Calendar Host",
          "key" : "CAL_HOST"
        }, {
          "description" : "Calendar Member",
          "key" : "ICAL_MEMBER"
        }, {
          "description" : "Calendar Organizer",
          "key" : "CAL_ORGANIZER"
        }, {
          "description" : "Calendar Owner",
          "key" : "CAL_OWNER"
        }, {
          "description" : "Carbon Copy",
          "key" : "CC"
        }, {
          "description" : "Carrier",
          "key" : "CARRIER"
        }, {
          "description" : "Cashier",
          "key" : "CASHIER"
        }, {
          "description" : "Client",
          "key" : "CLIENT"
        }, {
          "description" : "Client Analyst",
          "key" : "CLIENT_ANALYST"
        }, {
          "description" : "Client Billing",
          "key" : "CLIENT_BILLING"
        }, {
          "description" : "Client Manager",
          "key" : "CLIENT_MANAGER"
        }, {
          "description" : "Communication Participant",
          "key" : "COMMEVENT_ROLE"
        }, {
          "description" : "Competitor",
          "key" : "COMPETITOR"
        }, {
          "description" : "Consumer",
          "key" : "CONSUMER"
        }, {
          "description" : "Contact",
          "key" : "CONTACT"
        }, {
          "description" : "Content Administrator",
          "key" : "CONTENT_ADMIN"
        }, {
          "description" : "Content Author",
          "key" : "CONTENT_AUTHOR"
        }, {
          "description" : "Content Editor",
          "key" : "CONTENT_EDITOR"
        }, {
          "description" : "Content Guest",
          "key" : "CONTENT_GUEST"
        }, {
          "description" : "Content Member",
          "key" : "CONTENT"
        }, {
          "description" : "Content Publisher",
          "key" : "CONTENT_PUBLISHER"
        }, {
          "description" : "Content User",
          "key" : "CONTENT_USER"
        }, {
          "description" : "Contractor",
          "key" : "CONTRACTOR"
        }, {
          "description" : "Customer",
          "key" : "CUSTOMER"
        }, {
          "description" : "Department",
          "key" : "DEPARTMENT"
        }, {
          "description" : "Distribution Channel",
          "key" : "DISTRIBUTION_CHANNEL"
        }, {
          "description" : "Distributor",
          "key" : "DISTRIBUTOR"
        }, {
          "description" : "Division",
          "key" : "DIVISION"
        }, {
          "description" : "Email Administrator",
          "key" : "EMAIL_ADMIN"
        }, {
          "description" : "Employee",
          "key" : "EMPLOYEE"
        }, {
          "description" : "Employer",
          "key" : "EMPLOYER"
        }, {
          "description" : "End-User Customer",
          "key" : "END_USER_CUSTOMER"
        }, {
          "description" : "Family Member",
          "key" : "FAMILY_MEMBER"
        }, {
          "description" : "Fixed Asset Maint Assignee",
          "key" : "FAM_ASSIGNEE"
        }, {
          "description" : "Government Agency",
          "key" : "GOV_AGENCY"
        }, {
          "description" : "Hosting Server",
          "key" : "HOSTING_SERVER"
        }, {
          "description" : "Household",
          "key" : "HOUSEHOLD"
        }, {
          "description" : "ISP",
          "key" : "ISP"
        }, {
          "description" : "Image Approver",
          "key" : "IMAGEAPPROVER"
        }, {
          "description" : "Internal Organization",
          "key" : "INTERNAL_ORGANIZATIO"
        }, {
          "description" : "Lead",
          "key" : "LEAD"
        }, {
          "description" : "Limited Administrator",
          "key" : "LTD_ADMIN"
        }, {
          "description" : "Logged In",
          "key" : "LOGGEDIN"
        }, {
          "description" : "Main Role",
          "key" : "MAIN_ROLE"
        }, {
          "description" : "Maintenance Manager or Supervisor",
          "key" : "FAM_MANAGER"
        }, {
          "description" : "Maintenance Supplier or Service",
          "key" : "FAM_SUPPLIER"
        }, {
          "description" : "Maintenance Worker",
          "key" : "FAM_WORKER"
        }, {
          "description" : "Manager",
          "key" : "MANAGER"
        }, {
          "description" : "Manufacturer",
          "key" : "MANUFACTURER"
        }, {
          "description" : "Not Applicable",
          "key" : "_NA_"
        }, {
          "description" : "Order Clerk",
          "key" : "ORDER_CLERK"
        }, {
          "description" : "Organization",
          "key" : "ORGANIZATION_ROLE"
        }, {
          "description" : "Organization Unit",
          "key" : "ORGANIZATION_UNIT"
        }, {
          "description" : "Originator",
          "key" : "ORIGINATOR"
        }, {
          "description" : "Other Internal",
          "key" : "OTHER_INTERNAL_ORGAN"
        }, {
          "description" : "Other Organization Unit",
          "key" : "OTHER_ORGANIZATION_U"
        }, {
          "description" : "Owner",
          "key" : "OWNER"
        }, {
          "description" : "Packer",
          "key" : "PACKER"
        }, {
          "description" : "Parent Organization",
          "key" : "PARENT_ORGANIZATION"
        }, {
          "description" : "Partner",
          "key" : "PARTNER"
        }, {
          "description" : "Person",
          "key" : "PERSON_ROLE"
        }, {
          "description" : "Picker",
          "key" : "PICKER"
        }, {
          "description" : "Placing Customer",
          "key" : "PLACING_CUSTOMER"
        }, {
          "description" : "Product Owner",
          "key" : "PRODUCT_OWNER"
        }, {
          "description" : "Product Owner Company",
          "key" : "PRODUCT_OWNER_COMP"
        }, {
          "description" : "Project Team",
          "key" : "PROJECT_TEAM"
        }, {
          "description" : "Prospect",
          "key" : "PROSPECT"
        }, {
          "description" : "Provider Accounting",
          "key" : "PROVIDER_ACCOUNTING"
        }, {
          "description" : "Provider Analyst",
          "key" : "PROVIDER_ANALYST"
        }, {
          "description" : "Provider Functional",
          "key" : "PROVIDER_FUNCTIONAL"
        }, {
          "description" : "Provider Manager",
          "key" : "PROVIDER_MANAGER"
        }, {
          "description" : "Provider Tester",
          "key" : "PROVIDER_TESTER"
        }, {
          "description" : "Provider Validator",
          "key" : "PROVIDER_VALIDATOR"
        }, {
          "description" : "Receiver",
          "key" : "RECEIVER"
        }, {
          "description" : "Referrer",
          "key" : "REFERRER"
        }, {
          "description" : "Regulatory Agency",
          "key" : "REGULATORY_AGENCY"
        }, {
          "description" : "Request Manager",
          "key" : "REQ_MANAGER"
        }, {
          "description" : "Request Respondent",
          "key" : "REQ_RESPOND"
        }, {
          "description" : "Request Role",
          "key" : "REQUEST_ROLE"
        }, {
          "description" : "Request Taker",
          "key" : "REQ_TAKER"
        }, {
          "description" : "Requesting Party",
          "key" : "REQ_REQUESTER"
        }, {
          "description" : "Reviewer",
          "key" : "REVIEWER"
        }, {
          "description" : "SCRUM Master",
          "key" : "SCRUM_MASTER"
        }, {
          "description" : "SCRUM Team",
          "key" : "SCRUM_TEAM"
        }, {
          "description" : "Sales Force Autm.",
          "key" : "SFA_ROLE"
        }, {
          "description" : "Sales Representative",
          "key" : "SALES_REP"
        }, {
          "description" : "Scrum Member",
          "key" : "SCRUM_MEMBER"
        }, {
          "description" : "Shareholder",
          "key" : "SHAREHOLDER"
        }, {
          "description" : "Ship-From Vendor",
          "key" : "SHIP_FROM_VENDOR"
        }, {
          "description" : "Ship-To Customer",
          "key" : "SHIP_TO_CUSTOMER"
        }, {
          "description" : "Shipment Clerk",
          "key" : "SHIPMENT_CLERK"
        }, {
          "description" : "Sponsor",
          "key" : "SPONSOR"
        }, {
          "description" : "Spouse",
          "key" : "SPOUSE"
        }, {
          "description" : "Stakeholder",
          "key" : "STAKEHOLDER"
        }, {
          "description" : "Stocker",
          "key" : "STOCKER"
        }, {
          "description" : "Subscriber",
          "key" : "SUBSCRIBER"
        }, {
          "description" : "Subsidiary",
          "key" : "SUBSIDIARY"
        }, {
          "description" : "Supplier",
          "key" : "SUPPLIER"
        }, {
          "description" : "Supplier Agent",
          "key" : "SUPPLIER_AGENT"
        }, {
          "description" : "Tax Authority",
          "key" : "TAX_AUTHORITY"
        }, {
          "description" : "Union",
          "key" : "UNION"
        }, {
          "description" : "Vendor",
          "key" : "VENDOR"
        }, {
          "description" : "Visitor",
          "key" : "VISITOR"
        }, {
          "description" : "Web Master",
          "key" : "WEB_MASTER"
        }, {
          "description" : "Worker",
          "key" : "WORKER"
        }, {
          "description" : "Workflow",
          "key" : "WORKFLOW_ROLE"
        }, {
          "description" : "Workflow Owner",
          "key" : "WF_OWNER"
        } ],
        "disabled" : "false",
        "id" : "EditCommEvent_roleTypeIdTo",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "roleTypeIdTo",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "" ],
          "className" : "",
          "type" : "LOOKUP",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditCommEventRest",
          "id" : "EditCommEvent_contactListId",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupContactList",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "20",
          "name" : "contactListId",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "contactListId",
        "style" : "",
        "id" : "EditCommEvent_contactListId",
        "title" : "Contact List ID",
        "type" : "LOOKUP"
      }, {
        "classString" : "",
        "shortDateInput" : "false",
        "ampmName" : "",
        "className" : "",
        "title" : "Start Date",
        "type" : "DATE_TIME",
        "dateType" : "timestamp",
        "defaultDateTimeString" : "2023-03-01%2014:33:48.591",
        "timeDropdown" : "text",
        "alert" : "false",
        "timeValues" : "",
        "formName" : "EditCommEventRest",
        "timeDropdownParamName" : "datetimeStarted",
        "timeMinutesName" : "",
        "disabled" : "false",
        "id" : "EditCommEvent_datetimeStarted",
        "event" : "",
        "value" : "",
        "pmSelected" : "",
        "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
        "mask" : "",
        "hour1" : "0",
        "isTwelveHour" : "false",
        "fieldHelpText" : "",
        "hour2" : "0",
        "maxlength" : "30",
        "minutes" : "0",
        "tabindex" : "",
        "amSelected" : "",
        "size" : "25",
        "isXMLHttpRequest" : "false",
        "localizedIconTitle" : "View Calendar",
        "timeHourName" : "",
        "name" : "datetimeStarted",
        "style" : "",
        "step" : "1",
        "compositeType" : ""
      }, {
        "classString" : "",
        "shortDateInput" : "false",
        "ampmName" : "",
        "className" : "",
        "title" : "Finish Date/Time",
        "type" : "DATE_TIME",
        "dateType" : "timestamp",
        "defaultDateTimeString" : "2023-03-01%2014:33:48.595",
        "timeDropdown" : "text",
        "alert" : "false",
        "timeValues" : "",
        "formName" : "EditCommEventRest",
        "timeDropdownParamName" : "datetimeEnded",
        "timeMinutesName" : "",
        "disabled" : "false",
        "id" : "EditCommEvent_datetimeEnded",
        "event" : "",
        "value" : "",
        "pmSelected" : "",
        "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
        "mask" : "",
        "hour1" : "0",
        "isTwelveHour" : "false",
        "fieldHelpText" : "",
        "hour2" : "0",
        "maxlength" : "30",
        "minutes" : "0",
        "tabindex" : "",
        "amSelected" : "",
        "size" : "25",
        "isXMLHttpRequest" : "false",
        "localizedIconTitle" : "View Calendar",
        "timeHourName" : "",
        "name" : "datetimeEnded",
        "style" : "",
        "step" : "1",
        "compositeType" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "60",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Subject",
        "type" : "TEXT",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "subject",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditCommEvent_subject",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Reason Enum ID",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "Y",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditCommEventRest",
        "options" : [ ],
        "disabled" : "false",
        "id" : "EditCommEvent_reasonEnumId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "reasonEnumId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Content Mime Type ID",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "text/plain",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditCommEventRest",
        "options" : [ {
          "description" : "application/msword",
          "key" : "application/msword"
        }, {
          "description" : "application/octet-stream",
          "key" : "application/octet-stream"
        }, {
          "description" : "application/pdf",
          "key" : "application/pdf"
        }, {
          "description" : "application/pkcs7-signature",
          "key" : "application/pkcs7-signature"
        }, {
          "description" : "application/postscript",
          "key" : "application/postscript"
        }, {
          "description" : "application/vnd.ms-excel",
          "key" : "application/vnd.ms-excel"
        }, {
          "description" : "application/vnd.ms-powerpoint",
          "key" : "application/vnd.ms-powerpoint"
        }, {
          "description" : "application/vnd.oasis.opendocument.spreadsheet",
          "key" : "application/vnd.oasis.opendocument.spreadsheet"
        }, {
          "description" : "application/vnd.oasis.opendocument.text",
          "key" : "application/vnd.oasis.opendocument.text"
        }, {
          "description" : "application/vnd.ofbiz.survey",
          "key" : "application/vnd.ofbiz.survey"
        }, {
          "description" : "application/vnd.ofbiz.survey.response",
          "key" : "application/vnd.ofbiz.survey.response"
        }, {
          "description" : "application/x-shockwave-flash",
          "key" : "application/x-shockwave-flash"
        }, {
          "description" : "application/x-tgz",
          "key" : "application/x-tgz"
        }, {
          "description" : "application/x-zip-compressed",
          "key" : "application/x-zip-compressed"
        }, {
          "description" : "application/zip",
          "key" : "application/zip"
        }, {
          "description" : "audio/basic",
          "key" : "audio/basic"
        }, {
          "description" : "audio/flac",
          "key" : "audio/flac"
        }, {
          "description" : "audio/mp4",
          "key" : "audio/mp4"
        }, {
          "description" : "audio/mpeg",
          "key" : "audio/mpeg"
        }, {
          "description" : "audio/ogg",
          "key" : "audio/ogg"
        }, {
          "description" : "audio/vorbis",
          "key" : "audio/vorbis"
        }, {
          "description" : "audio/wav",
          "key" : "audio/wav"
        }, {
          "description" : "audio/x-flac",
          "key" : "audio/x-flac"
        }, {
          "description" : "audio/x-ms-wax",
          "key" : "audio/x-ms-wax"
        }, {
          "description" : "audio/x-ogg",
          "key" : "audio/x-ogg"
        }, {
          "description" : "image/gif",
          "key" : "image/gif"
        }, {
          "description" : "image/jpeg",
          "key" : "image/jpeg"
        }, {
          "description" : "image/pjpeg",
          "key" : "image/pjpeg"
        }, {
          "description" : "image/png",
          "key" : "image/png"
        }, {
          "description" : "image/svg+xml",
          "key" : "image/svg+xml"
        }, {
          "description" : "image/tiff",
          "key" : "image/tiff"
        }, {
          "description" : "message/external-body",
          "key" : "message/external-body"
        }, {
          "description" : "message/http",
          "key" : "message/http"
        }, {
          "description" : "message/news",
          "key" : "message/news"
        }, {
          "description" : "message/partial",
          "key" : "message/partial"
        }, {
          "description" : "message/rfc822",
          "key" : "message/rfc822"
        }, {
          "description" : "message/s-http",
          "key" : "message/s-http"
        }, {
          "description" : "model/mesh",
          "key" : "model/mesh"
        }, {
          "description" : "model/vrml",
          "key" : "model/vrml"
        }, {
          "description" : "multipart/alternative",
          "key" : "multipart/alternative"
        }, {
          "description" : "multipart/digest",
          "key" : "multipart/digest"
        }, {
          "description" : "multipart/encrypted",
          "key" : "multipart/encrypted"
        }, {
          "description" : "multipart/form-data",
          "key" : "multipart/form-data"
        }, {
          "description" : "multipart/mixed",
          "key" : "multipart/mixed"
        }, {
          "description" : "multipart/related",
          "key" : "multipart/related"
        }, {
          "description" : "multipart/signed",
          "key" : "multipart/signed"
        }, {
          "description" : "text/css",
          "key" : "text/css"
        }, {
          "description" : "text/csv",
          "key" : "text/csv"
        }, {
          "description" : "text/enriched",
          "key" : "text/enriched"
        }, {
          "description" : "text/html",
          "key" : "text/html"
        }, {
          "description" : "text/plain",
          "key" : "text/plain"
        }, {
          "description" : "text/richtext",
          "key" : "text/richtext"
        }, {
          "description" : "text/rtf",
          "key" : "text/rtf"
        }, {
          "description" : "text/sgml",
          "key" : "text/sgml"
        }, {
          "description" : "text/tab-separated-values",
          "key" : "text/tab-separated-values"
        }, {
          "description" : "text/x-diff",
          "key" : "text/x-diff"
        }, {
          "description" : "text/x-vcard",
          "key" : "text/x-vcard"
        }, {
          "description" : "text/xml",
          "key" : "text/xml"
        }, {
          "description" : "video/3gpp",
          "key" : "video/3gpp"
        }, {
          "description" : "video/avi",
          "key" : "video/avi"
        }, {
          "description" : "video/mp4",
          "key" : "video/mp4"
        }, {
          "description" : "video/mpeg",
          "key" : "video/mpeg"
        }, {
          "description" : "video/quicktime",
          "key" : "video/quicktime"
        }, {
          "description" : "video/x-flv",
          "key" : "video/x-flv"
        }, {
          "description" : "video/x-ms-asf",
          "key" : "video/x-ms-asf"
        }, {
          "description" : "video/x-ms-wm",
          "key" : "video/x-ms-wm"
        }, {
          "description" : "video/x-ms-wmv",
          "key" : "video/x-ms-wmv"
        }, {
          "description" : "video/x-ms-wmx",
          "key" : "video/x-ms-wmx"
        }, {
          "description" : "video/x-ms-wvx",
          "key" : "video/x-ms-wvx"
        } ],
        "disabled" : "false",
        "id" : "EditCommEvent_contentMimeTypeId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "contentMimeTypeId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldHelpText" : "",
        "buttons" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "language" : "en",
        "title" : "Content",
        "type" : "TEXTAREA",
        "rows" : "10",
        "readonly" : "",
        "visualEditorEnable" : "",
        "alert" : "false",
        "name" : "content",
        "style" : "",
        "disabled" : "false",
        "id" : "EditCommEvent_content",
        "value" : "",
        "cols" : "60"
      }, {
        "fieldHelpText" : "",
        "buttons" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "language" : "en",
        "title" : "Note",
        "type" : "TEXTAREA",
        "rows" : "3",
        "readonly" : "",
        "visualEditorEnable" : "",
        "alert" : "false",
        "name" : "note",
        "style" : "",
        "disabled" : "false",
        "id" : "EditCommEvent_note",
        "value" : "",
        "cols" : "60"
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "messageId",
        "description" : "",
        "style" : "",
        "id" : "EditCommEvent_messageId",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "EditCommEventRest",
        "tabindex" : "",
        "name" : "submitButton",
        "className" : "",
        "id" : "EditCommEvent_submitButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "Save",
        "event" : "",
        "imgSrc" : ""
      } ],
      "target" : "updateCommunicationEvent"

    },
    {
      "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "geoId", "productGeoEnumId", "description", "deleteLink", "submitButton" ]
      } ],
      "columns" : [ {
        "name" : "geoId",
        "title" : "Geo ID"
      }, {
        "name" : "productGeoEnumId",
        "title" : "Product Geo Enum ID"
      }, {
        "name" : "description",
        "title" : "Description"
      }, {
        "name" : "deleteLink",
        "title" : " "
      }, {
        "name" : "submitButton",
        "title" : "Update"
      } ],
      "formName" : "ListProductGeos",
      "targets":{
        "updateTarget":"updateProductGeo"
      },
      "altTarget" : [ ],
      "formLocation" : "component://kwikstore/widget/ProductForms.xml",
      "type" : "list",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "productId",
        "action" : "",
        "id" : "ListProductGeos_productId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "geoId",
        "description" : "",
        "style" : "",
        "id" : "ListProductGeos_geoId",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Product Geo Enum ID",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "ListProductGeos",
        "options" : [ {
          "description" : "Purchase Include Geo",
          "key" : "PG_PURCH_INCLUDE"
        }, {
          "description" : "Purchase Exclude Geo",
          "key" : "PG_PURCH_EXCLUDE"
        }, {
          "description" : "Shipment Include Geo",
          "key" : "PG_SHIP_INCLUDE"
        }, {
          "description" : "Shipment Exclude Geo",
          "key" : "PG_SHIP_EXCLUDE"
        } ],
        "disabled" : "false",
        "id" : "ListProductGeos_productGeoEnumId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "productGeoEnumId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "20",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Description",
        "type" : "TEXT",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "description",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "ListProductGeos_description",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "image" : "",
        "width" : "",
        "name" : "deleteLink",
        "alternate" : "",
        "description" : "Delete",
        "parameterList" : [ {
          "name" : "productId"
        }, {
          "name" : "geoId"
        } ],
        "id" : "ListProductGeos_deleteLink",
        "imageTitle" : "",
        "parameterMap" : { },
        "height" : "",
        "target" : "deleteProductGeo"
      }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "ListProductGeos",
        "tabindex" : "",
        "name" : "submitButton",
        "className" : "",
        "id" : "ListProductGeos_submitButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "Update",
        "event" : "",
        "imgSrc" : ""
      } ],
      "target" : "updateProductGeo"
    },
    {
        "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "geoId", "productGeoEnumId", "description", "submitButton" ]
      } ],
      "formName" : "AddProductGeo",
      "altTarget" : [ ],
      targets:{
        "createTarget":"createProductGeo"
      },
      "formLocation" : "component://kwikstore/widget/ProductForms.xml",
      "type" : "single",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "productId",
        "action" : "",
        "id" : "AddProductGeo_productId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Geo ID",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "AddProductGeo",
        "options" : [ {
          "description" : "Afghanistan",
          "key" : "AFG"
        }, {
          "description" : "Albania",
          "key" : "ALB"
        }, {
          "description" : "Algeria",
          "key" : "DZA"
        }, {
          "description" : "American Samoa",
          "key" : "ASM"
        }, {
          "description" : "Andorra",
          "key" : "AND"
        }, {
          "description" : "Angola",
          "key" : "AGO"
        }, {
          "description" : "Anguilla",
          "key" : "AIA"
        }, {
          "description" : "Antarctica",
          "key" : "ATA"
        }, {
          "description" : "Antigua And Barbuda",
          "key" : "ATG"
        }, {
          "description" : "Argentina",
          "key" : "ARG"
        }, {
          "description" : "Armenia",
          "key" : "ARM"
        }, {
          "description" : "Aruba",
          "key" : "ABW"
        }, {
          "description" : "Australia",
          "key" : "AUS"
        }, {
          "description" : "Austria",
          "key" : "AUT"
        }, {
          "description" : "Azerbaijan",
          "key" : "AZE"
        }, {
          "description" : "Bahamas",
          "key" : "BHS"
        }, {
          "description" : "Bahrain",
          "key" : "BHR"
        }, {
          "description" : "Bangladesh",
          "key" : "BGD"
        }, {
          "description" : "Barbados",
          "key" : "BRB"
        }, {
          "description" : "Belarus",
          "key" : "BLR"
        }, {
          "description" : "Belgium",
          "key" : "BEL"
        }, {
          "description" : "Belize",
          "key" : "BLZ"
        }, {
          "description" : "Benin",
          "key" : "BEN"
        }, {
          "description" : "Bermuda",
          "key" : "BMU"
        }, {
          "description" : "Bhutan",
          "key" : "BTN"
        }, {
          "description" : "Bolivia",
          "key" : "BOL"
        }, {
          "description" : "Bonaire, Sint Eustatius and Saba",
          "key" : "BES"
        }, {
          "description" : "Bosnia And Herzegowina",
          "key" : "BIH"
        }, {
          "description" : "Botswana ",
          "key" : "BWA"
        }, {
          "description" : "Bouvet Island",
          "key" : "BVT"
        }, {
          "description" : "Brazil",
          "key" : "BRA"
        }, {
          "description" : "British Indian Ocean Territory",
          "key" : "IOT"
        }, {
          "description" : "Brunei Darussalam",
          "key" : "BRN"
        }, {
          "description" : "Bulgaria",
          "key" : "BGR"
        }, {
          "description" : "Burkina Faso",
          "key" : "BFA"
        }, {
          "description" : "Burundi",
          "key" : "BDI"
        }, {
          "description" : "Cambodia",
          "key" : "KHM"
        }, {
          "description" : "Cameroon",
          "key" : "CMR"
        }, {
          "description" : "Canada",
          "key" : "CAN"
        }, {
          "description" : "Cape Verde",
          "key" : "CPV"
        }, {
          "description" : "Cayman Islands",
          "key" : "CYM"
        }, {
          "description" : "Central African Republic",
          "key" : "CAF"
        }, {
          "description" : "Chad",
          "key" : "TCD"
        }, {
          "description" : "Chile",
          "key" : "CHL"
        }, {
          "description" : "China",
          "key" : "CHN"
        }, {
          "description" : "Christmas Island",
          "key" : "CXR"
        }, {
          "description" : "Cocos (keeling) Islands",
          "key" : "CCK"
        }, {
          "description" : "Colombia",
          "key" : "COL"
        }, {
          "description" : "Comoros",
          "key" : "COM"
        }, {
          "description" : "Congo",
          "key" : "COG"
        }, {
          "description" : "Congo, The Democratic Republic Of The",
          "key" : "COD"
        }, {
          "description" : "Cook Islands",
          "key" : "COK"
        }, {
          "description" : "Costa Rica",
          "key" : "CRI"
        }, {
          "description" : "Cote D\\'ivoire",
          "key" : "CIV"
        }, {
          "description" : "Croatia (local Name: Hrvatska)",
          "key" : "HRV"
        }, {
          "description" : "Cuba",
          "key" : "CUB"
        }, {
          "description" : "Curaçao",
          "key" : "CUW"
        }, {
          "description" : "Cyprus",
          "key" : "CYP"
        }, {
          "description" : "Czech Republic",
          "key" : "CZE"
        }, {
          "description" : "Denmark",
          "key" : "DNK"
        }, {
          "description" : "Djibouti",
          "key" : "DJI"
        }, {
          "description" : "Dominica",
          "key" : "DMA"
        }, {
          "description" : "Dominican Republic",
          "key" : "DOM"
        }, {
          "description" : "East Timor",
          "key" : "TLS"
        }, {
          "description" : "Ecuador",
          "key" : "ECU"
        }, {
          "description" : "Egypt",
          "key" : "EGY"
        }, {
          "description" : "El Salvador",
          "key" : "SLV"
        }, {
          "description" : "England",
          "key" : "ENGL"
        }, {
          "description" : "Equatorial Guinea",
          "key" : "GNQ"
        }, {
          "description" : "Eritrea",
          "key" : "ERI"
        }, {
          "description" : "Estonia",
          "key" : "EST"
        }, {
          "description" : "Ethiopia",
          "key" : "ETH"
        }, {
          "description" : "Falkland Islands (malvinas)",
          "key" : "FLK"
        }, {
          "description" : "Faroe Islands",
          "key" : "FRO"
        }, {
          "description" : "Fiji",
          "key" : "FJI"
        }, {
          "description" : "Finland",
          "key" : "FIN"
        }, {
          "description" : "France",
          "key" : "FRA"
        }, {
          "description" : "France, Metropolitan",
          "key" : "FXX"
        }, {
          "description" : "French Guiana",
          "key" : "GUF"
        }, {
          "description" : "French Polynesia",
          "key" : "PYF"
        }, {
          "description" : "French Southern Territories",
          "key" : "ATF"
        }, {
          "description" : "Gabon",
          "key" : "GAB"
        }, {
          "description" : "Gambia",
          "key" : "GMB"
        }, {
          "description" : "Georgia",
          "key" : "GEO"
        }, {
          "description" : "Germany",
          "key" : "DEU"
        }, {
          "description" : "Ghana",
          "key" : "GHA"
        }, {
          "description" : "Gibraltar",
          "key" : "GIB"
        }, {
          "description" : "Greece",
          "key" : "GRC"
        }, {
          "description" : "Greenland",
          "key" : "GRL"
        }, {
          "description" : "Grenada",
          "key" : "GRD"
        }, {
          "description" : "Guadeloupe",
          "key" : "GLP"
        }, {
          "description" : "Guam",
          "key" : "GUM"
        }, {
          "description" : "Guatemala",
          "key" : "GTM"
        }, {
          "description" : "Guernsey",
          "key" : "GGY"
        }, {
          "description" : "Guinea",
          "key" : "GIN"
        }, {
          "description" : "Guinea-bissau",
          "key" : "GNB"
        }, {
          "description" : "Guyana",
          "key" : "GUY"
        }, {
          "description" : "Haiti",
          "key" : "HTI"
        }, {
          "description" : "Heard And Mc Donald Islands",
          "key" : "HMD"
        }, {
          "description" : "Holy See (vatican City State)",
          "key" : "VAT"
        }, {
          "description" : "Honduras",
          "key" : "HND"
        }, {
          "description" : "Hong Kong",
          "key" : "HKG"
        }, {
          "description" : "Hungary",
          "key" : "HUN"
        }, {
          "description" : "Iceland",
          "key" : "ISL"
        }, {
          "description" : "India",
          "key" : "IND"
        }, {
          "description" : "Indonesia",
          "key" : "IDN"
        }, {
          "description" : "Iran (islamic Republic Of)",
          "key" : "IRN"
        }, {
          "description" : "Iraq",
          "key" : "IRQ"
        }, {
          "description" : "Ireland",
          "key" : "IRL"
        }, {
          "description" : "Isle of Man",
          "key" : "IMN"
        }, {
          "description" : "Israel",
          "key" : "ISR"
        }, {
          "description" : "Italy",
          "key" : "ITA"
        }, {
          "description" : "Jamaica",
          "key" : "JAM"
        }, {
          "description" : "Japan",
          "key" : "JPN"
        }, {
          "description" : "Jersey",
          "key" : "JEY"
        }, {
          "description" : "Jordan",
          "key" : "JOR"
        }, {
          "description" : "Kazakhstan",
          "key" : "KAZ"
        }, {
          "description" : "Kenya",
          "key" : "KEN"
        }, {
          "description" : "Kiribati",
          "key" : "KIR"
        }, {
          "description" : "Korea, Democratic People\\'s Republic Of",
          "key" : "PRK"
        }, {
          "description" : "Korea, Republic Of",
          "key" : "KOR"
        }, {
          "description" : "Kuwait",
          "key" : "KWT"
        }, {
          "description" : "Kyrgyzstan",
          "key" : "KGZ"
        }, {
          "description" : "Lao People\\'s Democratic Republic",
          "key" : "LAO"
        }, {
          "description" : "Latvia",
          "key" : "LVA"
        }, {
          "description" : "Lebanon",
          "key" : "LBN"
        }, {
          "description" : "Lesotho",
          "key" : "LSO"
        }, {
          "description" : "Liberia",
          "key" : "LBR"
        }, {
          "description" : "Libyan Arab Jamahiriya",
          "key" : "LBY"
        }, {
          "description" : "Liechtenstein",
          "key" : "LIE"
        }, {
          "description" : "Lithuania",
          "key" : "LTU"
        }, {
          "description" : "Luxembourg",
          "key" : "LUX"
        }, {
          "description" : "Macau",
          "key" : "MAC"
        }, {
          "description" : "Macedonia, The Former Yugoslav Republic Of",
          "key" : "MKD"
        }, {
          "description" : "Madagascar",
          "key" : "MDG"
        }, {
          "description" : "Malawi",
          "key" : "MWI"
        }, {
          "description" : "Malaysia",
          "key" : "MYS"
        }, {
          "description" : "Maldives",
          "key" : "MDV"
        }, {
          "description" : "Mali",
          "key" : "MLI"
        }, {
          "description" : "Malta",
          "key" : "MLT"
        }, {
          "description" : "Marshall Islands",
          "key" : "MHL"
        }, {
          "description" : "Martinique",
          "key" : "MTQ"
        }, {
          "description" : "Mauritania",
          "key" : "MRT"
        }, {
          "description" : "Mauritius",
          "key" : "MUS"
        }, {
          "description" : "Mayotte",
          "key" : "MYT"
        }, {
          "description" : "Mexico",
          "key" : "MEX"
        }, {
          "description" : "Micronesia, Federated States Of",
          "key" : "FSM"
        }, {
          "description" : "Moldova, Republic Of",
          "key" : "MDA"
        }, {
          "description" : "Monaco",
          "key" : "MCO"
        }, {
          "description" : "Mongolia",
          "key" : "MNG"
        }, {
          "description" : "Montenegro",
          "key" : "MNE"
        }, {
          "description" : "Montserrat",
          "key" : "MSR"
        }, {
          "description" : "Morocco",
          "key" : "MAR"
        }, {
          "description" : "Mozambique",
          "key" : "MOZ"
        }, {
          "description" : "Myanmar",
          "key" : "MMR"
        }, {
          "description" : "NIRL",
          "key" : "NIRL"
        }, {
          "description" : "Namibia",
          "key" : "NAM"
        }, {
          "description" : "Nauru",
          "key" : "NRU"
        }, {
          "description" : "Nepal",
          "key" : "NPL"
        }, {
          "description" : "Netherlands",
          "key" : "NLD"
        }, {
          "description" : "Netherlands Antilles",
          "key" : "ANT"
        }, {
          "description" : "New Caledonia",
          "key" : "NCL"
        }, {
          "description" : "New Zealand",
          "key" : "NZL"
        }, {
          "description" : "Nicaragua",
          "key" : "NIC"
        }, {
          "description" : "Niger",
          "key" : "NER"
        }, {
          "description" : "Nigeria",
          "key" : "NGA"
        }, {
          "description" : "Niue",
          "key" : "NIU"
        }, {
          "description" : "Norfolk Island",
          "key" : "NFK"
        }, {
          "description" : "Northern Mariana Islands",
          "key" : "MNP"
        }, {
          "description" : "Norway",
          "key" : "NOR"
        }, {
          "description" : "Oman",
          "key" : "OMN"
        }, {
          "description" : "Pakistan",
          "key" : "PAK"
        }, {
          "description" : "Palau",
          "key" : "PLW"
        }, {
          "description" : "Palestinian Territory, Occupied",
          "key" : "PSE"
        }, {
          "description" : "Panama",
          "key" : "PAN"
        }, {
          "description" : "Papua New Guinea",
          "key" : "PNG"
        }, {
          "description" : "Paraguay",
          "key" : "PRY"
        }, {
          "description" : "Peru",
          "key" : "PER"
        }, {
          "description" : "Philippines",
          "key" : "PHL"
        }, {
          "description" : "Pitcairn",
          "key" : "PCN"
        }, {
          "description" : "Poland",
          "key" : "POL"
        }, {
          "description" : "Portugal",
          "key" : "PRT"
        }, {
          "description" : "Puerto Rico",
          "key" : "PRI"
        }, {
          "description" : "Qatar",
          "key" : "QAT"
        }, {
          "description" : "Reunion",
          "key" : "REU"
        }, {
          "description" : "Romania",
          "key" : "ROU"
        }, {
          "description" : "Russian Federation",
          "key" : "RUS"
        }, {
          "description" : "Rwanda",
          "key" : "RWA"
        }, {
          "description" : "Saint Barthélemy",
          "key" : "BLM"
        }, {
          "description" : "Saint Kitts And Nevis",
          "key" : "KNA"
        }, {
          "description" : "Saint Lucia",
          "key" : "LCA"
        }, {
          "description" : "Saint Martin (French part)",
          "key" : "MAF"
        }, {
          "description" : "Saint Vincent And The Grenadines",
          "key" : "VCT"
        }, {
          "description" : "Samoa",
          "key" : "WSM"
        }, {
          "description" : "San Marino",
          "key" : "SMR"
        }, {
          "description" : "Sao Tome And Principe",
          "key" : "STP"
        }, {
          "description" : "Saudi Arabia",
          "key" : "SAU"
        }, {
          "description" : "Scotland",
          "key" : "SCOT"
        }, {
          "description" : "Senegal",
          "key" : "SEN"
        }, {
          "description" : "Serbia",
          "key" : "SRB"
        }, {
          "description" : "Seychelles",
          "key" : "SYC"
        }, {
          "description" : "Sierra Leone",
          "key" : "SLE"
        }, {
          "description" : "Singapore",
          "key" : "SGP"
        }, {
          "description" : "Sint Maarten (Dutch part)",
          "key" : "SXM"
        }, {
          "description" : "Slovakia (slovak Republic)",
          "key" : "SVK"
        }, {
          "description" : "Slovenia",
          "key" : "SVN"
        }, {
          "description" : "Solomon Islands",
          "key" : "SLB"
        }, {
          "description" : "Somalia",
          "key" : "SOM"
        }, {
          "description" : "South Africa",
          "key" : "ZAF"
        }, {
          "description" : "South Georgia And The South Sandwich Islands",
          "key" : "SGS"
        }, {
          "description" : "South Sudan",
          "key" : "SSD"
        }, {
          "description" : "Spain",
          "key" : "ESP"
        }, {
          "description" : "Sri Lanka",
          "key" : "LKA"
        }, {
          "description" : "St. Helena",
          "key" : "SHN"
        }, {
          "description" : "St. Pierre And Miquelon",
          "key" : "SPM"
        }, {
          "description" : "Sudan",
          "key" : "SDN"
        }, {
          "description" : "Suriname",
          "key" : "SUR"
        }, {
          "description" : "Svalbard And Jan Mayen Islands",
          "key" : "SJM"
        }, {
          "description" : "Swaziland",
          "key" : "SWZ"
        }, {
          "description" : "Sweden",
          "key" : "SWE"
        }, {
          "description" : "Switzerland",
          "key" : "CHE"
        }, {
          "description" : "Syrian Arab Republic",
          "key" : "SYR"
        }, {
          "description" : "Taiwan",
          "key" : "TWN"
        }, {
          "description" : "Tajikistan",
          "key" : "TJK"
        }, {
          "description" : "Tanzania, United Republic Of",
          "key" : "TZA"
        }, {
          "description" : "Thailand",
          "key" : "THA"
        }, {
          "description" : "Togo",
          "key" : "TGO"
        }, {
          "description" : "Tokelau",
          "key" : "TKL"
        }, {
          "description" : "Tonga",
          "key" : "TON"
        }, {
          "description" : "Trinidad And Tobago",
          "key" : "TTO"
        }, {
          "description" : "Tunisia",
          "key" : "TUN"
        }, {
          "description" : "Turkey",
          "key" : "TUR"
        }, {
          "description" : "Turkmenistan",
          "key" : "TKM"
        }, {
          "description" : "Turks And Caicos Islands",
          "key" : "TCA"
        }, {
          "description" : "Tuvalu",
          "key" : "TUV"
        }, {
          "description" : "Uganda",
          "key" : "UGA"
        }, {
          "description" : "Ukraine",
          "key" : "UKR"
        }, {
          "description" : "United Arab Emirates",
          "key" : "ARE"
        }, {
          "description" : "United Kingdom",
          "key" : "GBR"
        }, {
          "description" : "United States",
          "key" : "USA"
        }, {
          "description" : "United States Minor Outlying Islands",
          "key" : "UMI"
        }, {
          "description" : "Uruguay",
          "key" : "URY"
        }, {
          "description" : "Uzbekistan",
          "key" : "UZB"
        }, {
          "description" : "Vanuatu",
          "key" : "VUT"
        }, {
          "description" : "Venezuela",
          "key" : "VEN"
        }, {
          "description" : "Viet Nam",
          "key" : "VNM"
        }, {
          "description" : "Virgin Islands (british)",
          "key" : "VGB"
        }, {
          "description" : "Virgin Islands (u.s.)",
          "key" : "VIR"
        }, {
          "description" : "WALS",
          "key" : "WALS"
        }, {
          "description" : "Wallis And Futuna Islands",
          "key" : "WLF"
        }, {
          "description" : "Western Sahara",
          "key" : "ESH"
        }, {
          "description" : "Yemen",
          "key" : "YEM"
        }, {
          "description" : "Yugoslavia",
          "key" : "YUG"
        }, {
          "description" : "Zambia",
          "key" : "ZMB"
        }, {
          "description" : "Zimbabwe",
          "key" : "ZWE"
        }, {
          "description" : "Åland islands",
          "key" : "ALA"
        }, {
          "description" : "Aberdeenshire",
          "key" : "GB-ABDN"
        }, {
          "description" : "Ain",
          "key" : "FR-01"
        }, {
          "description" : "Aisne",
          "key" : "FR-02"
        }, {
          "description" : "Allier",
          "key" : "FR-03"
        }, {
          "description" : "Alpes de Hautes-Provence",
          "key" : "FR-04"
        }, {
          "description" : "Alpes-Maritimes",
          "key" : "FR-06"
        }, {
          "description" : "Anglesey/Sir Fon",
          "key" : "GB-AGSY"
        }, {
          "description" : "Angus/Forfarshire",
          "key" : "GB-ANGS"
        }, {
          "description" : "Antrim",
          "key" : "NIRL-ATRM"
        }, {
          "description" : "Ardennes",
          "key" : "FR-08"
        }, {
          "description" : "Ardèche",
          "key" : "FR-07"
        }, {
          "description" : "Argyllshire",
          "key" : "GB-ARGL"
        }, {
          "description" : "Ariège",
          "key" : "FR-09"
        }, {
          "description" : "Armagh",
          "key" : "NIRL-ARMG"
        }, {
          "description" : "Aube",
          "key" : "FR-10"
        }, {
          "description" : "Aude",
          "key" : "FR-11"
        }, {
          "description" : "Aveyron",
          "key" : "FR-12"
        }, {
          "description" : "Ayrshire",
          "key" : "GB-AYRS"
        }, {
          "description" : "Banffshire",
          "key" : "GB-BANF"
        }, {
          "description" : "Bas-Rhin",
          "key" : "FR-67"
        }, {
          "description" : "Bedfordshire",
          "key" : "GB-BDFD"
        }, {
          "description" : "Berkshire",
          "key" : "GB-BRKS"
        }, {
          "description" : "Berwickshire",
          "key" : "GB-BWKS"
        }, {
          "description" : "Bouches-du-Rhône",
          "key" : "FR-13"
        }, {
          "description" : "Brecknockshire/Sir Frycheiniog",
          "key" : "GB-BREK"
        }, {
          "description" : "Buckinghamshire",
          "key" : "GB-BUCKS"
        }, {
          "description" : "Buteshire",
          "key" : "GB-BUTE"
        }, {
          "description" : "Caernarfonshire/Sir Gaernarfon",
          "key" : "GB-CNFN"
        }, {
          "description" : "Caithness",
          "key" : "GB-CTHN"
        }, {
          "description" : "Calvados",
          "key" : "FR-14"
        }, {
          "description" : "Cambridgeshire",
          "key" : "GB-CAMBS"
        }, {
          "description" : "Cantal",
          "key" : "FR-15"
        }, {
          "description" : "Cardiganshire/Ceredigion",
          "key" : "GB-CDGN"
        }, {
          "description" : "Carlow",
          "key" : "IE-CRLW"
        }, {
          "description" : "Carmarthenshire/Sir Gaerfyrddin",
          "key" : "GB-CMRN"
        }, {
          "description" : "Cavan",
          "key" : "IE-CAVN"
        }, {
          "description" : "Charente",
          "key" : "FR-16"
        }, {
          "description" : "Charente-Maritime",
          "key" : "FR-17"
        }, {
          "description" : "Cher",
          "key" : "FR-18"
        }, {
          "description" : "Cheshire",
          "key" : "GB-CHES"
        }, {
          "description" : "Clackmannanshire",
          "key" : "GB-CLAK"
        }, {
          "description" : "Clare",
          "key" : "IE-CLARE"
        }, {
          "description" : "Cork",
          "key" : "IE-CORK"
        }, {
          "description" : "Cornwall",
          "key" : "GB-CNWL"
        }, {
          "description" : "Corrèze",
          "key" : "FR-19"
        }, {
          "description" : "Corse",
          "key" : "FR-20"
        }, {
          "description" : "Corse-du-Sud",
          "key" : "FR-2A"
        }, {
          "description" : "Creuse",
          "key" : "FR-23"
        }, {
          "description" : "Cromartyshire",
          "key" : "GB-CMTY"
        }, {
          "description" : "Cumberland",
          "key" : "GB-CUMB"
        }, {
          "description" : "Côte-d\\'Or",
          "key" : "FR-21"
        }, {
          "description" : "Côtes d\\'Armor",
          "key" : "FR-22"
        }, {
          "description" : "Denbighshire/Sir Ddinbych",
          "key" : "GB-DENB"
        }, {
          "description" : "Derbyshire",
          "key" : "GB-DRBYS"
        }, {
          "description" : "Deux-Sèvres",
          "key" : "FR-79"
        }, {
          "description" : "Devon",
          "key" : "GB-DEVON"
        }, {
          "description" : "Donegal",
          "key" : "IE-DNGL"
        }, {
          "description" : "Dordogne",
          "key" : "FR-24"
        }, {
          "description" : "Dorset",
          "key" : "GB-DRST"
        }, {
          "description" : "Doubs",
          "key" : "FR-25"
        }, {
          "description" : "Down",
          "key" : "NIRL-DOWN"
        }, {
          "description" : "Drôme",
          "key" : "FR-26"
        }, {
          "description" : "Dublin",
          "key" : "IE-DBLN"
        }, {
          "description" : "Dumfriesshire",
          "key" : "GB-DMFS"
        }, {
          "description" : "Dunbartonshire/Dumbartonshire",
          "key" : "GB-DMBR"
        }, {
          "description" : "Durham",
          "key" : "GB-DRHM"
        }, {
          "description" : "East Lothian/Haddingtonshire",
          "key" : "GB-ELOTH"
        }, {
          "description" : "Essex",
          "key" : "GB-ESSX"
        }, {
          "description" : "Essonne",
          "key" : "FR-91"
        }, {
          "description" : "Eure",
          "key" : "FR-27"
        }, {
          "description" : "Eure-et-Loir",
          "key" : "FR-28"
        }, {
          "description" : "Fermanagh",
          "key" : "NIRL-FMNH"
        }, {
          "description" : "Fife",
          "key" : "GB-FIFE"
        }, {
          "description" : "Finistère",
          "key" : "FR-29"
        }, {
          "description" : "Flintshire/Sir Fflint",
          "key" : "GB-FTSH"
        }, {
          "description" : "Galway",
          "key" : "IE-GALW"
        }, {
          "description" : "Gard",
          "key" : "FR-30"
        }, {
          "description" : "Gers",
          "key" : "FR-32"
        }, {
          "description" : "Gironde",
          "key" : "FR-33"
        }, {
          "description" : "Glamorgan/Morgannwg",
          "key" : "GB-GLAM"
        }, {
          "description" : "Gloucestershire",
          "key" : "GB-GLOU"
        }, {
          "description" : "Guadeloupe",
          "key" : "FR-GP"
        }, {
          "description" : "Guyane",
          "key" : "FR-GF"
        }, {
          "description" : "Hampshire",
          "key" : "GB-HAMPS"
        }, {
          "description" : "Haut-Rhin",
          "key" : "FR-68"
        }, {
          "description" : "Haute-Corse",
          "key" : "FR-2B"
        }, {
          "description" : "Haute-Garonne",
          "key" : "FR-31"
        }, {
          "description" : "Haute-Loire",
          "key" : "FR-43"
        }, {
          "description" : "Haute-Marne",
          "key" : "FR-52"
        }, {
          "description" : "Haute-Savoie",
          "key" : "FR-74"
        }, {
          "description" : "Haute-Saône",
          "key" : "FR-70"
        }, {
          "description" : "Haute-Vienne",
          "key" : "FR-87"
        }, {
          "description" : "Hautes-Alpes",
          "key" : "FR-05"
        }, {
          "description" : "Hautes-Pyrénées",
          "key" : "FR-65"
        }, {
          "description" : "Hauts-de-Seine",
          "key" : "FR-92"
        }, {
          "description" : "Herefordshire",
          "key" : "GB-HRFDS"
        }, {
          "description" : "Hertfordshire",
          "key" : "GB-HERTS"
        }, {
          "description" : "Huntingdonshire",
          "key" : "GB-HUNTS"
        }, {
          "description" : "Hérault",
          "key" : "FR-34"
        }, {
          "description" : "Ille-et-Vilaine",
          "key" : "FR-35"
        }, {
          "description" : "Indre",
          "key" : "FR-36"
        }, {
          "description" : "Indre-et-Loire",
          "key" : "FR-37"
        }, {
          "description" : "Inverness-shire",
          "key" : "GB-INVER"
        }, {
          "description" : "Isère",
          "key" : "FR-38"
        }, {
          "description" : "Jura",
          "key" : "FR-39"
        }, {
          "description" : "Kent",
          "key" : "GB-KENT"
        }, {
          "description" : "Kerry",
          "key" : "IE-KERRY"
        }, {
          "description" : "Kildare",
          "key" : "IE-KLDR"
        }, {
          "description" : "Kilkenny",
          "key" : "IE-KLKNY"
        }, {
          "description" : "Kincardineshire",
          "key" : "GB-KNDN"
        }, {
          "description" : "Kinross-shire",
          "key" : "GB-KRSS"
        }, {
          "description" : "Kirkcudbrightshire",
          "key" : "GB-KRCUD"
        }, {
          "description" : "La Réunion",
          "key" : "FR-RE"
        }, {
          "description" : "Lanarkshire",
          "key" : "GB-LRKS"
        }, {
          "description" : "Lancashire",
          "key" : "GB-LANCS"
        }, {
          "description" : "Landes",
          "key" : "FR-40"
        }, {
          "description" : "Laois",
          "key" : "IE-LAOIS"
        }, {
          "description" : "Leicestershire",
          "key" : "GB-LIECS"
        }, {
          "description" : "Leitrim",
          "key" : "IE-LTRM"
        }, {
          "description" : "Limerick",
          "key" : "IE-LMRK"
        }, {
          "description" : "Lincolnshire",
          "key" : "GB-LINCS"
        }, {
          "description" : "Loir-et-Cher",
          "key" : "FR-41"
        }, {
          "description" : "Loire",
          "key" : "FR-42"
        }, {
          "description" : "Loire-Atlantique",
          "key" : "FR-44"
        }, {
          "description" : "Loiret",
          "key" : "FR-45"
        }, {
          "description" : "Londonderry",
          "key" : "NIRL-LDRY"
        }, {
          "description" : "Longford",
          "key" : "IE-LGFD"
        }, {
          "description" : "Lot",
          "key" : "FR-46"
        }, {
          "description" : "Lot-et-Garonne",
          "key" : "FR-47"
        }, {
          "description" : "Louth",
          "key" : "IE-LOUTH"
        }, {
          "description" : "Lozère",
          "key" : "FR-48"
        }, {
          "description" : "Maine-et-Loire",
          "key" : "FR-49"
        }, {
          "description" : "Manche",
          "key" : "FR-50"
        }, {
          "description" : "Marne",
          "key" : "FR-51"
        }, {
          "description" : "Martinique",
          "key" : "FR-MQ"
        }, {
          "description" : "Mayenne",
          "key" : "FR-53"
        }, {
          "description" : "Mayo",
          "key" : "IE-MAYO"
        }, {
          "description" : "Mayotte",
          "key" : "FR-YT"
        }, {
          "description" : "Meath",
          "key" : "IE-MEATH"
        }, {
          "description" : "Merioneth/Meirionnydd",
          "key" : "GB-MIENT"
        }, {
          "description" : "Meurthe-et-Moselle",
          "key" : "FR-54"
        }, {
          "description" : "Meuse",
          "key" : "FR-55"
        }, {
          "description" : "Middlesex",
          "key" : "GB-MSEX"
        }, {
          "description" : "Midlothian/Edinburghshire",
          "key" : "GB-MLOTH"
        }, {
          "description" : "Monaco",
          "key" : "FR-98"
        }, {
          "description" : "Monaghan",
          "key" : "IE-MNGHN"
        }, {
          "description" : "Monmouthshire/Sir Fynwy",
          "key" : "GB-MMTH"
        }, {
          "description" : "Montgomeryshire/Sir Drefaldwyn",
          "key" : "GB-MNTGS"
        }, {
          "description" : "Morayshire",
          "key" : "GB-MORAY"
        }, {
          "description" : "Morbihan",
          "key" : "FR-56"
        }, {
          "description" : "Moselle",
          "key" : "FR-57"
        }, {
          "description" : "Nairnshire",
          "key" : "GB-NAIRN"
        }, {
          "description" : "Nièvre",
          "key" : "FR-58"
        }, {
          "description" : "Nord",
          "key" : "FR-59"
        }, {
          "description" : "Norfolk",
          "key" : "GB-NFLK"
        }, {
          "description" : "Northamptonshire",
          "key" : "GB-NHANTS"
        }, {
          "description" : "Northumberland",
          "key" : "GB-NHUMB"
        }, {
          "description" : "Nottinghamshire",
          "key" : "GB-NOTTS"
        }, {
          "description" : "Nouvelle-Calédonie",
          "key" : "FR-NC"
        }, {
          "description" : "Offaly",
          "key" : "IE-OFLY"
        }, {
          "description" : "Oise",
          "key" : "FR-60"
        }, {
          "description" : "Orkney",
          "key" : "GB-ORK"
        }, {
          "description" : "Orne",
          "key" : "FR-61"
        }, {
          "description" : "Oxfordshire",
          "key" : "GB-OXFD"
        }, {
          "description" : "Paris",
          "key" : "FR-75"
        }, {
          "description" : "Pas-de-Calais",
          "key" : "FR-62"
        }, {
          "description" : "Peeblesshire",
          "key" : "GB-PEEBS"
        }, {
          "description" : "Pembrokeshire/Sir Benfro",
          "key" : "GB-PMBRK"
        }, {
          "description" : "Perthshire",
          "key" : "GB-PERTH"
        }, {
          "description" : "Polynésie française",
          "key" : "FR-PF"
        }, {
          "description" : "Puy-de-Dôme",
          "key" : "FR-63"
        }, {
          "description" : "Pyrénées-Atlantiques",
          "key" : "FR-64"
        }, {
          "description" : "Pyrénées-Orientales",
          "key" : "FR-66"
        }, {
          "description" : "Radnorshire/Sir Faesyfed",
          "key" : "GB-RNRS"
        }, {
          "description" : "Renfrewshire",
          "key" : "GB-RNFR"
        }, {
          "description" : "Rhône",
          "key" : "FR-69"
        }, {
          "description" : "Roscommon",
          "key" : "IE-RSCMN"
        }, {
          "description" : "Ross-shire",
          "key" : "GB-ROSS"
        }, {
          "description" : "Roxburghshire",
          "key" : "GB-ROXB"
        }, {
          "description" : "Rutland",
          "key" : "GB-RUTL"
        }, {
          "description" : "Saint-Barthélemy",
          "key" : "FR-BL"
        }, {
          "description" : "Saint-Martin",
          "key" : "FR-MT"
        }, {
          "description" : "Sanpete",
          "key" : "UT-SANPETE"
        }, {
          "description" : "Sarthe",
          "key" : "FR-72"
        }, {
          "description" : "Savoie",
          "key" : "FR-73"
        }, {
          "description" : "Saône-et-Loire",
          "key" : "FR-71"
        }, {
          "description" : "Seine-Maritime",
          "key" : "FR-76"
        }, {
          "description" : "Seine-Saint-Denis",
          "key" : "FR-93"
        }, {
          "description" : "Seine-et-Marne",
          "key" : "FR-77"
        }, {
          "description" : "Selkirkshire",
          "key" : "GB-SELKS"
        }, {
          "description" : "Shetland",
          "key" : "GB-SHET"
        }, {
          "description" : "Shropshire",
          "key" : "GB-SHROPS"
        }, {
          "description" : "Sligo",
          "key" : "IE-SLIGO"
        }, {
          "description" : "Somerset",
          "key" : "GB-SOMST"
        }, {
          "description" : "Somme",
          "key" : "FR-80"
        }, {
          "description" : "St Pierre et Miquelon",
          "key" : "FR-PM"
        }, {
          "description" : "Staffordshire",
          "key" : "GB-STAFFS"
        }, {
          "description" : "Stirlingshire",
          "key" : "GB-STLNG"
        }, {
          "description" : "Suffolk",
          "key" : "GB-SFFK"
        }, {
          "description" : "Surrey",
          "key" : "GB-SURR"
        }, {
          "description" : "Sussex",
          "key" : "GB-SUSX"
        }, {
          "description" : "Sutherland",
          "key" : "GB-SUTH"
        }, {
          "description" : "Tarn",
          "key" : "FR-81"
        }, {
          "description" : "Tarn-et-Garonne",
          "key" : "FR-82"
        }, {
          "description" : "Terres australes françaises",
          "key" : "FR-TF"
        }, {
          "description" : "Territoire-de-Belfort",
          "key" : "FR-90"
        }, {
          "description" : "Tipperary",
          "key" : "IE-TPRY"
        }, {
          "description" : "Tyrone",
          "key" : "NIRL-TYR"
        }, {
          "description" : "Utah County",
          "key" : "UT-UTAH"
        }, {
          "description" : "Val-d\\'Oise",
          "key" : "FR-95"
        }, {
          "description" : "Val-de-Marne",
          "key" : "FR-94"
        }, {
          "description" : "Var",
          "key" : "FR-83"
        }, {
          "description" : "Vaucluse",
          "key" : "FR-84"
        }, {
          "description" : "Vendée",
          "key" : "FR-85"
        }, {
          "description" : "Vienne",
          "key" : "FR-86"
        }, {
          "description" : "Vosges",
          "key" : "FR-88"
        }, {
          "description" : "Wallis et Futuna",
          "key" : "FR-WF"
        }, {
          "description" : "Warwickshire",
          "key" : "GB-WWKS"
        }, {
          "description" : "Waterford",
          "key" : "IE-WTFD"
        }, {
          "description" : "West Lothian/Linlithgowshire",
          "key" : "GB-WLOTH"
        }, {
          "description" : "West Meath",
          "key" : "IE-WMETH"
        }, {
          "description" : "Westmorland",
          "key" : "GB-WMLD"
        }, {
          "description" : "Wexford",
          "key" : "IE-WXFD"
        }, {
          "description" : "Wicklow",
          "key" : "IE-WKLW"
        }, {
          "description" : "Wigtownshire",
          "key" : "GB-WGNSH"
        }, {
          "description" : "Wiltshire",
          "key" : "GB-WILTS"
        }, {
          "description" : "Worcestershire",
          "key" : "GB-WORCS"
        }, {
          "description" : "Yonne",
          "key" : "FR-89"
        }, {
          "description" : "Yorkshire",
          "key" : "GB-YORKS"
        }, {
          "description" : "Yvelines",
          "key" : "FR-78"
        }, {
          "description" : "Agen",
          "key" : "FR-AGE47"
        }, {
          "description" : "Ajaccio",
          "key" : "FR-AJA2A"
        }, {
          "description" : "Albi",
          "key" : "FR-ALB81"
        }, {
          "description" : "Alençon",
          "key" : "FR-ALE61"
        }, {
          "description" : "Amiens",
          "key" : "FR-AMI80"
        }, {
          "description" : "Angers",
          "key" : "FR-ANG49"
        }, {
          "description" : "Angoulême",
          "key" : "FR-ANG16"
        }, {
          "description" : "Annecy",
          "key" : "FR-ACY74"
        }, {
          "description" : "Arras",
          "key" : "FR-ARR62"
        }, {
          "description" : "Auch",
          "key" : "FR-AUC32"
        }, {
          "description" : "Aurillac",
          "key" : "FR-AUR15"
        }, {
          "description" : "Auxerre",
          "key" : "FR-AXR89"
        }, {
          "description" : "Avignon",
          "key" : "FR-AVG84"
        }, {
          "description" : "Bar-le-Duc",
          "key" : "FR-BLD55"
        }, {
          "description" : "Bastia",
          "key" : "FR-BAS2B"
        }, {
          "description" : "Beauvais",
          "key" : "FR-BVA60"
        }, {
          "description" : "Belfort",
          "key" : "FR-BLF90"
        }, {
          "description" : "Besançon",
          "key" : "FR-BES25"
        }, {
          "description" : "Blois",
          "key" : "FR-BLO41"
        }, {
          "description" : "Bobigny",
          "key" : "FR-BBY93"
        }, {
          "description" : "Bordeaux",
          "key" : "FR-BOR33"
        }, {
          "description" : "Bourg-en-Bresse",
          "key" : "FR-BEB01"
        }, {
          "description" : "Bourges",
          "key" : "FR-BOU18"
        }, {
          "description" : "Caen",
          "key" : "FR-CAE14"
        }, {
          "description" : "Cahors",
          "key" : "FR-CAH46"
        }, {
          "description" : "Carcassonne",
          "key" : "FR-CAR11"
        }, {
          "description" : "Chambéry",
          "key" : "FR-CBY73"
        }, {
          "description" : "Charleville-Mézières",
          "key" : "FR-CHM08"
        }, {
          "description" : "Chartres",
          "key" : "FR-CHA28"
        }, {
          "description" : "Chaumont",
          "key" : "FR-CHM52"
        }, {
          "description" : "Châlons-en-Champagne",
          "key" : "FR-CEC51"
        }, {
          "description" : "Châteauroux",
          "key" : "FR-CHT36"
        }, {
          "description" : "Clermont-Ferrand",
          "key" : "FR-CLF63"
        }, {
          "description" : "Colmar",
          "key" : "FR-CLM68"
        }, {
          "description" : "Créteil",
          "key" : "FR-CTL94"
        }, {
          "description" : "Digne",
          "key" : "FR-DIG04"
        }, {
          "description" : "Dijon",
          "key" : "FR-DIJ21"
        }, {
          "description" : "Foix",
          "key" : "FR-FOI09"
        }, {
          "description" : "Gap",
          "key" : "FR-GAP05"
        }, {
          "description" : "Grenoble",
          "key" : "FR-GRE38"
        }, {
          "description" : "Guéret",
          "key" : "FR-GUE23"
        }, {
          "description" : "La Roche-sur-Yon",
          "key" : "FR-RSY85"
        }, {
          "description" : "La Rochelle",
          "key" : "FR-LRO17"
        }, {
          "description" : "Laon",
          "key" : "FR-LAO02"
        }, {
          "description" : "Laval",
          "key" : "FR-LVL53"
        }, {
          "description" : "Le Mans",
          "key" : "FR-LMA72"
        }, {
          "description" : "Le Puy-en-Velay",
          "key" : "FR-PEV43"
        }, {
          "description" : "Lille",
          "key" : "FR-LIL59"
        }, {
          "description" : "Limoges",
          "key" : "FR-LMG87"
        }, {
          "description" : "Lons-le-Saunier",
          "key" : "FR-LON39"
        }, {
          "description" : "Lyon",
          "key" : "FR-LYO69"
        }, {
          "description" : "Marseille",
          "key" : "FR-MAR13"
        }, {
          "description" : "Melun",
          "key" : "FR-MLN77"
        }, {
          "description" : "Mende",
          "key" : "FR-MEN48"
        }, {
          "description" : "Metz",
          "key" : "FR-MET57"
        }, {
          "description" : "Mont-de-Marsan",
          "key" : "FR-MDM40"
        }, {
          "description" : "Montauban",
          "key" : "FR-MTB82"
        }, {
          "description" : "Montpellier",
          "key" : "FR-MON34"
        }, {
          "description" : "Moulins",
          "key" : "FR-MOU03"
        }, {
          "description" : "Mâcon",
          "key" : "FR-MCN71"
        }, {
          "description" : "Nancy",
          "key" : "FR-NCY54"
        }, {
          "description" : "Nanterre",
          "key" : "FR-NTR92"
        }, {
          "description" : "Nantes",
          "key" : "FR-NAN44"
        }, {
          "description" : "Nevers",
          "key" : "FR-NEV58"
        }, {
          "description" : "Nice",
          "key" : "FR-NIC06"
        }, {
          "description" : "Niort",
          "key" : "FR-NIO79"
        }, {
          "description" : "Nîmes",
          "key" : "FR-NIM30"
        }, {
          "description" : "Orléans",
          "key" : "FR-ORL45"
        }, {
          "description" : "Paris",
          "key" : "FR-PAR75"
        }, {
          "description" : "Pau",
          "key" : "FR-PAU64"
        }, {
          "description" : "Perpignan",
          "key" : "FR-PPG66"
        }, {
          "description" : "Poitiers",
          "key" : "FR-POI86"
        }, {
          "description" : "Pontoise",
          "key" : "FR-PTO95"
        }, {
          "description" : "Privas",
          "key" : "FR-PRI07"
        }, {
          "description" : "Périgueux",
          "key" : "FR-PER24"
        }, {
          "description" : "Quimper",
          "key" : "FR-QUI29"
        }, {
          "description" : "Rennes",
          "key" : "FR-REN35"
        }, {
          "description" : "Rodez",
          "key" : "FR-ROD12"
        }, {
          "description" : "Rouen",
          "key" : "FR-ROU76"
        }, {
          "description" : "Saint-Brieuc",
          "key" : "FR-SBR22"
        }, {
          "description" : "Saint-Lô",
          "key" : "FR-SLO50"
        }, {
          "description" : "Saint-Étienne",
          "key" : "FR-SET42"
        }, {
          "description" : "Strasbourg",
          "key" : "FR-SBG67"
        }, {
          "description" : "Tarbes",
          "key" : "FR-TBS65"
        }, {
          "description" : "Toulon",
          "key" : "FR-TLN83"
        }, {
          "description" : "Toulouse",
          "key" : "FR-TLS31"
        }, {
          "description" : "Tours",
          "key" : "FR-TOU37"
        }, {
          "description" : "Troyes",
          "key" : "FR-TRO10"
        }, {
          "description" : "Tulle",
          "key" : "FR-TUL19"
        }, {
          "description" : "Valence",
          "key" : "FR-VAL26"
        }, {
          "description" : "Vannes",
          "key" : "FR-VAN56"
        }, {
          "description" : "Versailles",
          "key" : "FR-VSS78"
        }, {
          "description" : "Vesoul",
          "key" : "FR-VSL70"
        }, {
          "description" : "Épinal",
          "key" : "FR-EPI88"
        }, {
          "description" : "Évreux",
          "key" : "FR-EVR27"
        }, {
          "description" : "Évry",
          "key" : "FR-EVR91"
        }, {
          "description" : "Alaska/Hawaii",
          "key" : "AKHI"
        }, {
          "description" : "Alaska/Hawaii/Territories",
          "key" : "AHUST"
        }, {
          "description" : "European Union",
          "key" : "EU"
        }, {
          "description" : "Mexico/Canada",
          "key" : "MEXCAN"
        }, {
          "description" : "US 50 (no APO/FPO)",
          "key" : "US50"
        }, {
          "description" : "US All (w/ APO/FPO)",
          "key" : "USALL"
        }, {
          "description" : "US Armed Forces",
          "key" : "USAF"
        }, {
          "description" : "US Continental",
          "key" : "USCN"
        }, {
          "description" : "US Territories",
          "key" : "USTR"
        }, {
          "description" : "US/Canada",
          "key" : "USCAN"
        }, {
          "description" : "US/Mexico/Canada",
          "key" : "USMEXCAN"
        }, {
          "description" : "上海",
          "key" : "CN-SH"
        }, {
          "description" : "北京",
          "key" : "CN-BJ"
        }, {
          "description" : "天津",
          "key" : "CN-TJ"
        }, {
          "description" : "重庆",
          "key" : "CN-CQ"
        }, {
          "description" : "84057",
          "key" : "USA-84057"
        }, {
          "description" : "Agrigento",
          "key" : "IT-AG"
        }, {
          "description" : "Albacete",
          "key" : "ES-AB"
        }, {
          "description" : "Alberta",
          "key" : "AB"
        }, {
          "description" : "Alessandria",
          "key" : "IT-AL"
        }, {
          "description" : "Alicante",
          "key" : "ES-A"
        }, {
          "description" : "Almería",
          "key" : "ES-AL"
        }, {
          "description" : "Amnat Charoen",
          "key" : "TH-37"
        }, {
          "description" : "Ancona",
          "key" : "IT-AN"
        }, {
          "description" : "Ang Thong",
          "key" : "TH-15"
        }, {
          "description" : "Aosta",
          "key" : "IT-AO"
        }, {
          "description" : "Arezzo",
          "key" : "IT-AR"
        }, {
          "description" : "Ascoli Piceno",
          "key" : "IT-AP"
        }, {
          "description" : "Asti",
          "key" : "IT-AT"
        }, {
          "description" : "Asturias",
          "key" : "ES-O"
        }, {
          "description" : "Avellino",
          "key" : "IT-AV"
        }, {
          "description" : "Badajoz",
          "key" : "ES-BA"
        }, {
          "description" : "Bangkok",
          "key" : "TH-10"
        }, {
          "description" : "Barcelona",
          "key" : "ES-B"
        }, {
          "description" : "Bari",
          "key" : "IT-BA"
        }, {
          "description" : "Barletta-Andria-Trani",
          "key" : "IT-BT"
        }, {
          "description" : "Belluno",
          "key" : "IT-BL"
        }, {
          "description" : "Benevento",
          "key" : "IT-BN"
        }, {
          "description" : "Bergamo",
          "key" : "IT-BG"
        }, {
          "description" : "Biella",
          "key" : "IT-BI"
        }, {
          "description" : "Blagoevgrad",
          "key" : "BG-01"
        }, {
          "description" : "Bologna",
          "key" : "IT-BO"
        }, {
          "description" : "Bolzano",
          "key" : "IT-BZ"
        }, {
          "description" : "Brescia",
          "key" : "IT-BS"
        }, {
          "description" : "Brindisi",
          "key" : "IT-BR"
        }, {
          "description" : "British Columbia",
          "key" : "BC"
        }, {
          "description" : "Bueng Kan",
          "key" : "TH-38"
        }, {
          "description" : "Burgas",
          "key" : "BG-02"
        }, {
          "description" : "Burgos",
          "key" : "ES-BU"
        }, {
          "description" : "Buriram",
          "key" : "TH-31"
        }, {
          "description" : "Cagliari",
          "key" : "IT-CA"
        }, {
          "description" : "Caltanissetta",
          "key" : "IT-CL"
        }, {
          "description" : "Campobasso",
          "key" : "IT-CB"
        }, {
          "description" : "Cantabria",
          "key" : "ES-S"
        }, {
          "description" : "Carbonia-Iglesias",
          "key" : "IT-CI"
        }, {
          "description" : "Caserta",
          "key" : "IT-CE"
        }, {
          "description" : "Castellón",
          "key" : "ES-CS"
        }, {
          "description" : "Catania",
          "key" : "IT-CT"
        }, {
          "description" : "Catanzaro",
          "key" : "IT-CZ"
        }, {
          "description" : "Ceuta",
          "key" : "ES-CE"
        }, {
          "description" : "Chachoengsao",
          "key" : "TH-24"
        }, {
          "description" : "Chainat",
          "key" : "TH-18"
        }, {
          "description" : "Chaiyaphum",
          "key" : "TH-36"
        }, {
          "description" : "Chanthaburi",
          "key" : "TH-22"
        }, {
          "description" : "Chiang Mai",
          "key" : "TH-50"
        }, {
          "description" : "Chiang Rai",
          "key" : "TH-57"
        }, {
          "description" : "Chieti",
          "key" : "IT-CH"
        }, {
          "description" : "Chonburi",
          "key" : "TH-20"
        }, {
          "description" : "Chumphon",
          "key" : "TH-86"
        }, {
          "description" : "Ciudad Real",
          "key" : "ES-CR"
        }, {
          "description" : "Como",
          "key" : "IT-CO"
        }, {
          "description" : "Cosenza",
          "key" : "IT-CS"
        }, {
          "description" : "Cremona",
          "key" : "IT-CR"
        }, {
          "description" : "Crotone",
          "key" : "IT-KR"
        }, {
          "description" : "Cuenca",
          "key" : "ES-CU"
        }, {
          "description" : "Cuneo",
          "key" : "IT-CN"
        }, {
          "description" : "Cáceres",
          "key" : "ES-CC"
        }, {
          "description" : "Cádiz",
          "key" : "ES-CA"
        }, {
          "description" : "Córdoba",
          "key" : "ES-CO"
        }, {
          "description" : "Dobrich",
          "key" : "BG-08"
        }, {
          "description" : "Drenthe",
          "key" : "NL-DR"
        }, {
          "description" : "Enna",
          "key" : "IT-EN"
        }, {
          "description" : "Fermo",
          "key" : "IT-FM"
        }, {
          "description" : "Ferrara",
          "key" : "IT-FE"
        }, {
          "description" : "Firenze",
          "key" : "IT-FI"
        }, {
          "description" : "Flevoland",
          "key" : "NL-FL"
        }, {
          "description" : "Foggia",
          "key" : "IT-FG"
        }, {
          "description" : "Forli\\'-Cesena",
          "key" : "IT-FC"
        }, {
          "description" : "Friesland",
          "key" : "NL-FR"
        }, {
          "description" : "Frosinone",
          "key" : "IT-FR"
        }, {
          "description" : "Gabrovo",
          "key" : "BG-07"
        }, {
          "description" : "Gelderland",
          "key" : "NL-GL"
        }, {
          "description" : "Genova",
          "key" : "IT-GE"
        }, {
          "description" : "Gerona",
          "key" : "ES-GI"
        }, {
          "description" : "Gorizia",
          "key" : "IT-GO"
        }, {
          "description" : "Granada",
          "key" : "ES-GR"
        }, {
          "description" : "Groningen",
          "key" : "NL-GR"
        }, {
          "description" : "Grosseto",
          "key" : "IT-GR"
        }, {
          "description" : "Guadalajara",
          "key" : "ES-GU"
        }, {
          "description" : "Guipúzcoa",
          "key" : "ES-SS"
        }, {
          "description" : "HaDarom",
          "key" : "IL-D"
        }, {
          "description" : "HaMerkaz",
          "key" : "IL-M"
        }, {
          "description" : "HaZafon",
          "key" : "IL-Z"
        }, {
          "description" : "Haifa",
          "key" : "IL-HA"
        }, {
          "description" : "Haskovo",
          "key" : "BG-26"
        }, {
          "description" : "Huelva",
          "key" : "ES-H"
        }, {
          "description" : "Huesca",
          "key" : "ES-HU"
        }, {
          "description" : "Imperia",
          "key" : "IT-IM"
        }, {
          "description" : "Isernia",
          "key" : "IT-IS"
        }, {
          "description" : "Islas Baleares",
          "key" : "ES-PM"
        }, {
          "description" : "Jaén",
          "key" : "ES-J"
        }, {
          "description" : "Jerusalem",
          "key" : "IL-JM"
        }, {
          "description" : "Kalasin",
          "key" : "TH-46"
        }, {
          "description" : "Kamphaeng Phet",
          "key" : "TH-62"
        }, {
          "description" : "Kanchanaburi",
          "key" : "TH-71"
        }, {
          "description" : "Kardzhali",
          "key" : "BG-09"
        }, {
          "description" : "Khon Kaen",
          "key" : "TH-40"
        }, {
          "description" : "Krabi",
          "key" : "TH-81"
        }, {
          "description" : "Kyustendil",
          "key" : "BG-10"
        }, {
          "description" : "L\\'Aquila",
          "key" : "IT-AQ"
        }, {
          "description" : "La Coruña",
          "key" : "ES-C"
        }, {
          "description" : "La Spezia",
          "key" : "IT-SP"
        }, {
          "description" : "Lampang",
          "key" : "TH-52"
        }, {
          "description" : "Lamphun",
          "key" : "TH-51"
        }, {
          "description" : "Las Palmas",
          "key" : "ES-GC"
        }, {
          "description" : "Latina",
          "key" : "IT-LT"
        }, {
          "description" : "Lecce",
          "key" : "IT-LE"
        }, {
          "description" : "Lecco",
          "key" : "IT-LC"
        }, {
          "description" : "León",
          "key" : "ES-LE"
        }, {
          "description" : "Limburg",
          "key" : "NL-LB"
        }, {
          "description" : "Livorno",
          "key" : "IT-LI"
        }, {
          "description" : "Lodi",
          "key" : "IT-LO"
        }, {
          "description" : "Loei",
          "key" : "TH-42"
        }, {
          "description" : "Logroño",
          "key" : "ES-LO"
        }, {
          "description" : "Lopburi",
          "key" : "TH-16"
        }, {
          "description" : "Lovech",
          "key" : "BG-11"
        }, {
          "description" : "Lucca",
          "key" : "IT-LU"
        }, {
          "description" : "Lugo",
          "key" : "ES-LU"
        }, {
          "description" : "Lérida",
          "key" : "ES-L"
        }, {
          "description" : "Macerata",
          "key" : "IT-MC"
        }, {
          "description" : "Madrid",
          "key" : "ES-M"
        }, {
          "description" : "Mae Hong Son",
          "key" : "TH-58"
        }, {
          "description" : "Maha Sarakham",
          "key" : "TH-44"
        }, {
          "description" : "Manitoba",
          "key" : "MB"
        }, {
          "description" : "Mantova",
          "key" : "IT-MN"
        }, {
          "description" : "Massa-Carrara",
          "key" : "IT-MS"
        }, {
          "description" : "Matera",
          "key" : "IT-MT"
        }, {
          "description" : "Medio Campidano",
          "key" : "IT-VS"
        }, {
          "description" : "Melilla",
          "key" : "ES-ML"
        }, {
          "description" : "Messina",
          "key" : "IT-ME"
        }, {
          "description" : "Milano",
          "key" : "IT-MI"
        }, {
          "description" : "Modena",
          "key" : "IT-MO"
        }, {
          "description" : "Montana",
          "key" : "BG-12"
        }, {
          "description" : "Monza e Brianza",
          "key" : "IT-MB"
        }, {
          "description" : "Mukdahan",
          "key" : "TH-49"
        }, {
          "description" : "Murcia",
          "key" : "ES-MU"
        }, {
          "description" : "Málaga",
          "key" : "ES-MA"
        }, {
          "description" : "Nakhon Nayok",
          "key" : "TH-26"
        }, {
          "description" : "Nakhon Pathom",
          "key" : "TH-73"
        }, {
          "description" : "Nakhon Phanom",
          "key" : "TH-48"
        }, {
          "description" : "Nakhon Ratchasima",
          "key" : "TH-30"
        }, {
          "description" : "Nakhon Sawan",
          "key" : "TH-60"
        }, {
          "description" : "Nakhon Si Thammarat",
          "key" : "TH-80"
        }, {
          "description" : "Nan",
          "key" : "TH-55"
        }, {
          "description" : "Napoli",
          "key" : "IT-NA"
        }, {
          "description" : "Narathiwat",
          "key" : "TH-96"
        }, {
          "description" : "Navarra",
          "key" : "ES-NA"
        }, {
          "description" : "New Brunswick",
          "key" : "NB"
        }, {
          "description" : "Newfoundland/Labrador",
          "key" : "NL"
        }, {
          "description" : "Nong Bua Lamphu",
          "key" : "TH-39"
        }, {
          "description" : "Nong Khai",
          "key" : "TH-43"
        }, {
          "description" : "Nonthaburi",
          "key" : "TH-12"
        }, {
          "description" : "Noord-Brabant",
          "key" : "NL-NB"
        }, {
          "description" : "Noord-Holland",
          "key" : "NL-NH"
        }, {
          "description" : "Northwest Territories",
          "key" : "NT"
        }, {
          "description" : "Nova Scotia",
          "key" : "NS"
        }, {
          "description" : "Novara",
          "key" : "IT-NO"
        }, {
          "description" : "Nunavut",
          "key" : "NU"
        }, {
          "description" : "Nuoro",
          "key" : "IT-NU"
        }, {
          "description" : "Ogliastra",
          "key" : "IT-OG"
        }, {
          "description" : "Olbia-Tempio",
          "key" : "IT-OT"
        }, {
          "description" : "Ontario",
          "key" : "ON"
        }, {
          "description" : "Orense",
          "key" : "ES-OR"
        }, {
          "description" : "Oristano",
          "key" : "IT-OR"
        }, {
          "description" : "Overijssel",
          "key" : "NL-OV"
        }, {
          "description" : "Padova",
          "key" : "IT-PD"
        }, {
          "description" : "Palencia",
          "key" : "ES-P"
        }, {
          "description" : "Palermo",
          "key" : "IT-PA"
        }, {
          "description" : "Parma",
          "key" : "IT-PR"
        }, {
          "description" : "Pathum Thani",
          "key" : "TH-13"
        }, {
          "description" : "Pattani",
          "key" : "TH-94"
        }, {
          "description" : "Pavia",
          "key" : "IT-PV"
        }, {
          "description" : "Pazardzhik",
          "key" : "BG-13"
        }, {
          "description" : "Pernik",
          "key" : "BG-14"
        }, {
          "description" : "Perugia",
          "key" : "IT-PG"
        }, {
          "description" : "Pesaro e Urbino",
          "key" : "IT-PU"
        }, {
          "description" : "Pescara",
          "key" : "IT-PE"
        }, {
          "description" : "Phang Nga",
          "key" : "TH-82"
        }, {
          "description" : "Phatthalung",
          "key" : "TH-93"
        }, {
          "description" : "Phayao",
          "key" : "TH-56"
        }, {
          "description" : "Phetchabun",
          "key" : "TH-67"
        }, {
          "description" : "Phetchaburi",
          "key" : "TH-76"
        }, {
          "description" : "Phichit",
          "key" : "TH-66"
        }, {
          "description" : "Phitsanulok",
          "key" : "TH-65"
        }, {
          "description" : "Phra Nakhon Si Ayutthaya",
          "key" : "TH-14"
        }, {
          "description" : "Phrae",
          "key" : "TH-54"
        }, {
          "description" : "Phuket",
          "key" : "TH-83"
        }, {
          "description" : "Piacenza",
          "key" : "IT-PC"
        }, {
          "description" : "Pisa",
          "key" : "IT-PI"
        }, {
          "description" : "Pistoia",
          "key" : "IT-PT"
        }, {
          "description" : "Pleven",
          "key" : "BG-15"
        }, {
          "description" : "Plovdiv",
          "key" : "BG-16"
        }, {
          "description" : "Pontevedra",
          "key" : "ES-PO"
        }, {
          "description" : "Pordenone",
          "key" : "IT-PN"
        }, {
          "description" : "Potenza",
          "key" : "IT-PZ"
        }, {
          "description" : "Prachinburi",
          "key" : "TH-25"
        }, {
          "description" : "Prachuap Khiri Khan",
          "key" : "TH-77"
        }, {
          "description" : "Prato",
          "key" : "IT-PO"
        }, {
          "description" : "Prince Edward Island",
          "key" : "PE"
        }, {
          "description" : "Quebec",
          "key" : "QC"
        }, {
          "description" : "Ragusa",
          "key" : "IT-RG"
        }, {
          "description" : "Ranong",
          "key" : "TH-85"
        }, {
          "description" : "Ratchaburi",
          "key" : "TH-70"
        }, {
          "description" : "Ravenna",
          "key" : "IT-RA"
        }, {
          "description" : "Rayong",
          "key" : "TH-21"
        }, {
          "description" : "Razgrad",
          "key" : "BG-17"
        }, {
          "description" : "Reggio Calabria",
          "key" : "IT-RC"
        }, {
          "description" : "Reggio Emilia",
          "key" : "IT-RE"
        }, {
          "description" : "Rieti",
          "key" : "IT-RI"
        }, {
          "description" : "Rimini",
          "key" : "IT-RN"
        }, {
          "description" : "Roi Et",
          "key" : "TH-45"
        }, {
          "description" : "Roma",
          "key" : "IT-RM"
        }, {
          "description" : "Rovigo",
          "key" : "IT-RO"
        }, {
          "description" : "Ruse",
          "key" : "BG-18"
        }, {
          "description" : "Sa Kaeo",
          "key" : "TH-27"
        }, {
          "description" : "Sakon Nakhon",
          "key" : "TH-47"
        }, {
          "description" : "Salamanca",
          "key" : "ES-SA"
        }, {
          "description" : "Salerno",
          "key" : "IT-SA"
        }, {
          "description" : "Samut Prakan",
          "key" : "TH-11"
        }, {
          "description" : "Samut Sakhon",
          "key" : "TH-74"
        }, {
          "description" : "Samut Songkhram",
          "key" : "TH-75"
        }, {
          "description" : "Santa Cruz de Tenerife",
          "key" : "ES-TF"
        }, {
          "description" : "Saraburi",
          "key" : "TH-19"
        }, {
          "description" : "Saskatchewan",
          "key" : "SK"
        }, {
          "description" : "Sassari",
          "key" : "IT-SS"
        }, {
          "description" : "Satun",
          "key" : "TH-91"
        }, {
          "description" : "Savona",
          "key" : "IT-SV"
        }, {
          "description" : "Segovia",
          "key" : "ES-SG"
        }, {
          "description" : "Sevilla",
          "key" : "ES-SE"
        }, {
          "description" : "Shumen",
          "key" : "BG-27"
        }, {
          "description" : "Siena",
          "key" : "IT-SI"
        }, {
          "description" : "Silistra",
          "key" : "BG-19"
        }, {
          "description" : "Sing Buri",
          "key" : "TH-17"
        }, {
          "description" : "Siracusa",
          "key" : "IT-SR"
        }, {
          "description" : "Sisaket",
          "key" : "TH-33"
        }, {
          "description" : "Sliven",
          "key" : "BG-20"
        }, {
          "description" : "Smolyan",
          "key" : "BG-21"
        }, {
          "description" : "Sofia",
          "key" : "BG-22"
        }, {
          "description" : "Sofia Province",
          "key" : "BG-23"
        }, {
          "description" : "Sondrio",
          "key" : "IT-SO"
        }, {
          "description" : "Songkhla",
          "key" : "TH-90"
        }, {
          "description" : "Soria",
          "key" : "ES-SO"
        }, {
          "description" : "Stara Zagora",
          "key" : "BG-24"
        }, {
          "description" : "Sukhothai",
          "key" : "TH-64"
        }, {
          "description" : "Suphan Buri",
          "key" : "TH-72"
        }, {
          "description" : "Surat Thani",
          "key" : "TH-84"
        }, {
          "description" : "Surin",
          "key" : "TH-32"
        }, {
          "description" : "Tak",
          "key" : "TH-63"
        }, {
          "description" : "Taranto",
          "key" : "IT-TA"
        }, {
          "description" : "Targovishte",
          "key" : "BG-25"
        }, {
          "description" : "Tarragona",
          "key" : "ES-T"
        }, {
          "description" : "Tel Aviv",
          "key" : "IL-TA"
        }, {
          "description" : "Teramo",
          "key" : "IT-TE"
        }, {
          "description" : "Terni",
          "key" : "IT-TR"
        }, {
          "description" : "Teruel",
          "key" : "ES-TE"
        }, {
          "description" : "Toledo",
          "key" : "ES-TO"
        }, {
          "description" : "Torino",
          "key" : "IT-TO"
        }, {
          "description" : "Trang",
          "key" : "TH-92"
        }, {
          "description" : "Trapani",
          "key" : "IT-TP"
        }, {
          "description" : "Trat",
          "key" : "TH-23"
        }, {
          "description" : "Trento",
          "key" : "IT-TN"
        }, {
          "description" : "Treviso",
          "key" : "IT-TV"
        }, {
          "description" : "Trieste",
          "key" : "IT-TS"
        }, {
          "description" : "Ubon Ratchathani",
          "key" : "TH-34"
        }, {
          "description" : "Udine",
          "key" : "IT-UD"
        }, {
          "description" : "Udon Thani",
          "key" : "TH-41"
        }, {
          "description" : "Uthai Thani",
          "key" : "TH-61"
        }, {
          "description" : "Utrecht",
          "key" : "NL-UT"
        }, {
          "description" : "Uttaradit",
          "key" : "TH-53"
        }, {
          "description" : "Valencia",
          "key" : "ES-V"
        }, {
          "description" : "Valladolid",
          "key" : "ES-VA"
        }, {
          "description" : "Varese",
          "key" : "IT-VA"
        }, {
          "description" : "Varna",
          "key" : "BG-03"
        }, {
          "description" : "Veliko Tarnovo",
          "key" : "BG-04"
        }, {
          "description" : "Venezia",
          "key" : "IT-VE"
        }, {
          "description" : "Verbano-Cusio-Ossola",
          "key" : "IT-VB"
        }, {
          "description" : "Vercelli",
          "key" : "IT-VC"
        }, {
          "description" : "Verona",
          "key" : "IT-VR"
        }, {
          "description" : "Vibo Valentia",
          "key" : "IT-VV"
        }, {
          "description" : "Vicenza",
          "key" : "IT-VI"
        }, {
          "description" : "Vidin",
          "key" : "BG-05"
        }, {
          "description" : "Viterbo",
          "key" : "IT-VT"
        }, {
          "description" : "Vizcaya",
          "key" : "ES-BI"
        }, {
          "description" : "Vratsa",
          "key" : "BG-06"
        }, {
          "description" : "Yala",
          "key" : "TH-95"
        }, {
          "description" : "Yambol",
          "key" : "BG-28"
        }, {
          "description" : "Yasothon",
          "key" : "TH-35"
        }, {
          "description" : "Yukon Territory",
          "key" : "YT"
        }, {
          "description" : "Zamora",
          "key" : "ES-ZA"
        }, {
          "description" : "Zaragoza",
          "key" : "ES-Z"
        }, {
          "description" : "Zeeland",
          "key" : "NL-ZE"
        }, {
          "description" : "Zeeland",
          "key" : "NL-ZL"
        }, {
          "description" : "Zuid-Holland",
          "key" : "NL-ZH"
        }, {
          "description" : "Álava",
          "key" : "ES-VI"
        }, {
          "description" : "Ávila",
          "key" : "ES-AV"
        }, {
          "description" : "三重県",
          "key" : "JP-24"
        }, {
          "description" : "云南",
          "key" : "CN-YN"
        }, {
          "description" : "京都府",
          "key" : "JP-26"
        }, {
          "description" : "佐賀県",
          "key" : "JP-41"
        }, {
          "description" : "兵庫県",
          "key" : "JP-28"
        }, {
          "description" : "北海道",
          "key" : "JP-01"
        }, {
          "description" : "千葉県",
          "key" : "JP-12"
        }, {
          "description" : "台湾",
          "key" : "CN-TW"
        }, {
          "description" : "吉林",
          "key" : "CN-JL"
        }, {
          "description" : "和歌山県",
          "key" : "JP-30"
        }, {
          "description" : "四川",
          "key" : "CN-SC"
        }, {
          "description" : "埼玉県",
          "key" : "JP-11"
        }, {
          "description" : "大分県",
          "key" : "JP-44"
        }, {
          "description" : "大阪府",
          "key" : "JP-27"
        }, {
          "description" : "奈良県",
          "key" : "JP-29"
        }, {
          "description" : "安徽",
          "key" : "CN-AH"
        }, {
          "description" : "宮城県",
          "key" : "JP-04"
        }, {
          "description" : "宮崎県",
          "key" : "JP-45"
        }, {
          "description" : "富山県",
          "key" : "JP-16"
        }, {
          "description" : "山东",
          "key" : "CN-SD"
        }, {
          "description" : "山口県",
          "key" : "JP-35"
        }, {
          "description" : "山形県",
          "key" : "JP-06"
        }, {
          "description" : "山梨県",
          "key" : "JP-19"
        }, {
          "description" : "山西",
          "key" : "CN-SX"
        }, {
          "description" : "岐阜県",
          "key" : "JP-21"
        }, {
          "description" : "岡山県",
          "key" : "JP-33"
        }, {
          "description" : "岩手県",
          "key" : "JP-03"
        }, {
          "description" : "島根県",
          "key" : "JP-32"
        }, {
          "description" : "广东",
          "key" : "CN-GD"
        }, {
          "description" : "広島県",
          "key" : "JP-34"
        }, {
          "description" : "徳島県",
          "key" : "JP-36"
        }, {
          "description" : "愛媛県",
          "key" : "JP-38"
        }, {
          "description" : "愛知県",
          "key" : "JP-23"
        }, {
          "description" : "新潟県",
          "key" : "JP-15"
        }, {
          "description" : "東京都",
          "key" : "JP-13"
        }, {
          "description" : "栃木県",
          "key" : "JP-09"
        }, {
          "description" : "江苏",
          "key" : "CN-JS"
        }, {
          "description" : "江西",
          "key" : "CN-JX"
        }, {
          "description" : "沖縄県",
          "key" : "JP-47"
        }, {
          "description" : "河北",
          "key" : "CN-HE"
        }, {
          "description" : "河南",
          "key" : "CN-HA"
        }, {
          "description" : "浙江",
          "key" : "CN-ZJ"
        }, {
          "description" : "海南",
          "key" : "CN-HI"
        }, {
          "description" : "湖北",
          "key" : "CN-HB"
        }, {
          "description" : "湖南",
          "key" : "CN-HN"
        }, {
          "description" : "滋賀県",
          "key" : "JP-25"
        }, {
          "description" : "熊本県",
          "key" : "JP-43"
        }, {
          "description" : "甘肃",
          "key" : "CN-GS"
        }, {
          "description" : "石川県",
          "key" : "JP-17"
        }, {
          "description" : "神奈川県",
          "key" : "JP-14"
        }, {
          "description" : "福井県",
          "key" : "JP-18"
        }, {
          "description" : "福岡県",
          "key" : "JP-40"
        }, {
          "description" : "福島県",
          "key" : "JP-07"
        }, {
          "description" : "福建",
          "key" : "CN-FJ"
        }, {
          "description" : "秋田県",
          "key" : "JP-05"
        }, {
          "description" : "群馬県",
          "key" : "JP-10"
        }, {
          "description" : "茨城県",
          "key" : "JP-08"
        }, {
          "description" : "贵州",
          "key" : "CN-GZ"
        }, {
          "description" : "辽宁",
          "key" : "CN-LN"
        }, {
          "description" : "長崎県",
          "key" : "JP-42"
        }, {
          "description" : "長野県",
          "key" : "JP-20"
        }, {
          "description" : "陕西",
          "key" : "CN-SN"
        }, {
          "description" : "青森県",
          "key" : "JP-02"
        }, {
          "description" : "青海",
          "key" : "CN-QH"
        }, {
          "description" : "静岡県",
          "key" : "JP-22"
        }, {
          "description" : "香川県",
          "key" : "JP-37"
        }, {
          "description" : "高知県",
          "key" : "JP-39"
        }, {
          "description" : "鳥取県",
          "key" : "JP-31"
        }, {
          "description" : "鹿児島県",
          "key" : "JP-46"
        }, {
          "description" : "黑龙江",
          "key" : "CN-HL"
        }, {
          "description" : "Andalucía",
          "key" : "ES-AN"
        }, {
          "description" : "Aragón",
          "key" : "ES-AR"
        }, {
          "description" : "Auckland",
          "key" : "NZ-AUK"
        }, {
          "description" : "Auvergne-Rhône-Alpes",
          "key" : "FR-ARA"
        }, {
          "description" : "Bay of Plenty",
          "key" : "NZ-BOP"
        }, {
          "description" : "Bourgogne-Franche-Comté",
          "key" : "FR-BFC"
        }, {
          "description" : "Bretagne",
          "key" : "FR-BRE"
        }, {
          "description" : "Canarias",
          "key" : "ES-CN"
        }, {
          "description" : "Cantabria",
          "key" : "ES-CAN"
        }, {
          "description" : "Canterbury",
          "key" : "NZ-CAN"
        }, {
          "description" : "Castilla y León",
          "key" : "ES-CL"
        }, {
          "description" : "Castilla-La Mancha",
          "key" : "ES-CM"
        }, {
          "description" : "Cataluña",
          "key" : "ES-CT"
        }, {
          "description" : "Centre-Val de Loire",
          "key" : "FR-CVL"
        }, {
          "description" : "Comunidad Valenciana",
          "key" : "ES-VC"
        }, {
          "description" : "Corse",
          "key" : "FR-COR"
        }, {
          "description" : "Extremadura",
          "key" : "ES-EX"
        }, {
          "description" : "Galicia",
          "key" : "ES-GA"
        }, {
          "description" : "Gisborne",
          "key" : "NZ-GIS"
        }, {
          "description" : "Grand-Est",
          "key" : "FR-GES"
        }, {
          "description" : "Guadeloupe",
          "key" : "FR-GUA"
        }, {
          "description" : "Hauts-de-France",
          "key" : "FR-HDF"
        }, {
          "description" : "Hawkes Bay",
          "key" : "NZ-HKB"
        }, {
          "description" : "Ile-de-France",
          "key" : "FR-IDF"
        }, {
          "description" : "Islas Baleares",
          "key" : "ES-IB"
        }, {
          "description" : "La Rioja",
          "key" : "ES-LR"
        }, {
          "description" : "La Réunion",
          "key" : "FR-LRE"
        }, {
          "description" : "Madrid",
          "key" : "ES-MAD"
        }, {
          "description" : "Manawatu-Whanganui",
          "key" : "NZ-MWT"
        }, {
          "description" : "Marlborough",
          "key" : "NZ-MBH"
        }, {
          "description" : "Mayotte",
          "key" : "FR-MAY"
        }, {
          "description" : "Navarra",
          "key" : "ES-NAV"
        }, {
          "description" : "Nelson",
          "key" : "NZ-NSN"
        }, {
          "description" : "Normandie",
          "key" : "FR-NOR"
        }, {
          "description" : "Northland",
          "key" : "NZ-NTL"
        }, {
          "description" : "Nouvelle-Aquitaine",
          "key" : "FR-NAQ"
        }, {
          "description" : "Occitanie",
          "key" : "FR-OCC"
        }, {
          "description" : "Otago",
          "key" : "NZ-OTA"
        }, {
          "description" : "Oviedo",
          "key" : "ES-AS"
        }, {
          "description" : "Pays de la Loire",
          "key" : "FR-PDL"
        }, {
          "description" : "País Vasco",
          "key" : "ES-PV"
        }, {
          "description" : "Provence-Alpes-Côte d\\'Azur",
          "key" : "FR-PAC"
        }, {
          "description" : "Región de Murcia",
          "key" : "ES-MUR"
        }, {
          "description" : "Southland",
          "key" : "NZ-STL"
        }, {
          "description" : "Taranaki",
          "key" : "NZ-TKI"
        }, {
          "description" : "Tasman",
          "key" : "NZ-TAS"
        }, {
          "description" : "Waikato",
          "key" : "NZ-WKO"
        }, {
          "description" : "Wellington",
          "key" : "NZ-WGN"
        }, {
          "description" : "West Coast",
          "key" : "NZ-WTC"
        }, {
          "description" : "内蒙古",
          "key" : "CN-NM"
        }, {
          "description" : "宁夏",
          "key" : "CN-NX"
        }, {
          "description" : "广西",
          "key" : "CN-GX"
        }, {
          "description" : "新疆",
          "key" : "CN-XJ"
        }, {
          "description" : "澳门",
          "key" : "CN-MO"
        }, {
          "description" : "西藏",
          "key" : "CN-XZ"
        }, {
          "description" : "香港",
          "key" : "CN-HK"
        }, {
          "description" : "Aargau",
          "key" : "CH-AG"
        }, {
          "description" : "Acre",
          "key" : "BR-AC"
        }, {
          "description" : "Aguascalientes",
          "key" : "MX-AG"
        }, {
          "description" : "Alabama",
          "key" : "AL"
        }, {
          "description" : "Alagoas",
          "key" : "BR-AL"
        }, {
          "description" : "Alaska",
          "key" : "AK"
        }, {
          "description" : "Amapá",
          "key" : "BR-AP"
        }, {
          "description" : "Amazonas",
          "key" : "BR-AM"
        }, {
          "description" : "Amazonas",
          "key" : "CO-AMA"
        }, {
          "description" : "American Samoa",
          "key" : "AS"
        }, {
          "description" : "Andhra Pradesh",
          "key" : "IN-AP"
        }, {
          "description" : "Antioquia",
          "key" : "CO-ANT"
        }, {
          "description" : "Appenzell Ausserrhoden",
          "key" : "CH-AR"
        }, {
          "description" : "Appenzell Innerrhoden",
          "key" : "CH-AI"
        }, {
          "description" : "Arauca",
          "key" : "CO-ARA"
        }, {
          "description" : "Arizona",
          "key" : "AZ"
        }, {
          "description" : "Arkansas",
          "key" : "AR"
        }, {
          "description" : "Armed Forces Americas",
          "key" : "AA"
        }, {
          "description" : "Armed Forces Europe",
          "key" : "AE"
        }, {
          "description" : "Armed Forces Pacific",
          "key" : "AP"
        }, {
          "description" : "Arunāchal Pradesh",
          "key" : "IN-AR"
        }, {
          "description" : "Assam",
          "key" : "IN-AS"
        }, {
          "description" : "Atlántico",
          "key" : "CO-ATL"
        }, {
          "description" : "Baden-Württemberg",
          "key" : "DE-BW"
        }, {
          "description" : "Bahia",
          "key" : "BR-BA"
        }, {
          "description" : "Baja California",
          "key" : "MX-BC"
        }, {
          "description" : "Baja California Sur",
          "key" : "MX-BS"
        }, {
          "description" : "Basel-Landschaft",
          "key" : "CH-BL"
        }, {
          "description" : "Basel-Stadt",
          "key" : "CH-BS"
        }, {
          "description" : "Bayern",
          "key" : "DE-BY"
        }, {
          "description" : "Berlin",
          "key" : "DE-BE"
        }, {
          "description" : "Bern",
          "key" : "CH-BE"
        }, {
          "description" : "Bihār",
          "key" : "IN-BR"
        }, {
          "description" : "Bogotá D.C.",
          "key" : "CO-DC"
        }, {
          "description" : "Bolívar",
          "key" : "CO-BOL"
        }, {
          "description" : "Boyacá",
          "key" : "CO-BOY"
        }, {
          "description" : "Brandenburg",
          "key" : "DE-BB"
        }, {
          "description" : "Bremen",
          "key" : "DE-HB"
        }, {
          "description" : "Caldas",
          "key" : "CO-CAL"
        }, {
          "description" : "California",
          "key" : "CA"
        }, {
          "description" : "Campeche",
          "key" : "MX-CM"
        }, {
          "description" : "Caquetá",
          "key" : "CO-CAQ"
        }, {
          "description" : "Casanare",
          "key" : "CO-CAS"
        }, {
          "description" : "Cauca",
          "key" : "CO-CAU"
        }, {
          "description" : "Ceará",
          "key" : "BR-CE"
        }, {
          "description" : "Cesar",
          "key" : "CO-CES"
        }, {
          "description" : "Chhattīsgarh",
          "key" : "IN-CT"
        }, {
          "description" : "Chiapas",
          "key" : "MX-CS"
        }, {
          "description" : "Chihuahua",
          "key" : "MX-CH"
        }, {
          "description" : "Chocó",
          "key" : "CO-CHO"
        }, {
          "description" : "Ciudad de México",
          "key" : "MX-CX"
        }, {
          "description" : "Coahuila de Zaragoza",
          "key" : "MX-CO"
        }, {
          "description" : "Colima",
          "key" : "MX-CL"
        }, {
          "description" : "Colorado",
          "key" : "CO"
        }, {
          "description" : "Connecticut",
          "key" : "CT"
        }, {
          "description" : "Cundinamarca",
          "key" : "CO-CUN"
        }, {
          "description" : "Córdoba",
          "key" : "CO-COR"
        }, {
          "description" : "Delaware",
          "key" : "DE"
        }, {
          "description" : "District of Columbia",
          "key" : "DC"
        }, {
          "description" : "Distrito Federal",
          "key" : "BR-DF"
        }, {
          "description" : "Durango",
          "key" : "MX-DG"
        }, {
          "description" : "Espírito Santo",
          "key" : "BR-ES"
        }, {
          "description" : "Federated States of Micronesia",
          "key" : "FM"
        }, {
          "description" : "Florida",
          "key" : "FL"
        }, {
          "description" : "Fribourg",
          "key" : "CH-FR"
        }, {
          "description" : "Genève",
          "key" : "CH-GE"
        }, {
          "description" : "Georgia",
          "key" : "GA"
        }, {
          "description" : "Glarus",
          "key" : "CH-GL"
        }, {
          "description" : "Goa",
          "key" : "IN-GA"
        }, {
          "description" : "Goiás",
          "key" : "BR-GO"
        }, {
          "description" : "Graubünden",
          "key" : "CH-GR"
        }, {
          "description" : "Guainía",
          "key" : "CO-GUA"
        }, {
          "description" : "Guam",
          "key" : "GU"
        }, {
          "description" : "Guanajuato",
          "key" : "MX-GT"
        }, {
          "description" : "Guaviare",
          "key" : "CO-GUV"
        }, {
          "description" : "Guerrero",
          "key" : "MX-GR"
        }, {
          "description" : "Gujarāt",
          "key" : "IN-GJ"
        }, {
          "description" : "Hamburg",
          "key" : "DE-HH"
        }, {
          "description" : "Haryāna",
          "key" : "IN-HR"
        }, {
          "description" : "Hawaii",
          "key" : "HI"
        }, {
          "description" : "Hessen",
          "key" : "DE-HE"
        }, {
          "description" : "Hidalgo",
          "key" : "MX-HG"
        }, {
          "description" : "Himāchal Pradesh",
          "key" : "IN-HP"
        }, {
          "description" : "Huila",
          "key" : "CO-HUI"
        }, {
          "description" : "Idaho",
          "key" : "ID"
        }, {
          "description" : "Illinois",
          "key" : "IL"
        }, {
          "description" : "Indiana",
          "key" : "IN"
        }, {
          "description" : "Iowa",
          "key" : "IA"
        }, {
          "description" : "Jalisco",
          "key" : "MX-JC"
        }, {
          "description" : "Jhārkhand",
          "key" : "IN-JH"
        }, {
          "description" : "Johor",
          "key" : "MY-01"
        }, {
          "description" : "Jura",
          "key" : "CH-JU"
        }, {
          "description" : "Kansas",
          "key" : "KS"
        }, {
          "description" : "Karnātaka",
          "key" : "IN-KA"
        }, {
          "description" : "Kedah",
          "key" : "MY-02"
        }, {
          "description" : "Kelantan",
          "key" : "MY-03"
        }, {
          "description" : "Kentucky",
          "key" : "KY"
        }, {
          "description" : "Kerala",
          "key" : "IN-KL"
        }, {
          "description" : "La Guajira",
          "key" : "CO-LAG"
        }, {
          "description" : "Louisiana",
          "key" : "LA"
        }, {
          "description" : "Luzern",
          "key" : "CH-LU"
        }, {
          "description" : "Madhya Pradesh",
          "key" : "IN-MP"
        }, {
          "description" : "Magdalena",
          "key" : "CO-MAG"
        }, {
          "description" : "Mahārāshtra",
          "key" : "IN-MH"
        }, {
          "description" : "Maine",
          "key" : "ME"
        }, {
          "description" : "Malacca",
          "key" : "MY-04"
        }, {
          "description" : "Manipur",
          "key" : "IN-MN"
        }, {
          "description" : "Maranhão",
          "key" : "BR-MA"
        }, {
          "description" : "Marshall Islands",
          "key" : "MH"
        }, {
          "description" : "Maryland",
          "key" : "MD"
        }, {
          "description" : "Massachusetts",
          "key" : "MA"
        }, {
          "description" : "Mato Grosso",
          "key" : "BR-MT"
        }, {
          "description" : "Mato Grosso do Sul",
          "key" : "BR-MS"
        }, {
          "description" : "Mecklenburg-Vorpommern",
          "key" : "DE-MV"
        }, {
          "description" : "Meghālaya",
          "key" : "IN-ML"
        }, {
          "description" : "Meta",
          "key" : "CO-MET"
        }, {
          "description" : "Michigan",
          "key" : "MI"
        }, {
          "description" : "Michoacán de Ocampo",
          "key" : "MX-MI"
        }, {
          "description" : "Minas Gerais",
          "key" : "BR-MG"
        }, {
          "description" : "Minnesota",
          "key" : "MN"
        }, {
          "description" : "Mississippi",
          "key" : "MS"
        }, {
          "description" : "Missouri",
          "key" : "MO"
        }, {
          "description" : "Mizoram",
          "key" : "IN-MZ"
        }, {
          "description" : "Montana",
          "key" : "MT"
        }, {
          "description" : "Morelos",
          "key" : "MX-MO"
        }, {
          "description" : "México",
          "key" : "MX-EM"
        }, {
          "description" : "Nariño",
          "key" : "CO-NAR"
        }, {
          "description" : "Nayarit",
          "key" : "MX-NA"
        }, {
          "description" : "Nebraska",
          "key" : "NE"
        }, {
          "description" : "Negeri Sembilan",
          "key" : "MY-05"
        }, {
          "description" : "Neuchâtel",
          "key" : "CH-NE"
        }, {
          "description" : "Nevada",
          "key" : "NV"
        }, {
          "description" : "New Hampshire",
          "key" : "NH"
        }, {
          "description" : "New Jersey",
          "key" : "NJ"
        }, {
          "description" : "New Mexico",
          "key" : "NM"
        }, {
          "description" : "New South Wales",
          "key" : "AU-NSW"
        }, {
          "description" : "New York",
          "key" : "NY"
        }, {
          "description" : "Nidwalden",
          "key" : "CH-NW"
        }, {
          "description" : "Niedersachsen",
          "key" : "DE-NI"
        }, {
          "description" : "Nordrhein-Westfalen",
          "key" : "DE-NW"
        }, {
          "description" : "Norte de Santander",
          "key" : "CO-NSA"
        }, {
          "description" : "North Carolina",
          "key" : "NC"
        }, {
          "description" : "North Dakota",
          "key" : "ND"
        }, {
          "description" : "Northern Mariana Islands",
          "key" : "MP"
        }, {
          "description" : "Nuevo León",
          "key" : "MX-NL"
        }, {
          "description" : "Nāgāland",
          "key" : "IN-NL"
        }, {
          "description" : "Oaxaca",
          "key" : "MX-OA"
        }, {
          "description" : "Obwalden",
          "key" : "CH-OW"
        }, {
          "description" : "Odisha",
          "key" : "IN-OR"
        }, {
          "description" : "Ohio",
          "key" : "OH"
        }, {
          "description" : "Oklahoma",
          "key" : "OK"
        }, {
          "description" : "Oregon",
          "key" : "OR"
        }, {
          "description" : "Pahang",
          "key" : "MY-06"
        }, {
          "description" : "Palau",
          "key" : "PW"
        }, {
          "description" : "Paraná",
          "key" : "BR-PR"
        }, {
          "description" : "Paraíba",
          "key" : "BR-PB"
        }, {
          "description" : "Pará",
          "key" : "BR-PA"
        }, {
          "description" : "Penang",
          "key" : "MY-07"
        }, {
          "description" : "Pennsylvania",
          "key" : "PA"
        }, {
          "description" : "Perak",
          "key" : "MY-08"
        }, {
          "description" : "Perlis",
          "key" : "MY-09"
        }, {
          "description" : "Pernambuco",
          "key" : "BR-PE"
        }, {
          "description" : "Piauí",
          "key" : "BR-PI"
        }, {
          "description" : "Puebla",
          "key" : "MX-PU"
        }, {
          "description" : "Puerto Rico",
          "key" : "PR"
        }, {
          "description" : "Punjab",
          "key" : "IN-PB"
        }, {
          "description" : "Putumayo",
          "key" : "CO-PUT"
        }, {
          "description" : "Queensland",
          "key" : "AU-QLD"
        }, {
          "description" : "Querétaro",
          "key" : "MX-QT"
        }, {
          "description" : "Quindío",
          "key" : "CO-QUI"
        }, {
          "description" : "Quintana Roo",
          "key" : "MX-QR"
        }, {
          "description" : "Rheinland-Pfalz",
          "key" : "DE-RP"
        }, {
          "description" : "Rhode Island",
          "key" : "RI"
        }, {
          "description" : "Rio Grande do Norte",
          "key" : "BR-RN"
        }, {
          "description" : "Rio Grande do Sul",
          "key" : "BR-RS"
        }, {
          "description" : "Rio de Janeiro",
          "key" : "BR-RJ"
        }, {
          "description" : "Risaralda",
          "key" : "CO-RIS"
        }, {
          "description" : "Rondônia",
          "key" : "BR-RO"
        }, {
          "description" : "Roraima",
          "key" : "BR-RR"
        }, {
          "description" : "Rājasthān",
          "key" : "IN-RJ"
        }, {
          "description" : "Saarland",
          "key" : "DE-SL"
        }, {
          "description" : "Sabah",
          "key" : "MY-12"
        }, {
          "description" : "Sachsen",
          "key" : "DE-SN"
        }, {
          "description" : "Sachsen-Anhalt",
          "key" : "DE-ST"
        }, {
          "description" : "San Andrés y Providencia",
          "key" : "CO-SAP"
        }, {
          "description" : "San Luis Potosí",
          "key" : "MX-SL"
        }, {
          "description" : "Santa Catarina",
          "key" : "BR-SC"
        }, {
          "description" : "Santander",
          "key" : "CO-SAN"
        }, {
          "description" : "Sarawak",
          "key" : "MY-13"
        }, {
          "description" : "Schaffhausen",
          "key" : "CH-SH"
        }, {
          "description" : "Schleswig-Holstein",
          "key" : "DE-SH"
        }, {
          "description" : "Schwyz",
          "key" : "CH-SZ"
        }, {
          "description" : "Selangor",
          "key" : "MY-10"
        }, {
          "description" : "Sergipe",
          "key" : "BR-SE"
        }, {
          "description" : "Sikkim",
          "key" : "IN-SK"
        }, {
          "description" : "Sinaloa",
          "key" : "MX-SI"
        }, {
          "description" : "Solothurn",
          "key" : "CH-SO"
        }, {
          "description" : "Sonora",
          "key" : "MX-SO"
        }, {
          "description" : "South Australia",
          "key" : "AU-SA"
        }, {
          "description" : "South Carolina",
          "key" : "SC"
        }, {
          "description" : "South Dakota",
          "key" : "SD"
        }, {
          "description" : "St. Gallen",
          "key" : "CH-SG"
        }, {
          "description" : "Sucre",
          "key" : "CO-SUC"
        }, {
          "description" : "São Paulo",
          "key" : "BR-SP"
        }, {
          "description" : "Tabasco",
          "key" : "MX-TB"
        }, {
          "description" : "Tamaulipas",
          "key" : "MX-TM"
        }, {
          "description" : "Tamil Nādu",
          "key" : "IN-TN"
        }, {
          "description" : "Tasmania",
          "key" : "AU-TAS"
        }, {
          "description" : "Telangāna",
          "key" : "IN-TG"
        }, {
          "description" : "Tennessee",
          "key" : "TN"
        }, {
          "description" : "Terengganu",
          "key" : "MY-11"
        }, {
          "description" : "Texas",
          "key" : "TX"
        }, {
          "description" : "Thurgau",
          "key" : "CH-TG"
        }, {
          "description" : "Thüringen",
          "key" : "DE-TH"
        }, {
          "description" : "Ticino",
          "key" : "CH-TI"
        }, {
          "description" : "Tlaxcala",
          "key" : "MX-TL"
        }, {
          "description" : "Tocantins",
          "key" : "BR-TO"
        }, {
          "description" : "Tolima",
          "key" : "CO-TOL"
        }, {
          "description" : "Tripura",
          "key" : "IN-TR"
        }, {
          "description" : "U.S. Minor Outlying Islands",
          "key" : "UM"
        }, {
          "description" : "Uri",
          "key" : "CH-UR"
        }, {
          "description" : "Utah",
          "key" : "UT"
        }, {
          "description" : "Uttar Pradesh",
          "key" : "IN-UP"
        }, {
          "description" : "Uttarākhand",
          "key" : "IN-UT"
        }, {
          "description" : "Valais",
          "key" : "CH-VS"
        }, {
          "description" : "Valle del Cauca",
          "key" : "CO-VAC"
        }, {
          "description" : "Vaud",
          "key" : "CH-VD"
        }, {
          "description" : "Vaupés",
          "key" : "CO-VAU"
        }, {
          "description" : "Veracruz de Ignacio de la Llave",
          "key" : "MX-VE"
        }, {
          "description" : "Vermont",
          "key" : "VT"
        }, {
          "description" : "Vichada",
          "key" : "CO-VID"
        }, {
          "description" : "Victoria",
          "key" : "AU-VIC"
        }, {
          "description" : "Virgin Islands",
          "key" : "VI"
        }, {
          "description" : "Virginia",
          "key" : "VA"
        }, {
          "description" : "Washington",
          "key" : "WA"
        }, {
          "description" : "West Bengal",
          "key" : "IN-WB"
        }, {
          "description" : "West Virginia",
          "key" : "WV"
        }, {
          "description" : "Western Australia",
          "key" : "AU-WA"
        }, {
          "description" : "Wisconsin",
          "key" : "WI"
        }, {
          "description" : "Wyoming",
          "key" : "WY"
        }, {
          "description" : "Yucatán",
          "key" : "MX-YU"
        }, {
          "description" : "Zacatecas",
          "key" : "MX-ZA"
        }, {
          "description" : "Zug",
          "key" : "CH-ZG"
        }, {
          "description" : "Zürich",
          "key" : "CH-ZH"
        }, {
          "description" : "dolnośląskie",
          "key" : "PL-DŚ"
        }, {
          "description" : "kujawsko-pomorskie",
          "key" : "PL-KP"
        }, {
          "description" : "lubelskie",
          "key" : "PL-LB"
        }, {
          "description" : "lubuskie",
          "key" : "PL-LS"
        }, {
          "description" : "mazowieckie",
          "key" : "PL-MZ"
        }, {
          "description" : "małopolskie",
          "key" : "PL-MP"
        }, {
          "description" : "opolskie",
          "key" : "PL-OP"
        }, {
          "description" : "podkarpackie",
          "key" : "PL-PK"
        }, {
          "description" : "podlaskie",
          "key" : "PL-PL"
        }, {
          "description" : "pomorskie",
          "key" : "PL-PM"
        }, {
          "description" : "warmińsko-mazurskie",
          "key" : "PL-WM"
        }, {
          "description" : "wielkopolskie",
          "key" : "PL-WP"
        }, {
          "description" : "zachodniopomorskie",
          "key" : "PL-ZP"
        }, {
          "description" : "łódzkie",
          "key" : "PL-ŁD"
        }, {
          "description" : "śląskie",
          "key" : "PL-ŚL"
        }, {
          "description" : "świętokrzyskie",
          "key" : "PL-ŚK"
        }, {
          "description" : "Andaman and Nicobar Islands",
          "key" : "IN-AN"
        }, {
          "description" : "Australian Capital Territory",
          "key" : "AU-ACT"
        }, {
          "description" : "Chandigarh",
          "key" : "IN-CH"
        }, {
          "description" : "Chatham Islands",
          "key" : "NZ-CIT"
        }, {
          "description" : "Delhi",
          "key" : "IN-DL"
        }, {
          "description" : "Dādra and Nagar Haveli and Damān and Diu",
          "key" : "IN-DH"
        }, {
          "description" : "Federal Territory of Kuala Lumpur",
          "key" : "MY-14"
        }, {
          "description" : "Federal Territory of Labuan",
          "key" : "MY-15"
        }, {
          "description" : "Federal Territory of Putrajaya",
          "key" : "MY-16"
        }, {
          "description" : "Jammu and Kashmīr",
          "key" : "IN-JK"
        }, {
          "description" : "Ladākh",
          "key" : "IN-LA"
        }, {
          "description" : "Lakshadweep",
          "key" : "IN-LD"
        }, {
          "description" : "Northern Territory",
          "key" : "AU-NT"
        }, {
          "description" : "Puducherry",
          "key" : "IN-PY"
        }, {
          "description" : "Not Applicable",
          "key" : "_NA_"
        } ],
        "disabled" : "false",
        "id" : "AddProductGeo_geoId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "geoId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Product Geo Enum ID",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "AddProductGeo",
        "options" : [ {
          "description" : "Purchase Include Geo",
          "key" : "PG_PURCH_INCLUDE"
        }, {
          "description" : "Purchase Exclude Geo",
          "key" : "PG_PURCH_EXCLUDE"
        }, {
          "description" : "Shipment Include Geo",
          "key" : "PG_SHIP_INCLUDE"
        }, {
          "description" : "Shipment Exclude Geo",
          "key" : "PG_SHIP_EXCLUDE"
        } ],
        "disabled" : "false",
        "id" : "AddProductGeo_productGeoEnumId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "productGeoEnumId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "20",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Description",
        "type" : "TEXT",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "description",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "AddProductGeo_description",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "AddProductGeo",
        "tabindex" : "",
        "name" : "submitButton",
        "className" : "",
        "id" : "AddProductGeo_submitButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "Add",
        "event" : "",
        "imgSrc" : ""
      } ],
      "target" : "createProductGeo"
    },
    {
      "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "productId", "idValue", "submitButton", "deleteLink" ]
      } ],
      "columns" : [ {
        "name" : "goodIdentificationTypeId",
        "title" : "ID Type"
      }, {
        "name" : "idValue",
        "title" : "Id Value"
      }, {
        "name" : "submitButton",
        "title" : "Update"
      }, {
        "name" : "deleteLink",
        "title" : " "
      } ],
      "formName" : "UpdateProductGoodIdentifications",
      "altTarget" : [ ],
      "formLocation" : "component://kwikstore/widget/ProductForms.xml",
      "type" : "list",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "productId",
        "action" : "",
        "id" : "UpdateProductGoodIdentifications_productId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "goodIdentificationTypeId",
        "description" : "",
        "style" : "",
        "id" : "UpdateProductGoodIdentifications_goodIdentificationTypeId",
        "title" : "",
        "type" : "DISPLAY_ENTITY",
        "imageLocation" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "40",
        "ajaxUrl" : "",
        "maxlength" : "60",
        "tabindex" : "",
        "className" : "",
        "title" : "Id Value",
        "type" : "TEXT",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "idValue",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "UpdateProductGoodIdentifications_idValue",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "UpdateProductGoodIdentifications",
        "tabindex" : "",
        "name" : "submitButton",
        "className" : "",
        "id" : "UpdateProductGoodIdentifications_submitButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "Update",
        "event" : "",
        "imgSrc" : ""
      }, {
        "image" : "",
        "width" : "",
        "name" : "deleteLink",
        "alternate" : "",
        "description" : "Delete",
        "parameterList" : [ {
          "name" : "productId"
        }, {
          "name" : "goodIdentificationTypeId"
        } ],
        "id" : "UpdateProductGoodIdentifications_deleteLink",
        "imageTitle" : "",
        "parameterMap" : { },
        "height" : "",
        "target" : "deleteGoodIdentification"
      } ],
      "target" : "updateGoodIdentification"
    },
    {
      "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "productId", "idValue", "submitButton" ]
      } ],
      "formName" : "AddProductGoodIdentification",
      "altTarget" : [ ],
      "targets":{
        "createTarget":"createGoodIdentification"
      },
      "formLocation" : "component://kwikstore/widget/ProductForms.xml",
      "type" : "single",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "productId",
        "action" : "",
        "id" : "AddProductGoodIdentification_productId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "ID Type",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "ISBN",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "AddProductGoodIdentification",
        "options" : [ {
          "description" : "EAN",
          "key" : "EAN"
        }, {
          "description" : "Harmonized System Codes (HS Code)",
          "key" : "HS_CODE"
        }, {
          "description" : "ISBN",
          "key" : "ISBN"
        }, {
          "description" : "Library of Congress",
          "key" : "LOC"
        }, {
          "description" : "Manufacturer (Model) Number",
          "key" : "MANUFACTURER_ID_NO"
        }, {
          "description" : "Model Year",
          "key" : "MODEL_YEAR"
        }, {
          "description" : "Other",
          "key" : "OTHER_ID"
        }, {
          "description" : "SKU",
          "key" : "SKU"
        }, {
          "description" : "UPCA",
          "key" : "UPCA"
        }, {
          "description" : "UPCE",
          "key" : "UPCE"
        }, {
          "description" : "replacement value for partyId in the invoice export function in accounting",
          "key" : "INVOICE_EXPORT"
        } ],
        "disabled" : "false",
        "id" : "AddProductGoodIdentification_goodIdentificationTypeId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "goodIdentificationTypeId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "40",
        "ajaxUrl" : "",
        "maxlength" : "60",
        "tabindex" : "",
        "className" : "required",
        "title" : "Id Value",
        "type" : "TEXT",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "idValue",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "AddProductGoodIdentification_idValue",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "AddProductGoodIdentification",
        "tabindex" : "",
        "name" : "submitButton",
        "className" : "",
        "id" : "AddProductGoodIdentification_submitButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "Create",
        "event" : "",
        "imgSrc" : ""
      } ],
      "target" : "createGoodIdentification"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "fromDate", "thruDate", "comments", "sequenceNum", "quantity", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "productCategoryId",
            "title" : "Category [ID]"
        }, {
            "name" : "fromDate",
            "title" : "From Date  Time"
        }, {
            "name" : "thruDate",
            "title" : "Through Date  Time"
        }, {
            "name" : "comments",
            "title" : "Comments"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductCategoryMember",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductCategoryMember_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "hyperlink" : {
                "linkStyle" : "buttontext",
                "description" : "",
                "targetType" : "intra-app",
                "confirmation" : "",
                "parameterMap" : {
                    "VIEW_SIZE_0" : "20",
                    "VIEW_INDEX_0" : "0"
                },
                "uniqueItemName" : "Modal_4917a90a_fbc0_4b4d_81b4_aa53cfbf1026",
                "target" : "EditCategory",
                "targetWindow" : "",
                "remoteFormData":{
                    "formData":{
                        "formName":"EditCategory",
                        "formLocation":"component://kwikstore/widget/ProductForms.xml",
                        "link":"/admin/categories/category/${productCategoryId}"
                    }
                },
            },
            "event": "edit",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productCategoryId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductCategoryMember_productCategoryId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductCategoryMember_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date  Time",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-01%2016:56:35.003",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "UpdateProductCategoryMember",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "UpdateProductCategoryMember_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldHelpText" : "",
            "buttons" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "language" : "en",
            "title" : "Comments",
            "type" : "HIDDEN",
            "rows" : "3",
            "readonly" : "",
            "visualEditorEnable" : "",
            "alert" : "false",
            "name" : "comments",
            "style" : "",
            "disabled" : "false",
            "id" : "UpdateProductCategoryMember_comments",
            "value" : "",
            "cols" : "60"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductCategoryMember_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "quantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductCategoryMember_quantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductCategoryMember",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "UpdateProductCategoryMember_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productCategoryId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "UpdateProductCategoryMember_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "removeProductFromCategory"
        } ],
        "target" : "updateProductToCategory"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "fromDate", "thruDate", "comments", "sequenceNum", "quantity", "submitButton" ]
        } ],
        "formName" : "AddProductCategoryMember",
        "layout":"SingleColumn",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductCategoryMember_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductCategoryMember",
            "id" : "AddProductCategoryMember_productCategoryId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProductCategory",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productCategoryId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productCategoryId",
            "style" : "",
            "id" : "AddProductCategoryMember_productCategoryId",
            "title" : "Product Category ID",
            "type" : "LOOKUP"
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "required",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductCategoryMember",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductCategoryMember_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-01%2016:57:42.15",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductCategoryMember",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductCategoryMember_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldHelpText" : "",
            "buttons" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "language" : "en",
            "title" : "Comments",
            "type" : "TEXTAREA",
            "rows" : "3",
            "readonly" : "",
            "visualEditorEnable" : "",
            "alert" : "false",
            "name" : "comments",
            "style" : "",
            "disabled" : "false",
            "id" : "AddProductCategoryMember_comments",
            "value" : "",
            "cols" : "60"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductCategoryMember_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "quantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductCategoryMember_quantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductCategoryMember",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductCategoryMember_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "addProductToCategory"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "keyword", "keywordTypeId", "relevancyWeight", "statusId", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "keyword",
            "title" : "Keyword"
        }, {
            "name" : "keywordTypeId",
            "title" : "Keyword Type"
        }, {
            "name" : "relevancyWeight",
            "title" : "Relevancy Weight"
        }, {
            "name" : "statusId",
            "title" : "Status ID"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductKeyword",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductKeyword_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "keyword",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductKeyword_keyword",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "keywordTypeId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductKeyword_keywordTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "relevancyWeight",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductKeyword_relevancyWeight",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "UpdateProductKeyword",
            "options" : [ {
            "description" : "Approved",
            "key" : "KW_APPROVED"
            }, {
            "description" : "Pending",
            "key" : "KW_PENDING"
            }, {
            "description" : "Disapproved",
            "key" : "KW_DISAPPROVED"
            } ],
            "disabled" : "false",
            "id" : "UpdateProductKeyword_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductKeyword",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "UpdateProductKeyword_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "keyword"
            }, {
            "name" : "keywordTypeId"
            } ],
            "id" : "UpdateProductKeyword_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteProductKeyword"
        } ],
        "target" : "updateProductKeyword"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "keyword", "keywordTypeId", "relevancyWeight", "statusId", "submitButton" ]
        } ],
        "formName" : "AddProductKeyword",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"createProductKeyword"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductKeyword_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "40",
            "tabindex" : "",
            "className" : "required",
            "title" : "Keyword",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "keyword",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductKeyword_keyword",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Keyword Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductKeyword",
            "options" : [ {
            "description" : "Keyword",
            "key" : "KWT_KEYWORD"
            }, {
            "description" : "Tag",
            "key" : "KWT_TAG"
            } ],
            "disabled" : "false",
            "id" : "AddProductKeyword_keywordTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "keywordTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "1",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Relevancy Weight",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "relevancyWeight",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductKeyword_relevancyWeight",
            "placeholder" : "",
            "event" : "",
            "value" : "1",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductKeyword",
            "options" : [ {
            "description" : "Approved",
            "key" : "KW_APPROVED"
            }, {
            "description" : "Pending",
            "key" : "KW_PENDING"
            }, {
            "description" : "Disapproved",
            "key" : "KW_DISAPPROVED"
            } ],
            "disabled" : "false",
            "id" : "AddProductKeyword_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductKeyword",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddProductKeyword_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductKeyword"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productIdTo", "productAssocTypeId", "fromDate", "thruDate", "sequenceNum", "reason", "instruction", "quantity", "editLink", "deleteButton" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "productIdTo",
            "title" : "Product ID"
        }, {
            "name" : "productAssocTypeId",
            "title" : "Association Type"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "reason",
            "title" : "Reason"
        }, {
            "name" : "instruction",
            "title" : "Instruction"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "editLink",
            "title" : "Edit Link"
        }, {
            "name" : "deleteButton",
            "title" : "Delete"
        } ],
        "formName" : "ListProductAssocs",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_029673ec_c2b8_4a78_9470_238907bea973",
            "target" : "EditProductAssoc",
            "targetWindow" : "",
            "remoteFormData":{
                    "formData":{
                        "formName": "EditProductAssoc",
                        "formLocation": "component://kwikstore/widget/ProductForms.xml"
                    }
                }
            },
            "event":"edit",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_productId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : "",
            
        }, {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "productId" : "",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_b03e88d8_dd06_4ccb_9d21_85bb73a1d269",
            "target" : "EditProductAssoc",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditProductAssoc",
                    "formLocation":"component://kwikstore/widget/ProductForms.xml"
                }
            }
            },
            "event":"edit",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productIdTo",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_productIdTo",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productAssocTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_productAssocTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sequenceNum",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_sequenceNum",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "reason",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_reason",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "instruction",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_instruction",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "ListProductAssocs_quantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Edit",
            "title" : "Edit Link",
            "type" : "HYPERLINK",
            "target" : "EditProductAssoc",
            "name" : "editLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productIdTo"
            }, {
            "name" : "productAssocTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "style" : "",
            "id" : "ListProductAssocs_editLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"EditProductAssoc",
                "formLocation":"component://kwikstore/widget/ProductForms.xml"
            },
            "event":"edit"
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Delete",
            "title" : "Delete",
            "type" : "HYPERLINK",
            "target" : "deleteProductAssoc",
            "name" : "deleteButton",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productIdTo"
            }, {
            "name" : "productAssocTypeId"
            }, {
            "name" : "fromDate"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "parameters.productId",
                "bracketedOriginal" : "${parameters.productId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "parameters.productId"
            },
            "name" : "lastProductId"
            } ],
            "style" : "",
            "id" : "ListProductAssocs_deleteButton",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"deleteProductAssoc",
                "formLocation":"component://kwikstore/widget/ProductForms.xml"
            },
            "event":"delete"
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "productIdTo", "productIdTo", "productAssocTypeId", "productAssocTypeId", "fromDate", "fromDate", "thruDate", "sequenceNum", "reason", "instruction", "quantity", "scrapFactor", "routingWorkEffortId", "estimateCalcMethod", "recurrenceInfoId", "createButton", "updateButton" ]
        } ],
        "formName" : "EditProductAssoc",
        "altTarget" : [ {
            "useWhen" : "productAssoc!=null",
            "targetExdr" : {
            "chars" : "updateProductAssoc",
            "hint" : 20,
            "empty" : false,
            "original" : "updateProductAssoc"
            }
        } ],
        "targets":{
            "createTarget":"createProductAssoc",
            "updateTarget":"updateProductAssoc"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "scrapFactor",
            "action" : "",
            "id" : "EditProductAssoc_scrapFactor",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "routingWorkEffortId",
            "action" : "",
            "id" : "EditProductAssoc_routingWorkEffortId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "estimateCalcMethod",
            "action" : "",
            "id" : "EditProductAssoc_estimateCalcMethod",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "recurrenceInfoId",
            "action" : "",
            "id" : "EditProductAssoc_recurrenceInfoId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditProductAssoc",
            "id" : "EditProductAssoc_productId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProduct",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productId",
            "style" : "",
            "id" : "EditProductAssoc_productId",
            "title" : "Product ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditProductAssoc",
            "id" : "EditProductAssoc_productIdTo",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProduct",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productIdTo",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productIdTo",
            "style" : "",
            "id" : "EditProductAssoc_productIdTo",
            "title" : "Product ID To",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Association Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductAssoc",
            "options" : [ {
            "description" : "Accessory",
            "key" : "PRODUCT_ACCESSORY"
            }, {
            "description" : "Actual Product Component",
            "key" : "PRODUCT_COMPONENT"
            }, {
            "description" : "Also Bought",
            "key" : "ALSO_BOUGHT"
            }, {
            "description" : "Alternative Packaging",
            "key" : "ALTERNATIVE_PACKAGE"
            }, {
            "description" : "Auto Reorder (needs recurrenceInfoId)",
            "key" : "PRODUCT_AUTORO"
            }, {
            "description" : "Complementary or Cross-Sell",
            "key" : "PRODUCT_COMPLEMENT"
            }, {
            "description" : "Configurable product instance",
            "key" : "PRODUCT_CONF"
            }, {
            "description" : "Engineering Bill of Materials",
            "key" : "ENGINEER_COMPONENT"
            }, {
            "description" : "Equivalent or Substitute",
            "key" : "PRODUCT_SUBSTITUTE"
            }, {
            "description" : "Incompatable",
            "key" : "PRODUCT_INCOMPATABLE"
            }, {
            "description" : "Manufacturing Bill of Materials",
            "key" : "MANUF_COMPONENT"
            }, {
            "description" : "New Version, Replacement",
            "key" : "PRODUCT_OBSOLESCENCE"
            }, {
            "description" : "Product Manufactured As",
            "key" : "PRODUCT_MANUFACTURED"
            }, {
            "description" : "Product Variant",
            "key" : "PRODUCT_VARIANT"
            }, {
            "description" : "Refurbished Equivalent",
            "key" : "PRODUCT_REFURB"
            }, {
            "description" : "Repair Service",
            "key" : "PRODUCT_REPAIR_SRV"
            }, {
            "description" : "Revision",
            "key" : "PRODUCT_REVISION"
            }, {
            "description" : "Unique Item",
            "key" : "UNIQUE_ITEM"
            }, {
            "description" : "Upgrade or Up-Sell",
            "key" : "PRODUCT_UPGRADE"
            } ],
            "disabled" : "false",
            "id" : "EditProductAssoc_productAssocTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productAssocTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductAssoc",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProductAssoc_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-02%2006:35:52.64",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductAssoc",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProductAssoc_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductAssoc_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Reason",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "reason",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductAssoc_reason",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Instruction",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "instruction",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductAssoc_instruction",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "quantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductAssoc_quantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditProductAssoc",
            "tabindex" : "",
            "name" : "createButton",
            "className" : "",
            "id" : "EditProductAssoc_createButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductAssoc"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "workEffortGoodStdTypeId", "fromDate", "thruDate", "statusId", "estimatedQuantity", "estimatedCost", "workEffortName" ]
        } ],
        "columns" : [ {
            "name" : "workEffortId",
            "title" : "Edit"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "estimatedQuantity",
            "title" : "Estimated Quantity"
        }, {
            "name" : "estimatedCost",
            "title" : "Estimated cost"
        }, {
            "name" : "workEffortName",
            "title" : "Work Effort Name"
        } ],
        "formName" : "ListProductRoutings",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductRoutings_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "workEffortGoodStdTypeId",
            "action" : "",
            "id" : "ListProductRoutings_workEffortGoodStdTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "ROU_PROD_TEMPLATE"
        }, {
            "conditionGroup" : "",
            "name" : "statusId",
            "action" : "",
            "id" : "ListProductRoutings_statusId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Edit",
            "type" : "HYPERLINK",
            "target" : "/manufacturing/control/EditRoutingProductLink",
            "name" : "workEffortId",
            "width" : "",
            "parameterList" : [ {
            "name" : "workEffortId"
            } ],
            "style" : "",
            "id" : "ListProductRoutings_workEffortId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimatedQuantity",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_estimatedQuantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimatedCost",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_estimatedCost",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "workEffortName",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_workEffortName",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "workEffortGoodStdTypeId", "fromDate", "thruDate", "statusId", "estimatedQuantity", "estimatedCost", "workEffortName" ]
        } ],
        "columns" : [ {
            "name" : "workEffortId",
            "title" : "Edit"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "estimatedQuantity",
            "title" : "Estimated Quantity"
        }, {
            "name" : "estimatedCost",
            "title" : "Estimated cost"
        }, {
            "name" : "workEffortName",
            "title" : "Work Effort Name"
        } ],
        "formName" : "ListProductRoutings",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductRoutings_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "workEffortGoodStdTypeId",
            "action" : "",
            "id" : "ListProductRoutings_workEffortGoodStdTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "ROU_PROD_TEMPLATE"
        }, {
            "conditionGroup" : "",
            "name" : "statusId",
            "action" : "",
            "id" : "ListProductRoutings_statusId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Edit",
            "type" : "HYPERLINK",
            "target" : "/manufacturing/control/EditRoutingProductLink",
            "name" : "workEffortId",
            "width" : "",
            "parameterList" : [ {
            "name" : "workEffortId"
            } ],
            "style" : "",
            "id" : "ListProductRoutings_workEffortId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimatedQuantity",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_estimatedQuantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimatedCost",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_estimatedCost",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "workEffortName",
            "description" : "",
            "style" : "",
            "id" : "ListProductRoutings_workEffortName",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productIdTo", "productAssocTypeId", "fromDate", "thruDate", "sequenceNum", "reason", "quantity", "scrapFactor", "instruction", "routingWorkEffortId", "estimateCalcMethod", "recurrenceInfoId", "productName" ]
        } ],
        "columns" : [ {
            "name" : "productIdTo",
            "title" : "Edit"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "scrapFactor",
            "title" : "Scrap Factor"
        }, {
            "name" : "estimateCalcMethod",
            "title" : "Estimate Calc Method"
        }, {
            "name" : "recurrenceInfoId",
            "title" : "Recurrence Info ID"
        }, {
            "name" : "productName",
            "title" : "Product Name"
        } ],
        "formName" : "ListProductComponents",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductComponents_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productAssocTypeId",
            "action" : "",
            "id" : "ListProductComponents_productAssocTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "MANUF_COMPONENT"
        }, {
            "conditionGroup" : "",
            "name" : "reason",
            "action" : "",
            "id" : "ListProductComponents_reason",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "instruction",
            "action" : "",
            "id" : "ListProductComponents_instruction",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "routingWorkEffortId",
            "action" : "",
            "id" : "ListProductComponents_routingWorkEffortId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Edit",
            "type" : "HYPERLINK",
            "target" : "ViewProductManufacturing",
            "name" : "productIdTo",
            "width" : "",
            "parameterList" : [ {
            "fromField" : {
                "isEmpty" : false,
                "original" : "productIdTo",
                "bracketedOriginal" : "${productIdTo}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "productIdTo"
            },
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProductComponents_productIdTo",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sequenceNum",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_sequenceNum",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_quantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "scrapFactor",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_scrapFactor",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimateCalcMethod",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_estimateCalcMethod",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "recurrenceInfoId",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_recurrenceInfoId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productName",
            "description" : "",
            "style" : "",
            "id" : "ListProductComponents_productName",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productIdTo", "productAssocTypeId", "fromDate", "thruDate", "sequenceNum", "reason", "quantity", "scrapFactor", "instruction", "routingWorkEffortId", "estimateCalcMethod", "recurrenceInfoId", "productName" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Edit"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "estimateCalcMethod",
            "title" : "Estimate Calc Method"
        }, {
            "name" : "recurrenceInfoId",
            "title" : "Recurrence Info ID"
        }, {
            "name" : "productName",
            "title" : "Product Name"
        } ],
        "formName" : "ListProductParents",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productIdTo",
            "action" : "",
            "id" : "ListProductParents_productIdTo",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productAssocTypeId",
            "action" : "",
            "id" : "ListProductParents_productAssocTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "MANUF_COMPONENT"
        }, {
            "conditionGroup" : "",
            "name" : "sequenceNum",
            "action" : "",
            "id" : "ListProductParents_sequenceNum",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "reason",
            "action" : "",
            "id" : "ListProductParents_reason",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "scrapFactor",
            "action" : "",
            "id" : "ListProductParents_scrapFactor",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "instruction",
            "action" : "",
            "id" : "ListProductParents_instruction",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "routingWorkEffortId",
            "action" : "",
            "id" : "ListProductParents_routingWorkEffortId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Edit",
            "type" : "HYPERLINK",
            "target" : "ViewProductManufacturing",
            "name" : "productId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProductParents_productId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_quantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimateCalcMethod",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_estimateCalcMethod",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "recurrenceInfoId",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_recurrenceInfoId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productName",
            "description" : "",
            "style" : "",
            "id" : "ListProductParents_productName",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "costComponentTypePrefix", "costUomId", "submitButton" ]
        } ],
        "formName" : "FilterCostComponents",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "FilterCostComponents_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Cost Component Type Prefix",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FilterCostComponents",
            "options" : [ {
            "description" : "Estimated Standard Costs",
            "key" : "EST_STD"
            } ],
            "disabled" : "false",
            "id" : "FilterCostComponents_costComponentTypePrefix",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "costComponentTypePrefix",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Currency",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FilterCostComponents",
            "options" : [ {
            "description" : "Afghani [AFN]",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek [ALL]",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar [DZD]",
            "key" : "DZD"
            }, {
            "description" : "American Dollar [USD]",
            "key" : "USD"
            }, {
            "description" : "Angolan Kwanza [AOA]",
            "key" : "AOA"
            }, {
            "description" : "Argentina Peso [ARS]",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram [AMD]",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder [AWG]",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar [AUD]",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat [AZN]",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar [BSD]",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar [BHD]",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka [BDT]",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar [BBD]",
            "key" : "BBD"
            }, {
            "description" : "Belize Dollar [BZD]",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble [BYN]",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc [XOF]",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar [BMD]",
            "key" : "BMD"
            }, {
            "description" : "Bolivian Boliviano [BOB]",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula [BWP]",
            "key" : "BWP"
            }, {
            "description" : "Brazilian Real [BRL]",
            "key" : "BRL"
            }, {
            "description" : "British Pound [GBP]",
            "key" : "GBP"
            }, {
            "description" : "Brunei Dollar [BND]",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev [BGN]",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc [BIF]",
            "key" : "BIF"
            }, {
            "description" : "Cambodian Riel [KHR]",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar [CAD]",
            "key" : "CAD"
            }, {
            "description" : "Cape Verde Escudo [CVE]",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar [KYD]",
            "key" : "KYD"
            }, {
            "description" : "Chilean Peso [CLP]",
            "key" : "CLP"
            }, {
            "description" : "China [CNY]",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso [COP]",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc [KMF]",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks [BAM]",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon [CRC]",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna [HRK]",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso [CUP]",
            "key" : "CUP"
            }, {
            "description" : "Czech Krona [CZK]",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone [DKK]",
            "key" : "DKK"
            }, {
            "description" : "Djibouti Franc [DJF]",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso [DOP]",
            "key" : "DOP"
            }, {
            "description" : "East Carribean Dollar [XCD]",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound [EGP]",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon [SVC]",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr [ETB]",
            "key" : "ETB"
            }, {
            "description" : "Euro [EUR]",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound [FKP]",
            "key" : "FKP"
            }, {
            "description" : "Fiji Dollar [FJD]",
            "key" : "FJD"
            }, {
            "description" : "Gabon C.f.A Franc [XAF]",
            "key" : "XAF"
            }, {
            "description" : "Gambian Dalasi [GMD]",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi [GHS]",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound [GIP]",
            "key" : "GIP"
            }, {
            "description" : "Guatemalan Quedzal [GTQ]",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc [GNF]",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar [GYD]",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde [HTG]",
            "key" : "HTG"
            }, {
            "description" : "Honduran Lempira [HNL]",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar [HKD]",
            "key" : "HKD"
            }, {
            "description" : "Hungarian forint [HUF]",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona [ISK]",
            "key" : "ISK"
            }, {
            "description" : "Indian Rupee [INR]",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah [IDR]",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial [IRR]",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar [IQD]",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar [JMD]",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen [JPY]",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar [JOD]",
            "key" : "JOD"
            }, {
            "description" : "Kazakhstani Tenge [KZT]",
            "key" : "KZT"
            }, {
            "description" : "Kenyan Shilling [KES]",
            "key" : "KES"
            }, {
            "description" : "Kirghizstan Som [KGS]",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar [KWD]",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip [LAK]",
            "key" : "LAK"
            }, {
            "description" : "Lari [GEL]",
            "key" : "GEL"
            }, {
            "description" : "Lebanese Pound [LBP]",
            "key" : "LBP"
            }, {
            "description" : "Leone [SLL]",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti [LSL]",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar [LRD]",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar [LYD]",
            "key" : "LYD"
            }, {
            "description" : "Macao Pataca [MOP]",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary [MGA]",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha [MWK]",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit [MYR]",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa [MVR]",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya [MRU]",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee [MUR]",
            "key" : "MUR"
            }, {
            "description" : "Mexican Peso [MXN]",
            "key" : "MXN"
            }, {
            "description" : "Moldavian Lei [MDL]",
            "key" : "MDL"
            }, {
            "description" : "Mongolian Tugrik [MNT]",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham [MAD]",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical [MZN]",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee [NPR]",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel [ILS]",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar [TWD]",
            "key" : "TWD"
            }, {
            "description" : "New Zaire [ZRN]",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar [NZD]",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba [NIO]",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira [NGN]",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won [KPW]",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone [NOK]",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial [OMR]",
            "key" : "OMR"
            }, {
            "description" : "Pakistan Rupee [PKR]",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa [PAB]",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina [PGK]",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani [PYG]",
            "key" : "PYG"
            }, {
            "description" : "Peruvian Sol [PEN]",
            "key" : "PEN"
            }, {
            "description" : "Philippino Peso [PHP]",
            "key" : "PHP"
            }, {
            "description" : "Polish Zloty [PLN]",
            "key" : "PLN"
            }, {
            "description" : "Qatar Riyal [QAR]",
            "key" : "QAR"
            }, {
            "description" : "Romanian Leu [RON]",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble [RUB]",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc [RWF]",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala [WST]",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra [STN]",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal [SAR]",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee [SCR]",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar [SGD]",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar [SBD]",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling [SOS]",
            "key" : "SOS"
            }, {
            "description" : "South African Rand [ZAR]",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won [KRW]",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound [SSP]",
            "key" : "SSP"
            }, {
            "description" : "Sri Lankan Rupee [LKR]",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound [SHP]",
            "key" : "SHP"
            }, {
            "description" : "Sudanese Pound [SDG]",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar [SRD]",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni [SZL]",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona [SEK]",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc [CHF]",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound [SYP]",
            "key" : "SYP"
            }, {
            "description" : "Tadzhikistani Somoni [TJS]",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling [TZS]",
            "key" : "TZS"
            }, {
            "description" : "Thailand Baht [THB]",
            "key" : "THB"
            }, {
            "description" : "Tongan Pa\\'anga [TOP]",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar [TTD]",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar [TND]",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira [TRY]",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat [TMT]",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling [UGX]",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia [UAH]",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham [AED]",
            "key" : "AED"
            }, {
            "description" : "Uruguay [UYU]",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI) [UYI]",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu [VUV]",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano [VES]",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong [VND]",
            "key" : "VND"
            }, {
            "description" : "West Indian Guilder [ANG]",
            "key" : "ANG"
            }, {
            "description" : "Yemeni Ryal [YER]",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha [ZMW]",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar [ZWL]",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "FilterCostComponents_costUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "costUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "FilterCostComponents",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "FilterCostComponents_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "EditProductCosts"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "costComponentTypeId", "productId", "productFeatureId", "partyId", "geoId", "workEffortId", "fixedAssetId", "costComponentCalcId", "fromDate", "thruDate", "cost", "costUomId", "deleteCostComponent" ]
        } ],
        "columns" : [ {
            "name" : "costComponentId",
            "title" : "Cost Component ID"
        }, {
            "name" : "costComponentTypeId",
            "title" : "Cost Component Type ID"
        }, {
            "name" : "productFeatureId",
            "title" : "Product Feature ID"
        }, {
            "name" : "partyId",
            "title" : "Party ID"
        }, {
            "name" : "geoId",
            "title" : "Geo ID"
        }, {
            "name" : "workEffortId",
            "title" : "Work Effort ID"
        }, {
            "name" : "fixedAssetId",
            "title" : "Fixed Asset ID"
        }, {
            "name" : "costComponentCalcId",
            "title" : "Cost Component Calc ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "cost",
            "title" : "Cost"
        }, {
            "name" : "costUomId",
            "title" : "Cost Uom ID"
        }, {
            "name" : "deleteCostComponent",
            "title" : "Delete Cost Component"
        } ],
        "formName" : "ListCostComponents",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListCostComponents_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Cost Component ID",
            "type" : "HYPERLINK",
            "target" : "EditProductCosts",
            "name" : "costComponentId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "costComponentId",
                "bracketedOriginal" : "${costComponentId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "costComponentId"
            },
            "name" : "productCostComponentId"
            } ],
            "style" : "",
            "id" : "ListCostComponents_costComponentId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"EditProductCosts",
                "formLocation":"component://kwikstore/widget/ProductForms.xml"
            },
            "event":"edit"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "costComponentTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_costComponentTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productFeatureId",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_productFeatureId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_partyId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "geoId",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_geoId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "workEffortId",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_workEffortId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fixedAssetId",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_fixedAssetId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "costComponentCalcId",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_costComponentCalcId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "cost",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_cost",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "costUomId",
            "description" : "",
            "style" : "",
            "id" : "ListCostComponents_costUomId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Delete",
            "title" : "Delete Cost Component",
            "type" : "HYPERLINK",
            "target" : "deleteCostComponent",
            "name" : "deleteCostComponent",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "costComponentId"
            } ],
            "style" : "",
            "id" : "ListCostComponents_deleteCostComponent",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"deleteCostComponent",
                "formLocation":"component://kwikstore/widget/ProductForms.xml"
            },
            "event":"delete"
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "productFeatureId", "partyId", "geoId", "workEffortId", "fixedAssetId", "costComponentCalcId", "fromDate", "thruDate", "cost", "costUomId", "costComponentId", "costComponentId", "submitButton" ]
        } ],
        "formName" : "EditCostComponent",
        "targets":{
            "createTarget":"createCostComponent",
            "updateTarget":"updateCostComponent"
        },
        "altTarget" : [ {
            "useWhen" : "costComponent!=null",
            "targetExdr" : {
            "chars" : "updateCostComponent",
            "hint" : 20,
            "empty" : false,
            "original" : "updateCostComponent"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "EditCostComponent_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "costComponentId",
            "action" : "",
            "id" : "EditCostComponent_costComponentId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Cost Component Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditCostComponent",
            "options" : [ {
            "description" : "Actual General Cost",
            "key" : "ACTUAL_GEN_COST"
            }, {
            "description" : "Actual Indirect Cost",
            "key" : "ACTUAL_IND_COST"
            }, {
            "description" : "Actual Labor Cost",
            "key" : "ACTUAL_LABOR_COST"
            }, {
            "description" : "Actual Materials Cost",
            "key" : "ACTUAL_MAT_COST"
            }, {
            "description" : "Actual Other Cost",
            "key" : "ACTUAL_OTHER_COST"
            }, {
            "description" : "Actual Route (fixed asset usage) Cost",
            "key" : "ACTUAL_ROUTE_COST"
            }, {
            "description" : "Estimated Standard General Cost",
            "key" : "EST_STD_GEN_COST"
            }, {
            "description" : "Estimated Standard Indirect Cost",
            "key" : "EST_STD_IND_COST"
            }, {
            "description" : "Estimated Standard Labor Cost",
            "key" : "EST_STD_LABOR_COST"
            }, {
            "description" : "Estimated Standard Materials Cost",
            "key" : "EST_STD_MAT_COST"
            }, {
            "description" : "Estimated Standard Other Cost",
            "key" : "EST_STD_OTHER_COST"
            }, {
            "description" : "Estimated Standard Route (fixed asset usage) Cost",
            "key" : "EST_STD_ROUTE_COST"
            }, {
            "description" : "General Cost",
            "key" : "GEN_COST"
            }, {
            "description" : "Indirect Cost",
            "key" : "IND_COST"
            }, {
            "description" : "Labor Cost",
            "key" : "LABOR_COST"
            }, {
            "description" : "Materials Cost",
            "key" : "MAT_COST"
            }, {
            "description" : "Other Cost",
            "key" : "OTHER_COST"
            }, {
            "description" : "Route (fixed asset usage) Cost",
            "key" : "ROUTE_COST"
            } ],
            "disabled" : "false",
            "id" : "EditCostComponent_costComponentTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "costComponentTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditCostComponent",
            "id" : "EditCostComponent_productFeatureId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProductFeature",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productFeatureId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productFeatureId",
            "style" : "",
            "id" : "EditCostComponent_productFeatureId",
            "title" : "Product Feature ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditCostComponent",
            "id" : "EditCostComponent_partyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "partyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "partyId",
            "style" : "",
            "id" : "EditCostComponent_partyId",
            "title" : "Party ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditCostComponent",
            "id" : "EditCostComponent_geoId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupGeo",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "geoId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "geoId",
            "style" : "",
            "id" : "EditCostComponent_geoId",
            "title" : "Geo ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditCostComponent",
            "id" : "EditCostComponent_workEffortId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupWorkEffort",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "workEffortId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "workEffortId",
            "style" : "",
            "id" : "EditCostComponent_workEffortId",
            "title" : "Work Effort ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditCostComponent",
            "id" : "EditCostComponent_fixedAssetId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupFixedAsset",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "fixedAssetId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "fixedAssetId",
            "style" : "",
            "id" : "EditCostComponent_fixedAssetId",
            "title" : "Fixed Asset ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditCostComponent",
            "id" : "EditCostComponent_costComponentCalcId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupCostComponentCalc",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "costComponentCalcId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "costComponentCalcId",
            "style" : "",
            "id" : "EditCostComponent_costComponentCalcId",
            "title" : "Cost Component Calc ID",
            "type" : "LOOKUP"
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditCostComponent",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditCostComponent_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-02%2011:03:19.556",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditCostComponent",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditCostComponent_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Cost",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "cost",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditCostComponent_cost",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Currency",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditCostComponent",
            "options" : [ {
            "description" : "Afghani - AFN",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek - ALL",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar - DZD",
            "key" : "DZD"
            }, {
            "description" : "American Dollar - USD",
            "key" : "USD"
            }, {
            "description" : "Angolan Kwanza - AOA",
            "key" : "AOA"
            }, {
            "description" : "Argentina Peso - ARS",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram - AMD",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder - AWG",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar - AUD",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat - AZN",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar - BSD",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar - BHD",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka - BDT",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar - BBD",
            "key" : "BBD"
            }, {
            "description" : "Belize Dollar - BZD",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble - BYN",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc - XOF",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar - BMD",
            "key" : "BMD"
            }, {
            "description" : "Bolivian Boliviano - BOB",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula - BWP",
            "key" : "BWP"
            }, {
            "description" : "Brazilian Real - BRL",
            "key" : "BRL"
            }, {
            "description" : "British Pound - GBP",
            "key" : "GBP"
            }, {
            "description" : "Brunei Dollar - BND",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev - BGN",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc - BIF",
            "key" : "BIF"
            }, {
            "description" : "Cambodian Riel - KHR",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar - CAD",
            "key" : "CAD"
            }, {
            "description" : "Cape Verde Escudo - CVE",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar - KYD",
            "key" : "KYD"
            }, {
            "description" : "Chilean Peso - CLP",
            "key" : "CLP"
            }, {
            "description" : "China - CNY",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso - COP",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc - KMF",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks - BAM",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon - CRC",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna - HRK",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso - CUP",
            "key" : "CUP"
            }, {
            "description" : "Czech Krona - CZK",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone - DKK",
            "key" : "DKK"
            }, {
            "description" : "Djibouti Franc - DJF",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso - DOP",
            "key" : "DOP"
            }, {
            "description" : "East Carribean Dollar - XCD",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound - EGP",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon - SVC",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr - ETB",
            "key" : "ETB"
            }, {
            "description" : "Euro - EUR",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound - FKP",
            "key" : "FKP"
            }, {
            "description" : "Fiji Dollar - FJD",
            "key" : "FJD"
            }, {
            "description" : "Gabon C.f.A Franc - XAF",
            "key" : "XAF"
            }, {
            "description" : "Gambian Dalasi - GMD",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi - GHS",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound - GIP",
            "key" : "GIP"
            }, {
            "description" : "Guatemalan Quedzal - GTQ",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc - GNF",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar - GYD",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde - HTG",
            "key" : "HTG"
            }, {
            "description" : "Honduran Lempira - HNL",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar - HKD",
            "key" : "HKD"
            }, {
            "description" : "Hungarian forint - HUF",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona - ISK",
            "key" : "ISK"
            }, {
            "description" : "Indian Rupee - INR",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah - IDR",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial - IRR",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar - IQD",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar - JMD",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen - JPY",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar - JOD",
            "key" : "JOD"
            }, {
            "description" : "Kazakhstani Tenge - KZT",
            "key" : "KZT"
            }, {
            "description" : "Kenyan Shilling - KES",
            "key" : "KES"
            }, {
            "description" : "Kirghizstan Som - KGS",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar - KWD",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip - LAK",
            "key" : "LAK"
            }, {
            "description" : "Lari - GEL",
            "key" : "GEL"
            }, {
            "description" : "Lebanese Pound - LBP",
            "key" : "LBP"
            }, {
            "description" : "Leone - SLL",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti - LSL",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar - LRD",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar - LYD",
            "key" : "LYD"
            }, {
            "description" : "Macao Pataca - MOP",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary - MGA",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha - MWK",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit - MYR",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa - MVR",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya - MRU",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee - MUR",
            "key" : "MUR"
            }, {
            "description" : "Mexican Peso - MXN",
            "key" : "MXN"
            }, {
            "description" : "Moldavian Lei - MDL",
            "key" : "MDL"
            }, {
            "description" : "Mongolian Tugrik - MNT",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham - MAD",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical - MZN",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee - NPR",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel - ILS",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar - TWD",
            "key" : "TWD"
            }, {
            "description" : "New Zaire - ZRN",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar - NZD",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba - NIO",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira - NGN",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won - KPW",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone - NOK",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial - OMR",
            "key" : "OMR"
            }, {
            "description" : "Pakistan Rupee - PKR",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa - PAB",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina - PGK",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani - PYG",
            "key" : "PYG"
            }, {
            "description" : "Peruvian Sol - PEN",
            "key" : "PEN"
            }, {
            "description" : "Philippino Peso - PHP",
            "key" : "PHP"
            }, {
            "description" : "Polish Zloty - PLN",
            "key" : "PLN"
            }, {
            "description" : "Qatar Riyal - QAR",
            "key" : "QAR"
            }, {
            "description" : "Romanian Leu - RON",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble - RUB",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc - RWF",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala - WST",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra - STN",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal - SAR",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee - SCR",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar - SGD",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar - SBD",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling - SOS",
            "key" : "SOS"
            }, {
            "description" : "South African Rand - ZAR",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won - KRW",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound - SSP",
            "key" : "SSP"
            }, {
            "description" : "Sri Lankan Rupee - LKR",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound - SHP",
            "key" : "SHP"
            }, {
            "description" : "Sudanese Pound - SDG",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar - SRD",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni - SZL",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona - SEK",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc - CHF",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound - SYP",
            "key" : "SYP"
            }, {
            "description" : "Tadzhikistani Somoni - TJS",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling - TZS",
            "key" : "TZS"
            }, {
            "description" : "Thailand Baht - THB",
            "key" : "THB"
            }, {
            "description" : "Tongan Pa\\'anga - TOP",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar - TTD",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar - TND",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira - TRY",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat - TMT",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling - UGX",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia - UAH",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham - AED",
            "key" : "AED"
            }, {
            "description" : "Uruguay - UYU",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI) - UYI",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu - VUV",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano - VES",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong - VND",
            "key" : "VND"
            }, {
            "description" : "West Indian Guilder - ANG",
            "key" : "ANG"
            }, {
            "description" : "Yemeni Ryal - YER",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha - ZMW",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar - ZWL",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "EditCostComponent_costUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "costUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditCostComponent",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditCostComponent_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createCostComponent"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "costComponentTypeId", "costComponentCalcId", "costComponentCalc", "fromDate", "thruDate", "deleteProductCostComponentCalc" ]
        } ],
        "columns" : [ {
            "name" : "costComponentTypeId",
            "title" : "Cost Component Type ID"
        }, {
            "name" : "costComponentCalcId",
            "title" : "Cost Component Calc ID"
        }, {
            "name" : "costComponentCalc",
            "title" : "Cost Component Calc"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "deleteProductCostComponentCalc",
            "title" : "Delete Product Cost Component Calc"
        } ],
        "formName" : "ListProductCostComponentCalcs",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductCostComponentCalcs_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "costComponentTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListProductCostComponentCalcs_costComponentTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Cost Component Calc ID",
            "type" : "HYPERLINK",
            "target" : "/manufacturing/control/EditCostCalcs",
            "name" : "costComponentCalcId",
            "width" : "",
            "parameterList" : [ {
            "name" : "costComponentCalcId"
            } ],
            "style" : "",
            "id" : "ListProductCostComponentCalcs_costComponentCalcId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "costComponentCalc",
            "description" : "",
            "style" : "",
            "id" : "ListProductCostComponentCalcs_costComponentCalc",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductCostComponentCalcs_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductCostComponentCalcs_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Delete",
            "title" : "Delete Product Cost Component Calc",
            "type" : "HYPERLINK",
            "target" : "deleteProductCostComponentCalc",
            "name" : "deleteProductCostComponentCalc",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "costComponentTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "style" : "",
            "id" : "ListProductCostComponentCalcs_deleteProductCostComponentCalc",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "attrName", "attrValue", "attrType", "attrDescription", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "attrName",
            "title" : "Attr Name"
        }, {
            "name" : "attrValue",
            "title" : "Attr Value"
        }, {
            "name" : "attrType",
            "title" : "Attr Type"
        }, {
            "name" : "attrDescription",
            "title" : "Attr Description"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductAttribute",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductAttribute_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "attrName",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductAttribute_attrName",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Value",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrValue",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductAttribute_attrValue",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Type",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrType",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductAttribute_attrType",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrDescription",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductAttribute_attrDescription",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductAttribute",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "UpdateProductAttribute_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "attrName"
            } ],
            "id" : "UpdateProductAttribute_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteProductAttribute"
        } ],
        "target" : "updateProductAttribute"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "attrName", "attrValue", "attrType", "attrDescription", "submitButton" ]
        } ],
        "formName" : "AddProductAttribute",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"createProductAttribute",
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductAttribute_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "required",
            "title" : "Attr Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductAttribute_attrName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Value",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrValue",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductAttribute_attrValue",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Type",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrType",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductAttribute_attrType",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrDescription",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductAttribute_attrDescription",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductAttribute",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddProductAttribute_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductAttribute"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureId", "fromDate", "attrName", "attrValue", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "productFeatureId",
            "title" : "Product Feature ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "attrName",
            "title" : "Attr Name"
        }, {
            "name" : "attrValue",
            "title" : "Attr Value"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "ListProductFeatureApplAttrsRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductFeatureApplAttrs_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productFeatureId",
            "description" : "",
            "style" : "",
            "id" : "ListProductFeatureApplAttrs_productFeatureId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductFeatureApplAttrs_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "attrName",
            "description" : "",
            "style" : "",
            "id" : "ListProductFeatureApplAttrs_attrName",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "attrValue",
            "description" : "",
            "style" : "",
            "id" : "ListProductFeatureApplAttrs_attrValue",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productFeatureId"
            }, {
            "name" : "attrName"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "ListProductFeatureApplAttrs_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteProductFeatureApplAttr"
        } ],
        "target" : "EditProductFeatureAppl"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureId", "fromDate", "attrName", "attrValue", "submitButton" ]
        } ],
        "formName" : "AddProductFeatureApplAttrRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductFeatureApplAttr_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Feature ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductFeatureApplAttrRest",
            "options" : [ ],
            "disabled" : "false",
            "id" : "AddProductFeatureApplAttr_productFeatureId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-02%2017:40:51.242",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductFeatureApplAttrRest",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductFeatureApplAttr_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "required",
            "title" : "Attr Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductFeatureApplAttr_attrName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Attr Value",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "attrValue",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductFeatureApplAttr_attrValue",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductFeatureApplAttrRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductFeatureApplAttr_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductFeatureApplAttr"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureId", "productFeatureIdTo", "productFeatureIactnTypeId", "submitButton" ]
        } ],
        "formName" : "AddFeatureInteractionRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddFeatureInteraction_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Feature ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddFeatureInteractionRest",
            "options" : [ ],
            "disabled" : "false",
            "id" : "AddFeatureInteraction_productFeatureId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Feature Id To",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddFeatureInteractionRest",
            "options" : [ ],
            "disabled" : "false",
            "id" : "AddFeatureInteraction_productFeatureIdTo",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureIdTo",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Interaction Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddFeatureInteractionRest",
            "options" : [ {
            "description" : "Dependent Feature",
            "key" : "FEATURE_IACTN_DEPEND"
            }, {
            "description" : "Incompatible Feature",
            "key" : "FEATURE_IACTN_INCOMP"
            } ],
            "disabled" : "false",
            "id" : "AddFeatureInteraction_productFeatureIactnTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureIactnTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddFeatureInteractionRest",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddFeatureInteraction_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "AddProductFeatureIactn"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureId", "productFeatureIdTo", "productFeatureIactnTypeId", "removeFeatureInterAction" ]
        } ],
        "columns" : [ {
            "name" : "productFeatureId",
            "title" : "Product Feature ID"
        }, {
            "name" : "productFeatureIdTo",
            "title" : "Product Feature Id To"
        }, {
            "name" : "productFeatureIactnTypeId",
            "title" : "Interaction Type"
        }, {
            "name" : "removeFeatureInterAction",
            "title" : "Delete"
        } ],
        "formName" : "ListFeatureInteractionsRest",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListFeatureInteractions_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "",
            "description" : "[]",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_661ae055_e2f8_49e8_b890_d743eb8550dc",
            "target" : "EditFeature",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productFeatureId",
            "description" : "",
            "style" : "",
            "id" : "ListFeatureInteractions_productFeatureId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "",
            "description" : "[]",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_b1c7a5f8_313d_4f3e_a53e_b8aa71157a29",
            "target" : "EditFeature",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productFeatureIdTo",
            "description" : "",
            "style" : "",
            "id" : "ListFeatureInteractions_productFeatureIdTo",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productFeatureIactnTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListFeatureInteractions_productFeatureIactnTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Delete",
            "title" : "Delete",
            "type" : "HYPERLINK",
            "target" : "removeFeatureIactn",
            "name" : "removeFeatureInterAction",
            "width" : "",
            "parameterList" : [ {
            "name" : "productFeatureId"
            }, {
            "name" : "productFeatureIdTo"
            }, {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListFeatureInteractions_removeFeatureInterAction",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "facilityId", "minimumStock", "reorderQuantity", "daysToShip", "replenishMethodEnumId", "lastInventoryCount", "requirementMethodEnumId", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "facilityId",
            "title" : "Facility ID"
        }, {
            "name" : "minimumStock",
            "title" : "Minimum Stock"
        }, {
            "name" : "reorderQuantity",
            "title" : "Reorder Quantity"
        }, {
            "name" : "daysToShip",
            "title" : "Days To Ship"
        }, {
            "name" : "replenishMethodEnumId",
            "title" : "Replenish Method Enum ID"
        }, {
            "name" : "lastInventoryCount",
            "title" : "Last Inventory Count"
        }, {
            "name" : "requirementMethodEnumId",
            "title" : "Requirement Method Enum ID"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductFacilities",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductFacilities_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "facilityId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductFacilities_facilityId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Minimum Stock",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "minimumStock",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductFacilities_minimumStock",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Reorder Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "reorderQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductFacilities_reorderQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Days To Ship",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "daysToShip",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductFacilities_daysToShip",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Replenish Method Enum ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "replenishMethodEnumId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductFacilities_replenishMethodEnumId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "lastInventoryCount",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductFacilities_lastInventoryCount",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Requirement Method Enum ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "requirementMethodEnumId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductFacilities_requirementMethodEnumId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductFacilities",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "UpdateProductFacilities_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "facilityId"
            } ],
            "id" : "UpdateProductFacilities_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteProductFacility"
        } ],
        "target" : "updateProductFacility"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "facilityId", "minimumStock", "reorderQuantity", "daysToShip", "replenishMethodEnumId", "lastInventoryCount", "requirementMethodEnumId", "submitButton" ]
        } ],
        "formName" : "AddProductFacility",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"createProductFacility"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductFacility_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "lastInventoryCount",
            "action" : "",
            "id" : "AddProductFacility_lastInventoryCount",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Facility ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductFacility",
            "options" : [ {
            "description" : "My Retail Store",
            "key" : "MyRetailStore"
            }, {
            "description" : "Regional Warehouse1",
            "key" : "RegionalWarehouse1"
            }, {
            "description" : "Regional Warehouse2",
            "key" : "RegionalWarehouse2"
            }, {
            "description" : "Store Warehouse1",
            "key" : "StoreWarehouse1"
            }, {
            "description" : "Store Warehouse2",
            "key" : "StoreWarehouse2"
            }, {
            "description" : "Web Store Warehouse",
            "key" : "WebStoreWarehouse"
            } ],
            "disabled" : "false",
            "id" : "AddProductFacility_facilityId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "facilityId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Minimum Stock",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "minimumStock",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductFacility_minimumStock",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Reorder Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "reorderQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductFacility_reorderQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Days To Ship",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "daysToShip",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductFacility_daysToShip",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Replenish Method Enum ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "replenishMethodEnumId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductFacility_replenishMethodEnumId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Requirement Method Enum ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "requirementMethodEnumId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductFacility_requirementMethodEnumId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductFacility",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddProductFacility_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductFacility"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "facilityId", "locationSeqId", "minimumStock", "moveQuantity", "facilityName", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "minimumStock",
            "title" : "Minimum Stock"
        }, {
            "name" : "moveQuantity",
            "title" : "Move Quantity"
        }, {
            "name" : "facilityName",
            "title" : "Facility Name"
        }, {
            "name" : "locationSeqId",
            "title" : "Location Seq ID"
        }, {
            "name" : "submitButton",
            "title" : ""
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductFacilityLocations",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductFacilityLocations_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "facilityId",
            "action" : "",
            "id" : "UpdateProductFacilityLocations_facilityId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "locationSeqId",
            "description" : "     [] ()",
            "style" : "",
            "id" : "UpdateProductFacilityLocations_locationSeqId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Minimum Stock",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "minimumStock",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductFacilityLocations_minimumStock",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Move Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "moveQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductFacilityLocations_moveQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "facilityName",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductFacilityLocations_facilityName",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductFacilityLocations",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "UpdateProductFacilityLocations_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "facilityId"
            }, {
            "name" : "locationSeqId"
            } ],
            "id" : "UpdateProductFacilityLocations_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteProductFacilityLocation"
        } ],
        "target" : "updateProductFacilityLocation"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "facilityId", "locationSeqId", "minimumStock", "moveQuantity", "submitButton" ]
        } ],
        "formName" : "AddProductFacilityLocation",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"createProductFacilityLocation"
        },
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductFacilityLocation_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Facility ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductFacilityLocation",
            "options" : [ {
            "description" : "My Retail Store",
            "key" : "MyRetailStore"
            }, {
            "description" : "Regional Warehouse1",
            "key" : "RegionalWarehouse1"
            }, {
            "description" : "Regional Warehouse2",
            "key" : "RegionalWarehouse2"
            }, {
            "description" : "Store Warehouse1",
            "key" : "StoreWarehouse1"
            }, {
            "description" : "Store Warehouse2",
            "key" : "StoreWarehouse2"
            }, {
            "description" : "Web Store Warehouse",
            "key" : "WebStoreWarehouse"
            } ],
            "disabled" : "false",
            "id" : "AddProductFacilityLocation_facilityId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "facilityId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductFacilityLocation",
            "id" : "AddProductFacilityLocation_locationSeqId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupFacilityLocation",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "locationSeqId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "locationSeqId",
            "style" : "",
            "id" : "AddProductFacilityLocation_locationSeqId",
            "title" : "Location Seq ID",
            "type" : "LOOKUP"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Minimum Stock",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "minimumStock",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductFacilityLocation_minimumStock",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Move Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "moveQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductFacilityLocation_moveQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductFacilityLocation",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddProductFacilityLocation_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductFacilityLocation"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "totalAvailableToPromise", "totalQuantityOnHand", "accountingQuantityTotal", "mktgPkgATP", "mktgPkgQOH" ]
        } ],
        "columns" : [ {
            "name" : "facilityId",
            "title" : "Facility"
        }, {
            "name" : "totalAvailableToPromise",
            "title" : "ATP"
        }, {
            "name" : "totalQuantityOnHand",
            "title" : "QOH"
        }, {
            "name" : "accountingQuantityTotal",
            "title" : "AQT"
        }, {
            "name" : "mktgPkgATP",
            "title" : "ATP from Components"
        }, {
            "name" : "mktgPkgQOH",
            "title" : "QOH from Components"
        } ],
        "formName" : "ProductInventorySummary",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "Receive Inventory",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "productId" : "GZ-2644",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_dacd82d3_5f98_41a9_8cae_8c5be0a9aac4",
            "target" : "ReceiveInventory",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "facilityId",
            "description" : "",
            "style" : "",
            "id" : "ProductInventorySummary_facilityId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "totalAvailableToPromise",
            "description" : "",
            "style" : "",
            "id" : "ProductInventorySummary_totalAvailableToPromise",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "totalQuantityOnHand",
            "description" : "",
            "style" : "",
            "id" : "ProductInventorySummary_totalQuantityOnHand",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "accountingQuantityTotal",
            "description" : "",
            "style" : "",
            "id" : "ProductInventorySummary_accountingQuantityTotal",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "mktgPkgATP",
            "description" : "",
            "style" : "",
            "id" : "ProductInventorySummary_mktgPkgATP",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "mktgPkgQOH",
            "description" : "",
            "style" : "",
            "id" : "ProductInventorySummary_mktgPkgQOH",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "totalAvailableToPromise", "totalQuantityOnHand", "accountingQuantityTotal" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "ProductIdName"
        }, {
            "name" : "totalAvailableToPromise",
            "title" : "ATP"
        }, {
            "name" : "totalQuantityOnHand",
            "title" : "QOH"
        }, {
            "name" : "accountingQuantityTotal",
            "title" : "AQT"
        } ],
        "formName" : "VirtualProductInventorySummary",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "View Inventory By Facility",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "productId" : "GZ-2644",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_b66778dc_2fab_4039_a343_016c7022adbc",
            "target" : "ViewFacilityInventory",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "Round Gizmo []",
            "style" : "",
            "id" : "VirtualProductInventorySummary_productId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "totalAvailableToPromise",
            "description" : "",
            "style" : "",
            "id" : "VirtualProductInventorySummary_totalAvailableToPromise",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "totalQuantityOnHand",
            "description" : "",
            "style" : "",
            "id" : "VirtualProductInventorySummary_totalQuantityOnHand",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "accountingQuantityTotal",
            "description" : "",
            "style" : "",
            "id" : "VirtualProductInventorySummary_accountingQuantityTotal",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderId", "orderItemSeqId", "quantity", "cancelQuantity", "itemStatusId", "estimatedShipDate", "estimatedDeliveryDate", "shipBeforeDate", "shipAfterDate" ]
        } ],
        "columns" : [ {
            "name" : "orderDate",
            "title" : "Order Date"
        }, {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "orderItemSeqId",
            "title" : "Order Item Seq ID"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "cancelQuantity",
            "title" : "Cancel Quantity"
        }, {
            "name" : "itemStatusId",
            "title" : "Item Status ID"
        }, {
            "name" : "estimatedShipDate",
            "title" : "Estimated Ship Date"
        }, {
            "name" : "estimatedDeliveryDate",
            "title" : "Estimated Delivery Date"
        }, {
            "name" : "shipBeforeDate",
            "title" : "Ship Before Date"
        }, {
            "name" : "shipAfterDate",
            "title" : "Ship After Date"
        } ],
        "formName" : "OutstandingPurchaseOrders",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderDate",
            "description" : "",
            "style" : "",
            "id" : "OutstandingPurchaseOrders_orderDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Order ID",
            "type" : "HYPERLINK",
            "target" : "/ordermgr/control/orderview",
            "name" : "orderId",
            "width" : "",
            "parameterList" : [ {
            "name" : "orderId"
            } ],
            "style" : "",
            "id" : "OutstandingPurchaseOrders_orderId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderItemSeqId",
            "description" : "",
            "style" : "",
            "id" : "OutstandingPurchaseOrders_orderItemSeqId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "OutstandingPurchaseOrders_quantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "cancelQuantity",
            "description" : "",
            "style" : "",
            "id" : "OutstandingPurchaseOrders_cancelQuantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "itemStatusId",
            "description" : "",
            "style" : "",
            "id" : "OutstandingPurchaseOrders_itemStatusId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimatedShipDate",
            "description" : "",
            "style" : "",
            "id" : "OutstandingPurchaseOrders_estimatedShipDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "estimatedDeliveryDate",
            "description" : "",
            "style" : "",
            "id" : "OutstandingPurchaseOrders_estimatedDeliveryDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shipBeforeDate",
            "description" : "",
            "style" : "",
            "id" : "OutstandingPurchaseOrders_shipBeforeDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shipAfterDate",
            "description" : "",
            "style" : "",
            "id" : "OutstandingPurchaseOrders_shipAfterDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "supplierProductId", "minimumOrderQuantity", "orderQtyIncrements", "supplierPrefOrderId", "availableFromDate", "availableThruDate", "quantityUomId", "lastPrice", "shippingPrice", "editLink", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "partyId",
            "title" : "Supplier"
        }, {
            "name" : "supplierProductId",
            "title" : "Supplier Product ID"
        }, {
            "name" : "minimumOrderQuantity",
            "title" : "Minimum order quantity"
        }, {
            "name" : "orderQtyIncrements",
            "title" : "Order qty increments"
        }, {
            "name" : "supplierPrefOrderId",
            "title" : "Supplier Pref Order ID"
        }, {
            "name" : "availableFromDate",
            "title" : "Available from date"
        }, {
            "name" : "availableThruDate",
            "title" : "Available Through date"
        }, {
            "name" : "quantityUomId",
            "title" : "Quantity Uom ID"
        }, {
            "name" : "lastPrice",
            "title" : "Last Price"
        }, {
            "name" : "shippingPrice",
            "title" : "Shipping Price"
        }, {
            "name" : "editLink",
            "title" : " "
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "ListSupplierProducts",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "inter-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_c3712ed8_5c15_4ea7_93f5_54797a6625c0",
            "target" : "/partymgr/control/viewprofile",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_partyId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "supplierProductId",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_supplierProductId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "minimumOrderQuantity",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_minimumOrderQuantity",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "orderQtyIncrements",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_orderQtyIncrements",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "supplierPrefOrderId",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_supplierPrefOrderId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "availableFromDate",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_availableFromDate",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "availableThruDate",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_availableThruDate",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantityUomId",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_quantityUomId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "lastPrice",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_lastPrice",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shippingPrice",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProducts_shippingPrice",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "editLink",
            "alternate" : "",
            "description" : "Edit",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "partyId"
            }, {
            "name" : "currencyUomId"
            }, {
            "name" : "minimumOrderQuantity"
            }, {
            "name" : "availableFromDate"
            } ],
            "id" : "ListSupplierProducts_editLink",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : "",
            "target" : "EditProductSuppliers"
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "partyId"
            }, {
            "name" : "currencyUomId"
            }, {
            "name" : "minimumOrderQuantity"
            }, {
            "name" : "availableFromDate"
            } ],
            "id" : "ListSupplierProducts_deleteLink",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : "",
            "target" : "removeSupplierProduct"
        } ],
        "target" : "updateSupplierProduct"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "partyId", "partyId", "availableFromDate", "availableFromDate", "availableFromDate", "minimumOrderQuantity", "minimumOrderQuantity", "minimumOrderQuantity", "currencyUomId", "currencyUomId", "currencyUomId", "availableThruDate", "supplierPrefOrderId", "supplierRatingTypeId", "standardLeadTimeDays", "orderQtyIncrements", "unitsIncluded", "quantityUomId", "agreementId", "agreementItemSeqId", "lastPrice", "shippingPrice", "supplierProductName", "supplierProductId", "canDropShip", "comments", "submitButton", "submitButton" ]
        } ],
        "formName" : "AddSupplierProduct",
        "altTarget" : [ {
            "useWhen" : "supplierProduct==null",
            "targetExdr" : {
            "chars" : "createSupplierProduct",
            "hint" : 20,
            "empty" : false,
            "original" : "createSupplierProduct"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddSupplierProduct_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Supplier",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddSupplierProduct",
            "options" : [ {
            "description" : "Acct Big Supplier   [AcctBigSupplier]",
            "key" : "AcctBigSupplier"
            }, {
            "description" : "Big Supplier   [BigSupplier]",
            "key" : "BigSupplier"
            }, {
            "description" : "Demo Supplier   [DemoSupplier]",
            "key" : "DemoSupplier"
            }, {
            "description" : "European Supplier   [EuroSupplier]",
            "key" : "EuroSupplier"
            }, {
            "description" : " External User [externaluser]",
            "key" : "externaluser"
            } ],
            "disabled" : "false",
            "id" : "AddSupplierProduct_partyId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "partyId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Available From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-06%2017:36:10.899",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddSupplierProduct",
            "timeDropdownParamName" : "availableFromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddSupplierProduct_availableFromDate",
            "event" : "",
            "value" : "2023-03-06 17:36:10.905",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "availableFromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "0",
            "fieldHelpText" : "",
            "textSize" : "5",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Min Order Qty",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "minimumOrderQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_minimumOrderQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "0",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Currency Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddSupplierProduct",
            "options" : [ {
            "description" : "Afghani - AFN",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek - ALL",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar - DZD",
            "key" : "DZD"
            }, {
            "description" : "American Dollar - USD",
            "key" : "USD"
            }, {
            "description" : "Angolan Kwanza - AOA",
            "key" : "AOA"
            }, {
            "description" : "Argentina Peso - ARS",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram - AMD",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder - AWG",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar - AUD",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat - AZN",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar - BSD",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar - BHD",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka - BDT",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar - BBD",
            "key" : "BBD"
            }, {
            "description" : "Belize Dollar - BZD",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble - BYN",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc - XOF",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar - BMD",
            "key" : "BMD"
            }, {
            "description" : "Bolivian Boliviano - BOB",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula - BWP",
            "key" : "BWP"
            }, {
            "description" : "Brazilian Real - BRL",
            "key" : "BRL"
            }, {
            "description" : "British Pound - GBP",
            "key" : "GBP"
            }, {
            "description" : "Brunei Dollar - BND",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev - BGN",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc - BIF",
            "key" : "BIF"
            }, {
            "description" : "Cambodian Riel - KHR",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar - CAD",
            "key" : "CAD"
            }, {
            "description" : "Cape Verde Escudo - CVE",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar - KYD",
            "key" : "KYD"
            }, {
            "description" : "Chilean Peso - CLP",
            "key" : "CLP"
            }, {
            "description" : "China - CNY",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso - COP",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc - KMF",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks - BAM",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon - CRC",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna - HRK",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso - CUP",
            "key" : "CUP"
            }, {
            "description" : "Czech Krona - CZK",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone - DKK",
            "key" : "DKK"
            }, {
            "description" : "Djibouti Franc - DJF",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso - DOP",
            "key" : "DOP"
            }, {
            "description" : "East Carribean Dollar - XCD",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound - EGP",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon - SVC",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr - ETB",
            "key" : "ETB"
            }, {
            "description" : "Euro - EUR",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound - FKP",
            "key" : "FKP"
            }, {
            "description" : "Fiji Dollar - FJD",
            "key" : "FJD"
            }, {
            "description" : "Gabon C.f.A Franc - XAF",
            "key" : "XAF"
            }, {
            "description" : "Gambian Dalasi - GMD",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi - GHS",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound - GIP",
            "key" : "GIP"
            }, {
            "description" : "Guatemalan Quedzal - GTQ",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc - GNF",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar - GYD",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde - HTG",
            "key" : "HTG"
            }, {
            "description" : "Honduran Lempira - HNL",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar - HKD",
            "key" : "HKD"
            }, {
            "description" : "Hungarian forint - HUF",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona - ISK",
            "key" : "ISK"
            }, {
            "description" : "Indian Rupee - INR",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah - IDR",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial - IRR",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar - IQD",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar - JMD",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen - JPY",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar - JOD",
            "key" : "JOD"
            }, {
            "description" : "Kazakhstani Tenge - KZT",
            "key" : "KZT"
            }, {
            "description" : "Kenyan Shilling - KES",
            "key" : "KES"
            }, {
            "description" : "Kirghizstan Som - KGS",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar - KWD",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip - LAK",
            "key" : "LAK"
            }, {
            "description" : "Lari - GEL",
            "key" : "GEL"
            }, {
            "description" : "Lebanese Pound - LBP",
            "key" : "LBP"
            }, {
            "description" : "Leone - SLL",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti - LSL",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar - LRD",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar - LYD",
            "key" : "LYD"
            }, {
            "description" : "Macao Pataca - MOP",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary - MGA",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha - MWK",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit - MYR",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa - MVR",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya - MRU",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee - MUR",
            "key" : "MUR"
            }, {
            "description" : "Mexican Peso - MXN",
            "key" : "MXN"
            }, {
            "description" : "Moldavian Lei - MDL",
            "key" : "MDL"
            }, {
            "description" : "Mongolian Tugrik - MNT",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham - MAD",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical - MZN",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee - NPR",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel - ILS",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar - TWD",
            "key" : "TWD"
            }, {
            "description" : "New Zaire - ZRN",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar - NZD",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba - NIO",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira - NGN",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won - KPW",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone - NOK",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial - OMR",
            "key" : "OMR"
            }, {
            "description" : "Pakistan Rupee - PKR",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa - PAB",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina - PGK",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani - PYG",
            "key" : "PYG"
            }, {
            "description" : "Peruvian Sol - PEN",
            "key" : "PEN"
            }, {
            "description" : "Philippino Peso - PHP",
            "key" : "PHP"
            }, {
            "description" : "Polish Zloty - PLN",
            "key" : "PLN"
            }, {
            "description" : "Qatar Riyal - QAR",
            "key" : "QAR"
            }, {
            "description" : "Romanian Leu - RON",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble - RUB",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc - RWF",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala - WST",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra - STN",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal - SAR",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee - SCR",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar - SGD",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar - SBD",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling - SOS",
            "key" : "SOS"
            }, {
            "description" : "South African Rand - ZAR",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won - KRW",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound - SSP",
            "key" : "SSP"
            }, {
            "description" : "Sri Lankan Rupee - LKR",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound - SHP",
            "key" : "SHP"
            }, {
            "description" : "Sudanese Pound - SDG",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar - SRD",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni - SZL",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona - SEK",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc - CHF",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound - SYP",
            "key" : "SYP"
            }, {
            "description" : "Tadzhikistani Somoni - TJS",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling - TZS",
            "key" : "TZS"
            }, {
            "description" : "Thailand Baht - THB",
            "key" : "THB"
            }, {
            "description" : "Tongan Pa\\'anga - TOP",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar - TTD",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar - TND",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira - TRY",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat - TMT",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling - UGX",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia - UAH",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham - AED",
            "key" : "AED"
            }, {
            "description" : "Uruguay - UYU",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI) - UYI",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu - VUV",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano - VES",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong - VND",
            "key" : "VND"
            }, {
            "description" : "West Indian Guilder - ANG",
            "key" : "ANG"
            }, {
            "description" : "Yemeni Ryal - YER",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha - ZMW",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar - ZWL",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "AddSupplierProduct_currencyUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "currencyUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Available Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-06%2017:36:11.065",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddSupplierProduct",
            "timeDropdownParamName" : "availableThruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddSupplierProduct_availableThruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "availableThruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Supplier Pref Order ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "10_MAIN_SUPPL",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddSupplierProduct",
            "options" : [ {
            "description" : "Main Supplier",
            "key" : "10_MAIN_SUPPL"
            }, {
            "description" : "Alternative Supplier",
            "key" : "90_ALT_SUPPL"
            } ],
            "disabled" : "false",
            "id" : "AddSupplierProduct_supplierPrefOrderId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "supplierPrefOrderId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Supplier Rating Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddSupplierProduct",
            "options" : [ ],
            "disabled" : "false",
            "id" : "AddSupplierProduct_supplierRatingTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "supplierRatingTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Standard Lead Time Days",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "standardLeadTimeDays",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_standardLeadTimeDays",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Order Qty Increments",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "orderQtyIncrements",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_orderQtyIncrements",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Units Included",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "unitsIncluded",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_unitsIncluded",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Quantity UomId",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddSupplierProduct",
            "options" : [ {
            "description" : "Area: Acre (A)",
            "key" : "AREA_A"
            }, {
            "description" : "Area: Are (a)",
            "key" : "AREA_a"
            }, {
            "description" : "Area: Square Centimeter (cm2)",
            "key" : "AREA_cm2"
            }, {
            "description" : "Area: Square Foot (ft2)",
            "key" : "AREA_ft2"
            }, {
            "description" : "Area: Hectare (ha)",
            "key" : "AREA_ha"
            }, {
            "description" : "Area: Square Inch (in2)",
            "key" : "AREA_in2"
            }, {
            "description" : "Area: Square Kilometer (km2)",
            "key" : "AREA_km2"
            }, {
            "description" : "Area: Square Meter (m2)",
            "key" : "AREA_m2"
            }, {
            "description" : "Area: Square Mile (mi2)",
            "key" : "AREA_mi2"
            }, {
            "description" : "Area: Square Millimeter (mm2)",
            "key" : "AREA_mm2"
            }, {
            "description" : "Area: Square Rod (rd2)",
            "key" : "AREA_rd2"
            }, {
            "description" : "Area: Square Yard (yd2)",
            "key" : "AREA_yd2"
            }, {
            "description" : "Data Size: Byte of Data (B)",
            "key" : "DATA_B"
            }, {
            "description" : "Data Size: Gigabyte of Data (GB)",
            "key" : "DATA_GB"
            }, {
            "description" : "Data Size: Gigabit of Data (Gb)",
            "key" : "DATA_Gb"
            }, {
            "description" : "Data Size: Kilobyte of Data (KB)",
            "key" : "DATA_KB"
            }, {
            "description" : "Data Size: Kilobit of Data (Kb)",
            "key" : "DATA_Kb"
            }, {
            "description" : "Data Size: Megabyte of Data (MB)",
            "key" : "DATA_MB"
            }, {
            "description" : "Data Size: Megabit of Data (Mb)",
            "key" : "DATA_Mb"
            }, {
            "description" : "Data Size: Petabyte of Data (PB)",
            "key" : "DATA_PB"
            }, {
            "description" : "Data Size: Petabit of Data (Pb)",
            "key" : "DATA_Pb"
            }, {
            "description" : "Data Size: Terabyte of Data (TB)",
            "key" : "DATA_TB"
            }, {
            "description" : "Data Size: Terabit of Data (Tb)",
            "key" : "DATA_Tb"
            }, {
            "description" : "Data Size: Bit of Data (b)",
            "key" : "DATA_b"
            }, {
            "description" : "Data Speed: Gigabit-per-second of Data (Gbps)",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "Data Speed: Kilobit-per-second of Data (Kbps)",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "Data Speed: Megabit-per-second of Data (Mbps)",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "Data Speed: Terabit-per-second of Data (Tbps)",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "Data Speed: Bit-per-second of Data (bps)",
            "key" : "DATASPD_bps"
            }, {
            "description" : "Dry Volume: Stere (cubic meter) (ST)",
            "key" : "VDRY_ST"
            }, {
            "description" : "Dry Volume: Cubic centimeter (cm3)",
            "key" : "VDRY_cm3"
            }, {
            "description" : "Dry Volume: Cubic foot (ft3)",
            "key" : "VDRY_ft3"
            }, {
            "description" : "Dry Volume: Cubic inch (in3)",
            "key" : "VDRY_in3"
            }, {
            "description" : "Dry Volume: Cubic meter (m3)",
            "key" : "VDRY_m3"
            }, {
            "description" : "Dry Volume: Cubic millimeter (mm3)",
            "key" : "VDRY_mm3"
            }, {
            "description" : "Dry Volume: Cubic yard (yd3)",
            "key" : "VDRY_yd3"
            }, {
            "description" : "Energy: British Thermal Unit (Btu)",
            "key" : "EN_Btu"
            }, {
            "description" : "Energy: Horsepower (mechanical) (HP)",
            "key" : "EN_HP"
            }, {
            "description" : "Energy: Joule (absolute) (J)",
            "key" : "EN_J"
            }, {
            "description" : "Energy: Kilowatt (Kw)",
            "key" : "EN_Kw"
            }, {
            "description" : "Energy: Calorie (@15.5c) (cal15)",
            "key" : "EN_cal15"
            }, {
            "description" : "Energy: Watt (w)",
            "key" : "EN_w"
            }, {
            "description" : "Length: Angstrom (A)",
            "key" : "LEN_A"
            }, {
            "description" : "Length: Cable (cb)",
            "key" : "LEN_cb"
            }, {
            "description" : "Length: Chain (Gunter\\'s/surveyor\\'s) (chG)",
            "key" : "LEN_chG"
            }, {
            "description" : "Length: Chain (Ramden\\'s/engineer\\'s) (chR)",
            "key" : "LEN_chR"
            }, {
            "description" : "Length: Centimeter (cm)",
            "key" : "LEN_cm"
            }, {
            "description" : "Length: Dekameter (dam)",
            "key" : "LEN_dam"
            }, {
            "description" : "Length: Decimeter (dm)",
            "key" : "LEN_dm"
            }, {
            "description" : "Length: Fathom (fm)",
            "key" : "LEN_fm"
            }, {
            "description" : "Length: Foot (ft)",
            "key" : "LEN_ft"
            }, {
            "description" : "Length: Furlong (fur)",
            "key" : "LEN_fur"
            }, {
            "description" : "Length: Hand (horse\\'s height) (hand)",
            "key" : "LEN_hand"
            }, {
            "description" : "Length: Inch (in)",
            "key" : "LEN_in"
            }, {
            "description" : "Length: Kilometer (km)",
            "key" : "LEN_km"
            }, {
            "description" : "Length: League (league)",
            "key" : "LEN_league"
            }, {
            "description" : "Length: Link (Gunter\\'s) (lnG)",
            "key" : "LEN_lnG"
            }, {
            "description" : "Length: Link (Ramden\\'s) (lnR)",
            "key" : "LEN_lnR"
            }, {
            "description" : "Length: Meter (m)",
            "key" : "LEN_m"
            }, {
            "description" : "Length: Mile (statute/land) (mi)",
            "key" : "LEN_mi"
            }, {
            "description" : "Length: Mil (Milli-inch) (mil)",
            "key" : "LEN_mil"
            }, {
            "description" : "Length: Millimeter (mm)",
            "key" : "LEN_mm"
            }, {
            "description" : "Length: Mile (nautical/sea) (nmi)",
            "key" : "LEN_nmi"
            }, {
            "description" : "Length: Pica (type size) (pica)",
            "key" : "LEN_pica"
            }, {
            "description" : "Length: Point (type size) (point)",
            "key" : "LEN_point"
            }, {
            "description" : "Length: Rod (rd)",
            "key" : "LEN_rd"
            }, {
            "description" : "Length: Micrometer (Micron) (u)",
            "key" : "LEN_u"
            }, {
            "description" : "Length: Yard (yd)",
            "key" : "LEN_yd"
            }, {
            "description" : "Liquid Volume: Hectoliter (hL)",
            "key" : "VLIQ_HL"
            }, {
            "description" : "Liquid Volume: Liter (L)",
            "key" : "VLIQ_L"
            }, {
            "description" : "Liquid Volume: Cubic meter (liquid) (m3)",
            "key" : "VLIQ_M3"
            }, {
            "description" : "Liquid Volume: Tablespoon (Tbs)",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "Liquid Volume: Barrel (US) (bbl)",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "Liquid Volume: Cup (cup)",
            "key" : "VLIQ_cup"
            }, {
            "description" : "Liquid Volume: Dram (US) (dr)",
            "key" : "VLIQ_dr"
            }, {
            "description" : "Liquid Volume: Gallon (UK) (gal)",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "Liquid Volume: Gallon (US) (gal)",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "Liquid Volume: Gill (1/4 UK pint) (gi)",
            "key" : "VLIQ_gi"
            }, {
            "description" : "Liquid Volume: Milliliter (ml)",
            "key" : "VLIQ_ml"
            }, {
            "description" : "Liquid Volume: Ounce, fluid (UK) (fl. oz (UK))",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "Liquid Volume: Ounce, fluid (US) (fl. oz (US))",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "Liquid Volume: Pint (UK) (pt (UK))",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "Liquid Volume: Pint (US) (pt (US))",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "Liquid Volume: Quart (qt)",
            "key" : "VLIQ_qt"
            }, {
            "description" : "Liquid Volume: Teaspoon (tsp)",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "Other: Amphere - Electric current (A)",
            "key" : "OTH_A"
            }, {
            "description" : "Other: Box (bx)",
            "key" : "OTH_box"
            }, {
            "description" : "Other: Candela - Luminosity (intensity of light) (cd)",
            "key" : "OTH_cd"
            }, {
            "description" : "Other: Each (ea)",
            "key" : "OTH_ea"
            }, {
            "description" : "Other: Mole - Substance (molecule) (mol)",
            "key" : "OTH_mol"
            }, {
            "description" : "Other: Package (pk)",
            "key" : "OTH_pk"
            }, {
            "description" : "Other: Per Person (pp)",
            "key" : "OTH_pp"
            }, {
            "description" : "Temperature: Degrees Celsius (C)",
            "key" : "TEMP_C"
            }, {
            "description" : "Temperature: Degrees Fahrenheit (F)",
            "key" : "TEMP_F"
            }, {
            "description" : "Temperature: Kelvin (K)",
            "key" : "TEMP_K"
            }, {
            "description" : "Time/Frequency: Time in Centuries (century)",
            "key" : "TF_century"
            }, {
            "description" : "Time/Frequency: Time in Days (day)",
            "key" : "TF_day"
            }, {
            "description" : "Time/Frequency: Time in Decades (decade)",
            "key" : "TF_decade"
            }, {
            "description" : "Time/Frequency: Time in Hours (hr)",
            "key" : "TF_hr"
            }, {
            "description" : "Time/Frequency: Time in Millenia (millenium)",
            "key" : "TF_millenium"
            }, {
            "description" : "Time/Frequency: Time in Minutes (min)",
            "key" : "TF_min"
            }, {
            "description" : "Time/Frequency: Time in Months (mon)",
            "key" : "TF_mon"
            }, {
            "description" : "Time/Frequency: Time in Milli-Seconds (ms)",
            "key" : "TF_ms"
            }, {
            "description" : "Time/Frequency: Time in Seconds (s)",
            "key" : "TF_s"
            }, {
            "description" : "Time/Frequency: Time in Scores (score)",
            "key" : "TF_score"
            }, {
            "description" : "Time/Frequency: Time in Weeks (wk)",
            "key" : "TF_wk"
            }, {
            "description" : "Time/Frequency: Time in Years (yr)",
            "key" : "TF_yr"
            }, {
            "description" : "Weight: Dram (avdp) (dr avdp)",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Weight: Pennyweight (dwt)",
            "key" : "WT_dwt"
            }, {
            "description" : "Weight: Gram (g)",
            "key" : "WT_g"
            }, {
            "description" : "Weight: Grain (gr)",
            "key" : "WT_gr"
            }, {
            "description" : "Weight: Kilogram (kg)",
            "key" : "WT_kg"
            }, {
            "description" : "Weight: Pound (avdp) (lbs)",
            "key" : "WT_lb"
            }, {
            "description" : "Weight: Ton (long or British) (lt)",
            "key" : "WT_lt"
            }, {
            "description" : "Weight: Milligram (mg)",
            "key" : "WT_mg"
            }, {
            "description" : "Weight: Ton (metric) (mt)",
            "key" : "WT_mt"
            }, {
            "description" : "Weight: Ounce (avdp) (oz)",
            "key" : "WT_oz"
            }, {
            "description" : "Weight: Ounce (troy) (oz tr)",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Weight: Ton (short) (sh t)",
            "key" : "WT_sh_t"
            }, {
            "description" : "Weight: Stone (st)",
            "key" : "WT_st"
            } ],
            "disabled" : "false",
            "id" : "AddSupplierProduct_quantityUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "quantityUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Agreement ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "agreementId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_agreementId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Agreement Item Seq ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "agreementItemSeqId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_agreementItemSeqId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "required",
            "title" : "Last Price",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "lastPrice",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_lastPrice",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Shipping Price",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shippingPrice",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_shippingPrice",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Supplier Product Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "supplierProductName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_supplierProductName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "required",
            "title" : "Supplier Product ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "supplierProductId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_supplierProductId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Supplier can drop ship?",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "N",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddSupplierProduct",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "AddSupplierProduct_canDropShip",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "canDropShip",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Comments",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "comments",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddSupplierProduct_comments",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddSupplierProduct",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddSupplierProduct_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateSupplierProduct"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "agreementText", "description", "availableFromDate", "availableThruDate", "currencyUomId", "lastPrice" ]
        } ],
        "columns" : [ {
            "name" : "agreementId",
            "title" : "Agreement ID"
        }, {
            "name" : "partyId",
            "title" : "Supplier"
        }, {
            "name" : "agreementText",
            "title" : "Agreement Text"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "availableFromDate",
            "title" : "Available From Date"
        }, {
            "name" : "availableThruDate",
            "title" : "Available Through Date"
        }, {
            "name" : "currencyUomId",
            "title" : "Currency"
        }, {
            "name" : "lastPrice",
            "title" : "Last Price"
        } ],
        "formName" : "ListSupplierProductAgreements",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Agreement ID",
            "type" : "HYPERLINK",
            "target" : "/accounting/control/EditAgreement",
            "name" : "agreementId",
            "width" : "",
            "parameterList" : [ {
            "name" : "agreementId"
            } ],
            "style" : "",
            "id" : "ListSupplierProductAgreements_agreementId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProductAgreements_partyId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "agreementText",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProductAgreements_agreementText",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProductAgreements_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "availableFromDate",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProductAgreements_availableFromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "availableThruDate",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProductAgreements_availableThruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currencyUomId",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProductAgreements_currencyUomId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "lastPrice",
            "description" : "",
            "style" : "",
            "id" : "ListSupplierProductAgreements_lastPrice",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
      "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "partyIdFrom", "agreementText", "description", "fromDate", "thruDate", "currencyUomId", "price" ]
      } ],
      "columns" : [ {
        "name" : "agreementId",
        "title" : "Agreement ID"
      }, {
        "name" : "partyIdFrom",
        "title" : "Party Customer"
      }, {
        "name" : "agreementText",
        "title" : "Agreement Text"
      }, {
        "name" : "description",
        "title" : "Description"
      }, {
        "name" : "fromDate",
        "title" : "From Date"
      }, {
        "name" : "thruDate",
        "title" : "Through Date"
      }, {
        "name" : "currencyUomId",
        "title" : "Currency"
      }, {
        "name" : "price",
        "title" : "Price"
      } ],
      "formName" : "ListSalesAgreements",
      "altTarget" : [ ],
      "formLocation" : "component://kwikstore/widget/ProductForms.xml",
      "type" : "list",
      "fields" : [ {
        "image" : "",
        "fieldHelpText" : "",
        "alternate" : "",
        "description" : "/",
        "title" : "Agreement ID",
        "type" : "HYPERLINK",
        "target" : "/accounting/control/EditAgreementItemProduct",
        "name" : "agreementId",
        "width" : "",
        "parameterList" : [ {
          "name" : "agreementId"
        }, {
          "name" : "agreementItemSeqId"
        }, {
          "name" : "productId"
        } ],
        "style" : "",
        "id" : "ListSalesAgreements_agreementId",
        "imageTitle" : "",
        "parameterMap" : {
          "productId" : "GZ-2644"
        },
        "height" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "partyIdFrom",
        "description" : "",
        "style" : "",
        "id" : "ListSalesAgreements_partyIdFrom",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "agreementText",
        "description" : "",
        "style" : "",
        "id" : "ListSalesAgreements_agreementText",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "description",
        "description" : "",
        "style" : "",
        "id" : "ListSalesAgreements_description",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "fromDate",
        "description" : "",
        "style" : "",
        "id" : "ListSalesAgreements_fromDate",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "thruDate",
        "description" : "",
        "style" : "",
        "id" : "ListSalesAgreements_thruDate",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "currencyUomId",
        "description" : "",
        "style" : "",
        "id" : "ListSalesAgreements_currencyUomId",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "price",
        "description" : "",
        "style" : "",
        "id" : "ListSalesAgreements_price",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
      } ],
      "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyIdTo", "agreementText", "description", "fromDate", "thruDate", "currencyUomId", "price" ]
        } ],
        "columns" : [ {
            "name" : "agreementId",
            "title" : "Agreement ID"
        }, {
            "name" : "partyIdTo",
            "title" : "To Party ID"
        }, {
            "name" : "agreementText",
            "title" : "Agreement Text"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "currencyUomId",
            "title" : "Currency"
        }, {
            "name" : "price",
            "title" : "Price"
        } ],
        "formName" : "ListCommissionAgreements",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "/",
            "title" : "Agreement ID",
            "type" : "HYPERLINK",
            "target" : "/accounting/control/EditAgreementItemProduct",
            "name" : "agreementId",
            "width" : "",
            "parameterList" : [ {
            "name" : "agreementId"
            }, {
            "name" : "agreementItemSeqId"
            }, {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListCommissionAgreements_agreementId",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyIdTo",
            "description" : "",
            "style" : "",
            "id" : "ListCommissionAgreements_partyIdTo",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "agreementText",
            "description" : "",
            "style" : "",
            "id" : "ListCommissionAgreements_agreementText",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListCommissionAgreements_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListCommissionAgreements_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListCommissionAgreements_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currencyUomId",
            "description" : "",
            "style" : "",
            "id" : "ListCommissionAgreements_currencyUomId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "price",
            "description" : "",
            "style" : "",
            "id" : "ListCommissionAgreements_price",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyIdTo", "agreementText", "description", "fromDate", "thruDate", "currencyUomId", "price" ]
        } ],
        "columns" : [ {
            "name" : "agreementId",
            "title" : "Agreement ID"
        }, {
            "name" : "partyIdTo",
            "title" : "To Party ID"
        }, {
            "name" : "agreementText",
            "title" : "Agreement Text"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "currencyUomId",
            "title" : "Currency"
        }, {
            "name" : "price",
            "title" : "Price"
        } ],
        "formName" : "ListProductAgreements",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "/",
            "title" : "Agreement ID",
            "type" : "HYPERLINK",
            "target" : "/accounting/control/EditAgreementItemProduct",
            "name" : "agreementId",
            "width" : "",
            "parameterList" : [ {
            "name" : "agreementId"
            }, {
            "name" : "agreementItemSeqId"
            }, {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProductAgreements_agreementId",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyIdTo",
            "description" : "",
            "style" : "",
            "id" : "ListProductAgreements_partyIdTo",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "agreementText",
            "description" : "",
            "style" : "",
            "id" : "ListProductAgreements_agreementText",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListProductAgreements_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductAgreements_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductAgreements_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currencyUomId",
            "description" : "",
            "style" : "",
            "id" : "ListProductAgreements_currencyUomId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "price",
            "description" : "",
            "style" : "",
            "id" : "ListProductAgreements_price",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "paymentMethodTypeId", "productPricePurposeId", "fromDate", "thruDate", "sequenceNum", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "paymentMethodTypeId",
            "title" : "Payment Method Type ID"
        }, {
            "name" : "productPricePurposeId",
            "title" : "Purpose"
        }, {
            "name" : "fromDate",
            "title" : "From Date  Time"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "UpdateProductPaymentMethodType",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "UpdateProductPaymentMethodType_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodTypeId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductPaymentMethodType_paymentMethodTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productPricePurposeId",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductPaymentMethodType_productPricePurposeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "UpdateProductPaymentMethodType_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-07%2020:24:59.745",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "UpdateProductPaymentMethodType",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "UpdateProductPaymentMethodType_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateProductPaymentMethodType_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateProductPaymentMethodType",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "UpdateProductPaymentMethodType_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productPricePurposeId"
            }, {
            "name" : "paymentMethodTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "UpdateProductPaymentMethodType_deleteLink",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : "",
            "target" : "deleteProductPaymentMethodType"
        } ],
        "target" : "updateProductPaymentMethodType"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "paymentMethodTypeId", "productPricePurposeId", "fromDate", "thruDate", "sequenceNum", "submitButton" ]
        } ],
        "formName" : "AddProductPaymentMethodType",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductPaymentMethodType_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "smallSelect",
            "title" : "Payment Method Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductPaymentMethodType",
            "options" : [ {
            "description" : "Billing Account",
            "key" : "EXT_BILLACT"
            }, {
            "description" : "Cash",
            "key" : "CASH"
            }, {
            "description" : "Cash On Delivery",
            "key" : "EXT_COD"
            }, {
            "description" : "Certified Check",
            "key" : "CERTIFIED_CHECK"
            }, {
            "description" : "Company Account",
            "key" : "COMPANY_ACCOUNT"
            }, {
            "description" : "Company Check",
            "key" : "COMPANY_CHECK"
            }, {
            "description" : "Credit Card",
            "key" : "CREDIT_CARD"
            }, {
            "description" : "Electronic Funds Transfer",
            "key" : "EFT_ACCOUNT"
            }, {
            "description" : "Financial Account",
            "key" : "FIN_ACCOUNT"
            }, {
            "description" : "Gift Card",
            "key" : "GIFT_CARD"
            }, {
            "description" : "Gift Certificate",
            "key" : "GIFT_CERTIFICATE"
            }, {
            "description" : "Money Order",
            "key" : "MONEY_ORDER"
            }, {
            "description" : "Offline Payment",
            "key" : "EXT_OFFLINE"
            }, {
            "description" : "PayPal",
            "key" : "EXT_PAYPAL"
            }, {
            "description" : "Personal Check",
            "key" : "PERSONAL_CHECK"
            }, {
            "description" : "RBS WorldPay",
            "key" : "EXT_WORLDPAY"
            }, {
            "description" : "eBay",
            "key" : "EXT_EBAY"
            } ],
            "disabled" : "false",
            "id" : "AddProductPaymentMethodType_paymentMethodTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "paymentMethodTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "smallSelect",
            "title" : "Purpose",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductPaymentMethodType",
            "options" : [ {
            "description" : "Component Price",
            "key" : "COMPONENT_PRICE"
            }, {
            "description" : "Deposit price",
            "key" : "DEPOSIT"
            }, {
            "description" : "Purchase/Initial",
            "key" : "PURCHASE"
            }, {
            "description" : "Recurring Charge",
            "key" : "RECURRING_CHARGE"
            }, {
            "description" : "Usage Charge",
            "key" : "USAGE_CHARGE"
            }, {
            "description" : "eBay Auction",
            "key" : "EBAY"
            } ],
            "disabled" : "false",
            "id" : "AddProductPaymentMethodType_productPricePurposeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productPricePurposeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "required",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductPaymentMethodType",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductPaymentMethodType_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-07%2020:26:20.397",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductPaymentMethodType",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductPaymentMethodType_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductPaymentMethodType_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductPaymentMethodType",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductPaymentMethodType_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductPaymentMethodType"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productMaintSeqId", "productMaintTypeId", "maintName", "maintTemplateWorkEffortId", "intervalQuantity", "intervalUomId", "intervalMeterTypeId", "repeatCount", "deleteLink", "submitButton" ]
        } ],
        "columns" : [ {
            "name" : "productMaintTypeId",
            "title" : "Product Maint Type ID"
        }, {
            "name" : "maintName",
            "title" : "Maint Name"
        }, {
            "name" : "maintTemplateWorkEffortId",
            "title" : "Maint Template Work Effort ID"
        }, {
            "name" : "intervalQuantity",
            "title" : "Interval Quantity"
        }, {
            "name" : "intervalUomId",
            "title" : "Interval Uom ID"
        }, {
            "name" : "intervalMeterTypeId",
            "title" : "Interval Meter Type ID"
        }, {
            "name" : "repeatCount",
            "title" : "Repeat Count"
        }, {
            "name" : "deleteLink",
            "title" : " "
        }, {
            "name" : "submitButton",
            "title" : "Update"
        } ],
        "formName" : "ListProductMaints",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductMaints_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "conditionGroup" : "",
            "name" : "productMaintSeqId",
            "action" : "",
            "id" : "ListProductMaints_productMaintSeqId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Maint Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductMaints",
            "options" : [ {
            "description" : "Chassis Lubrication",
            "key" : "CHASSIS_LUBE"
            }, {
            "description" : "Check Battery",
            "key" : "CHECK_BATTERY"
            }, {
            "description" : "Check/Recharge Refrigerant",
            "key" : "HVAC_CHECK_REFR"
            }, {
            "description" : "HVAC Maintenance",
            "key" : "HVAC_MAINT"
            }, {
            "description" : "Oil Change",
            "key" : "OIL_CHANGE"
            }, {
            "description" : "Re-Fuel",
            "key" : "REFUEL"
            }, {
            "description" : "Replace Air Filter",
            "key" : "HVAC_REPLACE_FILTER"
            }, {
            "description" : "Replace Battery",
            "key" : "REPLACE_BATTERY"
            }, {
            "description" : "Rotate Tires",
            "key" : "ROTATE_TIRES"
            }, {
            "description" : "Serpentine Belt Replacement",
            "key" : "SERP_BELT"
            }, {
            "description" : "Tune Up",
            "key" : "TUNE_UP"
            }, {
            "description" : "Vehicle Maintenance",
            "key" : "VEHICLE_MAINT"
            }, {
            "description" : "Wash",
            "key" : "WASH"
            } ],
            "disabled" : "false",
            "id" : "ListProductMaints_productMaintTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productMaintTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Maint Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "maintName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductMaints_maintName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "ListProductMaints",
            "id" : "ListProductMaints_maintTemplateWorkEffortId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupWorkEffort",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "maintTemplateWorkEffortId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "maintTemplateWorkEffortId",
            "style" : "",
            "id" : "ListProductMaints_maintTemplateWorkEffortId",
            "title" : "Maint Template Work Effort ID",
            "type" : "LOOKUP"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Interval Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "intervalQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductMaints_intervalQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Interval Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductMaints",
            "options" : [ {
            "description" : "Acre",
            "key" : "AREA_A"
            }, {
            "description" : "Afghani",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar",
            "key" : "DZD"
            }, {
            "description" : "American Dollar",
            "key" : "USD"
            }, {
            "description" : "Amphere - Electric current",
            "key" : "OTH_A"
            }, {
            "description" : "Angolan Kwanza",
            "key" : "AOA"
            }, {
            "description" : "Angstrom",
            "key" : "LEN_A"
            }, {
            "description" : "Are",
            "key" : "AREA_a"
            }, {
            "description" : "Argentina Peso",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar",
            "key" : "BBD"
            }, {
            "description" : "Barrel (US)",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "Belize Dollar",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar",
            "key" : "BMD"
            }, {
            "description" : "Bit of Data",
            "key" : "DATA_b"
            }, {
            "description" : "Bit-per-second of Data",
            "key" : "DATASPD_bps"
            }, {
            "description" : "Bolivian Boliviano",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula",
            "key" : "BWP"
            }, {
            "description" : "Box",
            "key" : "OTH_box"
            }, {
            "description" : "Brazilian Real",
            "key" : "BRL"
            }, {
            "description" : "British Pound",
            "key" : "GBP"
            }, {
            "description" : "British Thermal Unit",
            "key" : "EN_Btu"
            }, {
            "description" : "Brunei Dollar",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc",
            "key" : "BIF"
            }, {
            "description" : "Byte of Data",
            "key" : "DATA_B"
            }, {
            "description" : "Cable",
            "key" : "LEN_cb"
            }, {
            "description" : "Calorie (@15.5c)",
            "key" : "EN_cal15"
            }, {
            "description" : "Cambodian Riel",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar",
            "key" : "CAD"
            }, {
            "description" : "Candela - Luminosity (intensity of light)",
            "key" : "OTH_cd"
            }, {
            "description" : "Cape Verde Escudo",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar",
            "key" : "KYD"
            }, {
            "description" : "Centimeter",
            "key" : "LEN_cm"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s)",
            "key" : "LEN_chG"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s)",
            "key" : "LEN_chR"
            }, {
            "description" : "Chilean Peso",
            "key" : "CLP"
            }, {
            "description" : "China",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso",
            "key" : "CUP"
            }, {
            "description" : "Cubic centimeter",
            "key" : "VDRY_cm3"
            }, {
            "description" : "Cubic foot",
            "key" : "VDRY_ft3"
            }, {
            "description" : "Cubic inch",
            "key" : "VDRY_in3"
            }, {
            "description" : "Cubic meter",
            "key" : "VDRY_m3"
            }, {
            "description" : "Cubic meter (liquid)",
            "key" : "VLIQ_M3"
            }, {
            "description" : "Cubic millimeter",
            "key" : "VDRY_mm3"
            }, {
            "description" : "Cubic yard",
            "key" : "VDRY_yd3"
            }, {
            "description" : "Cup",
            "key" : "VLIQ_cup"
            }, {
            "description" : "Czech Krona",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone",
            "key" : "DKK"
            }, {
            "description" : "Decimeter",
            "key" : "LEN_dm"
            }, {
            "description" : "Degrees Celsius",
            "key" : "TEMP_C"
            }, {
            "description" : "Degrees Fahrenheit",
            "key" : "TEMP_F"
            }, {
            "description" : "Dekameter",
            "key" : "LEN_dam"
            }, {
            "description" : "Djibouti Franc",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso",
            "key" : "DOP"
            }, {
            "description" : "Dram (US)",
            "key" : "VLIQ_dr"
            }, {
            "description" : "Dram (avdp)",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Each",
            "key" : "OTH_ea"
            }, {
            "description" : "East Carribean Dollar",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr",
            "key" : "ETB"
            }, {
            "description" : "Euro",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound",
            "key" : "FKP"
            }, {
            "description" : "Fathom",
            "key" : "LEN_fm"
            }, {
            "description" : "Fiji Dollar",
            "key" : "FJD"
            }, {
            "description" : "Foot",
            "key" : "LEN_ft"
            }, {
            "description" : "Furlong",
            "key" : "LEN_fur"
            }, {
            "description" : "Gabon C.f.A Franc",
            "key" : "XAF"
            }, {
            "description" : "Gallon (UK)",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "Gallon (US)",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "Gambian Dalasi",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound",
            "key" : "GIP"
            }, {
            "description" : "Gigabit of Data",
            "key" : "DATA_Gb"
            }, {
            "description" : "Gigabit-per-second of Data",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "Gigabyte of Data",
            "key" : "DATA_GB"
            }, {
            "description" : "Gill (1/4 UK pint)",
            "key" : "VLIQ_gi"
            }, {
            "description" : "Grain",
            "key" : "WT_gr"
            }, {
            "description" : "Gram",
            "key" : "WT_g"
            }, {
            "description" : "Guatemalan Quedzal",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde",
            "key" : "HTG"
            }, {
            "description" : "Hand (horse\\'s height)",
            "key" : "LEN_hand"
            }, {
            "description" : "Hectare",
            "key" : "AREA_ha"
            }, {
            "description" : "Hectoliter",
            "key" : "VLIQ_HL"
            }, {
            "description" : "Honduran Lempira",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar",
            "key" : "HKD"
            }, {
            "description" : "Horsepower (mechanical)",
            "key" : "EN_HP"
            }, {
            "description" : "Hungarian forint",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona",
            "key" : "ISK"
            }, {
            "description" : "Inch",
            "key" : "LEN_in"
            }, {
            "description" : "Indian Rupee",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar",
            "key" : "JOD"
            }, {
            "description" : "Joule (absolute)",
            "key" : "EN_J"
            }, {
            "description" : "Kazakhstani Tenge",
            "key" : "KZT"
            }, {
            "description" : "Kelvin",
            "key" : "TEMP_K"
            }, {
            "description" : "Kenyan Shilling",
            "key" : "KES"
            }, {
            "description" : "Kilobit of Data",
            "key" : "DATA_Kb"
            }, {
            "description" : "Kilobit-per-second of Data",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "Kilobyte of Data",
            "key" : "DATA_KB"
            }, {
            "description" : "Kilogram",
            "key" : "WT_kg"
            }, {
            "description" : "Kilometer",
            "key" : "LEN_km"
            }, {
            "description" : "Kilowatt",
            "key" : "EN_Kw"
            }, {
            "description" : "Kirghizstan Som",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip",
            "key" : "LAK"
            }, {
            "description" : "Lari",
            "key" : "GEL"
            }, {
            "description" : "League",
            "key" : "LEN_league"
            }, {
            "description" : "Lebanese Pound",
            "key" : "LBP"
            }, {
            "description" : "Leone",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar",
            "key" : "LYD"
            }, {
            "description" : "Link (Gunter\\'s)",
            "key" : "LEN_lnG"
            }, {
            "description" : "Link (Ramden\\'s)",
            "key" : "LEN_lnR"
            }, {
            "description" : "Liter",
            "key" : "VLIQ_L"
            }, {
            "description" : "Macao Pataca",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee",
            "key" : "MUR"
            }, {
            "description" : "Megabit of Data",
            "key" : "DATA_Mb"
            }, {
            "description" : "Megabit-per-second of Data",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "Megabyte of Data",
            "key" : "DATA_MB"
            }, {
            "description" : "Meter",
            "key" : "LEN_m"
            }, {
            "description" : "Mexican Peso",
            "key" : "MXN"
            }, {
            "description" : "Micrometer (Micron)",
            "key" : "LEN_u"
            }, {
            "description" : "Mil (Milli-inch)",
            "key" : "LEN_mil"
            }, {
            "description" : "Mile (nautical/sea)",
            "key" : "LEN_nmi"
            }, {
            "description" : "Mile (statute/land)",
            "key" : "LEN_mi"
            }, {
            "description" : "Milligram",
            "key" : "WT_mg"
            }, {
            "description" : "Milliliter",
            "key" : "VLIQ_ml"
            }, {
            "description" : "Millimeter",
            "key" : "LEN_mm"
            }, {
            "description" : "Moldavian Lei",
            "key" : "MDL"
            }, {
            "description" : "Mole - Substance (molecule)",
            "key" : "OTH_mol"
            }, {
            "description" : "Mongolian Tugrik",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar",
            "key" : "TWD"
            }, {
            "description" : "New Zaire",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial",
            "key" : "OMR"
            }, {
            "description" : "Ounce (avdp)",
            "key" : "WT_oz"
            }, {
            "description" : "Ounce (troy)",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Ounce, fluid (UK)",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "Ounce, fluid (US)",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "Package",
            "key" : "OTH_pk"
            }, {
            "description" : "Pakistan Rupee",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani",
            "key" : "PYG"
            }, {
            "description" : "Pennyweight",
            "key" : "WT_dwt"
            }, {
            "description" : "Per Person",
            "key" : "OTH_pp"
            }, {
            "description" : "Peruvian Sol",
            "key" : "PEN"
            }, {
            "description" : "Petabit of Data",
            "key" : "DATA_Pb"
            }, {
            "description" : "Petabyte of Data",
            "key" : "DATA_PB"
            }, {
            "description" : "Philippino Peso",
            "key" : "PHP"
            }, {
            "description" : "Pica (type size)",
            "key" : "LEN_pica"
            }, {
            "description" : "Pint (UK)",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "Pint (US)",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "Point (type size)",
            "key" : "LEN_point"
            }, {
            "description" : "Polish Zloty",
            "key" : "PLN"
            }, {
            "description" : "Pound (avdp)",
            "key" : "WT_lb"
            }, {
            "description" : "Qatar Riyal",
            "key" : "QAR"
            }, {
            "description" : "Quart",
            "key" : "VLIQ_qt"
            }, {
            "description" : "Rod",
            "key" : "LEN_rd"
            }, {
            "description" : "Romanian Leu",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling",
            "key" : "SOS"
            }, {
            "description" : "South African Rand",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound",
            "key" : "SSP"
            }, {
            "description" : "Square Centimeter",
            "key" : "AREA_cm2"
            }, {
            "description" : "Square Foot",
            "key" : "AREA_ft2"
            }, {
            "description" : "Square Inch",
            "key" : "AREA_in2"
            }, {
            "description" : "Square Kilometer",
            "key" : "AREA_km2"
            }, {
            "description" : "Square Meter",
            "key" : "AREA_m2"
            }, {
            "description" : "Square Mile",
            "key" : "AREA_mi2"
            }, {
            "description" : "Square Millimeter",
            "key" : "AREA_mm2"
            }, {
            "description" : "Square Rod",
            "key" : "AREA_rd2"
            }, {
            "description" : "Square Yard",
            "key" : "AREA_yd2"
            }, {
            "description" : "Sri Lankan Rupee",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound",
            "key" : "SHP"
            }, {
            "description" : "Stere (cubic meter)",
            "key" : "VDRY_ST"
            }, {
            "description" : "Stone",
            "key" : "WT_st"
            }, {
            "description" : "Sudanese Pound",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound",
            "key" : "SYP"
            }, {
            "description" : "Tablespoon",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "Tadzhikistani Somoni",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling",
            "key" : "TZS"
            }, {
            "description" : "Teaspoon",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "Terabit of Data",
            "key" : "DATA_Tb"
            }, {
            "description" : "Terabit-per-second of Data",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "Terabyte of Data",
            "key" : "DATA_TB"
            }, {
            "description" : "Thailand Baht",
            "key" : "THB"
            }, {
            "description" : "Time in Centuries",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years",
            "key" : "TF_yr"
            }, {
            "description" : "Ton (long or British)",
            "key" : "WT_lt"
            }, {
            "description" : "Ton (metric)",
            "key" : "WT_mt"
            }, {
            "description" : "Ton (short)",
            "key" : "WT_sh_t"
            }, {
            "description" : "Tongan Pa\\'anga",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham",
            "key" : "AED"
            }, {
            "description" : "Uruguay",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI)",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong",
            "key" : "VND"
            }, {
            "description" : "Watt",
            "key" : "EN_w"
            }, {
            "description" : "West Indian Guilder",
            "key" : "ANG"
            }, {
            "description" : "Yard",
            "key" : "LEN_yd"
            }, {
            "description" : "Yemeni Ryal",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "ListProductMaints_intervalUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "intervalUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Interval Meter Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductMaints",
            "options" : [ {
            "description" : "Copy Count Meter",
            "key" : "COPY_COUNT"
            }, {
            "description" : "Distance Meter",
            "key" : "DISTANCE"
            }, {
            "description" : "Use Event Data Recorder",
            "key" : "EVENT_DATA_RECORDER"
            }, {
            "description" : "Motor Time Meter",
            "key" : "MOTOR_TIME"
            }, {
            "description" : "Odometer",
            "key" : "ODOMETER"
            }, {
            "description" : "Use Pedometer",
            "key" : "PEDOMETER"
            }, {
            "description" : "Speedometer",
            "key" : "SPEEDOMETER"
            }, {
            "description" : "Use Tacograph",
            "key" : "TACHOGRAPH"
            }, {
            "description" : "Tachometer",
            "key" : "TACHOMETER"
            }, {
            "description" : "Use Taximeter",
            "key" : "TAXIMETER"
            }, {
            "description" : "Use Trip Meter",
            "key" : "TRIP_METER"
            }, {
            "description" : "Use Count Meter",
            "key" : "USE_COUNT"
            } ],
            "disabled" : "false",
            "id" : "ListProductMaints_intervalMeterTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "intervalMeterTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Repeat Count",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "repeatCount",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductMaints_repeatCount",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productMaintSeqId"
            } ],
            "id" : "ListProductMaints_deleteLink",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : "",
            "target" : "deleteProductMaint"
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListProductMaints",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ListProductMaints_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductMaint"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productMaintTypeId", "maintName", "maintTemplateWorkEffortId", "intervalQuantity", "intervalUomId", "intervalMeterTypeId", "repeatCount", "productMaintSeqId", "submitButton" ]
        } ],
        "formName" : "AddProductMaint",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductMaint_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Maint Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductMaint",
            "options" : [ {
            "description" : "Chassis Lubrication",
            "key" : "CHASSIS_LUBE"
            }, {
            "description" : "Check Battery",
            "key" : "CHECK_BATTERY"
            }, {
            "description" : "Check/Recharge Refrigerant",
            "key" : "HVAC_CHECK_REFR"
            }, {
            "description" : "HVAC Maintenance",
            "key" : "HVAC_MAINT"
            }, {
            "description" : "Oil Change",
            "key" : "OIL_CHANGE"
            }, {
            "description" : "Re-Fuel",
            "key" : "REFUEL"
            }, {
            "description" : "Replace Air Filter",
            "key" : "HVAC_REPLACE_FILTER"
            }, {
            "description" : "Replace Battery",
            "key" : "REPLACE_BATTERY"
            }, {
            "description" : "Rotate Tires",
            "key" : "ROTATE_TIRES"
            }, {
            "description" : "Serpentine Belt Replacement",
            "key" : "SERP_BELT"
            }, {
            "description" : "Tune Up",
            "key" : "TUNE_UP"
            }, {
            "description" : "Vehicle Maintenance",
            "key" : "VEHICLE_MAINT"
            }, {
            "description" : "Wash",
            "key" : "WASH"
            } ],
            "disabled" : "false",
            "id" : "AddProductMaint_productMaintTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productMaintTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Maint Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "maintName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductMaint_maintName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductMaint",
            "id" : "AddProductMaint_maintTemplateWorkEffortId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupWorkEffort",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "maintTemplateWorkEffortId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "maintTemplateWorkEffortId",
            "style" : "",
            "id" : "AddProductMaint_maintTemplateWorkEffortId",
            "title" : "Maint Template Work Effort ID",
            "type" : "LOOKUP"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Interval Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "intervalQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductMaint_intervalQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Interval Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductMaint",
            "options" : [ {
            "description" : "Acre",
            "key" : "AREA_A"
            }, {
            "description" : "Afghani",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar",
            "key" : "DZD"
            }, {
            "description" : "American Dollar",
            "key" : "USD"
            }, {
            "description" : "Amphere - Electric current",
            "key" : "OTH_A"
            }, {
            "description" : "Angolan Kwanza",
            "key" : "AOA"
            }, {
            "description" : "Angstrom",
            "key" : "LEN_A"
            }, {
            "description" : "Are",
            "key" : "AREA_a"
            }, {
            "description" : "Argentina Peso",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar",
            "key" : "BBD"
            }, {
            "description" : "Barrel (US)",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "Belize Dollar",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar",
            "key" : "BMD"
            }, {
            "description" : "Bit of Data",
            "key" : "DATA_b"
            }, {
            "description" : "Bit-per-second of Data",
            "key" : "DATASPD_bps"
            }, {
            "description" : "Bolivian Boliviano",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula",
            "key" : "BWP"
            }, {
            "description" : "Box",
            "key" : "OTH_box"
            }, {
            "description" : "Brazilian Real",
            "key" : "BRL"
            }, {
            "description" : "British Pound",
            "key" : "GBP"
            }, {
            "description" : "British Thermal Unit",
            "key" : "EN_Btu"
            }, {
            "description" : "Brunei Dollar",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc",
            "key" : "BIF"
            }, {
            "description" : "Byte of Data",
            "key" : "DATA_B"
            }, {
            "description" : "Cable",
            "key" : "LEN_cb"
            }, {
            "description" : "Calorie (@15.5c)",
            "key" : "EN_cal15"
            }, {
            "description" : "Cambodian Riel",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar",
            "key" : "CAD"
            }, {
            "description" : "Candela - Luminosity (intensity of light)",
            "key" : "OTH_cd"
            }, {
            "description" : "Cape Verde Escudo",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar",
            "key" : "KYD"
            }, {
            "description" : "Centimeter",
            "key" : "LEN_cm"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s)",
            "key" : "LEN_chG"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s)",
            "key" : "LEN_chR"
            }, {
            "description" : "Chilean Peso",
            "key" : "CLP"
            }, {
            "description" : "China",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso",
            "key" : "CUP"
            }, {
            "description" : "Cubic centimeter",
            "key" : "VDRY_cm3"
            }, {
            "description" : "Cubic foot",
            "key" : "VDRY_ft3"
            }, {
            "description" : "Cubic inch",
            "key" : "VDRY_in3"
            }, {
            "description" : "Cubic meter",
            "key" : "VDRY_m3"
            }, {
            "description" : "Cubic meter (liquid)",
            "key" : "VLIQ_M3"
            }, {
            "description" : "Cubic millimeter",
            "key" : "VDRY_mm3"
            }, {
            "description" : "Cubic yard",
            "key" : "VDRY_yd3"
            }, {
            "description" : "Cup",
            "key" : "VLIQ_cup"
            }, {
            "description" : "Czech Krona",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone",
            "key" : "DKK"
            }, {
            "description" : "Decimeter",
            "key" : "LEN_dm"
            }, {
            "description" : "Degrees Celsius",
            "key" : "TEMP_C"
            }, {
            "description" : "Degrees Fahrenheit",
            "key" : "TEMP_F"
            }, {
            "description" : "Dekameter",
            "key" : "LEN_dam"
            }, {
            "description" : "Djibouti Franc",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso",
            "key" : "DOP"
            }, {
            "description" : "Dram (US)",
            "key" : "VLIQ_dr"
            }, {
            "description" : "Dram (avdp)",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Each",
            "key" : "OTH_ea"
            }, {
            "description" : "East Carribean Dollar",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr",
            "key" : "ETB"
            }, {
            "description" : "Euro",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound",
            "key" : "FKP"
            }, {
            "description" : "Fathom",
            "key" : "LEN_fm"
            }, {
            "description" : "Fiji Dollar",
            "key" : "FJD"
            }, {
            "description" : "Foot",
            "key" : "LEN_ft"
            }, {
            "description" : "Furlong",
            "key" : "LEN_fur"
            }, {
            "description" : "Gabon C.f.A Franc",
            "key" : "XAF"
            }, {
            "description" : "Gallon (UK)",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "Gallon (US)",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "Gambian Dalasi",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound",
            "key" : "GIP"
            }, {
            "description" : "Gigabit of Data",
            "key" : "DATA_Gb"
            }, {
            "description" : "Gigabit-per-second of Data",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "Gigabyte of Data",
            "key" : "DATA_GB"
            }, {
            "description" : "Gill (1/4 UK pint)",
            "key" : "VLIQ_gi"
            }, {
            "description" : "Grain",
            "key" : "WT_gr"
            }, {
            "description" : "Gram",
            "key" : "WT_g"
            }, {
            "description" : "Guatemalan Quedzal",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde",
            "key" : "HTG"
            }, {
            "description" : "Hand (horse\\'s height)",
            "key" : "LEN_hand"
            }, {
            "description" : "Hectare",
            "key" : "AREA_ha"
            }, {
            "description" : "Hectoliter",
            "key" : "VLIQ_HL"
            }, {
            "description" : "Honduran Lempira",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar",
            "key" : "HKD"
            }, {
            "description" : "Horsepower (mechanical)",
            "key" : "EN_HP"
            }, {
            "description" : "Hungarian forint",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona",
            "key" : "ISK"
            }, {
            "description" : "Inch",
            "key" : "LEN_in"
            }, {
            "description" : "Indian Rupee",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar",
            "key" : "JOD"
            }, {
            "description" : "Joule (absolute)",
            "key" : "EN_J"
            }, {
            "description" : "Kazakhstani Tenge",
            "key" : "KZT"
            }, {
            "description" : "Kelvin",
            "key" : "TEMP_K"
            }, {
            "description" : "Kenyan Shilling",
            "key" : "KES"
            }, {
            "description" : "Kilobit of Data",
            "key" : "DATA_Kb"
            }, {
            "description" : "Kilobit-per-second of Data",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "Kilobyte of Data",
            "key" : "DATA_KB"
            }, {
            "description" : "Kilogram",
            "key" : "WT_kg"
            }, {
            "description" : "Kilometer",
            "key" : "LEN_km"
            }, {
            "description" : "Kilowatt",
            "key" : "EN_Kw"
            }, {
            "description" : "Kirghizstan Som",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip",
            "key" : "LAK"
            }, {
            "description" : "Lari",
            "key" : "GEL"
            }, {
            "description" : "League",
            "key" : "LEN_league"
            }, {
            "description" : "Lebanese Pound",
            "key" : "LBP"
            }, {
            "description" : "Leone",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar",
            "key" : "LYD"
            }, {
            "description" : "Link (Gunter\\'s)",
            "key" : "LEN_lnG"
            }, {
            "description" : "Link (Ramden\\'s)",
            "key" : "LEN_lnR"
            }, {
            "description" : "Liter",
            "key" : "VLIQ_L"
            }, {
            "description" : "Macao Pataca",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee",
            "key" : "MUR"
            }, {
            "description" : "Megabit of Data",
            "key" : "DATA_Mb"
            }, {
            "description" : "Megabit-per-second of Data",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "Megabyte of Data",
            "key" : "DATA_MB"
            }, {
            "description" : "Meter",
            "key" : "LEN_m"
            }, {
            "description" : "Mexican Peso",
            "key" : "MXN"
            }, {
            "description" : "Micrometer (Micron)",
            "key" : "LEN_u"
            }, {
            "description" : "Mil (Milli-inch)",
            "key" : "LEN_mil"
            }, {
            "description" : "Mile (nautical/sea)",
            "key" : "LEN_nmi"
            }, {
            "description" : "Mile (statute/land)",
            "key" : "LEN_mi"
            }, {
            "description" : "Milligram",
            "key" : "WT_mg"
            }, {
            "description" : "Milliliter",
            "key" : "VLIQ_ml"
            }, {
            "description" : "Millimeter",
            "key" : "LEN_mm"
            }, {
            "description" : "Moldavian Lei",
            "key" : "MDL"
            }, {
            "description" : "Mole - Substance (molecule)",
            "key" : "OTH_mol"
            }, {
            "description" : "Mongolian Tugrik",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar",
            "key" : "TWD"
            }, {
            "description" : "New Zaire",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial",
            "key" : "OMR"
            }, {
            "description" : "Ounce (avdp)",
            "key" : "WT_oz"
            }, {
            "description" : "Ounce (troy)",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Ounce, fluid (UK)",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "Ounce, fluid (US)",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "Package",
            "key" : "OTH_pk"
            }, {
            "description" : "Pakistan Rupee",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani",
            "key" : "PYG"
            }, {
            "description" : "Pennyweight",
            "key" : "WT_dwt"
            }, {
            "description" : "Per Person",
            "key" : "OTH_pp"
            }, {
            "description" : "Peruvian Sol",
            "key" : "PEN"
            }, {
            "description" : "Petabit of Data",
            "key" : "DATA_Pb"
            }, {
            "description" : "Petabyte of Data",
            "key" : "DATA_PB"
            }, {
            "description" : "Philippino Peso",
            "key" : "PHP"
            }, {
            "description" : "Pica (type size)",
            "key" : "LEN_pica"
            }, {
            "description" : "Pint (UK)",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "Pint (US)",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "Point (type size)",
            "key" : "LEN_point"
            }, {
            "description" : "Polish Zloty",
            "key" : "PLN"
            }, {
            "description" : "Pound (avdp)",
            "key" : "WT_lb"
            }, {
            "description" : "Qatar Riyal",
            "key" : "QAR"
            }, {
            "description" : "Quart",
            "key" : "VLIQ_qt"
            }, {
            "description" : "Rod",
            "key" : "LEN_rd"
            }, {
            "description" : "Romanian Leu",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling",
            "key" : "SOS"
            }, {
            "description" : "South African Rand",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound",
            "key" : "SSP"
            }, {
            "description" : "Square Centimeter",
            "key" : "AREA_cm2"
            }, {
            "description" : "Square Foot",
            "key" : "AREA_ft2"
            }, {
            "description" : "Square Inch",
            "key" : "AREA_in2"
            }, {
            "description" : "Square Kilometer",
            "key" : "AREA_km2"
            }, {
            "description" : "Square Meter",
            "key" : "AREA_m2"
            }, {
            "description" : "Square Mile",
            "key" : "AREA_mi2"
            }, {
            "description" : "Square Millimeter",
            "key" : "AREA_mm2"
            }, {
            "description" : "Square Rod",
            "key" : "AREA_rd2"
            }, {
            "description" : "Square Yard",
            "key" : "AREA_yd2"
            }, {
            "description" : "Sri Lankan Rupee",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound",
            "key" : "SHP"
            }, {
            "description" : "Stere (cubic meter)",
            "key" : "VDRY_ST"
            }, {
            "description" : "Stone",
            "key" : "WT_st"
            }, {
            "description" : "Sudanese Pound",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound",
            "key" : "SYP"
            }, {
            "description" : "Tablespoon",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "Tadzhikistani Somoni",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling",
            "key" : "TZS"
            }, {
            "description" : "Teaspoon",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "Terabit of Data",
            "key" : "DATA_Tb"
            }, {
            "description" : "Terabit-per-second of Data",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "Terabyte of Data",
            "key" : "DATA_TB"
            }, {
            "description" : "Thailand Baht",
            "key" : "THB"
            }, {
            "description" : "Time in Centuries",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years",
            "key" : "TF_yr"
            }, {
            "description" : "Ton (long or British)",
            "key" : "WT_lt"
            }, {
            "description" : "Ton (metric)",
            "key" : "WT_mt"
            }, {
            "description" : "Ton (short)",
            "key" : "WT_sh_t"
            }, {
            "description" : "Tongan Pa\\'anga",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham",
            "key" : "AED"
            }, {
            "description" : "Uruguay",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI)",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong",
            "key" : "VND"
            }, {
            "description" : "Watt",
            "key" : "EN_w"
            }, {
            "description" : "West Indian Guilder",
            "key" : "ANG"
            }, {
            "description" : "Yard",
            "key" : "LEN_yd"
            }, {
            "description" : "Yemeni Ryal",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "AddProductMaint_intervalUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "intervalUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Interval Meter Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductMaint",
            "options" : [ {
            "description" : "Copy Count Meter",
            "key" : "COPY_COUNT"
            }, {
            "description" : "Distance Meter",
            "key" : "DISTANCE"
            }, {
            "description" : "Motor Time Meter",
            "key" : "MOTOR_TIME"
            }, {
            "description" : "Odometer",
            "key" : "ODOMETER"
            }, {
            "description" : "Speedometer",
            "key" : "SPEEDOMETER"
            }, {
            "description" : "Tachometer",
            "key" : "TACHOMETER"
            }, {
            "description" : "Use Count Meter",
            "key" : "USE_COUNT"
            }, {
            "description" : "Use Event Data Recorder",
            "key" : "EVENT_DATA_RECORDER"
            }, {
            "description" : "Use Pedometer",
            "key" : "PEDOMETER"
            }, {
            "description" : "Use Tacograph",
            "key" : "TACHOGRAPH"
            }, {
            "description" : "Use Taximeter",
            "key" : "TAXIMETER"
            }, {
            "description" : "Use Trip Meter",
            "key" : "TRIP_METER"
            } ],
            "disabled" : "false",
            "id" : "AddProductMaint_intervalMeterTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "intervalMeterTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Repeat Count",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "repeatCount",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductMaint_repeatCount",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductMaint",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductMaint_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductMaint"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productMeterTypeId", "meterUomId", "meterName", "deleteLink", "submitButton" ]
        } ],
        "columns" : [ {
            "name" : "productMeterTypeId",
            "title" : "Product Meter Type ID"
        }, {
            "name" : "meterUomId",
            "title" : "Meter Uom ID"
        }, {
            "name" : "meterName",
            "title" : "Meter Name"
        }, {
            "name" : "deleteLink",
            "title" : " "
        }, {
            "name" : "submitButton",
            "title" : "Update"
        } ],
        "formName" : "ListProductMeters",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductMeters_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productMeterTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListProductMeters_productMeterTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Meter Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductMeters",
            "options" : [ {
            "description" : "Acre",
            "key" : "AREA_A"
            }, {
            "description" : "Afghani",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar",
            "key" : "DZD"
            }, {
            "description" : "American Dollar",
            "key" : "USD"
            }, {
            "description" : "Amphere - Electric current",
            "key" : "OTH_A"
            }, {
            "description" : "Angolan Kwanza",
            "key" : "AOA"
            }, {
            "description" : "Angstrom",
            "key" : "LEN_A"
            }, {
            "description" : "Are",
            "key" : "AREA_a"
            }, {
            "description" : "Argentina Peso",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar",
            "key" : "BBD"
            }, {
            "description" : "Barrel (US)",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "Belize Dollar",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar",
            "key" : "BMD"
            }, {
            "description" : "Bit of Data",
            "key" : "DATA_b"
            }, {
            "description" : "Bit-per-second of Data",
            "key" : "DATASPD_bps"
            }, {
            "description" : "Bolivian Boliviano",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula",
            "key" : "BWP"
            }, {
            "description" : "Box",
            "key" : "OTH_box"
            }, {
            "description" : "Brazilian Real",
            "key" : "BRL"
            }, {
            "description" : "British Pound",
            "key" : "GBP"
            }, {
            "description" : "British Thermal Unit",
            "key" : "EN_Btu"
            }, {
            "description" : "Brunei Dollar",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc",
            "key" : "BIF"
            }, {
            "description" : "Byte of Data",
            "key" : "DATA_B"
            }, {
            "description" : "Cable",
            "key" : "LEN_cb"
            }, {
            "description" : "Calorie (@15.5c)",
            "key" : "EN_cal15"
            }, {
            "description" : "Cambodian Riel",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar",
            "key" : "CAD"
            }, {
            "description" : "Candela - Luminosity (intensity of light)",
            "key" : "OTH_cd"
            }, {
            "description" : "Cape Verde Escudo",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar",
            "key" : "KYD"
            }, {
            "description" : "Centimeter",
            "key" : "LEN_cm"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s)",
            "key" : "LEN_chG"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s)",
            "key" : "LEN_chR"
            }, {
            "description" : "Chilean Peso",
            "key" : "CLP"
            }, {
            "description" : "China",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso",
            "key" : "CUP"
            }, {
            "description" : "Cubic centimeter",
            "key" : "VDRY_cm3"
            }, {
            "description" : "Cubic foot",
            "key" : "VDRY_ft3"
            }, {
            "description" : "Cubic inch",
            "key" : "VDRY_in3"
            }, {
            "description" : "Cubic meter",
            "key" : "VDRY_m3"
            }, {
            "description" : "Cubic meter (liquid)",
            "key" : "VLIQ_M3"
            }, {
            "description" : "Cubic millimeter",
            "key" : "VDRY_mm3"
            }, {
            "description" : "Cubic yard",
            "key" : "VDRY_yd3"
            }, {
            "description" : "Cup",
            "key" : "VLIQ_cup"
            }, {
            "description" : "Czech Krona",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone",
            "key" : "DKK"
            }, {
            "description" : "Decimeter",
            "key" : "LEN_dm"
            }, {
            "description" : "Degrees Celsius",
            "key" : "TEMP_C"
            }, {
            "description" : "Degrees Fahrenheit",
            "key" : "TEMP_F"
            }, {
            "description" : "Dekameter",
            "key" : "LEN_dam"
            }, {
            "description" : "Djibouti Franc",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso",
            "key" : "DOP"
            }, {
            "description" : "Dram (US)",
            "key" : "VLIQ_dr"
            }, {
            "description" : "Dram (avdp)",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Each",
            "key" : "OTH_ea"
            }, {
            "description" : "East Carribean Dollar",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr",
            "key" : "ETB"
            }, {
            "description" : "Euro",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound",
            "key" : "FKP"
            }, {
            "description" : "Fathom",
            "key" : "LEN_fm"
            }, {
            "description" : "Fiji Dollar",
            "key" : "FJD"
            }, {
            "description" : "Foot",
            "key" : "LEN_ft"
            }, {
            "description" : "Furlong",
            "key" : "LEN_fur"
            }, {
            "description" : "Gabon C.f.A Franc",
            "key" : "XAF"
            }, {
            "description" : "Gallon (UK)",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "Gallon (US)",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "Gambian Dalasi",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound",
            "key" : "GIP"
            }, {
            "description" : "Gigabit of Data",
            "key" : "DATA_Gb"
            }, {
            "description" : "Gigabit-per-second of Data",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "Gigabyte of Data",
            "key" : "DATA_GB"
            }, {
            "description" : "Gill (1/4 UK pint)",
            "key" : "VLIQ_gi"
            }, {
            "description" : "Grain",
            "key" : "WT_gr"
            }, {
            "description" : "Gram",
            "key" : "WT_g"
            }, {
            "description" : "Guatemalan Quedzal",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde",
            "key" : "HTG"
            }, {
            "description" : "Hand (horse\\'s height)",
            "key" : "LEN_hand"
            }, {
            "description" : "Hectare",
            "key" : "AREA_ha"
            }, {
            "description" : "Hectoliter",
            "key" : "VLIQ_HL"
            }, {
            "description" : "Honduran Lempira",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar",
            "key" : "HKD"
            }, {
            "description" : "Horsepower (mechanical)",
            "key" : "EN_HP"
            }, {
            "description" : "Hungarian forint",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona",
            "key" : "ISK"
            }, {
            "description" : "Inch",
            "key" : "LEN_in"
            }, {
            "description" : "Indian Rupee",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar",
            "key" : "JOD"
            }, {
            "description" : "Joule (absolute)",
            "key" : "EN_J"
            }, {
            "description" : "Kazakhstani Tenge",
            "key" : "KZT"
            }, {
            "description" : "Kelvin",
            "key" : "TEMP_K"
            }, {
            "description" : "Kenyan Shilling",
            "key" : "KES"
            }, {
            "description" : "Kilobit of Data",
            "key" : "DATA_Kb"
            }, {
            "description" : "Kilobit-per-second of Data",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "Kilobyte of Data",
            "key" : "DATA_KB"
            }, {
            "description" : "Kilogram",
            "key" : "WT_kg"
            }, {
            "description" : "Kilometer",
            "key" : "LEN_km"
            }, {
            "description" : "Kilowatt",
            "key" : "EN_Kw"
            }, {
            "description" : "Kirghizstan Som",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip",
            "key" : "LAK"
            }, {
            "description" : "Lari",
            "key" : "GEL"
            }, {
            "description" : "League",
            "key" : "LEN_league"
            }, {
            "description" : "Lebanese Pound",
            "key" : "LBP"
            }, {
            "description" : "Leone",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar",
            "key" : "LYD"
            }, {
            "description" : "Link (Gunter\\'s)",
            "key" : "LEN_lnG"
            }, {
            "description" : "Link (Ramden\\'s)",
            "key" : "LEN_lnR"
            }, {
            "description" : "Liter",
            "key" : "VLIQ_L"
            }, {
            "description" : "Macao Pataca",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee",
            "key" : "MUR"
            }, {
            "description" : "Megabit of Data",
            "key" : "DATA_Mb"
            }, {
            "description" : "Megabit-per-second of Data",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "Megabyte of Data",
            "key" : "DATA_MB"
            }, {
            "description" : "Meter",
            "key" : "LEN_m"
            }, {
            "description" : "Mexican Peso",
            "key" : "MXN"
            }, {
            "description" : "Micrometer (Micron)",
            "key" : "LEN_u"
            }, {
            "description" : "Mil (Milli-inch)",
            "key" : "LEN_mil"
            }, {
            "description" : "Mile (nautical/sea)",
            "key" : "LEN_nmi"
            }, {
            "description" : "Mile (statute/land)",
            "key" : "LEN_mi"
            }, {
            "description" : "Milligram",
            "key" : "WT_mg"
            }, {
            "description" : "Milliliter",
            "key" : "VLIQ_ml"
            }, {
            "description" : "Millimeter",
            "key" : "LEN_mm"
            }, {
            "description" : "Moldavian Lei",
            "key" : "MDL"
            }, {
            "description" : "Mole - Substance (molecule)",
            "key" : "OTH_mol"
            }, {
            "description" : "Mongolian Tugrik",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar",
            "key" : "TWD"
            }, {
            "description" : "New Zaire",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial",
            "key" : "OMR"
            }, {
            "description" : "Ounce (avdp)",
            "key" : "WT_oz"
            }, {
            "description" : "Ounce (troy)",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Ounce, fluid (UK)",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "Ounce, fluid (US)",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "Package",
            "key" : "OTH_pk"
            }, {
            "description" : "Pakistan Rupee",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani",
            "key" : "PYG"
            }, {
            "description" : "Pennyweight",
            "key" : "WT_dwt"
            }, {
            "description" : "Per Person",
            "key" : "OTH_pp"
            }, {
            "description" : "Peruvian Sol",
            "key" : "PEN"
            }, {
            "description" : "Petabit of Data",
            "key" : "DATA_Pb"
            }, {
            "description" : "Petabyte of Data",
            "key" : "DATA_PB"
            }, {
            "description" : "Philippino Peso",
            "key" : "PHP"
            }, {
            "description" : "Pica (type size)",
            "key" : "LEN_pica"
            }, {
            "description" : "Pint (UK)",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "Pint (US)",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "Point (type size)",
            "key" : "LEN_point"
            }, {
            "description" : "Polish Zloty",
            "key" : "PLN"
            }, {
            "description" : "Pound (avdp)",
            "key" : "WT_lb"
            }, {
            "description" : "Qatar Riyal",
            "key" : "QAR"
            }, {
            "description" : "Quart",
            "key" : "VLIQ_qt"
            }, {
            "description" : "Rod",
            "key" : "LEN_rd"
            }, {
            "description" : "Romanian Leu",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling",
            "key" : "SOS"
            }, {
            "description" : "South African Rand",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound",
            "key" : "SSP"
            }, {
            "description" : "Square Centimeter",
            "key" : "AREA_cm2"
            }, {
            "description" : "Square Foot",
            "key" : "AREA_ft2"
            }, {
            "description" : "Square Inch",
            "key" : "AREA_in2"
            }, {
            "description" : "Square Kilometer",
            "key" : "AREA_km2"
            }, {
            "description" : "Square Meter",
            "key" : "AREA_m2"
            }, {
            "description" : "Square Mile",
            "key" : "AREA_mi2"
            }, {
            "description" : "Square Millimeter",
            "key" : "AREA_mm2"
            }, {
            "description" : "Square Rod",
            "key" : "AREA_rd2"
            }, {
            "description" : "Square Yard",
            "key" : "AREA_yd2"
            }, {
            "description" : "Sri Lankan Rupee",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound",
            "key" : "SHP"
            }, {
            "description" : "Stere (cubic meter)",
            "key" : "VDRY_ST"
            }, {
            "description" : "Stone",
            "key" : "WT_st"
            }, {
            "description" : "Sudanese Pound",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound",
            "key" : "SYP"
            }, {
            "description" : "Tablespoon",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "Tadzhikistani Somoni",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling",
            "key" : "TZS"
            }, {
            "description" : "Teaspoon",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "Terabit of Data",
            "key" : "DATA_Tb"
            }, {
            "description" : "Terabit-per-second of Data",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "Terabyte of Data",
            "key" : "DATA_TB"
            }, {
            "description" : "Thailand Baht",
            "key" : "THB"
            }, {
            "description" : "Time in Centuries",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years",
            "key" : "TF_yr"
            }, {
            "description" : "Ton (long or British)",
            "key" : "WT_lt"
            }, {
            "description" : "Ton (metric)",
            "key" : "WT_mt"
            }, {
            "description" : "Ton (short)",
            "key" : "WT_sh_t"
            }, {
            "description" : "Tongan Pa\\'anga",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham",
            "key" : "AED"
            }, {
            "description" : "Uruguay",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI)",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong",
            "key" : "VND"
            }, {
            "description" : "Watt",
            "key" : "EN_w"
            }, {
            "description" : "West Indian Guilder",
            "key" : "ANG"
            }, {
            "description" : "Yard",
            "key" : "LEN_yd"
            }, {
            "description" : "Yemeni Ryal",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "ListProductMeters_meterUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "meterUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Meter Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "meterName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductMeters_meterName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "productMeterTypeId"
            } ],
            "id" : "ListProductMeters_deleteLink",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : "",
            "target" : "deleteProductMeter"
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListProductMeters",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ListProductMeters_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductMeter"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productMeterTypeId", "meterUomId", "meterName", "submitButton" ]
        } ],
        "formName" : "AddProductMeter",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductMeter_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Meter Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductMeter",
            "options" : [ {
            "description" : "Copy Count Meter",
            "key" : "COPY_COUNT"
            }, {
            "description" : "Distance Meter",
            "key" : "DISTANCE"
            }, {
            "description" : "Motor Time Meter",
            "key" : "MOTOR_TIME"
            }, {
            "description" : "Odometer",
            "key" : "ODOMETER"
            }, {
            "description" : "Speedometer",
            "key" : "SPEEDOMETER"
            }, {
            "description" : "Tachometer",
            "key" : "TACHOMETER"
            }, {
            "description" : "Use Count Meter",
            "key" : "USE_COUNT"
            }, {
            "description" : "Use Event Data Recorder",
            "key" : "EVENT_DATA_RECORDER"
            }, {
            "description" : "Use Pedometer",
            "key" : "PEDOMETER"
            }, {
            "description" : "Use Tacograph",
            "key" : "TACHOGRAPH"
            }, {
            "description" : "Use Taximeter",
            "key" : "TAXIMETER"
            }, {
            "description" : "Use Trip Meter",
            "key" : "TRIP_METER"
            } ],
            "disabled" : "false",
            "id" : "AddProductMeter_productMeterTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productMeterTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Meter Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductMeter",
            "options" : [ {
            "description" : "Acre",
            "key" : "AREA_A"
            }, {
            "description" : "Afghani",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar",
            "key" : "DZD"
            }, {
            "description" : "American Dollar",
            "key" : "USD"
            }, {
            "description" : "Amphere - Electric current",
            "key" : "OTH_A"
            }, {
            "description" : "Angolan Kwanza",
            "key" : "AOA"
            }, {
            "description" : "Angstrom",
            "key" : "LEN_A"
            }, {
            "description" : "Are",
            "key" : "AREA_a"
            }, {
            "description" : "Argentina Peso",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar",
            "key" : "BBD"
            }, {
            "description" : "Barrel (US)",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "Belize Dollar",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar",
            "key" : "BMD"
            }, {
            "description" : "Bit of Data",
            "key" : "DATA_b"
            }, {
            "description" : "Bit-per-second of Data",
            "key" : "DATASPD_bps"
            }, {
            "description" : "Bolivian Boliviano",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula",
            "key" : "BWP"
            }, {
            "description" : "Box",
            "key" : "OTH_box"
            }, {
            "description" : "Brazilian Real",
            "key" : "BRL"
            }, {
            "description" : "British Pound",
            "key" : "GBP"
            }, {
            "description" : "British Thermal Unit",
            "key" : "EN_Btu"
            }, {
            "description" : "Brunei Dollar",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc",
            "key" : "BIF"
            }, {
            "description" : "Byte of Data",
            "key" : "DATA_B"
            }, {
            "description" : "Cable",
            "key" : "LEN_cb"
            }, {
            "description" : "Calorie (@15.5c)",
            "key" : "EN_cal15"
            }, {
            "description" : "Cambodian Riel",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar",
            "key" : "CAD"
            }, {
            "description" : "Candela - Luminosity (intensity of light)",
            "key" : "OTH_cd"
            }, {
            "description" : "Cape Verde Escudo",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar",
            "key" : "KYD"
            }, {
            "description" : "Centimeter",
            "key" : "LEN_cm"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s)",
            "key" : "LEN_chG"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s)",
            "key" : "LEN_chR"
            }, {
            "description" : "Chilean Peso",
            "key" : "CLP"
            }, {
            "description" : "China",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso",
            "key" : "CUP"
            }, {
            "description" : "Cubic centimeter",
            "key" : "VDRY_cm3"
            }, {
            "description" : "Cubic foot",
            "key" : "VDRY_ft3"
            }, {
            "description" : "Cubic inch",
            "key" : "VDRY_in3"
            }, {
            "description" : "Cubic meter",
            "key" : "VDRY_m3"
            }, {
            "description" : "Cubic meter (liquid)",
            "key" : "VLIQ_M3"
            }, {
            "description" : "Cubic millimeter",
            "key" : "VDRY_mm3"
            }, {
            "description" : "Cubic yard",
            "key" : "VDRY_yd3"
            }, {
            "description" : "Cup",
            "key" : "VLIQ_cup"
            }, {
            "description" : "Czech Krona",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone",
            "key" : "DKK"
            }, {
            "description" : "Decimeter",
            "key" : "LEN_dm"
            }, {
            "description" : "Degrees Celsius",
            "key" : "TEMP_C"
            }, {
            "description" : "Degrees Fahrenheit",
            "key" : "TEMP_F"
            }, {
            "description" : "Dekameter",
            "key" : "LEN_dam"
            }, {
            "description" : "Djibouti Franc",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso",
            "key" : "DOP"
            }, {
            "description" : "Dram (US)",
            "key" : "VLIQ_dr"
            }, {
            "description" : "Dram (avdp)",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Each",
            "key" : "OTH_ea"
            }, {
            "description" : "East Carribean Dollar",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr",
            "key" : "ETB"
            }, {
            "description" : "Euro",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound",
            "key" : "FKP"
            }, {
            "description" : "Fathom",
            "key" : "LEN_fm"
            }, {
            "description" : "Fiji Dollar",
            "key" : "FJD"
            }, {
            "description" : "Foot",
            "key" : "LEN_ft"
            }, {
            "description" : "Furlong",
            "key" : "LEN_fur"
            }, {
            "description" : "Gabon C.f.A Franc",
            "key" : "XAF"
            }, {
            "description" : "Gallon (UK)",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "Gallon (US)",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "Gambian Dalasi",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound",
            "key" : "GIP"
            }, {
            "description" : "Gigabit of Data",
            "key" : "DATA_Gb"
            }, {
            "description" : "Gigabit-per-second of Data",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "Gigabyte of Data",
            "key" : "DATA_GB"
            }, {
            "description" : "Gill (1/4 UK pint)",
            "key" : "VLIQ_gi"
            }, {
            "description" : "Grain",
            "key" : "WT_gr"
            }, {
            "description" : "Gram",
            "key" : "WT_g"
            }, {
            "description" : "Guatemalan Quedzal",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde",
            "key" : "HTG"
            }, {
            "description" : "Hand (horse\\'s height)",
            "key" : "LEN_hand"
            }, {
            "description" : "Hectare",
            "key" : "AREA_ha"
            }, {
            "description" : "Hectoliter",
            "key" : "VLIQ_HL"
            }, {
            "description" : "Honduran Lempira",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar",
            "key" : "HKD"
            }, {
            "description" : "Horsepower (mechanical)",
            "key" : "EN_HP"
            }, {
            "description" : "Hungarian forint",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona",
            "key" : "ISK"
            }, {
            "description" : "Inch",
            "key" : "LEN_in"
            }, {
            "description" : "Indian Rupee",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar",
            "key" : "JOD"
            }, {
            "description" : "Joule (absolute)",
            "key" : "EN_J"
            }, {
            "description" : "Kazakhstani Tenge",
            "key" : "KZT"
            }, {
            "description" : "Kelvin",
            "key" : "TEMP_K"
            }, {
            "description" : "Kenyan Shilling",
            "key" : "KES"
            }, {
            "description" : "Kilobit of Data",
            "key" : "DATA_Kb"
            }, {
            "description" : "Kilobit-per-second of Data",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "Kilobyte of Data",
            "key" : "DATA_KB"
            }, {
            "description" : "Kilogram",
            "key" : "WT_kg"
            }, {
            "description" : "Kilometer",
            "key" : "LEN_km"
            }, {
            "description" : "Kilowatt",
            "key" : "EN_Kw"
            }, {
            "description" : "Kirghizstan Som",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip",
            "key" : "LAK"
            }, {
            "description" : "Lari",
            "key" : "GEL"
            }, {
            "description" : "League",
            "key" : "LEN_league"
            }, {
            "description" : "Lebanese Pound",
            "key" : "LBP"
            }, {
            "description" : "Leone",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar",
            "key" : "LYD"
            }, {
            "description" : "Link (Gunter\\'s)",
            "key" : "LEN_lnG"
            }, {
            "description" : "Link (Ramden\\'s)",
            "key" : "LEN_lnR"
            }, {
            "description" : "Liter",
            "key" : "VLIQ_L"
            }, {
            "description" : "Macao Pataca",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee",
            "key" : "MUR"
            }, {
            "description" : "Megabit of Data",
            "key" : "DATA_Mb"
            }, {
            "description" : "Megabit-per-second of Data",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "Megabyte of Data",
            "key" : "DATA_MB"
            }, {
            "description" : "Meter",
            "key" : "LEN_m"
            }, {
            "description" : "Mexican Peso",
            "key" : "MXN"
            }, {
            "description" : "Micrometer (Micron)",
            "key" : "LEN_u"
            }, {
            "description" : "Mil (Milli-inch)",
            "key" : "LEN_mil"
            }, {
            "description" : "Mile (nautical/sea)",
            "key" : "LEN_nmi"
            }, {
            "description" : "Mile (statute/land)",
            "key" : "LEN_mi"
            }, {
            "description" : "Milligram",
            "key" : "WT_mg"
            }, {
            "description" : "Milliliter",
            "key" : "VLIQ_ml"
            }, {
            "description" : "Millimeter",
            "key" : "LEN_mm"
            }, {
            "description" : "Moldavian Lei",
            "key" : "MDL"
            }, {
            "description" : "Mole - Substance (molecule)",
            "key" : "OTH_mol"
            }, {
            "description" : "Mongolian Tugrik",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar",
            "key" : "TWD"
            }, {
            "description" : "New Zaire",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial",
            "key" : "OMR"
            }, {
            "description" : "Ounce (avdp)",
            "key" : "WT_oz"
            }, {
            "description" : "Ounce (troy)",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Ounce, fluid (UK)",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "Ounce, fluid (US)",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "Package",
            "key" : "OTH_pk"
            }, {
            "description" : "Pakistan Rupee",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani",
            "key" : "PYG"
            }, {
            "description" : "Pennyweight",
            "key" : "WT_dwt"
            }, {
            "description" : "Per Person",
            "key" : "OTH_pp"
            }, {
            "description" : "Peruvian Sol",
            "key" : "PEN"
            }, {
            "description" : "Petabit of Data",
            "key" : "DATA_Pb"
            }, {
            "description" : "Petabyte of Data",
            "key" : "DATA_PB"
            }, {
            "description" : "Philippino Peso",
            "key" : "PHP"
            }, {
            "description" : "Pica (type size)",
            "key" : "LEN_pica"
            }, {
            "description" : "Pint (UK)",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "Pint (US)",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "Point (type size)",
            "key" : "LEN_point"
            }, {
            "description" : "Polish Zloty",
            "key" : "PLN"
            }, {
            "description" : "Pound (avdp)",
            "key" : "WT_lb"
            }, {
            "description" : "Qatar Riyal",
            "key" : "QAR"
            }, {
            "description" : "Quart",
            "key" : "VLIQ_qt"
            }, {
            "description" : "Rod",
            "key" : "LEN_rd"
            }, {
            "description" : "Romanian Leu",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling",
            "key" : "SOS"
            }, {
            "description" : "South African Rand",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound",
            "key" : "SSP"
            }, {
            "description" : "Square Centimeter",
            "key" : "AREA_cm2"
            }, {
            "description" : "Square Foot",
            "key" : "AREA_ft2"
            }, {
            "description" : "Square Inch",
            "key" : "AREA_in2"
            }, {
            "description" : "Square Kilometer",
            "key" : "AREA_km2"
            }, {
            "description" : "Square Meter",
            "key" : "AREA_m2"
            }, {
            "description" : "Square Mile",
            "key" : "AREA_mi2"
            }, {
            "description" : "Square Millimeter",
            "key" : "AREA_mm2"
            }, {
            "description" : "Square Rod",
            "key" : "AREA_rd2"
            }, {
            "description" : "Square Yard",
            "key" : "AREA_yd2"
            }, {
            "description" : "Sri Lankan Rupee",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound",
            "key" : "SHP"
            }, {
            "description" : "Stere (cubic meter)",
            "key" : "VDRY_ST"
            }, {
            "description" : "Stone",
            "key" : "WT_st"
            }, {
            "description" : "Sudanese Pound",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound",
            "key" : "SYP"
            }, {
            "description" : "Tablespoon",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "Tadzhikistani Somoni",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling",
            "key" : "TZS"
            }, {
            "description" : "Teaspoon",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "Terabit of Data",
            "key" : "DATA_Tb"
            }, {
            "description" : "Terabit-per-second of Data",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "Terabyte of Data",
            "key" : "DATA_TB"
            }, {
            "description" : "Thailand Baht",
            "key" : "THB"
            }, {
            "description" : "Time in Centuries",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years",
            "key" : "TF_yr"
            }, {
            "description" : "Ton (long or British)",
            "key" : "WT_lt"
            }, {
            "description" : "Ton (metric)",
            "key" : "WT_mt"
            }, {
            "description" : "Ton (short)",
            "key" : "WT_sh_t"
            }, {
            "description" : "Tongan Pa\\'anga",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham",
            "key" : "AED"
            }, {
            "description" : "Uruguay",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI)",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong",
            "key" : "VND"
            }, {
            "description" : "Watt",
            "key" : "EN_w"
            }, {
            "description" : "West Indian Guilder",
            "key" : "ANG"
            }, {
            "description" : "Yard",
            "key" : "LEN_yd"
            }, {
            "description" : "Yemeni Ryal",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "AddProductMeter_meterUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "meterUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Meter Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "meterName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductMeter_meterName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductMeter",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductMeter_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductMeter"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "subscriptionResourceId", "fromDate", "thruDate", "purchaseFromDate", "purchaseThruDate", "maxLifeTime", "maxLifeTimeUomId", "availableTime", "availableTimeUomId", "useCountLimit", "useTime", "useTimeUomId", "useRoleTypeId", "automaticExtend", "canclAutmExtTime", "canclAutmExtTimeUomId", "gracePeriodOnExpiry", "gracePeriodOnExpiryUomId", "submitButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "subscriptionResourceId",
            "title" : "Subscription Resource ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "purchaseFromDate",
            "title" : "Purchase From Date"
        }, {
            "name" : "purchaseThruDate",
            "title" : "Purchase Through Date"
        }, {
            "name" : "maxLifeTime",
            "title" : "Max Life Time"
        }, {
            "name" : "maxLifeTimeUomId",
            "title" : "Max Life Time Uom ID"
        }, {
            "name" : "availableTime",
            "title" : "Available Time"
        }, {
            "name" : "availableTimeUomId",
            "title" : "Available Time Uom ID"
        }, {
            "name" : "useCountLimit",
            "title" : "Use Count Limit"
        }, {
            "name" : "useTime",
            "title" : "Use Time"
        }, {
            "name" : "useTimeUomId",
            "title" : "Use Time Uom ID"
        }, {
            "name" : "useRoleTypeId",
            "title" : "Use Role Type ID"
        }, {
            "name" : "automaticExtend",
            "title" : "The subscription will be extended at the end of the subscription period with a new order"
        }, {
            "name" : "canclAutmExtTime",
            "title" : "Time period (before the end of the thrudate) for automatic extension of the subscription"
        }, {
            "name" : "canclAutmExtTimeUomId",
            "title" : "Unit Of Measure used for the automatic extension of the subscription"
        }, {
            "name" : "gracePeriodOnExpiry",
            "title" : "Grace Period On Expiry"
        }, {
            "name" : "gracePeriodOnExpiryUomId",
            "title" : "Grace Period On Expiry Uom ID"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : "Delete Link"
        } ],
        "formName" : "ListProductSubscriptionResources",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListProductSubscriptionResources_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_b2e8b0e3_9238_4c1a_8152_3b0c85d0db22",
            "target" : "EditSubscriptionResource",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "subscriptionResourceId",
            "description" : "",
            "style" : "",
            "id" : "ListProductSubscriptionResources_subscriptionResourceId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListProductSubscriptionResources_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-08%2005:57:03.647",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListProductSubscriptionResources",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListProductSubscriptionResources_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Purchase From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-08%2005:57:03.647",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListProductSubscriptionResources",
            "timeDropdownParamName" : "purchaseFromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListProductSubscriptionResources_purchaseFromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "purchaseFromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Purchase Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-08%2005:57:03.647",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListProductSubscriptionResources",
            "timeDropdownParamName" : "purchaseThruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListProductSubscriptionResources_purchaseThruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "purchaseThruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Max Life Time",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "maxLifeTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductSubscriptionResources_maxLifeTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Max Life Time Uom ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "maxLifeTimeUomId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductSubscriptionResources_maxLifeTimeUomId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Available Time",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "availableTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductSubscriptionResources_availableTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Available Time Uom ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "availableTimeUomId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductSubscriptionResources_availableTimeUomId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Use Count Limit",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "useCountLimit",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductSubscriptionResources_useCountLimit",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Use Time",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "useTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductSubscriptionResources_useTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Use Time Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductSubscriptionResources",
            "options" : [ {
            "description" : "Time in Centuries (century)",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days (day)",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades (decade)",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours (hr)",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia (millenium)",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds (ms)",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes (min)",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months (mon)",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores (score)",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds (s)",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks (wk)",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years (yr)",
            "key" : "TF_yr"
            } ],
            "disabled" : "false",
            "id" : "ListProductSubscriptionResources_useTimeUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "useTimeUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Use Role Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductSubscriptionResources",
            "options" : [ {
            "description" : "Account",
            "key" : "ACCOUNT"
            }, {
            "description" : "Account Lead",
            "key" : "ACCOUNT_LEAD"
            }, {
            "description" : "Accountant",
            "key" : "ACCOUNTANT"
            }, {
            "description" : "Addressee",
            "key" : "ADDRESSEE"
            }, {
            "description" : "Administrator",
            "key" : "ADMIN"
            }, {
            "description" : "Affiliate",
            "key" : "AFFILIATE"
            }, {
            "description" : "Agent",
            "key" : "AGENT"
            }, {
            "description" : "Approver",
            "key" : "APPROVER"
            }, {
            "description" : "Association",
            "key" : "ASSOCIATION"
            }, {
            "description" : "Automated Agent",
            "key" : "AUTOMATED_AGENT_ROLE"
            }, {
            "description" : "Bill-From-Vendor",
            "key" : "BILL_FROM_VENDOR"
            }, {
            "description" : "Bill-To Customer",
            "key" : "BILL_TO_CUSTOMER"
            }, {
            "description" : "Blind Copy",
            "key" : "BCC"
            }, {
            "description" : "Budget Application",
            "key" : "BUDGET_APPL"
            }, {
            "description" : "Budget Approver",
            "key" : "BUDGET_APPRV"
            }, {
            "description" : "Budget Manager",
            "key" : "BUDGET_MGR"
            }, {
            "description" : "Budget Reviewer",
            "key" : "BUDGET_RVR"
            }, {
            "description" : "Budget Roles Group (not to be assigned to parties)",
            "key" : "BUDGET"
            }, {
            "description" : "Bulk Customer",
            "key" : "BULK_CUSTOMER"
            }, {
            "description" : "Buyer",
            "key" : "BUYER"
            }, {
            "description" : "Calendar",
            "key" : "CALENDAR_ROLE"
            }, {
            "description" : "Calendar Attendee",
            "key" : "CAL_ATTENDEE"
            }, {
            "description" : "Calendar Delegate",
            "key" : "CAL_DELEGATE"
            }, {
            "description" : "Calendar Host",
            "key" : "CAL_HOST"
            }, {
            "description" : "Calendar Member",
            "key" : "ICAL_MEMBER"
            }, {
            "description" : "Calendar Organizer",
            "key" : "CAL_ORGANIZER"
            }, {
            "description" : "Calendar Owner",
            "key" : "CAL_OWNER"
            }, {
            "description" : "Carbon Copy",
            "key" : "CC"
            }, {
            "description" : "Carrier",
            "key" : "CARRIER"
            }, {
            "description" : "Cashier",
            "key" : "CASHIER"
            }, {
            "description" : "Client",
            "key" : "CLIENT"
            }, {
            "description" : "Client Analyst",
            "key" : "CLIENT_ANALYST"
            }, {
            "description" : "Client Billing",
            "key" : "CLIENT_BILLING"
            }, {
            "description" : "Client Manager",
            "key" : "CLIENT_MANAGER"
            }, {
            "description" : "Communication Participant",
            "key" : "COMMEVENT_ROLE"
            }, {
            "description" : "Competitor",
            "key" : "COMPETITOR"
            }, {
            "description" : "Consumer",
            "key" : "CONSUMER"
            }, {
            "description" : "Contact",
            "key" : "CONTACT"
            }, {
            "description" : "Content Administrator",
            "key" : "CONTENT_ADMIN"
            }, {
            "description" : "Content Author",
            "key" : "CONTENT_AUTHOR"
            }, {
            "description" : "Content Editor",
            "key" : "CONTENT_EDITOR"
            }, {
            "description" : "Content Guest",
            "key" : "CONTENT_GUEST"
            }, {
            "description" : "Content Member",
            "key" : "CONTENT"
            }, {
            "description" : "Content Publisher",
            "key" : "CONTENT_PUBLISHER"
            }, {
            "description" : "Content User",
            "key" : "CONTENT_USER"
            }, {
            "description" : "Contractor",
            "key" : "CONTRACTOR"
            }, {
            "description" : "Customer",
            "key" : "CUSTOMER"
            }, {
            "description" : "Department",
            "key" : "DEPARTMENT"
            }, {
            "description" : "Distribution Channel",
            "key" : "DISTRIBUTION_CHANNEL"
            }, {
            "description" : "Distributor",
            "key" : "DISTRIBUTOR"
            }, {
            "description" : "Division",
            "key" : "DIVISION"
            }, {
            "description" : "Email Administrator",
            "key" : "EMAIL_ADMIN"
            }, {
            "description" : "Employee",
            "key" : "EMPLOYEE"
            }, {
            "description" : "Employer",
            "key" : "EMPLOYER"
            }, {
            "description" : "End-User Customer",
            "key" : "END_USER_CUSTOMER"
            }, {
            "description" : "Family Member",
            "key" : "FAMILY_MEMBER"
            }, {
            "description" : "Fixed Asset Maint Assignee",
            "key" : "FAM_ASSIGNEE"
            }, {
            "description" : "Government Agency",
            "key" : "GOV_AGENCY"
            }, {
            "description" : "Hosting Server",
            "key" : "HOSTING_SERVER"
            }, {
            "description" : "Household",
            "key" : "HOUSEHOLD"
            }, {
            "description" : "ISP",
            "key" : "ISP"
            }, {
            "description" : "Image Approver",
            "key" : "IMAGEAPPROVER"
            }, {
            "description" : "Internal Organization",
            "key" : "INTERNAL_ORGANIZATIO"
            }, {
            "description" : "Lead",
            "key" : "LEAD"
            }, {
            "description" : "Limited Administrator",
            "key" : "LTD_ADMIN"
            }, {
            "description" : "Logged In",
            "key" : "LOGGEDIN"
            }, {
            "description" : "Main Role",
            "key" : "MAIN_ROLE"
            }, {
            "description" : "Maintenance Manager or Supervisor",
            "key" : "FAM_MANAGER"
            }, {
            "description" : "Maintenance Supplier or Service",
            "key" : "FAM_SUPPLIER"
            }, {
            "description" : "Maintenance Worker",
            "key" : "FAM_WORKER"
            }, {
            "description" : "Manager",
            "key" : "MANAGER"
            }, {
            "description" : "Manufacturer",
            "key" : "MANUFACTURER"
            }, {
            "description" : "Not Applicable",
            "key" : "_NA_"
            }, {
            "description" : "Order Clerk",
            "key" : "ORDER_CLERK"
            }, {
            "description" : "Organization",
            "key" : "ORGANIZATION_ROLE"
            }, {
            "description" : "Organization Unit",
            "key" : "ORGANIZATION_UNIT"
            }, {
            "description" : "Originator",
            "key" : "ORIGINATOR"
            }, {
            "description" : "Other Internal",
            "key" : "OTHER_INTERNAL_ORGAN"
            }, {
            "description" : "Other Organization Unit",
            "key" : "OTHER_ORGANIZATION_U"
            }, {
            "description" : "Owner",
            "key" : "OWNER"
            }, {
            "description" : "Packer",
            "key" : "PACKER"
            }, {
            "description" : "Parent Organization",
            "key" : "PARENT_ORGANIZATION"
            }, {
            "description" : "Partner",
            "key" : "PARTNER"
            }, {
            "description" : "Person",
            "key" : "PERSON_ROLE"
            }, {
            "description" : "Picker",
            "key" : "PICKER"
            }, {
            "description" : "Placing Customer",
            "key" : "PLACING_CUSTOMER"
            }, {
            "description" : "Product Owner",
            "key" : "PRODUCT_OWNER"
            }, {
            "description" : "Product Owner Company",
            "key" : "PRODUCT_OWNER_COMP"
            }, {
            "description" : "Project Team",
            "key" : "PROJECT_TEAM"
            }, {
            "description" : "Prospect",
            "key" : "PROSPECT"
            }, {
            "description" : "Provider Accounting",
            "key" : "PROVIDER_ACCOUNTING"
            }, {
            "description" : "Provider Analyst",
            "key" : "PROVIDER_ANALYST"
            }, {
            "description" : "Provider Functional",
            "key" : "PROVIDER_FUNCTIONAL"
            }, {
            "description" : "Provider Manager",
            "key" : "PROVIDER_MANAGER"
            }, {
            "description" : "Provider Tester",
            "key" : "PROVIDER_TESTER"
            }, {
            "description" : "Provider Validator",
            "key" : "PROVIDER_VALIDATOR"
            }, {
            "description" : "Receiver",
            "key" : "RECEIVER"
            }, {
            "description" : "Referrer",
            "key" : "REFERRER"
            }, {
            "description" : "Regulatory Agency",
            "key" : "REGULATORY_AGENCY"
            }, {
            "description" : "Request Manager",
            "key" : "REQ_MANAGER"
            }, {
            "description" : "Request Respondent",
            "key" : "REQ_RESPOND"
            }, {
            "description" : "Request Role",
            "key" : "REQUEST_ROLE"
            }, {
            "description" : "Request Taker",
            "key" : "REQ_TAKER"
            }, {
            "description" : "Requesting Party",
            "key" : "REQ_REQUESTER"
            }, {
            "description" : "Reviewer",
            "key" : "REVIEWER"
            }, {
            "description" : "SCRUM Master",
            "key" : "SCRUM_MASTER"
            }, {
            "description" : "SCRUM Team",
            "key" : "SCRUM_TEAM"
            }, {
            "description" : "Sales Force Autm.",
            "key" : "SFA_ROLE"
            }, {
            "description" : "Sales Representative",
            "key" : "SALES_REP"
            }, {
            "description" : "Scrum Member",
            "key" : "SCRUM_MEMBER"
            }, {
            "description" : "Shareholder",
            "key" : "SHAREHOLDER"
            }, {
            "description" : "Ship-From Vendor",
            "key" : "SHIP_FROM_VENDOR"
            }, {
            "description" : "Ship-To Customer",
            "key" : "SHIP_TO_CUSTOMER"
            }, {
            "description" : "Shipment Clerk",
            "key" : "SHIPMENT_CLERK"
            }, {
            "description" : "Sponsor",
            "key" : "SPONSOR"
            }, {
            "description" : "Spouse",
            "key" : "SPOUSE"
            }, {
            "description" : "Stakeholder",
            "key" : "STAKEHOLDER"
            }, {
            "description" : "Stocker",
            "key" : "STOCKER"
            }, {
            "description" : "Subscriber",
            "key" : "SUBSCRIBER"
            }, {
            "description" : "Subsidiary",
            "key" : "SUBSIDIARY"
            }, {
            "description" : "Supplier",
            "key" : "SUPPLIER"
            }, {
            "description" : "Supplier Agent",
            "key" : "SUPPLIER_AGENT"
            }, {
            "description" : "Tax Authority",
            "key" : "TAX_AUTHORITY"
            }, {
            "description" : "Union",
            "key" : "UNION"
            }, {
            "description" : "Vendor",
            "key" : "VENDOR"
            }, {
            "description" : "Visitor",
            "key" : "VISITOR"
            }, {
            "description" : "Web Master",
            "key" : "WEB_MASTER"
            }, {
            "description" : "Worker",
            "key" : "WORKER"
            }, {
            "description" : "Workflow",
            "key" : "WORKFLOW_ROLE"
            }, {
            "description" : "Workflow Owner",
            "key" : "WF_OWNER"
            } ],
            "disabled" : "false",
            "id" : "ListProductSubscriptionResources_useRoleTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "useRoleTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "The subscription will be extended at the end of the subscription period with a new order",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductSubscriptionResources",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "ListProductSubscriptionResources_automaticExtend",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "first-in-list",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "automaticExtend",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Time period (before the end of the thrudate) for automatic extension of the subscription",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "canclAutmExtTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductSubscriptionResources_canclAutmExtTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Unit Of Measure used for the automatic extension of the subscription",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductSubscriptionResources",
            "options" : [ {
            "description" : "Time in Centuries (century)",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days (day)",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades (decade)",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours (hr)",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia (millenium)",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds (ms)",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes (min)",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months (mon)",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores (score)",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds (s)",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks (wk)",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years (yr)",
            "key" : "TF_yr"
            } ],
            "disabled" : "false",
            "id" : "ListProductSubscriptionResources_canclAutmExtTimeUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "canclAutmExtTimeUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Grace Period On Expiry",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "gracePeriodOnExpiry",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductSubscriptionResources_gracePeriodOnExpiry",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Grace Period On Expiry Uom ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "gracePeriodOnExpiryUomId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductSubscriptionResources_gracePeriodOnExpiryUomId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListProductSubscriptionResources",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ListProductSubscriptionResources_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Delete",
            "title" : "Delete Link",
            "type" : "HYPERLINK",
            "target" : "deleteProductSubscriptionResource",
            "name" : "deleteLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "subscriptionResourceId"
            }, {
            "name" : "fromDate"
            } ],
            "style" : "",
            "id" : "ListProductSubscriptionResources_deleteLink",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : ""
        } ],
        "target" : "updateProductSubscriptionResource"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "subscriptionResourceId", "fromDate", "thruDate", "purchaseFromDate", "purchaseThruDate", "maxLifeTime", "maxLifeTimeUomId", "availableTime", "availableTimeUomId", "useCountLimit", "useTime", "useTimeUomId", "useRoleTypeId", "automaticExtend", "canclAutmExtTime", "canclAutmExtTimeUomId", "gracePeriodOnExpiry", "gracePeriodOnExpiryUomId", "submitButton" ]
        } ],
        "formName" : "AddProductSubscriptionResource",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductSubscriptionResource_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Subscription Resource ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductSubscriptionResource",
            "options" : [ {
            "description" : "Gizmo Newsletter",
            "key" : "GZ-NEWS"
            } ],
            "disabled" : "false",
            "id" : "AddProductSubscriptionResource_subscriptionResourceId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "subscriptionResourceId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "required",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductSubscriptionResource",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductSubscriptionResource_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-08%2006:00:38.273",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductSubscriptionResource",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductSubscriptionResource_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Purchase From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-08%2006:00:38.273",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductSubscriptionResource",
            "timeDropdownParamName" : "purchaseFromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductSubscriptionResource_purchaseFromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "purchaseFromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Purchase Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-08%2006:00:38.273",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductSubscriptionResource",
            "timeDropdownParamName" : "purchaseThruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductSubscriptionResource_purchaseThruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "purchaseThruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Max Life Time",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "maxLifeTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductSubscriptionResource_maxLifeTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Max Life Time Uom ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "maxLifeTimeUomId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductSubscriptionResource_maxLifeTimeUomId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Available Time",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "availableTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductSubscriptionResource_availableTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Available Time Uom ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "availableTimeUomId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductSubscriptionResource_availableTimeUomId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Use Count Limit",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "useCountLimit",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductSubscriptionResource_useCountLimit",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Use Time",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "useTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductSubscriptionResource_useTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Use Time Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductSubscriptionResource",
            "options" : [ {
            "description" : "Time in Centuries (century)",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days (day)",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades (decade)",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours (hr)",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia (millenium)",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds (ms)",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes (min)",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months (mon)",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores (score)",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds (s)",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks (wk)",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years (yr)",
            "key" : "TF_yr"
            } ],
            "disabled" : "false",
            "id" : "AddProductSubscriptionResource_useTimeUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "useTimeUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Use Role Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductSubscriptionResource",
            "options" : [ {
            "description" : "Account",
            "key" : "ACCOUNT"
            }, {
            "description" : "Account Lead",
            "key" : "ACCOUNT_LEAD"
            }, {
            "description" : "Accountant",
            "key" : "ACCOUNTANT"
            }, {
            "description" : "Addressee",
            "key" : "ADDRESSEE"
            }, {
            "description" : "Administrator",
            "key" : "ADMIN"
            }, {
            "description" : "Affiliate",
            "key" : "AFFILIATE"
            }, {
            "description" : "Agent",
            "key" : "AGENT"
            }, {
            "description" : "Approver",
            "key" : "APPROVER"
            }, {
            "description" : "Association",
            "key" : "ASSOCIATION"
            }, {
            "description" : "Automated Agent",
            "key" : "AUTOMATED_AGENT_ROLE"
            }, {
            "description" : "Bill-From-Vendor",
            "key" : "BILL_FROM_VENDOR"
            }, {
            "description" : "Bill-To Customer",
            "key" : "BILL_TO_CUSTOMER"
            }, {
            "description" : "Blind Copy",
            "key" : "BCC"
            }, {
            "description" : "Budget Application",
            "key" : "BUDGET_APPL"
            }, {
            "description" : "Budget Approver",
            "key" : "BUDGET_APPRV"
            }, {
            "description" : "Budget Manager",
            "key" : "BUDGET_MGR"
            }, {
            "description" : "Budget Reviewer",
            "key" : "BUDGET_RVR"
            }, {
            "description" : "Budget Roles Group (not to be assigned to parties)",
            "key" : "BUDGET"
            }, {
            "description" : "Bulk Customer",
            "key" : "BULK_CUSTOMER"
            }, {
            "description" : "Buyer",
            "key" : "BUYER"
            }, {
            "description" : "Calendar",
            "key" : "CALENDAR_ROLE"
            }, {
            "description" : "Calendar Attendee",
            "key" : "CAL_ATTENDEE"
            }, {
            "description" : "Calendar Delegate",
            "key" : "CAL_DELEGATE"
            }, {
            "description" : "Calendar Host",
            "key" : "CAL_HOST"
            }, {
            "description" : "Calendar Member",
            "key" : "ICAL_MEMBER"
            }, {
            "description" : "Calendar Organizer",
            "key" : "CAL_ORGANIZER"
            }, {
            "description" : "Calendar Owner",
            "key" : "CAL_OWNER"
            }, {
            "description" : "Carbon Copy",
            "key" : "CC"
            }, {
            "description" : "Carrier",
            "key" : "CARRIER"
            }, {
            "description" : "Cashier",
            "key" : "CASHIER"
            }, {
            "description" : "Client",
            "key" : "CLIENT"
            }, {
            "description" : "Client Analyst",
            "key" : "CLIENT_ANALYST"
            }, {
            "description" : "Client Billing",
            "key" : "CLIENT_BILLING"
            }, {
            "description" : "Client Manager",
            "key" : "CLIENT_MANAGER"
            }, {
            "description" : "Communication Participant",
            "key" : "COMMEVENT_ROLE"
            }, {
            "description" : "Competitor",
            "key" : "COMPETITOR"
            }, {
            "description" : "Consumer",
            "key" : "CONSUMER"
            }, {
            "description" : "Contact",
            "key" : "CONTACT"
            }, {
            "description" : "Content Administrator",
            "key" : "CONTENT_ADMIN"
            }, {
            "description" : "Content Author",
            "key" : "CONTENT_AUTHOR"
            }, {
            "description" : "Content Editor",
            "key" : "CONTENT_EDITOR"
            }, {
            "description" : "Content Guest",
            "key" : "CONTENT_GUEST"
            }, {
            "description" : "Content Member",
            "key" : "CONTENT"
            }, {
            "description" : "Content Publisher",
            "key" : "CONTENT_PUBLISHER"
            }, {
            "description" : "Content User",
            "key" : "CONTENT_USER"
            }, {
            "description" : "Contractor",
            "key" : "CONTRACTOR"
            }, {
            "description" : "Customer",
            "key" : "CUSTOMER"
            }, {
            "description" : "Department",
            "key" : "DEPARTMENT"
            }, {
            "description" : "Distribution Channel",
            "key" : "DISTRIBUTION_CHANNEL"
            }, {
            "description" : "Distributor",
            "key" : "DISTRIBUTOR"
            }, {
            "description" : "Division",
            "key" : "DIVISION"
            }, {
            "description" : "Email Administrator",
            "key" : "EMAIL_ADMIN"
            }, {
            "description" : "Employee",
            "key" : "EMPLOYEE"
            }, {
            "description" : "Employer",
            "key" : "EMPLOYER"
            }, {
            "description" : "End-User Customer",
            "key" : "END_USER_CUSTOMER"
            }, {
            "description" : "Family Member",
            "key" : "FAMILY_MEMBER"
            }, {
            "description" : "Fixed Asset Maint Assignee",
            "key" : "FAM_ASSIGNEE"
            }, {
            "description" : "Government Agency",
            "key" : "GOV_AGENCY"
            }, {
            "description" : "Hosting Server",
            "key" : "HOSTING_SERVER"
            }, {
            "description" : "Household",
            "key" : "HOUSEHOLD"
            }, {
            "description" : "ISP",
            "key" : "ISP"
            }, {
            "description" : "Image Approver",
            "key" : "IMAGEAPPROVER"
            }, {
            "description" : "Internal Organization",
            "key" : "INTERNAL_ORGANIZATIO"
            }, {
            "description" : "Lead",
            "key" : "LEAD"
            }, {
            "description" : "Limited Administrator",
            "key" : "LTD_ADMIN"
            }, {
            "description" : "Logged In",
            "key" : "LOGGEDIN"
            }, {
            "description" : "Main Role",
            "key" : "MAIN_ROLE"
            }, {
            "description" : "Maintenance Manager or Supervisor",
            "key" : "FAM_MANAGER"
            }, {
            "description" : "Maintenance Supplier or Service",
            "key" : "FAM_SUPPLIER"
            }, {
            "description" : "Maintenance Worker",
            "key" : "FAM_WORKER"
            }, {
            "description" : "Manager",
            "key" : "MANAGER"
            }, {
            "description" : "Manufacturer",
            "key" : "MANUFACTURER"
            }, {
            "description" : "Not Applicable",
            "key" : "_NA_"
            }, {
            "description" : "Order Clerk",
            "key" : "ORDER_CLERK"
            }, {
            "description" : "Organization",
            "key" : "ORGANIZATION_ROLE"
            }, {
            "description" : "Organization Unit",
            "key" : "ORGANIZATION_UNIT"
            }, {
            "description" : "Originator",
            "key" : "ORIGINATOR"
            }, {
            "description" : "Other Internal",
            "key" : "OTHER_INTERNAL_ORGAN"
            }, {
            "description" : "Other Organization Unit",
            "key" : "OTHER_ORGANIZATION_U"
            }, {
            "description" : "Owner",
            "key" : "OWNER"
            }, {
            "description" : "Packer",
            "key" : "PACKER"
            }, {
            "description" : "Parent Organization",
            "key" : "PARENT_ORGANIZATION"
            }, {
            "description" : "Partner",
            "key" : "PARTNER"
            }, {
            "description" : "Person",
            "key" : "PERSON_ROLE"
            }, {
            "description" : "Picker",
            "key" : "PICKER"
            }, {
            "description" : "Placing Customer",
            "key" : "PLACING_CUSTOMER"
            }, {
            "description" : "Product Owner",
            "key" : "PRODUCT_OWNER"
            }, {
            "description" : "Product Owner Company",
            "key" : "PRODUCT_OWNER_COMP"
            }, {
            "description" : "Project Team",
            "key" : "PROJECT_TEAM"
            }, {
            "description" : "Prospect",
            "key" : "PROSPECT"
            }, {
            "description" : "Provider Accounting",
            "key" : "PROVIDER_ACCOUNTING"
            }, {
            "description" : "Provider Analyst",
            "key" : "PROVIDER_ANALYST"
            }, {
            "description" : "Provider Functional",
            "key" : "PROVIDER_FUNCTIONAL"
            }, {
            "description" : "Provider Manager",
            "key" : "PROVIDER_MANAGER"
            }, {
            "description" : "Provider Tester",
            "key" : "PROVIDER_TESTER"
            }, {
            "description" : "Provider Validator",
            "key" : "PROVIDER_VALIDATOR"
            }, {
            "description" : "Receiver",
            "key" : "RECEIVER"
            }, {
            "description" : "Referrer",
            "key" : "REFERRER"
            }, {
            "description" : "Regulatory Agency",
            "key" : "REGULATORY_AGENCY"
            }, {
            "description" : "Request Manager",
            "key" : "REQ_MANAGER"
            }, {
            "description" : "Request Respondent",
            "key" : "REQ_RESPOND"
            }, {
            "description" : "Request Role",
            "key" : "REQUEST_ROLE"
            }, {
            "description" : "Request Taker",
            "key" : "REQ_TAKER"
            }, {
            "description" : "Requesting Party",
            "key" : "REQ_REQUESTER"
            }, {
            "description" : "Reviewer",
            "key" : "REVIEWER"
            }, {
            "description" : "SCRUM Master",
            "key" : "SCRUM_MASTER"
            }, {
            "description" : "SCRUM Team",
            "key" : "SCRUM_TEAM"
            }, {
            "description" : "Sales Force Autm.",
            "key" : "SFA_ROLE"
            }, {
            "description" : "Sales Representative",
            "key" : "SALES_REP"
            }, {
            "description" : "Scrum Member",
            "key" : "SCRUM_MEMBER"
            }, {
            "description" : "Shareholder",
            "key" : "SHAREHOLDER"
            }, {
            "description" : "Ship-From Vendor",
            "key" : "SHIP_FROM_VENDOR"
            }, {
            "description" : "Ship-To Customer",
            "key" : "SHIP_TO_CUSTOMER"
            }, {
            "description" : "Shipment Clerk",
            "key" : "SHIPMENT_CLERK"
            }, {
            "description" : "Sponsor",
            "key" : "SPONSOR"
            }, {
            "description" : "Spouse",
            "key" : "SPOUSE"
            }, {
            "description" : "Stakeholder",
            "key" : "STAKEHOLDER"
            }, {
            "description" : "Stocker",
            "key" : "STOCKER"
            }, {
            "description" : "Subscriber",
            "key" : "SUBSCRIBER"
            }, {
            "description" : "Subsidiary",
            "key" : "SUBSIDIARY"
            }, {
            "description" : "Supplier",
            "key" : "SUPPLIER"
            }, {
            "description" : "Supplier Agent",
            "key" : "SUPPLIER_AGENT"
            }, {
            "description" : "Tax Authority",
            "key" : "TAX_AUTHORITY"
            }, {
            "description" : "Union",
            "key" : "UNION"
            }, {
            "description" : "Vendor",
            "key" : "VENDOR"
            }, {
            "description" : "Visitor",
            "key" : "VISITOR"
            }, {
            "description" : "Web Master",
            "key" : "WEB_MASTER"
            }, {
            "description" : "Worker",
            "key" : "WORKER"
            }, {
            "description" : "Workflow",
            "key" : "WORKFLOW_ROLE"
            }, {
            "description" : "Workflow Owner",
            "key" : "WF_OWNER"
            } ],
            "disabled" : "false",
            "id" : "AddProductSubscriptionResource_useRoleTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "useRoleTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "The subscription will be extended at the end of the subscription period with a new order",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductSubscriptionResource",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "AddProductSubscriptionResource_automaticExtend",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "first-in-list",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "automaticExtend",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Time period (before the end of the thrudate) for automatic extension of the subscription",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "canclAutmExtTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductSubscriptionResource_canclAutmExtTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Unit Of Measure used for the automatic extension of the subscription",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductSubscriptionResource",
            "options" : [ {
            "description" : "Time in Centuries (century)",
            "key" : "TF_century"
            }, {
            "description" : "Time in Days (day)",
            "key" : "TF_day"
            }, {
            "description" : "Time in Decades (decade)",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Hours (hr)",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Millenia (millenium)",
            "key" : "TF_millenium"
            }, {
            "description" : "Time in Milli-Seconds (ms)",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Minutes (min)",
            "key" : "TF_min"
            }, {
            "description" : "Time in Months (mon)",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Scores (score)",
            "key" : "TF_score"
            }, {
            "description" : "Time in Seconds (s)",
            "key" : "TF_s"
            }, {
            "description" : "Time in Weeks (wk)",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Years (yr)",
            "key" : "TF_yr"
            } ],
            "disabled" : "false",
            "id" : "AddProductSubscriptionResource_canclAutmExtTimeUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "canclAutmExtTimeUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Grace Period On Expiry",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "gracePeriodOnExpiry",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductSubscriptionResource_gracePeriodOnExpiry",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Grace Period On Expiry Uom ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "gracePeriodOnExpiryUomId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddProductSubscriptionResource_gracePeriodOnExpiryUomId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductSubscriptionResource",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductSubscriptionResource_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductSubscriptionResource"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "vendorPartyId", "productStoreGroupId", "submitButton" ]
        } ],
        "columns" : [ {
            "name" : "vendorPartyId",
            "title" : "Vendor Party ID"
        }, {
            "name" : "productStoreGroupId",
            "title" : "Product Store Group ID"
        }, {
            "name" : "submitButton",
            "title" : "Delete"
        } ],
        "formName" : "ListVendorProducts",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListVendorProducts_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "vendorPartyId",
            "description" : "",
            "style" : "",
            "id" : "ListVendorProducts_vendorPartyId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productStoreGroupId",
            "description" : "",
            "style" : "",
            "id" : "ListVendorProducts_productStoreGroupId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListVendorProducts",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ListVendorProducts_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Delete",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "deleteVendorProduct"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "vendorPartyId", "productStoreGroupId", "submitButton" ]
        } ],
        "formName" : "EditVendorProduct",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "EditVendorProduct_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "GZ-2644"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditVendorProduct",
            "id" : "EditVendorProduct_vendorPartyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "vendorPartyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "vendorPartyId",
            "style" : "",
            "id" : "EditVendorProduct_vendorPartyId",
            "title" : "Vendor Party ID",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Store Group ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditVendorProduct",
            "options" : [ {
            "description" : "Not Applicable",
            "key" : "_NA_"
            } ],
            "disabled" : "false",
            "id" : "EditVendorProduct_productStoreGroupId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productStoreGroupId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditVendorProduct",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditVendorProduct_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createVendorProduct"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "statusId", "orderItemSequenceId", "orderDate", "unitPrice", "quantity", "orderType" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "statusId",
            "title" : "Item Status ID"
        }, {
            "name" : "orderItemSequenceId",
            "title" : "Order Item Seq ID"
        }, {
            "name" : "orderDate",
            "title" : "Order Date"
        }, {
            "name" : "unitPrice",
            "title" : "Unit Price"
        }, {
            "name" : "quantity",
            "title" : ">Quantity"
        }, {
            "name" : "orderType",
            "title" : "Order Type"
        } ],
        "formName" : "ProductOrderList",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "hyperlink" : {
            "linkStyle" : "",
            "description" : "View Order",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "1"
            },
            "uniqueItemName" : "Modal_e83f47ca_6c43_40f6_81b6_8ae647f90c67",
            "target" : "ViewOrder",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderId",
            "description" : "",
            "style" : "",
            "id" : "ProductOrderList_orderId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "ProductOrderList_statusId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderItemSequenceId",
            "description" : "",
            "style" : "",
            "id" : "ProductOrderList_orderItemSequenceId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderDate",
            "description" : "",
            "style" : "",
            "id" : "ProductOrderList_orderDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "unitPrice",
            "description" : "",
            "style" : "",
            "id" : "ProductOrderList_unitPrice",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "ProductOrderList_quantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderType",
            "description" : "",
            "style" : "",
            "id" : "ProductOrderList_orderType",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""

    }

    
]